/* tslint:disable */
/* eslint-disable */
/**
 * Onestaff
 * The Onestaff API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AcceptAvaibilityData
 */
export interface AcceptAvaibilityData {
    /**
     * 
     * @type {number}
     * @memberof AcceptAvaibilityData
     */
    'id': number;
    /**
     * 
     * @type {boolean}
     * @memberof AcceptAvaibilityData
     */
    'answer': boolean;
}
/**
 * 
 * @export
 * @interface AcceptAvaibilityDto
 */
export interface AcceptAvaibilityDto {
    /**
     * 
     * @type {Array<AcceptAvaibilityData>}
     * @memberof AcceptAvaibilityDto
     */
    'array': Array<AcceptAvaibilityData>;
}
/**
 * 
 * @export
 * @interface AccountEntity
 */
export interface AccountEntity {
    /**
     * 
     * @type {number}
     * @memberof AccountEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AccountEntity
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof AccountEntity
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface AddSecondaryBossDto
 */
export interface AddSecondaryBossDto {
    /**
     * ID of the work position to be set as secondary boss
     * @type {number}
     * @memberof AddSecondaryBossDto
     */
    'secondaryBossId': number;
}
/**
 * 
 * @export
 * @interface AddToPipelineDto
 */
export interface AddToPipelineDto {
    /**
     * ID of the candidate to add to a hiring pipeline
     * @type {number}
     * @memberof AddToPipelineDto
     */
    'candidateId': number;
    /**
     * ID of the job advertisement whose pipeline the candidate is added to
     * @type {number}
     * @memberof AddToPipelineDto
     */
    'jobAdvertisementsId': number;
}
/**
 * 
 * @export
 * @interface AdditionalBreakDto
 */
export interface AdditionalBreakDto {
    /**
     * ID of the additional break (for updates)
     * @type {number}
     * @memberof AdditionalBreakDto
     */
    'id'?: number;
    /**
     * Start time of the break
     * @type {string}
     * @memberof AdditionalBreakDto
     */
    'startTime': string;
    /**
     * End time of the break
     * @type {string}
     * @memberof AdditionalBreakDto
     */
    'endTime': string;
}
/**
 * 
 * @export
 * @interface AdditionalInformationsEntity
 */
export interface AdditionalInformationsEntity {
    /**
     * 
     * @type {number}
     * @memberof AdditionalInformationsEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdditionalInformationsEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {Array<object>}
     * @memberof AdditionalInformationsEntity
     */
    'foodRequirments': Array<object>;
    /**
     * 
     * @type {string}
     * @memberof AdditionalInformationsEntity
     */
    'customFoodRequirments': string;
    /**
     * 
     * @type {number}
     * @memberof AdditionalInformationsEntity
     */
    'pantsSize': number;
    /**
     * 
     * @type {object}
     * @memberof AdditionalInformationsEntity
     */
    'shirtSize': object;
    /**
     * 
     * @type {Array<LicenceEntity>}
     * @memberof AdditionalInformationsEntity
     */
    'licences'?: Array<LicenceEntity>;
    /**
     * 
     * @type {Array<EmergencyContactEntity>}
     * @memberof AdditionalInformationsEntity
     */
    'emergencyContacts'?: Array<EmergencyContactEntity>;
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof AdditionalInformationsEntity
     */
    'employee'?: EmployeeEntity;
}
/**
 * 
 * @export
 * @interface AgreementDto
 */
export interface AgreementDto {
    /**
     * Agreement ID
     * @type {number}
     * @memberof AgreementDto
     */
    'id': number;
    /**
     * Agreement start date
     * @type {string}
     * @memberof AgreementDto
     */
    'startedOn': string;
    /**
     * Agreement end date
     * @type {string}
     * @memberof AgreementDto
     */
    'endedOn'?: string;
    /**
     * Net daily amount
     * @type {number}
     * @memberof AgreementDto
     */
    'net_daily'?: number;
    /**
     * Encrypted net daily
     * @type {string}
     * @memberof AgreementDto
     */
    'net_daily_encrypted'?: string;
    /**
     * Downpayment amount
     * @type {number}
     * @memberof AgreementDto
     */
    'downpayment'?: number;
    /**
     * Agreement notes
     * @type {string}
     * @memberof AgreementDto
     */
    'notes'?: string;
    /**
     * Days off
     * @type {number}
     * @memberof AgreementDto
     */
    'daysOff': number;
    /**
     * Free days
     * @type {Array<string>}
     * @memberof AgreementDto
     */
    'freeDays': Array<string>;
    /**
     * Create days automatically
     * @type {boolean}
     * @memberof AgreementDto
     */
    'createDaysAutomatically': boolean;
    /**
     * Hours vacation
     * @type {number}
     * @memberof AgreementDto
     */
    'hoursVacation'?: number;
    /**
     * Days vacation
     * @type {number}
     * @memberof AgreementDto
     */
    'daysVacation'?: number;
    /**
     * 730 balance
     * @type {number}
     * @memberof AgreementDto
     */
    'balance730'?: number;
    /**
     * Encrypted 730 balance
     * @type {string}
     * @memberof AgreementDto
     */
    'balance730_encrypted'?: string;
    /**
     * 730 balance date
     * @type {string}
     * @memberof AgreementDto
     */
    'balance730_date'?: string;
    /**
     * Hourly employer cost (plain)
     * @type {number}
     * @memberof AgreementDto
     */
    'costPerHour'?: number;
    /**
     * Encrypted hourly employer cost
     * @type {string}
     * @memberof AgreementDto
     */
    'costPerHour_encrypted'?: string;
    /**
     * Special daily net entries
     * @type {Array<SpecialDailyNetDto>}
     * @memberof AgreementDto
     */
    'SpecialDailyNet': Array<SpecialDailyNetDto>;
}
/**
 * 
 * @export
 * @interface AgreementEntity
 */
export interface AgreementEntity {
    /**
     * 
     * @type {number}
     * @memberof AgreementEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AgreementEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof AgreementEntity
     */
    'net_daily': number | null;
    /**
     * 
     * @type {string}
     * @memberof AgreementEntity
     */
    'startedOn': string;
    /**
     * 
     * @type {string}
     * @memberof AgreementEntity
     */
    'endedOn': string | null;
    /**
     * 
     * @type {number}
     * @memberof AgreementEntity
     */
    'daysOff': number;
    /**
     * 
     * @type {Array<object>}
     * @memberof AgreementEntity
     */
    'freeDays': Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof AgreementEntity
     */
    'isLongTheWholeContract': boolean;
    /**
     * 
     * @type {number}
     * @memberof AgreementEntity
     */
    'downpayment': number | null;
    /**
     * 
     * @type {string}
     * @memberof AgreementEntity
     */
    'notes': string | null;
    /**
     * 
     * @type {number}
     * @memberof AgreementEntity
     */
    'contractId': number;
    /**
     * 
     * @type {string}
     * @memberof AgreementEntity
     */
    'net_daily_encrypted': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgreementEntity
     */
    'createDaysAutomatically': boolean;
    /**
     * 
     * @type {Array<DailySpecialNetEntity>}
     * @memberof AgreementEntity
     */
    'SpecialDailyNet'?: Array<DailySpecialNetEntity>;
    /**
     * 
     * @type {number}
     * @memberof AgreementEntity
     */
    'hoursVacation': number | null;
    /**
     * 
     * @type {number}
     * @memberof AgreementEntity
     */
    'daysVacation': number | null;
    /**
     * 
     * @type {number}
     * @memberof AgreementEntity
     */
    'weeklyWorkHours': number | null;
    /**
     * 
     * @type {number}
     * @memberof AgreementEntity
     */
    'balance730': number | null;
    /**
     * 
     * @type {string}
     * @memberof AgreementEntity
     */
    'balance730_encrypted': string | null;
    /**
     * 
     * @type {string}
     * @memberof AgreementEntity
     */
    'balance730_date': string | null;
    /**
     * 
     * @type {number}
     * @memberof AgreementEntity
     */
    'costPerHour': number | null;
    /**
     * 
     * @type {string}
     * @memberof AgreementEntity
     */
    'costPerHour_encrypted': string | null;
}
/**
 * 
 * @export
 * @interface AgreementWithEmployeeDto
 */
export interface AgreementWithEmployeeDto {
    /**
     * Employee ID that this agreement belongs to
     * @type {number}
     * @memberof AgreementWithEmployeeDto
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof AgreementWithEmployeeDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AgreementWithEmployeeDto
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof AgreementWithEmployeeDto
     */
    'net_daily': number | null;
    /**
     * 
     * @type {string}
     * @memberof AgreementWithEmployeeDto
     */
    'startedOn': string;
    /**
     * 
     * @type {string}
     * @memberof AgreementWithEmployeeDto
     */
    'endedOn': string | null;
    /**
     * 
     * @type {number}
     * @memberof AgreementWithEmployeeDto
     */
    'daysOff': number;
    /**
     * 
     * @type {Array<object>}
     * @memberof AgreementWithEmployeeDto
     */
    'freeDays': Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof AgreementWithEmployeeDto
     */
    'isLongTheWholeContract': boolean;
    /**
     * 
     * @type {number}
     * @memberof AgreementWithEmployeeDto
     */
    'downpayment': number | null;
    /**
     * 
     * @type {string}
     * @memberof AgreementWithEmployeeDto
     */
    'notes': string | null;
    /**
     * 
     * @type {number}
     * @memberof AgreementWithEmployeeDto
     */
    'contractId': number;
    /**
     * 
     * @type {string}
     * @memberof AgreementWithEmployeeDto
     */
    'net_daily_encrypted': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgreementWithEmployeeDto
     */
    'createDaysAutomatically': boolean;
    /**
     * 
     * @type {Array<DailySpecialNetEntity>}
     * @memberof AgreementWithEmployeeDto
     */
    'SpecialDailyNet'?: Array<DailySpecialNetEntity>;
    /**
     * 
     * @type {number}
     * @memberof AgreementWithEmployeeDto
     */
    'hoursVacation': number | null;
    /**
     * 
     * @type {number}
     * @memberof AgreementWithEmployeeDto
     */
    'daysVacation': number | null;
    /**
     * 
     * @type {number}
     * @memberof AgreementWithEmployeeDto
     */
    'weeklyWorkHours': number | null;
    /**
     * 
     * @type {number}
     * @memberof AgreementWithEmployeeDto
     */
    'balance730': number | null;
    /**
     * 
     * @type {string}
     * @memberof AgreementWithEmployeeDto
     */
    'balance730_encrypted': string | null;
    /**
     * 
     * @type {string}
     * @memberof AgreementWithEmployeeDto
     */
    'balance730_date': string | null;
    /**
     * 
     * @type {number}
     * @memberof AgreementWithEmployeeDto
     */
    'costPerHour': number | null;
    /**
     * 
     * @type {string}
     * @memberof AgreementWithEmployeeDto
     */
    'costPerHour_encrypted': string | null;
}
/**
 * 
 * @export
 * @interface AgreementsSummaryDto
 */
export interface AgreementsSummaryDto {
    /**
     * Average net daily
     * @type {number}
     * @memberof AgreementsSummaryDto
     */
    'avgNetDaily': number;
    /**
     * Monthly amount
     * @type {number}
     * @memberof AgreementsSummaryDto
     */
    'monthly': number;
    /**
     * Total amount
     * @type {number}
     * @memberof AgreementsSummaryDto
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface AiGenerateJobAdDto
 */
export interface AiGenerateJobAdDto {
    /**
     * Job advertisement title (used as the main hint to the model)
     * @type {string}
     * @memberof AiGenerateJobAdDto
     */
    'title': string;
    /**
     * Which field to generate
     * @type {string}
     * @memberof AiGenerateJobAdDto
     */
    'field': AiGenerateJobAdDtoFieldEnum;
    /**
     * Current description HTML — passed when refining instead of generating from scratch
     * @type {string}
     * @memberof AiGenerateJobAdDto
     */
    'currentDescription'?: string;
    /**
     * Current requirements HTML — passed when refining instead of generating from scratch
     * @type {string}
     * @memberof AiGenerateJobAdDto
     */
    'currentRequirements'?: string;
    /**
     * Free-form user instruction (e.g. \"make it more friendly\", \"add a sentence about flexibility\")
     * @type {string}
     * @memberof AiGenerateJobAdDto
     */
    'userPrompt'?: string;
    /**
     * ID of the job ad currently being edited — used to exclude itself from the context examples
     * @type {number}
     * @memberof AiGenerateJobAdDto
     */
    'jobAdvertisementId'?: number;
}

export const AiGenerateJobAdDtoFieldEnum = {
    Description: 'description',
    Requirements: 'requirements',
    Both: 'both'
} as const;

export type AiGenerateJobAdDtoFieldEnum = typeof AiGenerateJobAdDtoFieldEnum[keyof typeof AiGenerateJobAdDtoFieldEnum];

/**
 * 
 * @export
 * @interface AiGenerateJobAdResponseDto
 */
export interface AiGenerateJobAdResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AiGenerateJobAdResponseDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof AiGenerateJobAdResponseDto
     */
    'requirements'?: string;
}
/**
 * 
 * @export
 * @interface AiTranslateDto
 */
export interface AiTranslateDto {
    /**
     * HTML content to translate
     * @type {string}
     * @memberof AiTranslateDto
     */
    'content': string;
    /**
     * Target language (e.g. English, Italian, German, French)
     * @type {string}
     * @memberof AiTranslateDto
     */
    'targetLanguage': string;
}
/**
 * 
 * @export
 * @interface ApplicationCountDto
 */
export interface ApplicationCountDto {
    /**
     * 
     * @type {number}
     * @memberof ApplicationCountDto
     */
    'currentMonth': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationCountDto
     */
    'lastMonth': number;
}
/**
 * 
 * @export
 * @interface ApplicationEntity
 */
export interface ApplicationEntity {
    /**
     * 
     * @type {number}
     * @memberof ApplicationEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationEntity
     */
    'candidateId': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicationEntity
     */
    'jobAdvertisementsId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationEntity
     */
    'employeeDocumentId'?: number | null;
    /**
     * AI-parsed CV data stored as JSON
     * @type {object}
     * @memberof ApplicationEntity
     */
    'resumeData'?: object | null;
    /**
     * Current pipeline stage ID
     * @type {number}
     * @memberof ApplicationEntity
     */
    'currentStageId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationEntity
     */
    'convertedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationEntity
     */
    'status': ApplicationEntityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ApplicationEntity
     */
    'rejectedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApplicationEntity
     */
    'rejectedById'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationEntity
     */
    'rejectionReason'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationEntity
     */
    'rejectionEmailSent': boolean;
    /**
     * Platform the application originated from (e.g. INDEED, LINKEDIN, SOCIAL_MEDIA, SUEDTIROL_JOBS)
     * @type {string}
     * @memberof ApplicationEntity
     */
    'source'?: string | null;
}

export const ApplicationEntityStatusEnum = {
    Active: 'ACTIVE',
    Rejected: 'REJECTED',
    Hired: 'HIRED',
    Archived: 'ARCHIVED'
} as const;

export type ApplicationEntityStatusEnum = typeof ApplicationEntityStatusEnum[keyof typeof ApplicationEntityStatusEnum];

/**
 * 
 * @export
 * @interface ApproveTimeEntryDto
 */
export interface ApproveTimeEntryDto {
    /**
     * 
     * @type {string}
     * @memberof ApproveTimeEntryDto
     */
    'comment'?: string;
}
/**
 * 
 * @export
 * @interface ArchiveApplicationDto
 */
export interface ArchiveApplicationDto {
    /**
     * The ID of the application to archive (remove from Kanban board)
     * @type {number}
     * @memberof ArchiveApplicationDto
     */
    'applicationId': number;
}
/**
 * 
 * @export
 * @interface AssignEmployeesToSeasonsDto
 */
export interface AssignEmployeesToSeasonsDto {
    /**
     * 
     * @type {number}
     * @memberof AssignEmployeesToSeasonsDto
     */
    'seasonId': number;
    /**
     * 
     * @type {number}
     * @memberof AssignEmployeesToSeasonsDto
     */
    'seasonToCopyFromId': number;
    /**
     * 
     * @type {Array<EmployeeOptions>}
     * @memberof AssignEmployeesToSeasonsDto
     */
    'employeesOptions': Array<EmployeeOptions>;
}
/**
 * 
 * @export
 * @interface AssignShiftTemplateDto
 */
export interface AssignShiftTemplateDto {
    /**
     * 
     * @type {number}
     * @memberof AssignShiftTemplateDto
     */
    'templateId': number;
    /**
     * 
     * @type {string}
     * @memberof AssignShiftTemplateDto
     */
    'fromDate': string;
    /**
     * 
     * @type {string}
     * @memberof AssignShiftTemplateDto
     */
    'toDate': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignShiftTemplateDto
     */
    'daysOfWeek': Array<string>;
}
/**
 * 
 * @export
 * @interface AssignShiftToEmployeeDto
 */
export interface AssignShiftToEmployeeDto {
    /**
     * 
     * @type {number}
     * @memberof AssignShiftToEmployeeDto
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof AssignShiftToEmployeeDto
     */
    'shiftDetailId': number;
    /**
     * 
     * @type {string}
     * @memberof AssignShiftToEmployeeDto
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof AssignShiftToEmployeeDto
     */
    'seasonId'?: number;
}
/**
 * 
 * @export
 * @interface AutoPopulateHolidaysDto
 */
export interface AutoPopulateHolidaysDto {
    /**
     * 
     * @type {number}
     * @memberof AutoPopulateHolidaysDto
     */
    'year': number;
    /**
     * 
     * @type {string}
     * @memberof AutoPopulateHolidaysDto
     */
    'region'?: string;
}
/**
 * 
 * @export
 * @interface AutoPopulateResponseDto
 */
export interface AutoPopulateResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AutoPopulateResponseDto
     */
    'added': number;
    /**
     * 
     * @type {number}
     * @memberof AutoPopulateResponseDto
     */
    'skipped': number;
}
/**
 * 
 * @export
 * @interface BankingInformationEntity
 */
export interface BankingInformationEntity {
    /**
     * 
     * @type {number}
     * @memberof BankingInformationEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof BankingInformationEntity
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof BankingInformationEntity
     */
    'iban': string;
    /**
     * 
     * @type {string}
     * @memberof BankingInformationEntity
     */
    'bicSwift': string;
    /**
     * 
     * @type {number}
     * @memberof BankingInformationEntity
     */
    'employeeId': number;
}
/**
 * 
 * @export
 * @interface BuildingEntity
 */
export interface BuildingEntity {
    /**
     * 
     * @type {number}
     * @memberof BuildingEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof BuildingEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BuildingEntity
     */
    'address': string;
    /**
     * 
     * @type {number}
     * @memberof BuildingEntity
     */
    'cost': number;
    /**
     * 
     * @type {string}
     * @memberof BuildingEntity
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof BuildingEntity
     */
    'endDate': string;
}
/**
 * 
 * @export
 * @interface BulkConfirmDto
 */
export interface BulkConfirmDto {
    /**
     * 
     * @type {number}
     * @memberof BulkConfirmDto
     */
    'seasonId': number;
    /**
     * 
     * @type {number}
     * @memberof BulkConfirmDto
     */
    'departmentId': number;
    /**
     * 
     * @type {Array<BulkConfirmItemDto>}
     * @memberof BulkConfirmDto
     */
    'items': Array<BulkConfirmItemDto>;
}
/**
 * 
 * @export
 * @interface BulkConfirmItemDto
 */
export interface BulkConfirmItemDto {
    /**
     * 
     * @type {number}
     * @memberof BulkConfirmItemDto
     */
    'shiftAssignmentId': number;
    /**
     * 
     * @type {number}
     * @memberof BulkConfirmItemDto
     */
    'employeeId': number;
}
/**
 * 
 * @export
 * @interface CalendarEntryEntity
 */
export interface CalendarEntryEntity {
    /**
     * 
     * @type {string}
     * @memberof CalendarEntryEntity
     */
    'type': CalendarEntryEntityTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarEntryEntity
     */
    'accepted': boolean;
    /**
     * 
     * @type {number}
     * @memberof CalendarEntryEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof CalendarEntryEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof CalendarEntryEntity
     */
    'seasonId': number;
    /**
     * 
     * @type {EmployeeToSeasonEntity}
     * @memberof CalendarEntryEntity
     */
    'employeeToSeason'?: EmployeeToSeasonEntity;
    /**
     * 
     * @type {string}
     * @memberof CalendarEntryEntity
     */
    'startedOn': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEntryEntity
     */
    'endedOn': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEntryEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEntryEntity
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof CalendarEntryEntity
     */
    'createdById': number;
    /**
     * 
     * @type {number}
     * @memberof CalendarEntryEntity
     */
    'updatedById': number;
    /**
     * 
     * @type {string}
     * @memberof CalendarEntryEntity
     */
    'managerNotes': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEntryEntity
     */
    'publicNotes': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEntryEntity
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEntryEntity
     */
    'endTime': string;
    /**
     * 
     * @type {number}
     * @memberof CalendarEntryEntity
     */
    'customTypeId': number;
    /**
     * 
     * @type {CustomCalendarEntryTypesEntity}
     * @memberof CalendarEntryEntity
     */
    'customType'?: CustomCalendarEntryTypesEntity;
}

export const CalendarEntryEntityTypeEnum = {
    HalfDay: 'HALF_DAY',
    DayOff: 'DAY_OFF',
    Vacation: 'VACATION',
    Ill: 'ILL',
    UnpaidLeave: 'UNPAID_LEAVE',
    Custom: 'CUSTOM'
} as const;

export type CalendarEntryEntityTypeEnum = typeof CalendarEntryEntityTypeEnum[keyof typeof CalendarEntryEntityTypeEnum];

/**
 * 
 * @export
 * @interface CalendarEntryShiftTemplateEntity
 */
export interface CalendarEntryShiftTemplateEntity {
    /**
     * 
     * @type {number}
     * @memberof CalendarEntryShiftTemplateEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CalendarEntryShiftTemplateEntity
     */
    'startedOn': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEntryShiftTemplateEntity
     */
    'endedOn': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEntryShiftTemplateEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEntryShiftTemplateEntity
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarEntryShiftTemplateEntity
     */
    'isAutoGenerated': boolean;
    /**
     * 
     * @type {number}
     * @memberof CalendarEntryShiftTemplateEntity
     */
    'templateId': number;
    /**
     * 
     * @type {number}
     * @memberof CalendarEntryShiftTemplateEntity
     */
    'seasonId': number;
    /**
     * 
     * @type {ShiftTemplateEntity}
     * @memberof CalendarEntryShiftTemplateEntity
     */
    'shiftTemplate'?: ShiftTemplateEntity;
}
/**
 * 
 * @export
 * @interface CandidateCommentEntity
 */
export interface CandidateCommentEntity {
    /**
     * 
     * @type {number}
     * @memberof CandidateCommentEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof CandidateCommentEntity
     */
    'applicationId': number;
    /**
     * Employee ID of the comment author
     * @type {number}
     * @memberof CandidateCommentEntity
     */
    'authorId': number;
    /**
     * 
     * @type {string}
     * @memberof CandidateCommentEntity
     */
    'content': string;
    /**
     * Rating from 1 to 5
     * @type {number}
     * @memberof CandidateCommentEntity
     */
    'rating'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CandidateCommentEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CandidateCommentEntity
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface CandidateEntity
 */
export interface CandidateEntity {
    /**
     * 
     * @type {number}
     * @memberof CandidateEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CandidateEntity
     */
    'tenantId': string;
    /**
     * 
     * @type {string}
     * @memberof CandidateEntity
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CandidateEntity
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CandidateEntity
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CandidateEntity
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CandidateEntity
     */
    'gender'?: CandidateEntityGenderEnum;
    /**
     * 
     * @type {number}
     * @memberof CandidateEntity
     */
    'employeeId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CandidateEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CandidateEntity
     */
    'updatedAt': string;
}

export const CandidateEntityGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Undefined: 'UNDEFINED'
} as const;

export type CandidateEntityGenderEnum = typeof CandidateEntityGenderEnum[keyof typeof CandidateEntityGenderEnum];

/**
 * 
 * @export
 * @interface CertificationDocumentEntity
 */
export interface CertificationDocumentEntity {
    /**
     * 
     * @type {number}
     * @memberof CertificationDocumentEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CertificationDocumentEntity
     */
    'documentName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CertificationDocumentEntity
     */
    'typeName': string;
    /**
     * 
     * @type {number}
     * @memberof CertificationDocumentEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof CertificationDocumentEntity
     */
    'certificationId'?: number | null;
    /**
     * 
     * @type {Array<DocumentFileEntity>}
     * @memberof CertificationDocumentEntity
     */
    'documentFiles'?: Array<DocumentFileEntity>;
}
/**
 * 
 * @export
 * @interface ChartDataDto
 */
export interface ChartDataDto {
    /**
     * Monthly payments array
     * @type {Array<number>}
     * @memberof ChartDataDto
     */
    'paid': Array<number>;
    /**
     * Monthly dues array
     * @type {Array<number>}
     * @memberof ChartDataDto
     */
    'due': Array<number>;
    /**
     * Credit array
     * @type {Array<number>}
     * @memberof ChartDataDto
     */
    'credit': Array<number>;
}
/**
 * 
 * @export
 * @interface CheckEmployeeResponseDto
 */
export interface CheckEmployeeResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof CheckEmployeeResponseDto
     */
    'exists': boolean;
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof CheckEmployeeResponseDto
     */
    'employee'?: EmployeeEntity;
}
/**
 * 
 * @export
 * @interface CommunicationEntity
 */
export interface CommunicationEntity {
    /**
     * 
     * @type {number}
     * @memberof CommunicationEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CommunicationEntity
     */
    'text': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunicationEntity
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunicationEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof CommunicationEntity
     */
    'senderId': number;
    /**
     * 
     * @type {number}
     * @memberof CommunicationEntity
     */
    'receiverId': number;
    /**
     * 
     * @type {object}
     * @memberof CommunicationEntity
     */
    'sender': object;
}
/**
 * 
 * @export
 * @interface CompleteEmployeeReportDto
 */
export interface CompleteEmployeeReportDto {
    /**
     * 
     * @type {CompleteEmployeeReportDtoEmployee}
     * @memberof CompleteEmployeeReportDto
     */
    'employee': CompleteEmployeeReportDtoEmployee;
    /**
     * Effective contract start date
     * @type {string}
     * @memberof CompleteEmployeeReportDto
     */
    'effectiveContractStartDate': string;
    /**
     * Contract ID
     * @type {number}
     * @memberof CompleteEmployeeReportDto
     */
    'contractId': number;
    /**
     * 
     * @type {CompleteEmployeeReportDtoContract}
     * @memberof CompleteEmployeeReportDto
     */
    'contract': CompleteEmployeeReportDtoContract;
    /**
     * 
     * @type {CompleteEmployeeReportDtoAgreements}
     * @memberof CompleteEmployeeReportDto
     */
    'agreements': CompleteEmployeeReportDtoAgreements;
    /**
     * Agreements list
     * @type {Array<AgreementDto>}
     * @memberof CompleteEmployeeReportDto
     */
    'agreementsList': Array<AgreementDto>;
    /**
     * Rewards list
     * @type {Array<RewardDto>}
     * @memberof CompleteEmployeeReportDto
     */
    'rewards': Array<RewardDto>;
    /**
     * 
     * @type {CompleteEmployeeReportDtoStats}
     * @memberof CompleteEmployeeReportDto
     */
    'stats': CompleteEmployeeReportDtoStats;
    /**
     * 
     * @type {CompleteEmployeeReportDtoChart}
     * @memberof CompleteEmployeeReportDto
     */
    'chart': CompleteEmployeeReportDtoChart;
    /**
     * Payments data
     * @type {Array<PaymentDataDto>}
     * @memberof CompleteEmployeeReportDto
     */
    'paymentsData': Array<PaymentDataDto>;
    /**
     * Payments count
     * @type {number}
     * @memberof CompleteEmployeeReportDto
     */
    'paymentsCount': number;
    /**
     * All employees for autocomplete
     * @type {Array<EmployeeBasicInfoDto>}
     * @memberof CompleteEmployeeReportDto
     */
    'allEmployees': Array<EmployeeBasicInfoDto>;
    /**
     * All departments
     * @type {Array<DepartmentDto>}
     * @memberof CompleteEmployeeReportDto
     */
    'departments': Array<DepartmentDto>;
    /**
     * 
     * @type {CompleteEmployeeReportDtoMetadata}
     * @memberof CompleteEmployeeReportDto
     */
    'metadata': CompleteEmployeeReportDtoMetadata;
}
/**
 * Agreements summary
 * @export
 * @interface CompleteEmployeeReportDtoAgreements
 */
export interface CompleteEmployeeReportDtoAgreements {
    /**
     * Average net daily
     * @type {number}
     * @memberof CompleteEmployeeReportDtoAgreements
     */
    'avgNetDaily': number;
    /**
     * Monthly amount
     * @type {number}
     * @memberof CompleteEmployeeReportDtoAgreements
     */
    'monthly': number;
    /**
     * Total amount
     * @type {number}
     * @memberof CompleteEmployeeReportDtoAgreements
     */
    'total': number;
}
/**
 * Chart data
 * @export
 * @interface CompleteEmployeeReportDtoChart
 */
export interface CompleteEmployeeReportDtoChart {
    /**
     * Monthly payments array
     * @type {Array<number>}
     * @memberof CompleteEmployeeReportDtoChart
     */
    'paid': Array<number>;
    /**
     * Monthly dues array
     * @type {Array<number>}
     * @memberof CompleteEmployeeReportDtoChart
     */
    'due': Array<number>;
    /**
     * Credit array
     * @type {Array<number>}
     * @memberof CompleteEmployeeReportDtoChart
     */
    'credit': Array<number>;
}
/**
 * Contract information
 * @export
 * @interface CompleteEmployeeReportDtoContract
 */
export interface CompleteEmployeeReportDtoContract {
    /**
     * Contract start date
     * @type {string}
     * @memberof CompleteEmployeeReportDtoContract
     */
    'startDate': string;
    /**
     * Contract end date
     * @type {string}
     * @memberof CompleteEmployeeReportDtoContract
     */
    'endDate': string;
    /**
     * Total work days
     * @type {number}
     * @memberof CompleteEmployeeReportDtoContract
     */
    'days': number;
    /**
     * Total days off
     * @type {number}
     * @memberof CompleteEmployeeReportDtoContract
     */
    'totalDaysOff': number;
    /**
     * Days off taken
     * @type {number}
     * @memberof CompleteEmployeeReportDtoContract
     */
    'todayDaysOff': number;
    /**
     * Days off remaining
     * @type {number}
     * @memberof CompleteEmployeeReportDtoContract
     */
    'daysOff': number;
    /**
     * Legal contract type
     * @type {string}
     * @memberof CompleteEmployeeReportDtoContract
     */
    'legalContractType': string;
}
/**
 * Employee basic information
 * @export
 * @interface CompleteEmployeeReportDtoEmployee
 */
export interface CompleteEmployeeReportDtoEmployee {
    /**
     * Employee ID
     * @type {number}
     * @memberof CompleteEmployeeReportDtoEmployee
     */
    'id': number;
    /**
     * First name
     * @type {string}
     * @memberof CompleteEmployeeReportDtoEmployee
     */
    'firstName': string;
    /**
     * Last name
     * @type {string}
     * @memberof CompleteEmployeeReportDtoEmployee
     */
    'lastName': string;
    /**
     * Email
     * @type {string}
     * @memberof CompleteEmployeeReportDtoEmployee
     */
    'email'?: string;
    /**
     * File path
     * @type {string}
     * @memberof CompleteEmployeeReportDtoEmployee
     */
    'filePath'?: string;
    /**
     * Phone
     * @type {string}
     * @memberof CompleteEmployeeReportDtoEmployee
     */
    'phone': string;
    /**
     * Date of birth
     * @type {string}
     * @memberof CompleteEmployeeReportDtoEmployee
     */
    'dateOfBirth'?: string;
    /**
     * Role
     * @type {string}
     * @memberof CompleteEmployeeReportDtoEmployee
     */
    'role': string;
}
/**
 * 
 * @export
 * @interface CompleteEmployeeReportDtoMetadata
 */
export interface CompleteEmployeeReportDtoMetadata {
    /**
     * 
     * @type {number}
     * @memberof CompleteEmployeeReportDtoMetadata
     */
    'seasonId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompleteEmployeeReportDtoMetadata
     */
    'isUnlimited'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompleteEmployeeReportDtoMetadata
     */
    'hasEncryptedAgreements'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompleteEmployeeReportDtoMetadata
     */
    'calculationDate'?: string;
}
/**
 * Employee statistics
 * @export
 * @interface CompleteEmployeeReportDtoStats
 */
export interface CompleteEmployeeReportDtoStats {
    /**
     * Unpaid leave days
     * @type {number}
     * @memberof CompleteEmployeeReportDtoStats
     */
    'unpaidLeave': number;
    /**
     * Ill days
     * @type {number}
     * @memberof CompleteEmployeeReportDtoStats
     */
    'ill': number;
    /**
     * Vacation days
     * @type {number}
     * @memberof CompleteEmployeeReportDtoStats
     */
    'vacation': number;
    /**
     * Seniority information
     * @type {object}
     * @memberof CompleteEmployeeReportDtoStats
     */
    'seniority': object;
}
/**
 * 
 * @export
 * @interface CompleteTrainingCourseDto
 */
export interface CompleteTrainingCourseDto {
    /**
     * Array of employee results for this training session
     * @type {Array<EmployeeResultDto>}
     * @memberof CompleteTrainingCourseDto
     */
    'results': Array<EmployeeResultDto>;
}
/**
 * 
 * @export
 * @interface ComplianceStatsDto
 */
export interface ComplianceStatsDto {
    /**
     * Total count of valid (non-expired) certifications for active/candidate employees
     * @type {number}
     * @memberof ComplianceStatsDto
     */
    'totalValid': number;
    /**
     * Certifications expiring within the next 30 days
     * @type {number}
     * @memberof ComplianceStatsDto
     */
    'expiringSoon': number;
    /**
     * Certifications already expired
     * @type {number}
     * @memberof ComplianceStatsDto
     */
    'expired': number;
    /**
     * Number of mandatory certification gaps (employee required but missing valid cert)
     * @type {number}
     * @memberof ComplianceStatsDto
     */
    'missingMandatory': number;
}
/**
 * 
 * @export
 * @interface ConfigureSubordinateOrderDto
 */
export interface ConfigureSubordinateOrderDto {
    /**
     * 
     * @type {Array<SubordinateOrderItemDto>}
     * @memberof ConfigureSubordinateOrderDto
     */
    'items': Array<SubordinateOrderItemDto>;
}
/**
 * 
 * @export
 * @interface ContractEntity
 */
export interface ContractEntity {
    /**
     * 
     * @type {string}
     * @memberof ContractEntity
     */
    'legalContractType': ContractEntityLegalContractTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ContractEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ContractEntity
     */
    'filePath': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContractEntity
     */
    'isAllIncluded': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractEntity
     */
    'isFoodIncluded': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractEntity
     */
    'isHousingIncluded': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractEntity
     */
    'isPartTime': boolean;
    /**
     * 
     * @type {number}
     * @memberof ContractEntity
     */
    'workPercentage': number;
    /**
     * 
     * @type {string}
     * @memberof ContractEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof ContractEntity
     */
    'isDraft': boolean;
    /**
     * 
     * @type {string}
     * @memberof ContractEntity
     */
    'startedOn': string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractEntity
     */
    'endedOn': string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractEntity
     */
    'probationPeriod': string;
    /**
     * 
     * @type {number}
     * @memberof ContractEntity
     */
    'probationPeriodDays': number;
    /**
     * 
     * @type {string}
     * @memberof ContractEntity
     */
    'levelName': string;
    /**
     * 
     * @type {Array<RewardEntity>}
     * @memberof ContractEntity
     */
    'rewards'?: Array<RewardEntity>;
    /**
     * 
     * @type {Array<EmployeeToSeasonEntity>}
     * @memberof ContractEntity
     */
    'employeesToSeasons'?: Array<EmployeeToSeasonEntity>;
}

export const ContractEntityLegalContractTypeEnum = {
    Limited: 'LIMITED',
    Unlimited: 'UNLIMITED',
    Internship: 'INTERNSHIP',
    Call: 'CALL',
    Apprenticeship: 'APPRENTICESHIP'
} as const;

export type ContractEntityLegalContractTypeEnum = typeof ContractEntityLegalContractTypeEnum[keyof typeof ContractEntityLegalContractTypeEnum];

/**
 * 
 * @export
 * @interface ContractInfoDto
 */
export interface ContractInfoDto {
    /**
     * Contract start date
     * @type {string}
     * @memberof ContractInfoDto
     */
    'startDate': string;
    /**
     * Contract end date
     * @type {string}
     * @memberof ContractInfoDto
     */
    'endDate': string;
    /**
     * Total work days
     * @type {number}
     * @memberof ContractInfoDto
     */
    'days': number;
    /**
     * Total days off
     * @type {number}
     * @memberof ContractInfoDto
     */
    'totalDaysOff': number;
    /**
     * Days off taken
     * @type {number}
     * @memberof ContractInfoDto
     */
    'todayDaysOff': number;
    /**
     * Days off remaining
     * @type {number}
     * @memberof ContractInfoDto
     */
    'daysOff': number;
    /**
     * Legal contract type
     * @type {string}
     * @memberof ContractInfoDto
     */
    'legalContractType': string;
}
/**
 * 
 * @export
 * @interface ContractTypeEntity
 */
export interface ContractTypeEntity {
    /**
     * 
     * @type {number}
     * @memberof ContractTypeEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ContractTypeEntity
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CopyShiftPlanDto
 */
export interface CopyShiftPlanDto {
    /**
     * 
     * @type {number}
     * @memberof CopyShiftPlanDto
     */
    'departmentId': number;
    /**
     * 
     * @type {number}
     * @memberof CopyShiftPlanDto
     */
    'seasonId': number;
    /**
     * 
     * @type {string}
     * @memberof CopyShiftPlanDto
     */
    'copyFromDate': string;
    /**
     * 
     * @type {string}
     * @memberof CopyShiftPlanDto
     */
    'copyToDate': string;
    /**
     *
     * @type {string}
     * @memberof CopyShiftPlanDto
     */
    'pasteStartDate': string;
    /**
     *
     * @type {boolean}
     * @memberof CopyShiftPlanDto
     */
    'copyCalendarEntries'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof CopyShiftPlanDto
     */
    'replaceCalendarEntries'?: boolean;
    /**
     *
     * @type {Array<number>}
     * @memberof CopyShiftPlanDto
     */
    'employeeIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface CourseTypeEntity
 */
export interface CourseTypeEntity {
    /**
     * 
     * @type {number}
     * @memberof CourseTypeEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CourseTypeEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CourseTypeEntity
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CourseTypeEntity
     */
    'category': CourseTypeEntityCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof CourseTypeEntity
     */
    'validityMonths'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CourseTypeEntity
     */
    'requiredHours'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CourseTypeEntity
     */
    'isMandatory': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CourseTypeEntity
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof CourseTypeEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CourseTypeEntity
     */
    'updatedAt': string;
}

export const CourseTypeEntityCategoryEnum = {
    Haccp: 'HACCP',
    Safety: 'SAFETY',
    FirstAid: 'FIRST_AID',
    FirePrevention: 'FIRE_PREVENTION',
    Equipment: 'EQUIPMENT',
    Language: 'LANGUAGE',
    Professional: 'PROFESSIONAL',
    Other: 'OTHER'
} as const;

export type CourseTypeEntityCategoryEnum = typeof CourseTypeEntityCategoryEnum[keyof typeof CourseTypeEntityCategoryEnum];

/**
 * 
 * @export
 * @interface CreateAdditionalInformationDto
 */
export interface CreateAdditionalInformationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateAdditionalInformationDto
     */
    'foodRequirments': CreateAdditionalInformationDtoFoodRequirmentsEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateAdditionalInformationDto
     */
    'shirtSize'?: CreateAdditionalInformationDtoShirtSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateAdditionalInformationDto
     */
    'customFoodRequirments'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateAdditionalInformationDto
     */
    'pantsSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAdditionalInformationDto
     */
    'typeName'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateAdditionalInformationDto
     */
    'employeeId': number;
}

export const CreateAdditionalInformationDtoFoodRequirmentsEnum = {
    Gluten: 'GLUTEN',
    Dairy: 'DAIRY',
    Egg: 'EGG',
    Fish: 'FISH',
    Soy: 'SOY',
    Peanut: 'PEANUT',
    Vegeterian: 'VEGETERIAN',
    Vegan: 'VEGAN',
    Halal: 'HALAL',
    Kosher: 'KOSHER',
    Crustacean: 'CRUSTACEAN',
    Nut: 'NUT',
    Celery: 'CELERY',
    Mustard: 'MUSTARD',
    Sesame: 'SESAME',
    Clam: 'CLAM',
    Lupine: 'LUPINE',
    Solfite: 'SOLFITE'
} as const;

export type CreateAdditionalInformationDtoFoodRequirmentsEnum = typeof CreateAdditionalInformationDtoFoodRequirmentsEnum[keyof typeof CreateAdditionalInformationDtoFoodRequirmentsEnum];
export const CreateAdditionalInformationDtoShirtSizeEnum = {
    Xxs: 'XXS',
    Xs: 'XS',
    S: 'S',
    M: 'M',
    L: 'L',
    Xl: 'XL',
    Xxl: 'XXL',
    Xxxl: 'XXXL'
} as const;

export type CreateAdditionalInformationDtoShirtSizeEnum = typeof CreateAdditionalInformationDtoShirtSizeEnum[keyof typeof CreateAdditionalInformationDtoShirtSizeEnum];

/**
 * 
 * @export
 * @interface CreateAgreementDto
 */
export interface CreateAgreementDto {
    /**
     * 
     * @type {number}
     * @memberof CreateAgreementDto
     */
    'net_daily'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAgreementDto
     */
    'startedOn': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgreementDto
     */
    'endedOn'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAgreementDto
     */
    'isLongTheWholeContract': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateAgreementDto
     */
    'notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateAgreementDto
     */
    'downpayment'?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof CreateAgreementDto
     */
    'freeDays': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof CreateAgreementDto
     */
    'contractId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateAgreementDto
     */
    'net_daily_encrypted'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAgreementDto
     */
    'createDaysAutomatically': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateAgreementDto
     */
    'daysOff': number;
    /**
     * Vacation hours - cannot be set if daysVacation is provided
     * @type {number}
     * @memberof CreateAgreementDto
     */
    'hoursVacation'?: number;
    /**
     * Vacation days - cannot be set if hoursVacation is provided
     * @type {number}
     * @memberof CreateAgreementDto
     */
    'daysVacation'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAgreementDto
     */
    'balance730'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAgreementDto
     */
    'balance730_encrypted'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgreementDto
     */
    'balance730_date'?: string;
    /**
     * Weekly work hours for this agreement
     * @type {number}
     * @memberof CreateAgreementDto
     */
    'weeklyWorkHours'?: number;
    /**
     * Fully-loaded employer cost per worked hour, in EUR (plain).
     * @type {number}
     * @memberof CreateAgreementDto
     */
    'costPerHour'?: number;
    /**
     * Encrypted costPerHour blob (frontend-encrypted).
     * @type {string}
     * @memberof CreateAgreementDto
     */
    'costPerHour_encrypted'?: string;
}
/**
 * 
 * @export
 * @interface CreateAvailabilityRequestsDto
 */
export interface CreateAvailabilityRequestsDto {
    /**
     * 
     * @type {string}
     * @memberof CreateAvailabilityRequestsDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAvailabilityRequestsDto
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof CreateAvailabilityRequestsDto
     */
    'departmentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAvailabilityRequestsDto
     */
    'seasonId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateAvailabilityRequestsDto
     */
    'expirationDate'?: string;
}
/**
 * 
 * @export
 * @interface CreateBankingInformationDto
 */
export interface CreateBankingInformationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateBankingInformationDto
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBankingInformationDto
     */
    'iban': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBankingInformationDto
     */
    'bicSwift': string;
    /**
     * 
     * @type {number}
     * @memberof CreateBankingInformationDto
     */
    'employeeId': number;
}
/**
 * 
 * @export
 * @interface CreateBreakDto
 */
export interface CreateBreakDto {
    /**
     * 
     * @type {string}
     * @memberof CreateBreakDto
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBreakDto
     */
    'endedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBreakDto
     */
    'isAutoDeducted'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateBuildingDto
 */
export interface CreateBuildingDto {
    /**
     * 
     * @type {string}
     * @memberof CreateBuildingDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBuildingDto
     */
    'address'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateBuildingDto
     */
    'cost'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateBuildingDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBuildingDto
     */
    'endDate'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateCalendarEntryDto
 */
export interface CreateCalendarEntryDto {
    /**
     * Start date of the calendar entry (ISO 8601 date string)
     * @type {string}
     * @memberof CreateCalendarEntryDto
     */
    'startedOn': string;
    /**
     * End date of the calendar entry (ISO 8601 date string)
     * @type {string}
     * @memberof CreateCalendarEntryDto
     */
    'endedOn': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCalendarEntryDto
     */
    'type': CreateCalendarEntryDtoTypeEnum;
    /**
     * ID of custom calendar entry type (optional)
     * @type {number}
     * @memberof CreateCalendarEntryDto
     */
    'customTypeId'?: number;
    /**
     * Start time in HH:MM format (00:00 to 23:59)
     * @type {string}
     * @memberof CreateCalendarEntryDto
     */
    'startTime'?: string;
    /**
     * End time in HH:MM format (00:00 to 23:59)
     * @type {string}
     * @memberof CreateCalendarEntryDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCalendarEntryDto
     */
    'managerNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCalendarEntryDto
     */
    'publicNotes'?: string;
}

export const CreateCalendarEntryDtoTypeEnum = {
    HalfDay: 'HALF_DAY',
    DayOff: 'DAY_OFF',
    Vacation: 'VACATION',
    Ill: 'ILL',
    UnpaidLeave: 'UNPAID_LEAVE',
    Custom: 'CUSTOM'
} as const;

export type CreateCalendarEntryDtoTypeEnum = typeof CreateCalendarEntryDtoTypeEnum[keyof typeof CreateCalendarEntryDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreateCalendarEntryShiftTemplateDto
 */
export interface CreateCalendarEntryShiftTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCalendarEntryShiftTemplateDto
     */
    'startedOn': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCalendarEntryShiftTemplateDto
     */
    'endedOn': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCalendarEntryShiftTemplateDto
     */
    'isAutoGenerated'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateCalendarEntryShiftTemplateDto
     */
    'templateId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateCalendarEntryShiftTemplateDto
     */
    'departmentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCalendarEntryShiftTemplateDto
     */
    'seasonId': number;
}
/**
 * 
 * @export
 * @interface CreateCandidateCommentDto
 */
export interface CreateCandidateCommentDto {
    /**
     * Comment text
     * @type {string}
     * @memberof CreateCandidateCommentDto
     */
    'content': string;
    /**
     * Rating from 1 to 5
     * @type {number}
     * @memberof CreateCandidateCommentDto
     */
    'rating'?: number;
    /**
     * Application this comment belongs to
     * @type {number}
     * @memberof CreateCandidateCommentDto
     */
    'applicationId': number;
}
/**
 * 
 * @export
 * @interface CreateCandidateDto
 */
export interface CreateCandidateDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCandidateDto
     */
    'tenantId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCandidateDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCandidateDto
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCandidateDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCandidateDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCandidateDto
     */
    'gender'?: CreateCandidateDtoGenderEnum;
}

export const CreateCandidateDtoGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Undefined: 'UNDEFINED'
} as const;

export type CreateCandidateDtoGenderEnum = typeof CreateCandidateDtoGenderEnum[keyof typeof CreateCandidateDtoGenderEnum];

/**
 * 
 * @export
 * @interface CreateCommunicationDto
 */
export interface CreateCommunicationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCommunicationDto
     */
    'text': string;
    /**
     * 
     * @type {number}
     * @memberof CreateCommunicationDto
     */
    'senderId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateCommunicationDto
     */
    'receiverId': number;
}
/**
 * 
 * @export
 * @interface CreateContractDto
 */
export interface CreateContractDto {
    /**
     * 
     * @type {string}
     * @memberof CreateContractDto
     */
    'legalContractType': CreateContractDtoLegalContractTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateContractDto
     */
    'startedOn': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateContractDto
     */
    'endedOn': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateContractDto
     */
    'isAllIncluded': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateContractDto
     */
    'isFoodIncluded': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateContractDto
     */
    'isHousingIncluded': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateContractDto
     */
    'isPartTime': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateContractDto
     */
    'workPercentage'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateContractDto
     */
    'probationPeriod'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateContractDto
     */
    'probationPeriodDays'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateContractDto
     */
    'employeeId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateContractDto
     */
    'levelName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateContractDto
     */
    'typeName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateContractDto
     */
    'isDraft': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateContractDto
     */
    'seasonId': number;
}

export const CreateContractDtoLegalContractTypeEnum = {
    Limited: 'LIMITED',
    Unlimited: 'UNLIMITED',
    Internship: 'INTERNSHIP',
    Call: 'CALL',
    Apprenticeship: 'APPRENTICESHIP'
} as const;

export type CreateContractDtoLegalContractTypeEnum = typeof CreateContractDtoLegalContractTypeEnum[keyof typeof CreateContractDtoLegalContractTypeEnum];

/**
 * 
 * @export
 * @interface CreateContractTypeDto
 */
export interface CreateContractTypeDto {
    /**
     * 
     * @type {string}
     * @memberof CreateContractTypeDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateCourseTypeDto
 */
export interface CreateCourseTypeDto {
    /**
     * Unique name of the course type
     * @type {string}
     * @memberof CreateCourseTypeDto
     */
    'name': string;
    /**
     * Description of the course type
     * @type {string}
     * @memberof CreateCourseTypeDto
     */
    'description'?: string;
    /**
     * Category of the course
     * @type {string}
     * @memberof CreateCourseTypeDto
     */
    'category': CreateCourseTypeDtoCategoryEnum;
    /**
     * Validity period in months (null = never expires)
     * @type {number}
     * @memberof CreateCourseTypeDto
     */
    'validityMonths'?: number;
    /**
     * Required training hours
     * @type {number}
     * @memberof CreateCourseTypeDto
     */
    'requiredHours'?: number;
    /**
     * Whether this course is legally mandatory
     * @type {boolean}
     * @memberof CreateCourseTypeDto
     */
    'isMandatory'?: boolean;
    /**
     * Whether this course type is active
     * @type {boolean}
     * @memberof CreateCourseTypeDto
     */
    'isActive'?: boolean;
}

export const CreateCourseTypeDtoCategoryEnum = {
    Haccp: 'HACCP',
    Safety: 'SAFETY',
    FirstAid: 'FIRST_AID',
    FirePrevention: 'FIRE_PREVENTION',
    Equipment: 'EQUIPMENT',
    Language: 'LANGUAGE',
    Professional: 'PROFESSIONAL',
    Other: 'OTHER'
} as const;

export type CreateCourseTypeDtoCategoryEnum = typeof CreateCourseTypeDtoCategoryEnum[keyof typeof CreateCourseTypeDtoCategoryEnum];

/**
 * 
 * @export
 * @interface CreateCustomTypeDto
 */
export interface CreateCustomTypeDto {
    /**
     * Name of the custom calendar entry type
     * @type {string}
     * @memberof CreateCustomTypeDto
     */
    'name': string;
    /**
     * Color for the custom type in hex format
     * @type {string}
     * @memberof CreateCustomTypeDto
     */
    'colour'?: string;
    /**
     * Whether this custom type counts as a day off
     * @type {boolean}
     * @memberof CreateCustomTypeDto
     */
    'countsAsDayOff'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateDailyNoteDto
 */
export interface CreateDailyNoteDto {
    /**
     * The text content of the daily note
     * @type {string}
     * @memberof CreateDailyNoteDto
     */
    'text': string;
    /**
     * The date of the daily note
     * @type {string}
     * @memberof CreateDailyNoteDto
     */
    'date': string;
    /**
     * The path to the uploaded image (optional)
     * @type {string}
     * @memberof CreateDailyNoteDto
     */
    'imagePath'?: string;
}
/**
 * 
 * @export
 * @interface CreateDailySpecialNetDto
 */
export interface CreateDailySpecialNetDto {
    /**
     * Employee ID
     * @type {number}
     * @memberof CreateDailySpecialNetDto
     */
    'employeeId': number;
    /**
     * Agreement ID
     * @type {number}
     * @memberof CreateDailySpecialNetDto
     */
    'agreementId': number;
    /**
     * Date (YYYY-MM-DD)
     * @type {string}
     * @memberof CreateDailySpecialNetDto
     */
    'date': string;
    /**
     * Net value
     * @type {number}
     * @memberof CreateDailySpecialNetDto
     */
    'net'?: number;
    /**
     * Encrypted net value
     * @type {string}
     * @memberof CreateDailySpecialNetDto
     */
    'net_encrypted'?: string;
    /**
     * Optional notes
     * @type {string}
     * @memberof CreateDailySpecialNetDto
     */
    'notes'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateDailyTicketDto
 */
export interface CreateDailyTicketDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDailyTicketDto
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof CreateDailyTicketDto
     */
    'itemId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateDailyTicketDto
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof CreateDailyTicketDto
     */
    'employeeId'?: number;
}
/**
 * 
 * @export
 * @interface CreateDepartmentDto
 */
export interface CreateDepartmentDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDepartmentDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateDepartmentDto
     */
    'segmentId'?: number;
}
/**
 * 
 * @export
 * @interface CreateDepartmentEmployeeDto
 */
export interface CreateDepartmentEmployeeDto {
    /**
     * 
     * @type {number}
     * @memberof CreateDepartmentEmployeeDto
     */
    'workPositionId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateDepartmentEmployeeDto
     */
    'bossEmployeeId': number | null;
}
/**
 * 
 * @export
 * @interface CreateDepositDto
 */
export interface CreateDepositDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDepositDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDepositDto
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof CreateDepositDto
     */
    'paymentSectionId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateDepositDto
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface CreateDocumentTypeDto
 */
export interface CreateDocumentTypeDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDocumentTypeDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateEmailTemplateDto
 */
export interface CreateEmailTemplateDto {
    /**
     * Template name (e.g. \"Interview Invitation\")
     * @type {string}
     * @memberof CreateEmailTemplateDto
     */
    'name': string;
    /**
     * Email subject line, supports {{placeholders}}
     * @type {string}
     * @memberof CreateEmailTemplateDto
     */
    'subject': string;
    /**
     * HTML body, supports {{placeholders}} like {{candidateName}}, {{jobTitle}}
     * @type {string}
     * @memberof CreateEmailTemplateDto
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailTemplateDto
     */
    'triggerType'?: CreateEmailTemplateDtoTriggerTypeEnum;
    /**
     * Pipeline stage name that triggers this email automatically (e.g. \"Applied\", \"Interview\")
     * @type {string}
     * @memberof CreateEmailTemplateDto
     */
    'triggerStageName'?: string;
    /**
     * Number of days before contract start/end to send the email
     * @type {number}
     * @memberof CreateEmailTemplateDto
     */
    'triggerDaysBefore'?: number;
}

export const CreateEmailTemplateDtoTriggerTypeEnum = {
    Stage: 'STAGE',
    Rejection: 'REJECTION',
    ContractStartReminder: 'CONTRACT_START_REMINDER',
    ContractEndReminder: 'CONTRACT_END_REMINDER',
    JobInvitation: 'JOB_INVITATION'
} as const;

export type CreateEmailTemplateDtoTriggerTypeEnum = typeof CreateEmailTemplateDtoTriggerTypeEnum[keyof typeof CreateEmailTemplateDtoTriggerTypeEnum];

/**
 * 
 * @export
 * @interface CreateEmergencyContactDto
 */
export interface CreateEmergencyContactDto {
    /**
     * 
     * @type {number}
     * @memberof CreateEmergencyContactDto
     */
    'additionalInformationId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateEmergencyContactDto
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmergencyContactDto
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmergencyContactDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmergencyContactDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmergencyContactDto
     */
    'relation': string;
}
/**
 * 
 * @export
 * @interface CreateEmployeeCertificationDto
 */
export interface CreateEmployeeCertificationDto {
    /**
     * Employee ID
     * @type {number}
     * @memberof CreateEmployeeCertificationDto
     */
    'employeeId': number;
    /**
     * Course type ID
     * @type {number}
     * @memberof CreateEmployeeCertificationDto
     */
    'courseTypeId': number;
    /**
     * Date the certification was obtained
     * @type {string}
     * @memberof CreateEmployeeCertificationDto
     */
    'obtainedDate': string;
    /**
     * Expiration date (null = never expires)
     * @type {string}
     * @memberof CreateEmployeeCertificationDto
     */
    'expirationDate'?: string;
    /**
     * Certificate number or reference
     * @type {string}
     * @memberof CreateEmployeeCertificationDto
     */
    'certificateNumber'?: string;
    /**
     * Issuing authority or training provider
     * @type {string}
     * @memberof CreateEmployeeCertificationDto
     */
    'issuingAuthority'?: string;
    /**
     * Additional notes
     * @type {string}
     * @memberof CreateEmployeeCertificationDto
     */
    'notes'?: string;
}
/**
 * 
 * @export
 * @interface CreateEmployeeDocumentDto
 */
export interface CreateEmployeeDocumentDto {
    /**
     * 
     * @type {number}
     * @memberof CreateEmployeeDocumentDto
     */
    'employeeId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDocumentDto
     */
    'typeName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDocumentDto
     */
    'expiringDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmployeeDocumentDto
     */
    'isEncrypted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmployeeDocumentDto
     */
    'isVisibleForUser': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDocumentDto
     */
    'documentName': string;
}
/**
 * 
 * @export
 * @interface CreateEmployeeDto
 */
export interface CreateEmployeeDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'role': CreateEmployeeDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'gender': CreateEmployeeDtoGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'filePath': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'dateOfBirth': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'countryOfBirth': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'provinceOfBirth': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'townshipOfBirth': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'taxcode': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeDto
     */
    'lastPayment': string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEmployeeDto
     */
    'seasonId': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmployeeDto
     */
    'canViewShifts'?: boolean;
}

export const CreateEmployeeDtoRoleEnum = {
    User: 'USER',
    Manager: 'MANAGER',
    Owner: 'OWNER',
    Developer: 'DEVELOPER',
    Depchief: 'DEPCHIEF',
    Termsnotaccepted: 'TERMSNOTACCEPTED',
    Controller: 'CONTROLLER'
} as const;

export type CreateEmployeeDtoRoleEnum = typeof CreateEmployeeDtoRoleEnum[keyof typeof CreateEmployeeDtoRoleEnum];
export const CreateEmployeeDtoGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Undefined: 'UNDEFINED'
} as const;

export type CreateEmployeeDtoGenderEnum = typeof CreateEmployeeDtoGenderEnum[keyof typeof CreateEmployeeDtoGenderEnum];

/**
 * 
 * @export
 * @interface CreateEmployeeWithStatusDto
 */
export interface CreateEmployeeWithStatusDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithStatusDto
     */
    'role': CreateEmployeeWithStatusDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithStatusDto
     */
    'gender': CreateEmployeeWithStatusDtoGenderEnum;
    /**
     * 
     * @type {object}
     * @memberof CreateEmployeeWithStatusDto
     */
    'statusType'?: object;
    /**
     * 
     * @type {number}
     * @memberof CreateEmployeeWithStatusDto
     */
    'statusId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithStatusDto
     */
    'filePath': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithStatusDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithStatusDto
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithStatusDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithStatusDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithStatusDto
     */
    'dateOfBirth': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithStatusDto
     */
    'countryOfBirth': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithStatusDto
     */
    'provinceOfBirth': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithStatusDto
     */
    'townshipOfBirth': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithStatusDto
     */
    'taxcode': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeWithStatusDto
     */
    'lastPayment': string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEmployeeWithStatusDto
     */
    'seasonId': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmployeeWithStatusDto
     */
    'canViewShifts'?: boolean;
}

export const CreateEmployeeWithStatusDtoRoleEnum = {
    User: 'USER',
    Manager: 'MANAGER',
    Owner: 'OWNER',
    Developer: 'DEVELOPER',
    Depchief: 'DEPCHIEF',
    Termsnotaccepted: 'TERMSNOTACCEPTED',
    Controller: 'CONTROLLER'
} as const;

export type CreateEmployeeWithStatusDtoRoleEnum = typeof CreateEmployeeWithStatusDtoRoleEnum[keyof typeof CreateEmployeeWithStatusDtoRoleEnum];
export const CreateEmployeeWithStatusDtoGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Undefined: 'UNDEFINED'
} as const;

export type CreateEmployeeWithStatusDtoGenderEnum = typeof CreateEmployeeWithStatusDtoGenderEnum[keyof typeof CreateEmployeeWithStatusDtoGenderEnum];

/**
 * 
 * @export
 * @interface CreateExperienceLevelDto
 */
export interface CreateExperienceLevelDto {
    /**
     * 
     * @type {string}
     * @memberof CreateExperienceLevelDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateHolidayDto
 */
export interface CreateHolidayDto {
    /**
     * 
     * @type {string}
     * @memberof CreateHolidayDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof CreateHolidayDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateHolidayDto
     */
    'region'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateInterviewDto
 */
export interface CreateInterviewDto {
    /**
     * Application this interview belongs to
     * @type {number}
     * @memberof CreateInterviewDto
     */
    'applicationId': number;
    /**
     * Optional calendar entry ID to link
     * @type {number}
     * @memberof CreateInterviewDto
     */
    'calendarEntryId'?: number;
    /**
     * Interview type, e.g. PHONE, VIDEO, ONSITE
     * @type {string}
     * @memberof CreateInterviewDto
     */
    'type': string;
    /**
     * Interview status, e.g. SCHEDULED, COMPLETED, CANCELLED
     * @type {string}
     * @memberof CreateInterviewDto
     */
    'status': string;
    /**
     * Scheduled date/time for the interview
     * @type {string}
     * @memberof CreateInterviewDto
     */
    'scheduledAt': string;
    /**
     * Optional notes about the interview
     * @type {string}
     * @memberof CreateInterviewDto
     */
    'notes'?: string;
    /**
     * Optional video conference link for VIDEO interviews
     * @type {string}
     * @memberof CreateInterviewDto
     */
    'videoLink'?: string;
}
/**
 * 
 * @export
 * @interface CreateJobAdDto
 */
export interface CreateJobAdDto {
    /**
     * 
     * @type {string}
     * @memberof CreateJobAdDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobAdDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobAdDto
     */
    'descriptionEn'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobAdDto
     */
    'descriptionIt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobAdDto
     */
    'descriptionDe'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobAdDto
     */
    'descriptionFr'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateJobAdDto
     */
    'workPositionId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateJobAdDto
     */
    'departmentId': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateJobAdDto
     */
    'isPublic': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateJobAdDto
     */
    'seasonId': number;
    /**
     * Minimum salary
     * @type {number}
     * @memberof CreateJobAdDto
     */
    'salaryMin'?: number;
    /**
     * Maximum salary
     * @type {number}
     * @memberof CreateJobAdDto
     */
    'salaryMax'?: number;
    /**
     * Currency code (e.g. EUR, USD)
     * @type {string}
     * @memberof CreateJobAdDto
     */
    'currency'?: string;
    /**
     * Job requirements
     * @type {string}
     * @memberof CreateJobAdDto
     */
    'requirements'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobAdDto
     */
    'requirementsEn'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobAdDto
     */
    'requirementsIt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobAdDto
     */
    'requirementsDe'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateJobAdDto
     */
    'requirementsFr'?: string;
    /**
     * Job type (e.g. FULL_TIME, PART_TIME, SEASONAL)
     * @type {string}
     * @memberof CreateJobAdDto
     */
    'jobType'?: string;
    /**
     * Application deadline (ISO 8601 date string)
     * @type {string}
     * @memberof CreateJobAdDto
     */
    'deadline'?: string;
    /**
     * Array of image URLs for workplace gallery
     * @type {Array<string>}
     * @memberof CreateJobAdDto
     */
    'images'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateLicenceDto
 */
export interface CreateLicenceDto {
    /**
     * 
     * @type {string}
     * @memberof CreateLicenceDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateMetaSafetyAreaDto
 */
export interface CreateMetaSafetyAreaDto {
    /**
     * The name of the meta safety area
     * @type {string}
     * @memberof CreateMetaSafetyAreaDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateMyBankingInformationDto
 */
export interface CreateMyBankingInformationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateMyBankingInformationDto
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMyBankingInformationDto
     */
    'iban': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMyBankingInformationDto
     */
    'bicSwift': string;
}
/**
 * 
 * @export
 * @interface CreateNoteDto
 */
export interface CreateNoteDto {
    /**
     * 
     * @type {string}
     * @memberof CreateNoteDto
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof CreateNoteDto
     */
    'text_encrypted'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateNoteDto
     */
    'authorId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateNoteDto
     */
    'employeeId': number;
}
/**
 * 
 * @export
 * @interface CreateNotesDto
 */
export interface CreateNotesDto {
    /**
     * 
     * @type {number}
     * @memberof CreateNotesDto
     */
    'roomId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateNotesDto
     */
    'seasonId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateNotesDto
     */
    'notes': string;
}
/**
 * 
 * @export
 * @interface CreateOfferLetterDto
 */
export interface CreateOfferLetterDto {
    /**
     * Application this offer belongs to
     * @type {number}
     * @memberof CreateOfferLetterDto
     */
    'applicationId': number;
    /**
     * Salary offer amount
     * @type {number}
     * @memberof CreateOfferLetterDto
     */
    'salaryOffer': number;
    /**
     * Salary type: NETTO_TUTTO_COMPRESO, LORDO_MENSILE, or RAL
     * @type {string}
     * @memberof CreateOfferLetterDto
     */
    'salaryType'?: string;
    /**
     * Proposed start date (ISO 8601)
     * @type {string}
     * @memberof CreateOfferLetterDto
     */
    'startDate': string;
    /**
     * Additional offer details as JSON
     * @type {object}
     * @memberof CreateOfferLetterDto
     */
    'content'?: object;
}
/**
 * 
 * @export
 * @interface CreatePaymentMethodDto
 */
export interface CreatePaymentMethodDto {
    /**
     * 
     * @type {object}
     * @memberof CreatePaymentMethodDto
     */
    'type': object;
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentMethodDto
     */
    'description': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePaymentMethodDto
     */
    'depositable': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreatePaymentMethodDto
     */
    'tenantBankingInformationId'?: number;
}
/**
 * 
 * @export
 * @interface CreatePipelineDto
 */
export interface CreatePipelineDto {
    /**
     * Job advertisement to attach the pipeline to
     * @type {number}
     * @memberof CreatePipelineDto
     */
    'jobAdvertisementId': number;
    /**
     * Custom pipeline name (defaults to \"Default Pipeline\")
     * @type {string}
     * @memberof CreatePipelineDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CreatePopulatedSeasonDto
 */
export interface CreatePopulatedSeasonDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePopulatedSeasonDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePopulatedSeasonDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePopulatedSeasonDto
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof CreatePopulatedSeasonDto
     */
    'seasonToCopyFromId': number;
    /**
     * 
     * @type {Array<EmployeeOptions>}
     * @memberof CreatePopulatedSeasonDto
     */
    'employeesOptions': Array<EmployeeOptions>;
}
/**
 * 
 * @export
 * @interface CreateRewardsDto
 */
export interface CreateRewardsDto {
    /**
     * 
     * @type {number}
     * @memberof CreateRewardsDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardsDto
     */
    'earnedOn': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardsDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRewardsDto
     */
    'notes': string;
    /**
     * 
     * @type {number}
     * @memberof CreateRewardsDto
     */
    'contractId': number;
}
/**
 * 
 * @export
 * @interface CreateRoomAssignmentDto
 */
export interface CreateRoomAssignmentDto {
    /**
     * 
     * @type {number}
     * @memberof CreateRoomAssignmentDto
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateRoomAssignmentDto
     */
    'roomId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateRoomAssignmentDto
     */
    'seasonId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomAssignmentDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomAssignmentDto
     */
    'endDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomAssignmentDto
     */
    'notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRoomAssignmentDto
     */
    'bedIndex'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRoomAssignmentDto
     */
    'previousBookingId'?: number;
}
/**
 * 
 * @export
 * @interface CreateRoomDto
 */
export interface CreateRoomDto {
    /**
     * 
     * @type {string}
     * @memberof CreateRoomDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateRoomDto
     */
    'buildingId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateRoomDto
     */
    'maxTenants': number;
    /**
     * 
     * @type {number}
     * @memberof CreateRoomDto
     */
    'floor'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomDto
     */
    'accessMode'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRoomDto
     */
    'bathrooms'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRoomDto
     */
    'hasKitchen'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomDto
     */
    'notes'?: string;
}
/**
 * 
 * @export
 * @interface CreateSafetyAreaDto
 */
export interface CreateSafetyAreaDto {
    /**
     * The name of the safety area
     * @type {string}
     * @memberof CreateSafetyAreaDto
     */
    'name': string;
    /**
     * The ID of the associated meta safety area
     * @type {number}
     * @memberof CreateSafetyAreaDto
     */
    'metaSafetyAreaId': number;
    /**
     * The path to the safety area image
     * @type {string}
     * @memberof CreateSafetyAreaDto
     */
    'imagePath'?: string;
}
/**
 * 
 * @export
 * @interface CreateSafetyAreaItemDto
 */
export interface CreateSafetyAreaItemDto {
    /**
     * The ID of the safety area
     * @type {number}
     * @memberof CreateSafetyAreaItemDto
     */
    'safetyAreaId': number;
    /**
     * The ID of the safety item
     * @type {number}
     * @memberof CreateSafetyAreaItemDto
     */
    'safetyItemId': number;
    /**
     * The x-coordinate position on the floorplan
     * @type {number}
     * @memberof CreateSafetyAreaItemDto
     */
    'x': number;
    /**
     * The y-coordinate position on the floorplan
     * @type {number}
     * @memberof CreateSafetyAreaItemDto
     */
    'y': number;
    /**
     * The name of the safety area item
     * @type {string}
     * @memberof CreateSafetyAreaItemDto
     */
    'name'?: string;
    /**
     * The serial number of the safety item
     * @type {string}
     * @memberof CreateSafetyAreaItemDto
     */
    'serialNumber'?: string;
    /**
     * The check interval days of the safety item
     * @type {number}
     * @memberof CreateSafetyAreaItemDto
     */
    'checkIntervalDays'?: number;
    /**
     * The description of the safety area item
     * @type {string}
     * @memberof CreateSafetyAreaItemDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface CreateSafetyItemAreaChecklistItemDto
 */
export interface CreateSafetyItemAreaChecklistItemDto {
    /**
     * The ID of the checklist item (for updates)
     * @type {number}
     * @memberof CreateSafetyItemAreaChecklistItemDto
     */
    'id'?: number;
    /**
     * The ID of the safety area item (optional)
     * @type {number}
     * @memberof CreateSafetyItemAreaChecklistItemDto
     */
    'safetyItemAreaId'?: number;
    /**
     * The ID of the safety item (optional)
     * @type {number}
     * @memberof CreateSafetyItemAreaChecklistItemDto
     */
    'safetyItemId'?: number;
    /**
     * The name of the checklist item
     * @type {string}
     * @memberof CreateSafetyItemAreaChecklistItemDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateSafetyItemAreaContentDto
 */
export interface CreateSafetyItemAreaContentDto {
    /**
     * The ID of the content (for updates)
     * @type {number}
     * @memberof CreateSafetyItemAreaContentDto
     */
    'id'?: number;
    /**
     * The ID of the safety area item (optional)
     * @type {number}
     * @memberof CreateSafetyItemAreaContentDto
     */
    'safetyItemAreaId'?: number;
    /**
     * The ID of the safety item (optional)
     * @type {number}
     * @memberof CreateSafetyItemAreaContentDto
     */
    'safetyItemId'?: number;
    /**
     * The name of the item
     * @type {string}
     * @memberof CreateSafetyItemAreaContentDto
     */
    'itemName': string;
    /**
     * Whether the item is perishable
     * @type {boolean}
     * @memberof CreateSafetyItemAreaContentDto
     */
    'isPerishable': boolean;
    /**
     * The expected quantity
     * @type {number}
     * @memberof CreateSafetyItemAreaContentDto
     */
    'expectedQuantity': number;
}
/**
 * 
 * @export
 * @interface CreateSafetyItemAreaContentPeriodicCheckDto
 */
export interface CreateSafetyItemAreaContentPeriodicCheckDto {
    /**
     * 
     * @type {number}
     * @memberof CreateSafetyItemAreaContentPeriodicCheckDto
     */
    'safetyItemAreaContentId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateSafetyItemAreaContentPeriodicCheckDto
     */
    'actualQuantity': number;
    /**
     * 
     * @type {string}
     * @memberof CreateSafetyItemAreaContentPeriodicCheckDto
     */
    'expirationDate': string;
}
/**
 * 
 * @export
 * @interface CreateSafetyItemCheckIntervalDto
 */
export interface CreateSafetyItemCheckIntervalDto {
    /**
     * The ID of the safety area item (optional)
     * @type {number}
     * @memberof CreateSafetyItemCheckIntervalDto
     */
    'safetyItemAreaId'?: number;
    /**
     * The ID of the safety item (optional)
     * @type {number}
     * @memberof CreateSafetyItemCheckIntervalDto
     */
    'safetyItemId'?: number;
    /**
     * The interval in days
     * @type {number}
     * @memberof CreateSafetyItemCheckIntervalDto
     */
    'intervalDays': number;
    /**
     * The name of the interval (optional)
     * @type {string}
     * @memberof CreateSafetyItemCheckIntervalDto
     */
    'name'?: string;
    /**
     * The ID of the interval (for updates)
     * @type {number}
     * @memberof CreateSafetyItemCheckIntervalDto
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateSafetyItemDto
 */
export interface CreateSafetyItemDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSafetyItemDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSafetyItemDto
     */
    'imagePath': string;
    /**
     * 
     * @type {Array<SafetyItemCheckIntervalEntity>}
     * @memberof CreateSafetyItemDto
     */
    'safetyItemCheckInterval'?: Array<SafetyItemCheckIntervalEntity>;
    /**
     * 
     * @type {Array<SafetyItemAreaContentEntity>}
     * @memberof CreateSafetyItemDto
     */
    'safetyItemAreaContent'?: Array<SafetyItemAreaContentEntity>;
    /**
     * 
     * @type {Array<SafetyItemAreaChecklistItemEntity>}
     * @memberof CreateSafetyItemDto
     */
    'safetyItemAreaChecklistItem'?: Array<SafetyItemAreaChecklistItemEntity>;
}
/**
 * 
 * @export
 * @interface CreateSafetyPeriodicCheckDto
 */
export interface CreateSafetyPeriodicCheckDto {
    /**
     * 
     * @type {number}
     * @memberof CreateSafetyPeriodicCheckDto
     */
    'safetyAreaItemId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateSafetyPeriodicCheckDto
     */
    'checkedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSafetyPeriodicCheckDto
     */
    'notes'?: string;
    /**
     * 
     * @type {Array<CreateSafetyItemAreaContentPeriodicCheckDto>}
     * @memberof CreateSafetyPeriodicCheckDto
     */
    'contentChecks': Array<CreateSafetyItemAreaContentPeriodicCheckDto>;
    /**
     * 
     * @type {number}
     * @memberof CreateSafetyPeriodicCheckDto
     */
    'safetyItemAreaCheckIntervalId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSafetyPeriodicCheckDto
     */
    'checklistCompleted': boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateSafetyPeriodicCheckDto
     */
    'checklistItemIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface CreateSeasonDto
 */
export interface CreateSeasonDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSeasonDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSeasonDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSeasonDto
     */
    'endDate': string;
}
/**
 * 
 * @export
 * @interface CreateSectionDto
 */
export interface CreateSectionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSectionDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSectionDto
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof CreateSectionDto
     */
    'taxPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof CreateSectionDto
     */
    'departmentId': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSectionDto
     */
    'onlyToBeShowed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSectionDto
     */
    'stillCountsDepositable': boolean;
}
/**
 * 
 * @export
 * @interface CreateSegmentDto
 */
export interface CreateSegmentDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSegmentDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CreateShiftDetailDto
 */
export interface CreateShiftDetailDto {
    /**
     * 
     * @type {number}
     * @memberof CreateShiftDetailDto
     */
    'shiftId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateShiftDetailDto
     */
    'workPositionId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateShiftDetailDto
     */
    'seasonId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateShiftDetailDto
     */
    'number': number;
}
/**
 * 
 * @export
 * @interface CreateShiftDetailWithChoiceDto
 */
export interface CreateShiftDetailWithChoiceDto {
    /**
     * 
     * @type {string}
     * @memberof CreateShiftDetailWithChoiceDto
     */
    'choice': CreateShiftDetailWithChoiceDtoChoiceEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateShiftDetailWithChoiceDto
     */
    'shiftId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateShiftDetailWithChoiceDto
     */
    'workPositionId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateShiftDetailWithChoiceDto
     */
    'number': number;
    /**
     * 
     * @type {string}
     * @memberof CreateShiftDetailWithChoiceDto
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof CreateShiftDetailWithChoiceDto
     */
    'departmentId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateShiftDetailWithChoiceDto
     */
    'seasonId': number;
}

export const CreateShiftDetailWithChoiceDtoChoiceEnum = {
    Single: 'single',
    All: 'all',
    Future: 'future'
} as const;

export type CreateShiftDetailWithChoiceDtoChoiceEnum = typeof CreateShiftDetailWithChoiceDtoChoiceEnum[keyof typeof CreateShiftDetailWithChoiceDtoChoiceEnum];

/**
 * 
 * @export
 * @interface CreateShiftDto
 */
export interface CreateShiftDto {
    /**
     * 
     * @type {number}
     * @memberof CreateShiftDto
     */
    'templateId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateShiftDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateShiftDto
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof CreateShiftDto
     */
    'endTime': string;
    /**
     * 
     * @type {number}
     * @memberof CreateShiftDto
     */
    'seasonId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateShiftDto
     */
    'notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateShiftDto
     */
    'departmentId': number;
}
/**
 * 
 * @export
 * @interface CreateShiftTemplateDto
 */
export interface CreateShiftTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof CreateShiftTemplateDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateShiftTemplateDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateShiftTemplateDto
     */
    'departmentId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateShiftTemplateDto
     */
    'repeatStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShiftTemplateDto
     */
    'repeatEnd'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof CreateShiftTemplateDto
     */
    'days'?: Array<object>;
    /**
     * 
     * @type {number}
     * @memberof CreateShiftTemplateDto
     */
    'seasonId'?: number;
}
/**
 * 
 * @export
 * @interface CreateSimpleDepositDto
 */
export interface CreateSimpleDepositDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSimpleDepositDto
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof CreateSimpleDepositDto
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface CreateStatusChangeDto
 */
export interface CreateStatusChangeDto {
    /**
     * 
     * @type {number}
     * @memberof CreateStatusChangeDto
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateStatusChangeDto
     */
    'seasonId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateStatusChangeDto
     */
    'note'?: string;
    /**
     * 
     * @type {object}
     * @memberof CreateStatusChangeDto
     */
    'newStatustype': object;
    /**
     * 
     * @type {object}
     * @memberof CreateStatusChangeDto
     */
    'previousStatusType': object;
    /**
     * 
     * @type {number}
     * @memberof CreateStatusChangeDto
     */
    'newStatusId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateStatusChangeDto
     */
    'previousStatusId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateStatusChangeDto
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface CreateStatusDto
 */
export interface CreateStatusDto {
    /**
     * 
     * @type {string}
     * @memberof CreateStatusDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateStatusDto
     */
    'color': string;
}
/**
 * 
 * @export
 * @interface CreateTenantBankingInformationDto
 */
export interface CreateTenantBankingInformationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTenantBankingInformationDto
     */
    'iban'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantBankingInformationDto
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenantBankingInformationDto
     */
    'bicSwift'?: string;
}
/**
 * 
 * @export
 * @interface CreateTicketItemDto
 */
export interface CreateTicketItemDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTicketItemDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketItemDto
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof CreateTicketItemDto
     */
    'resetAtDate': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketItemDto
     */
    'resetAtValue': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketItemDto
     */
    'taxPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketItemDto
     */
    'paymentSectionId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTicketItemDto
     */
    'paymentSectionToExcludeId'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateTimeEntryDto
 */
export interface CreateTimeEntryDto {
    /**
     * 
     * @type {number}
     * @memberof CreateTimeEntryDto
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTimeEntryDto
     */
    'seasonId': number;
    /**
     * Required for DEPCHIEF permission scoping
     * @type {number}
     * @memberof CreateTimeEntryDto
     */
    'departmentId': number;
    /**
     * Clock-in time as UTC ISO-8601
     * @type {string}
     * @memberof CreateTimeEntryDto
     */
    'startedAt': string;
    /**
     * Clock-out time; omit to create a DRAFT entry
     * @type {string}
     * @memberof CreateTimeEntryDto
     */
    'endedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryDto
     */
    'clockInSource': CreateTimeEntryDtoClockInSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryDto
     */
    'clockOutSource'?: CreateTimeEntryDtoClockOutSourceEnum;
    /**
     * 
     * @type {Array<CreateBreakDto>}
     * @memberof CreateTimeEntryDto
     */
    'breaks'?: Array<CreateBreakDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryDto
     */
    'varianceNote'?: string;
    /**
     * Idempotency key for EXTERNAL source entries
     * @type {string}
     * @memberof CreateTimeEntryDto
     */
    'externalReferenceId'?: string;
}

export const CreateTimeEntryDtoClockInSourceEnum = {
    ManagerManual: 'MANAGER_MANUAL',
    MobileApp: 'MOBILE_APP',
    External: 'EXTERNAL',
    System: 'SYSTEM'
} as const;

export type CreateTimeEntryDtoClockInSourceEnum = typeof CreateTimeEntryDtoClockInSourceEnum[keyof typeof CreateTimeEntryDtoClockInSourceEnum];
export const CreateTimeEntryDtoClockOutSourceEnum = {
    ManagerManual: 'MANAGER_MANUAL',
    MobileApp: 'MOBILE_APP',
    External: 'EXTERNAL',
    System: 'SYSTEM'
} as const;

export type CreateTimeEntryDtoClockOutSourceEnum = typeof CreateTimeEntryDtoClockOutSourceEnum[keyof typeof CreateTimeEntryDtoClockOutSourceEnum];

/**
 * 
 * @export
 * @interface CreateTodoDto
 */
export interface CreateTodoDto {
    /**
     * 
     * @type {number}
     * @memberof CreateTodoDto
     */
    'employeeId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateTodoDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTodoDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateTodoDto
     */
    'statusId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTodoDto
     */
    'shiftDetailId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTodoDto
     */
    'expirationDate'?: string;
}
/**
 * 
 * @export
 * @interface CreateTodoStatusDto
 */
export interface CreateTodoStatusDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTodoStatusDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTodoStatusDto
     */
    'departmentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTodoStatusDto
     */
    'nextStatusChoiceId'?: number;
}
/**
 * 
 * @export
 * @interface CreateTrainingCourseDto
 */
export interface CreateTrainingCourseDto {
    /**
     * ID of the course type
     * @type {number}
     * @memberof CreateTrainingCourseDto
     */
    'courseTypeId': number;
    /**
     * Title of the training session
     * @type {string}
     * @memberof CreateTrainingCourseDto
     */
    'title': string;
    /**
     * Training provider / instructor
     * @type {string}
     * @memberof CreateTrainingCourseDto
     */
    'provider'?: string;
    /**
     * Training location
     * @type {string}
     * @memberof CreateTrainingCourseDto
     */
    'location'?: string;
    /**
     * Start date of the course
     * @type {string}
     * @memberof CreateTrainingCourseDto
     */
    'startDate': string;
    /**
     * End date of the course
     * @type {string}
     * @memberof CreateTrainingCourseDto
     */
    'endDate'?: string;
    /**
     * Total training hours
     * @type {number}
     * @memberof CreateTrainingCourseDto
     */
    'hours'?: number;
    /**
     * Total cost of the course session
     * @type {string}
     * @memberof CreateTrainingCourseDto
     */
    'cost'?: string;
    /**
     * Additional notes
     * @type {string}
     * @memberof CreateTrainingCourseDto
     */
    'notes'?: string;
    /**
     * Season ID to link this course to
     * @type {number}
     * @memberof CreateTrainingCourseDto
     */
    'seasonId'?: number;
    /**
     * Course status
     * @type {string}
     * @memberof CreateTrainingCourseDto
     */
    'status'?: CreateTrainingCourseDtoStatusEnum;
}

export const CreateTrainingCourseDtoStatusEnum = {
    Scheduled: 'SCHEDULED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED'
} as const;

export type CreateTrainingCourseDtoStatusEnum = typeof CreateTrainingCourseDtoStatusEnum[keyof typeof CreateTrainingCourseDtoStatusEnum];

/**
 * 
 * @export
 * @interface CreateTrainingRequirementDto
 */
export interface CreateTrainingRequirementDto {
    /**
     * ID of the course type to require
     * @type {number}
     * @memberof CreateTrainingRequirementDto
     */
    'courseTypeId': number;
    /**
     * ID of the department this requirement applies to
     * @type {number}
     * @memberof CreateTrainingRequirementDto
     */
    'departmentId'?: number;
    /**
     * ID of the work position this requirement applies to (more specific than department)
     * @type {number}
     * @memberof CreateTrainingRequirementDto
     */
    'workPositionId'?: number;
    /**
     * Whether the course is required (true) or recommended (false)
     * @type {boolean}
     * @memberof CreateTrainingRequirementDto
     */
    'isRequired'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateTurnoverItemDto
 */
export interface CreateTurnoverItemDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTurnoverItemDto
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTurnoverItemDto
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTurnoverItemDto
     */
    'paymentMethodId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateTurnoverItemDto
     */
    'paymentSectionId': number;
    /**
     * 
     * @type {object}
     * @memberof CreateTurnoverItemDto
     */
    'status': object;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTurnoverItemDto
     */
    'wasModifiedByController'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateWorkPositionDto
 */
export interface CreateWorkPositionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateWorkPositionDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateWorkPositionDto
     */
    'departmentId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateWorkPositionDto
     */
    'bossId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateWorkPositionDto
     */
    'desiredResources'?: number | null;
}
/**
 * 
 * @export
 * @interface CustomCalendarEntryTypesEntity
 */
export interface CustomCalendarEntryTypesEntity {
    /**
     * 
     * @type {number}
     * @memberof CustomCalendarEntryTypesEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CustomCalendarEntryTypesEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomCalendarEntryTypesEntity
     */
    'colour': string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomCalendarEntryTypesEntity
     */
    'countsAsDayOff': boolean;
}
/**
 * 
 * @export
 * @interface DailyAccuracyPointDto
 */
export interface DailyAccuracyPointDto {
    /**
     * 
     * @type {string}
     * @memberof DailyAccuracyPointDto
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof DailyAccuracyPointDto
     */
    'plannedShifts': number;
    /**
     * 
     * @type {number}
     * @memberof DailyAccuracyPointDto
     */
    'workedShifts': number;
    /**
     * 
     * @type {number}
     * @memberof DailyAccuracyPointDto
     */
    'missedShifts': number;
    /**
     * 
     * @type {number}
     * @memberof DailyAccuracyPointDto
     */
    'accuracyPct': number;
}
/**
 * 
 * @export
 * @interface DailyNoteEntity
 */
export interface DailyNoteEntity {
    /**
     * 
     * @type {string}
     * @memberof DailyNoteEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof DailyNoteEntity
     */
    'editedAt': string;
    /**
     * 
     * @type {number}
     * @memberof DailyNoteEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof DailyNoteEntity
     */
    'createdById': number;
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof DailyNoteEntity
     */
    'createdBy'?: EmployeeEntity;
    /**
     * 
     * @type {string}
     * @memberof DailyNoteEntity
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof DailyNoteEntity
     */
    'date': string;
    /**
     * 
     * @type {boolean}
     * @memberof DailyNoteEntity
     */
    'resolved': boolean;
    /**
     * 
     * @type {string}
     * @memberof DailyNoteEntity
     */
    'imagePath': string | null;
}
/**
 * 
 * @export
 * @interface DailySpecialNetEntity
 */
export interface DailySpecialNetEntity {
    /**
     * 
     * @type {number}
     * @memberof DailySpecialNetEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof DailySpecialNetEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof DailySpecialNetEntity
     */
    'net': number;
    /**
     * 
     * @type {string}
     * @memberof DailySpecialNetEntity
     */
    'net_encrypted': string;
    /**
     * 
     * @type {string}
     * @memberof DailySpecialNetEntity
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof DailySpecialNetEntity
     */
    'notes': string;
    /**
     * 
     * @type {string}
     * @memberof DailySpecialNetEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof DailySpecialNetEntity
     */
    'createdById': number;
    /**
     * 
     * @type {number}
     * @memberof DailySpecialNetEntity
     */
    'agreementId': number;
}
/**
 * 
 * @export
 * @interface DailyTicketEntity
 */
export interface DailyTicketEntity {
    /**
     * 
     * @type {number}
     * @memberof DailyTicketEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DailyTicketEntity
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof DailyTicketEntity
     */
    'itemId': number;
    /**
     * 
     * @type {number}
     * @memberof DailyTicketEntity
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof DailyTicketEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof DailyTicketEntity
     */
    'createdById': number;
    /**
     * 
     * @type {TicketItemEntity}
     * @memberof DailyTicketEntity
     */
    'item'?: TicketItemEntity;
}
/**
 * 
 * @export
 * @interface DailyTicketingEntity
 */
export interface DailyTicketingEntity {
    /**
     * 
     * @type {number}
     * @memberof DailyTicketingEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DailyTicketingEntity
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof DailyTicketingEntity
     */
    'itemId': number;
    /**
     * 
     * @type {number}
     * @memberof DailyTicketingEntity
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof DailyTicketingEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof DailyTicketingEntity
     */
    'createdById': number;
}
/**
 * 
 * @export
 * @interface DailyTicketingStatusEntity
 */
export interface DailyTicketingStatusEntity {
    /**
     * 
     * @type {number}
     * @memberof DailyTicketingStatusEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DailyTicketingStatusEntity
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof DailyTicketingStatusEntity
     */
    'paymentSectionId': number;
    /**
     * 
     * @type {string}
     * @memberof DailyTicketingStatusEntity
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface DailyVariancePointDto
 */
export interface DailyVariancePointDto {
    /**
     * 
     * @type {string}
     * @memberof DailyVariancePointDto
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof DailyVariancePointDto
     */
    'plannedMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof DailyVariancePointDto
     */
    'workedMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof DailyVariancePointDto
     */
    'varianceMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof DailyVariancePointDto
     */
    'costoPianificatoCents'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DailyVariancePointDto
     */
    'costoEffettivoCents'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DailyVariancePointDto
     */
    'variazioneCostoCents'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DailyVariancePointDto
     */
    'costMissingForCell': number;
}
/**
 * 
 * @export
 * @interface DateRange
 */
export interface DateRange {
    /**
     * 
     * @type {string}
     * @memberof DateRange
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof DateRange
     */
    'end': string;
}
/**
 * 
 * @export
 * @interface DateSumEntity
 */
export interface DateSumEntity {
    /**
     * 
     * @type {string}
     * @memberof DateSumEntity
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof DateSumEntity
     */
    'sum': number;
}
/**
 * 
 * @export
 * @interface DepartmentDto
 */
export interface DepartmentDto {
    /**
     * Department ID
     * @type {number}
     * @memberof DepartmentDto
     */
    'id': number;
    /**
     * Department name
     * @type {string}
     * @memberof DepartmentDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface DepartmentEmployeeEntity
 */
export interface DepartmentEmployeeEntity {
    /**
     * 
     * @type {number}
     * @memberof DepartmentEmployeeEntity
     */
    'departmentId': number;
    /**
     * 
     * @type {number}
     * @memberof DepartmentEmployeeEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof DepartmentEmployeeEntity
     */
    'employee'?: EmployeeEntity;
    /**
     * 
     * @type {number}
     * @memberof DepartmentEmployeeEntity
     */
    'workPositionId': number;
    /**
     * 
     * @type {number}
     * @memberof DepartmentEmployeeEntity
     */
    'bossDepartmentId': number | null;
    /**
     * 
     * @type {number}
     * @memberof DepartmentEmployeeEntity
     */
    'bossEmployeeId': number | null;
    /**
     * 
     * @type {number}
     * @memberof DepartmentEmployeeEntity
     */
    'bossSeasonId': number | null;
    /**
     * 
     * @type {number}
     * @memberof DepartmentEmployeeEntity
     */
    'seasonId': number;
    /**
     * 
     * @type {boolean}
     * @memberof DepartmentEmployeeEntity
     */
    'isDepartmentManager': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DepartmentEmployeeEntity
     */
    'canMakeTurnovers': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DepartmentEmployeeEntity
     */
    'canHandleSafety': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DepartmentEmployeeEntity
     */
    'canChangeTurnoversDates': boolean;
}
/**
 * 
 * @export
 * @interface DepartmentEntity
 */
export interface DepartmentEntity {
    /**
     * 
     * @type {number}
     * @memberof DepartmentEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DepartmentEntity
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof DepartmentEntity
     */
    'segmentId': number;
    /**
     * 
     * @type {SegmentEntity}
     * @memberof DepartmentEntity
     */
    'segment'?: SegmentEntity;
}
/**
 * 
 * @export
 * @interface DepartmentHoursStatisticsDto
 */
export interface DepartmentHoursStatisticsDto {
    /**
     * Department ID
     * @type {number}
     * @memberof DepartmentHoursStatisticsDto
     */
    'departmentId': number;
    /**
     * Department name
     * @type {string}
     * @memberof DepartmentHoursStatisticsDto
     */
    'departmentName': string;
    /**
     * Average daily hours per employee in this department
     * @type {number}
     * @memberof DepartmentHoursStatisticsDto
     */
    'averageDailyHours': number;
    /**
     * Total hours worked in this department for the date
     * @type {number}
     * @memberof DepartmentHoursStatisticsDto
     */
    'totalHours': number;
    /**
     * Number of employees in this department
     * @type {number}
     * @memberof DepartmentHoursStatisticsDto
     */
    'employeeCount': number;
    /**
     * Date of the latest published shift in this department (null if no published shifts exist)
     * @type {string}
     * @memberof DepartmentHoursStatisticsDto
     */
    'latestPublishedShiftDate': string | null;
    /**
     * Comparison with previous period - average daily hours (positive = increase, negative = decrease)
     * @type {number}
     * @memberof DepartmentHoursStatisticsDto
     */
    'averageDailyHoursComparison': number;
}
/**
 * 
 * @export
 * @interface DepartmentOnDutyDto
 */
export interface DepartmentOnDutyDto {
    /**
     * Department ID
     * @type {number}
     * @memberof DepartmentOnDutyDto
     */
    'departmentId': number;
    /**
     * Department name
     * @type {string}
     * @memberof DepartmentOnDutyDto
     */
    'departmentName': string;
    /**
     * Number of employees currently on duty in this department
     * @type {number}
     * @memberof DepartmentOnDutyDto
     */
    'employeesOnDuty': number;
}
/**
 * 
 * @export
 * @interface DepositEntity
 */
export interface DepositEntity {
    /**
     * 
     * @type {number}
     * @memberof DepositEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DepositEntity
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof DepositEntity
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof DepositEntity
     */
    'paymentSectionId': number;
    /**
     * 
     * @type {number}
     * @memberof DepositEntity
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof DepositEntity
     */
    'createdById': number;
    /**
     * 
     * @type {number}
     * @memberof DepositEntity
     */
    'updatedById': number;
    /**
     * 
     * @type {string}
     * @memberof DepositEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof DepositEntity
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface DocumentFileEntity
 */
export interface DocumentFileEntity {
    /**
     * 
     * @type {number}
     * @memberof DocumentFileEntity
     */
    'documentId': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentFileEntity
     */
    'filePath': string;
    /**
     * 
     * @type {number}
     * @memberof DocumentFileEntity
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface DocumentTypeEntity
 */
export interface DocumentTypeEntity {
    /**
     * 
     * @type {number}
     * @memberof DocumentTypeEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentTypeEntity
     */
    'name': string;
    /**
     * 
     * @type {Array<UsedDocumentNameEntity>}
     * @memberof DocumentTypeEntity
     */
    'usedDocumentsNames'?: Array<UsedDocumentNameEntity>;
}
/**
 * 
 * @export
 * @interface DryRunResult
 */
export interface DryRunResult {
    /**
     * 
     * @type {number}
     * @memberof DryRunResult
     */
    'totalFiles': number;
    /**
     * 
     * @type {Array<Array<FileAnalysisResult>>}
     * @memberof DryRunResult
     */
    'successfulFiles': Array<Array<FileAnalysisResult>>;
    /**
     * 
     * @type {Array<Array<FileAnalysisResult>>}
     * @memberof DryRunResult
     */
    'failedFiles': Array<Array<FileAnalysisResult>>;
    /**
     * 
     * @type {Array<Array<FileWithNetAmount>>}
     * @memberof DryRunResult
     */
    'filesWithNetAmount': Array<Array<FileWithNetAmount>>;
    /**
     * 
     * @type {DryRunResultSummary}
     * @memberof DryRunResult
     */
    'summary': DryRunResultSummary;
}
/**
 * 
 * @export
 * @interface DryRunResultSummary
 */
export interface DryRunResultSummary {
    /**
     * 
     * @type {number}
     * @memberof DryRunResultSummary
     */
    'totalProcessed'?: number;
    /**
     * 
     * @type {number}
     * @memberof DryRunResultSummary
     */
    'successful'?: number;
    /**
     * 
     * @type {number}
     * @memberof DryRunResultSummary
     */
    'failed'?: number;
    /**
     * 
     * @type {number}
     * @memberof DryRunResultSummary
     */
    'employeesAffected'?: number;
    /**
     * 
     * @type {number}
     * @memberof DryRunResultSummary
     */
    'totalNetAmount'?: number;
}
/**
 * 
 * @export
 * @interface EducationEntity
 */
export interface EducationEntity {
    /**
     * 
     * @type {string}
     * @memberof EducationEntity
     */
    'institution': string;
    /**
     * 
     * @type {string}
     * @memberof EducationEntity
     */
    'typeOfEducation': string;
    /**
     * 
     * @type {string}
     * @memberof EducationEntity
     */
    'fieldOfStudy': string;
    /**
     * 
     * @type {string}
     * @memberof EducationEntity
     */
    'dateOfCompletion': string;
}
/**
 * 
 * @export
 * @interface EmailTemplateEntity
 */
export interface EmailTemplateEntity {
    /**
     * 
     * @type {number}
     * @memberof EmailTemplateEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateEntity
     */
    'tenantId': string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateEntity
     */
    'subject': string;
    /**
     * HTML body with {{placeholder}} variables
     * @type {string}
     * @memberof EmailTemplateEntity
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateEntity
     */
    'triggerType': EmailTemplateEntityTriggerTypeEnum;
    /**
     * Pipeline stage name that triggers this email when a candidate is moved to a stage with this name
     * @type {string}
     * @memberof EmailTemplateEntity
     */
    'triggerStageName'?: string | null;
    /**
     * Days before contract date to send the email
     * @type {number}
     * @memberof EmailTemplateEntity
     */
    'triggerDaysBefore'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateEntity
     */
    'updatedAt': string;
}

export const EmailTemplateEntityTriggerTypeEnum = {
    Stage: 'STAGE',
    Rejection: 'REJECTION',
    ContractStartReminder: 'CONTRACT_START_REMINDER',
    ContractEndReminder: 'CONTRACT_END_REMINDER',
    JobInvitation: 'JOB_INVITATION'
} as const;

export type EmailTemplateEntityTriggerTypeEnum = typeof EmailTemplateEntityTriggerTypeEnum[keyof typeof EmailTemplateEntityTriggerTypeEnum];

/**
 * 
 * @export
 * @interface EmergencyContactEntity
 */
export interface EmergencyContactEntity {
    /**
     * 
     * @type {number}
     * @memberof EmergencyContactEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof EmergencyContactEntity
     */
    'additionalInformationId': number;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContactEntity
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContactEntity
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContactEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContactEntity
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContactEntity
     */
    'relation': string;
}
/**
 * 
 * @export
 * @interface EmployeeBasicInfoDto
 */
export interface EmployeeBasicInfoDto {
    /**
     * Employee ID
     * @type {number}
     * @memberof EmployeeBasicInfoDto
     */
    'id': number;
    /**
     * First name
     * @type {string}
     * @memberof EmployeeBasicInfoDto
     */
    'firstName': string;
    /**
     * Last name
     * @type {string}
     * @memberof EmployeeBasicInfoDto
     */
    'lastName': string;
    /**
     * Email
     * @type {string}
     * @memberof EmployeeBasicInfoDto
     */
    'email'?: string;
    /**
     * File path
     * @type {string}
     * @memberof EmployeeBasicInfoDto
     */
    'filePath'?: string;
    /**
     * Phone
     * @type {string}
     * @memberof EmployeeBasicInfoDto
     */
    'phone': string;
    /**
     * Date of birth
     * @type {string}
     * @memberof EmployeeBasicInfoDto
     */
    'dateOfBirth'?: string;
    /**
     * Role
     * @type {string}
     * @memberof EmployeeBasicInfoDto
     */
    'role': string;
}
/**
 * 
 * @export
 * @interface EmployeeCertificationEntity
 */
export interface EmployeeCertificationEntity {
    /**
     * 
     * @type {number}
     * @memberof EmployeeCertificationEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeCertificationEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeCertificationEntity
     */
    'courseTypeId': number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeCertificationEntity
     */
    'obtainedDate': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeCertificationEntity
     */
    'expirationDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeCertificationEntity
     */
    'certificateNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeCertificationEntity
     */
    'issuingAuthority'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeCertificationEntity
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeCertificationEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeCertificationEntity
     */
    'updatedAt': string;
    /**
     * 
     * @type {CertificationDocumentEntity}
     * @memberof EmployeeCertificationEntity
     */
    'document'?: CertificationDocumentEntity;
}
/**
 * 
 * @export
 * @interface EmployeeDocumentEntity
 */
export interface EmployeeDocumentEntity {
    /**
     * 
     * @type {number}
     * @memberof EmployeeDocumentEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDocumentEntity
     */
    'documentName': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDocumentEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDocumentEntity
     */
    'typeName': string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeDocumentEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeDocumentEntity
     */
    'certificationId': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeDocumentEntity
     */
    'isVisibleForUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeDocumentEntity
     */
    'isEncrypted': boolean;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDocumentEntity
     */
    'expiringDate': string | null;
    /**
     * 
     * @type {Array<DocumentFileEntity>}
     * @memberof EmployeeDocumentEntity
     */
    'documentFiles'?: Array<DocumentFileEntity>;
}
/**
 * 
 * @export
 * @interface EmployeeEntity
 */
export interface EmployeeEntity {
    /**
     * 
     * @type {string}
     * @memberof EmployeeEntity
     */
    'role': EmployeeEntityRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof EmployeeEntity
     */
    'gender': EmployeeEntityGenderEnum;
    /**
     * 
     * @type {number}
     * @memberof EmployeeEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeEntity
     */
    'filePath': string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeEntity
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeEntity
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeEntity
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeEntity
     */
    'dateOfBirth': string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeEntity
     */
    'countryOfBirth': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeEntity
     */
    'provinceOfBirth': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeEntity
     */
    'townshipOfBirth': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeEntity
     */
    'taxcode': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeEntity
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeEntity
     */
    'currentExpoToken': string;
    /**
     * 
     * @type {BankingInformationEntity}
     * @memberof EmployeeEntity
     */
    'bankingInformation'?: BankingInformationEntity | null;
    /**
     * 
     * @type {Array<EmployeeDocumentEntity>}
     * @memberof EmployeeEntity
     */
    'documents'?: Array<EmployeeDocumentEntity> | null;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeEntity
     */
    'isIncomplete'?: boolean;
    /**
     * 
     * @type {Array<AgreementEntity>}
     * @memberof EmployeeEntity
     */
    'agreements'?: Array<AgreementEntity> | null;
    /**
     * 
     * @type {Array<NoteEntity>}
     * @memberof EmployeeEntity
     */
    'notes'?: Array<NoteEntity> | null;
    /**
     * 
     * @type {Array<CommunicationEntity>}
     * @memberof EmployeeEntity
     */
    'communications'?: Array<CommunicationEntity> | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeEntity
     */
    'lastPayment': string | null;
    /**
     * 
     * @type {RoomEntity}
     * @memberof EmployeeEntity
     */
    'room'?: RoomEntity;
    /**
     * 
     * @type {number}
     * @memberof EmployeeEntity
     */
    'seasonId': number | null;
    /**
     * 
     * @type {Array<PaymentEntity>}
     * @memberof EmployeeEntity
     */
    'payments'?: Array<PaymentEntity> | null;
    /**
     * 
     * @type {Array<EmployeeToSeasonEntity>}
     * @memberof EmployeeEntity
     */
    'employeesToSeasons'?: Array<EmployeeToSeasonEntity> | null;
    /**
     * 
     * @type {Array<EmployeesToDepartmentsEntity>}
     * @memberof EmployeeEntity
     */
    'employeesToDepartments'?: Array<EmployeesToDepartmentsEntity> | null;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeEntity
     */
    'canSeeDocuments': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeEntity
     */
    'canViewShifts': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeEntity
     */
    'hasResponded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeEntity
     */
    'hasConfirmed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeEntity
     */
    'hasBeenAsked'?: boolean;
}

export const EmployeeEntityRoleEnum = {
    User: 'USER',
    Manager: 'MANAGER',
    Owner: 'OWNER',
    Developer: 'DEVELOPER',
    Depchief: 'DEPCHIEF',
    Termsnotaccepted: 'TERMSNOTACCEPTED',
    Controller: 'CONTROLLER'
} as const;

export type EmployeeEntityRoleEnum = typeof EmployeeEntityRoleEnum[keyof typeof EmployeeEntityRoleEnum];
export const EmployeeEntityGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Undefined: 'UNDEFINED'
} as const;

export type EmployeeEntityGenderEnum = typeof EmployeeEntityGenderEnum[keyof typeof EmployeeEntityGenderEnum];

/**
 * 
 * @export
 * @interface EmployeeHoursDailyDto
 */
export interface EmployeeHoursDailyDto {
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof EmployeeHoursDailyDto
     */
    'employee': EmployeeEntity;
    /**
     * 
     * @type {string}
     * @memberof EmployeeHoursDailyDto
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeHoursDailyDto
     */
    'totalMinutes': number;
}
/**
 * 
 * @export
 * @interface EmployeeHoursDto
 */
export interface EmployeeHoursDto {
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof EmployeeHoursDto
     */
    'employee': EmployeeEntity;
    /**
     * 
     * @type {number}
     * @memberof EmployeeHoursDto
     */
    'totalMinutes': number;
}
/**
 * 
 * @export
 * @interface EmployeeOptions
 */
export interface EmployeeOptions {
    /**
     * 
     * @type {number}
     * @memberof EmployeeOptions
     */
    'employeeId': number;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeOptions
     */
    'room': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeOptions
     */
    'position': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeOptions
     */
    'status': boolean;
}
/**
 * 
 * @export
 * @interface EmployeePeriodSummaryDto
 */
export interface EmployeePeriodSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'employeeId': number;
    /**
     * 
     * @type {string}
     * @memberof EmployeePeriodSummaryDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeePeriodSummaryDto
     */
    'lastName': string;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'totalWorkedMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'plannedMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'overtimeMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'contractualMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'expectedMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'missedShiftCount': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'daysOff': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'lateInCount': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'earlyOutCount': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'absenceMinutesVacation': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'absenceMinutesIllness': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'absenceMinutesUnpaidLeave': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'absenceMinutesHolidays': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'absenceMinutesOther': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'publicHolidayCount': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'costPerHourCents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeePeriodSummaryDto
     */
    'costPerHourEncrypted'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'costoPianificatoCents'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'costoEffettivoCents'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'costoStraordinarioCents'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EmployeePeriodSummaryDto
     */
    'variazioneCostoCents'?: number | null;
}
/**
 * 
 * @export
 * @interface EmployeeResultDto
 */
export interface EmployeeResultDto {
    /**
     * Employee ID
     * @type {number}
     * @memberof EmployeeResultDto
     */
    'employeeId': number;
    /**
     * Whether the employee passed the course
     * @type {boolean}
     * @memberof EmployeeResultDto
     */
    'passed': boolean;
}
/**
 * 
 * @export
 * @interface EmployeeRoomAssignmentEntity
 */
export interface EmployeeRoomAssignmentEntity {
    /**
     * 
     * @type {number}
     * @memberof EmployeeRoomAssignmentEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeRoomAssignmentEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeRoomAssignmentEntity
     */
    'roomId': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeRoomAssignmentEntity
     */
    'seasonId': number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeRoomAssignmentEntity
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeRoomAssignmentEntity
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeRoomAssignmentEntity
     */
    'bedIndex': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeRoomAssignmentEntity
     */
    'previousBookingId': number | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeRoomAssignmentEntity
     */
    'notes': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeRoomAssignmentEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeRoomAssignmentEntity
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface EmployeeStatsDto
 */
export interface EmployeeStatsDto {
    /**
     * Unpaid leave days
     * @type {number}
     * @memberof EmployeeStatsDto
     */
    'unpaidLeave': number;
    /**
     * Ill days
     * @type {number}
     * @memberof EmployeeStatsDto
     */
    'ill': number;
    /**
     * Vacation days
     * @type {number}
     * @memberof EmployeeStatsDto
     */
    'vacation': number;
    /**
     * Seniority information
     * @type {object}
     * @memberof EmployeeStatsDto
     */
    'seniority': object;
}
/**
 * 
 * @export
 * @interface EmployeeToSeasonEntity
 */
export interface EmployeeToSeasonEntity {
    /**
     * 
     * @type {string}
     * @memberof EmployeeToSeasonEntity
     */
    'statusType': EmployeeToSeasonEntityStatusTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof EmployeeToSeasonEntity
     */
    'seasonId': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeToSeasonEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof EmployeeToSeasonEntity
     */
    'employee'?: EmployeeEntity;
    /**
     * 
     * @type {number}
     * @memberof EmployeeToSeasonEntity
     */
    'roomId': number | null;
    /**
     * 
     * @type {number}
     * @memberof EmployeeToSeasonEntity
     */
    'contractId': number | null;
    /**
     * 
     * @type {number}
     * @memberof EmployeeToSeasonEntity
     */
    'statusId': number | null;
    /**
     * 
     * @type {ContractEntity}
     * @memberof EmployeeToSeasonEntity
     */
    'contract'?: ContractEntity | null;
    /**
     * 
     * @type {StatusEntity}
     * @memberof EmployeeToSeasonEntity
     */
    'status'?: StatusEntity | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeToSeasonEntity
     */
    'notes': string;
    /**
     * 
     * @type {SeasonEntity}
     * @memberof EmployeeToSeasonEntity
     */
    'season'?: SeasonEntity | null;
}

export const EmployeeToSeasonEntityStatusTypeEnum = {
    Candidate: 'CANDIDATE',
    Active: 'ACTIVE',
    Terminated: 'TERMINATED',
    Custom: 'CUSTOM'
} as const;

export type EmployeeToSeasonEntityStatusTypeEnum = typeof EmployeeToSeasonEntityStatusTypeEnum[keyof typeof EmployeeToSeasonEntityStatusTypeEnum];

/**
 * 
 * @export
 * @interface EmployeeWeeklyHoursBulkDto
 */
export interface EmployeeWeeklyHoursBulkDto {
    /**
     * Array of employee IDs to fetch weekly hours for
     * @type {Array<number>}
     * @memberof EmployeeWeeklyHoursBulkDto
     */
    'employeeIds': Array<number>;
    /**
     * Date within the week to calculate hours for (any date in the week works)
     * @type {string}
     * @memberof EmployeeWeeklyHoursBulkDto
     */
    'date': string;
    /**
     * Season ID
     * @type {number}
     * @memberof EmployeeWeeklyHoursBulkDto
     */
    'seasonId': number;
    /**
     * Optional department ID for DEPCHIEF access validation
     * @type {number}
     * @memberof EmployeeWeeklyHoursBulkDto
     */
    'departmentId'?: number;
}
/**
 * 
 * @export
 * @interface EmployeeWeeklyHoursResponseDto
 */
export interface EmployeeWeeklyHoursResponseDto {
    /**
     * Employee ID
     * @type {number}
     * @memberof EmployeeWeeklyHoursResponseDto
     */
    'employeeId': number;
    /**
     * Total hours worked in the week
     * @type {number}
     * @memberof EmployeeWeeklyHoursResponseDto
     */
    'hours': number;
}
/**
 * 
 * @export
 * @interface EmployeesDepartmentEntity
 */
export interface EmployeesDepartmentEntity {
    /**
     * 
     * @type {number}
     * @memberof EmployeesDepartmentEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof EmployeesDepartmentEntity
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof EmployeesDepartmentEntity
     */
    'segmentId': number;
    /**
     * 
     * @type {SegmentEntity}
     * @memberof EmployeesDepartmentEntity
     */
    'segment'?: SegmentEntity;
}
/**
 * 
 * @export
 * @interface EmployeesToDepartmentsEntity
 */
export interface EmployeesToDepartmentsEntity {
    /**
     * 
     * @type {number}
     * @memberof EmployeesToDepartmentsEntity
     */
    'departmentId'?: number;
    /**
     * 
     * @type {DepartmentEntity}
     * @memberof EmployeesToDepartmentsEntity
     */
    'department'?: DepartmentEntity | null;
    /**
     * 
     * @type {number}
     * @memberof EmployeesToDepartmentsEntity
     */
    'seasonId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeesToDepartmentsEntity
     */
    'isDepartmentManager': boolean;
    /**
     * 
     * @type {SimpleWorkPositionEntity}
     * @memberof EmployeesToDepartmentsEntity
     */
    'workPosition'?: SimpleWorkPositionEntity | null;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeesToDepartmentsEntity
     */
    'canMakeTurnovers': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeesToDepartmentsEntity
     */
    'canHandleSafety': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeesToDepartmentsEntity
     */
    'canChangeTurnoversDates': boolean;
}
/**
 * 
 * @export
 * @interface EnrollEmployeesDto
 */
export interface EnrollEmployeesDto {
    /**
     * Array of employee IDs to enroll
     * @type {Array<number>}
     * @memberof EnrollEmployeesDto
     */
    'employeeIds': Array<number>;
}
/**
 * 
 * @export
 * @interface ExperienceLevelEntity
 */
export interface ExperienceLevelEntity {
    /**
     * 
     * @type {number}
     * @memberof ExperienceLevelEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ExperienceLevelEntity
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ExpiringCertificationDto
 */
export interface ExpiringCertificationDto {
    /**
     * 
     * @type {number}
     * @memberof ExpiringCertificationDto
     */
    'certificationId': number;
    /**
     * 
     * @type {number}
     * @memberof ExpiringCertificationDto
     */
    'employeeId': number;
    /**
     * 
     * @type {string}
     * @memberof ExpiringCertificationDto
     */
    'employeeName': string;
    /**
     * 
     * @type {string}
     * @memberof ExpiringCertificationDto
     */
    'courseTypeName': string;
    /**
     * 
     * @type {number}
     * @memberof ExpiringCertificationDto
     */
    'courseTypeId': number;
    /**
     * 
     * @type {string}
     * @memberof ExpiringCertificationDto
     */
    'departmentName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ExpiringCertificationDto
     */
    'expirationDate': string;
    /**
     * Days until expiration (negative = already expired)
     * @type {number}
     * @memberof ExpiringCertificationDto
     */
    'daysRemaining': number;
}
/**
 * 
 * @export
 * @interface ExtendedCreateSectionDto
 */
export interface ExtendedCreateSectionDto {
    /**
     * 
     * @type {CreateSectionDto}
     * @memberof ExtendedCreateSectionDto
     */
    'sectionData': CreateSectionDto;
    /**
     * 
     * @type {Array<PaymentMethodEntity>}
     * @memberof ExtendedCreateSectionDto
     */
    'paymentMethods': Array<PaymentMethodEntity>;
}
/**
 * 
 * @export
 * @interface ExtendedUpdateSectionDto
 */
export interface ExtendedUpdateSectionDto {
    /**
     * 
     * @type {UpdateSectionDto}
     * @memberof ExtendedUpdateSectionDto
     */
    'sectionData': UpdateSectionDto;
    /**
     * 
     * @type {Array<PaymentMethodEntity>}
     * @memberof ExtendedUpdateSectionDto
     */
    'paymentMethods': Array<PaymentMethodEntity>;
}
/**
 * 
 * @export
 * @interface FileAnalysisResult
 */
export interface FileAnalysisResult {
    /**
     * 
     * @type {string}
     * @memberof FileAnalysisResult
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof FileAnalysisResult
     */
    'status': FileAnalysisResultStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof FileAnalysisResult
     */
    'taxCode'?: string;
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof FileAnalysisResult
     */
    'employee'?: EmployeeEntity;
    /**
     * 
     * @type {number}
     * @memberof FileAnalysisResult
     */
    'netAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileAnalysisResult
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileAnalysisResult
     */
    'documentName'?: string;
}

export const FileAnalysisResultStatusEnum = {
    Success: 'SUCCESS',
    TaxCodeNotFound: 'TAX_CODE_NOT_FOUND',
    EmployeeNotFound: 'EMPLOYEE_NOT_FOUND',
    OcrFailed: 'OCR_FAILED',
    NetExtractionFailed: 'NET_EXTRACTION_FAILED',
    ProcessingError: 'PROCESSING_ERROR'
} as const;

export type FileAnalysisResultStatusEnum = typeof FileAnalysisResultStatusEnum[keyof typeof FileAnalysisResultStatusEnum];

/**
 * 
 * @export
 * @interface FileEntity
 */
export interface FileEntity {
    /**
     * 
     * @type {string}
     * @memberof FileEntity
     */
    'filePath': string;
}
/**
 * 
 * @export
 * @interface FileWithNetAmount
 */
export interface FileWithNetAmount {
    /**
     * 
     * @type {string}
     * @memberof FileWithNetAmount
     */
    'fileName': string;
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof FileWithNetAmount
     */
    'employee': EmployeeEntity;
    /**
     * 
     * @type {number}
     * @memberof FileWithNetAmount
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface FindByDateRangeDto
 */
export interface FindByDateRangeDto {
    /**
     * Start date of the range (ISO date string)
     * @type {string}
     * @memberof FindByDateRangeDto
     */
    'startDate': string;
    /**
     * End date of the range (ISO date string)
     * @type {string}
     * @memberof FindByDateRangeDto
     */
    'endDate': string;
    /**
     * Department ID
     * @type {number}
     * @memberof FindByDateRangeDto
     */
    'departmentId': number;
    /**
     * Season ID
     * @type {number}
     * @memberof FindByDateRangeDto
     */
    'seasonId': number;
}
/**
 * 
 * @export
 * @interface FindByEmployeesDto
 */
export interface FindByEmployeesDto {
    /**
     * Array of employee IDs to fetch agreements for
     * @type {Array<number>}
     * @memberof FindByEmployeesDto
     */
    'employeeIds': Array<number>;
    /**
     * Season ID
     * @type {number}
     * @memberof FindByEmployeesDto
     */
    'seasonId': number;
    /**
     * Optional contract ID to filter agreements
     * @type {number}
     * @memberof FindByEmployeesDto
     */
    'contractId'?: number;
    /**
     * Optional department ID for additional filtering
     * @type {number}
     * @memberof FindByEmployeesDto
     */
    'departmentId'?: number;
}
/**
 * 
 * @export
 * @interface FunnelDto
 */
export interface FunnelDto {
    /**
     * 
     * @type {number}
     * @memberof FunnelDto
     */
    'applied': number;
    /**
     * 
     * @type {number}
     * @memberof FunnelDto
     */
    'interview': number;
    /**
     * 
     * @type {number}
     * @memberof FunnelDto
     */
    'hired': number;
    /**
     * Percentage of applied that reached interview
     * @type {number}
     * @memberof FunnelDto
     */
    'appliedToInterview': number;
    /**
     * Percentage of interviews that resulted in hire
     * @type {number}
     * @memberof FunnelDto
     */
    'interviewToHired': number;
    /**
     * Overall conversion from applied to hired
     * @type {number}
     * @memberof FunnelDto
     */
    'overallConversion': number;
}
/**
 * 
 * @export
 * @interface GenerateTokenDto
 */
export interface GenerateTokenDto {
    /**
     * 
     * @type {string}
     * @memberof GenerateTokenDto
     */
    'language': GenerateTokenDtoLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof GenerateTokenDto
     */
    'type': GenerateTokenDtoTypeEnum;
}

export const GenerateTokenDtoLanguageEnum = {
    En: 'EN',
    It: 'IT',
    De: 'DE',
    Fr: 'FR'
} as const;

export type GenerateTokenDtoLanguageEnum = typeof GenerateTokenDtoLanguageEnum[keyof typeof GenerateTokenDtoLanguageEnum];
export const GenerateTokenDtoTypeEnum = {
    CompleteDataRequest: 'COMPLETE_DATA_REQUEST',
    ResetPassword: 'RESET_PASSWORD',
    PreContractSign: 'PRE_CONTRACT_SIGN'
} as const;

export type GenerateTokenDtoTypeEnum = typeof GenerateTokenDtoTypeEnum[keyof typeof GenerateTokenDtoTypeEnum];

/**
 * 
 * @export
 * @interface GetUserVacationDto
 */
export interface GetUserVacationDto {
    /**
     * Array of agreements with vacation configurations
     * @type {Array<UserVacationAgreementDto>}
     * @memberof GetUserVacationDto
     */
    'agreements': Array<UserVacationAgreementDto>;
    /**
     * Total number of agreements found
     * @type {number}
     * @memberof GetUserVacationDto
     */
    'totalAgreements': number;
}
/**
 * 
 * @export
 * @interface GoogleCallbackMobileRequest
 */
export interface GoogleCallbackMobileRequest {
    /**
     * 
     * @type {string}
     * @memberof GoogleCallbackMobileRequest
     */
    'idToken': string;
}
/**
 * 
 * @export
 * @interface HiringPipelineEntity
 */
export interface HiringPipelineEntity {
    /**
     * 
     * @type {number}
     * @memberof HiringPipelineEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof HiringPipelineEntity
     */
    'tenantId': string;
    /**
     * 
     * @type {number}
     * @memberof HiringPipelineEntity
     */
    'jobAdvertisementId': number;
    /**
     * 
     * @type {string}
     * @memberof HiringPipelineEntity
     */
    'name': string;
    /**
     * 
     * @type {Array<PipelineStageEntity>}
     * @memberof HiringPipelineEntity
     */
    'stages'?: Array<PipelineStageEntity>;
    /**
     * 
     * @type {string}
     * @memberof HiringPipelineEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof HiringPipelineEntity
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface IncompleteChecklistDto
 */
export interface IncompleteChecklistDto {
    /**
     * 
     * @type {number}
     * @memberof IncompleteChecklistDto
     */
    'checkId': number;
    /**
     * 
     * @type {string}
     * @memberof IncompleteChecklistDto
     */
    'checkedAt': string;
    /**
     * 
     * @type {string}
     * @memberof IncompleteChecklistDto
     */
    'itemName': string;
    /**
     * 
     * @type {string}
     * @memberof IncompleteChecklistDto
     */
    'areaName': string;
    /**
     * 
     * @type {string}
     * @memberof IncompleteChecklistDto
     */
    'metaAreaName': string;
    /**
     * 
     * @type {number}
     * @memberof IncompleteChecklistDto
     */
    'totalItems': number;
    /**
     * 
     * @type {number}
     * @memberof IncompleteChecklistDto
     */
    'completedItems': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof IncompleteChecklistDto
     */
    'incompleteItems': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof IncompleteChecklistDto
     */
    'checkedBy': string;
    /**
     * 
     * @type {number}
     * @memberof IncompleteChecklistDto
     */
    'safetyAreaItemId': number;
    /**
     * 
     * @type {number}
     * @memberof IncompleteChecklistDto
     */
    'areaId': number;
    /**
     * 
     * @type {number}
     * @memberof IncompleteChecklistDto
     */
    'metaAreaId': number;
}
/**
 * 
 * @export
 * @interface IntervalEmployeeCountDto
 */
export interface IntervalEmployeeCountDto {
    /**
     * Time interval in format HH:MM (15-minute intervals)
     * @type {string}
     * @memberof IntervalEmployeeCountDto
     */
    'time': string;
    /**
     * Average number of employees on duty during this 15-minute interval across the period
     * @type {number}
     * @memberof IntervalEmployeeCountDto
     */
    'averageEmployeeCount': number;
}
/**
 * 
 * @export
 * @interface InterviewEntity
 */
export interface InterviewEntity {
    /**
     * 
     * @type {number}
     * @memberof InterviewEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof InterviewEntity
     */
    'applicationId': number;
    /**
     * 
     * @type {number}
     * @memberof InterviewEntity
     */
    'calendarEntryId'?: number | null;
    /**
     * Interview type, e.g. PHONE, VIDEO, ONSITE
     * @type {string}
     * @memberof InterviewEntity
     */
    'type': string;
    /**
     * Interview status, e.g. SCHEDULED, COMPLETED, CANCELLED
     * @type {string}
     * @memberof InterviewEntity
     */
    'status': string;
    /**
     * Optional notes about the interview
     * @type {string}
     * @memberof InterviewEntity
     */
    'notes'?: string | null;
    /**
     * Optional video conference link
     * @type {string}
     * @memberof InterviewEntity
     */
    'videoLink'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InterviewEntity
     */
    'scheduledAt': string;
    /**
     * 
     * @type {string}
     * @memberof InterviewEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof InterviewEntity
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface InviteToJobDto
 */
export interface InviteToJobDto {
    /**
     * ID of the candidate to invite
     * @type {number}
     * @memberof InviteToJobDto
     */
    'candidateId': number;
    /**
     * ID of the job advertisement to invite the candidate to
     * @type {number}
     * @memberof InviteToJobDto
     */
    'jobAdvertisementsId': number;
    /**
     * ID of the JOB_INVITATION email template to use
     * @type {number}
     * @memberof InviteToJobDto
     */
    'emailTemplateId': number;
}
/**
 * 
 * @export
 * @interface IssuePreContractDto
 */
export interface IssuePreContractDto {
    /**
     * 
     * @type {number}
     * @memberof IssuePreContractDto
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof IssuePreContractDto
     */
    'contractId'?: number;
    /**
     * When true, also create a Token + send the email. False = generate snapshot only (status DRAFT).
     * @type {boolean}
     * @memberof IssuePreContractDto
     */
    'sendEmail'?: boolean;
    /**
     * \"IT\" | \"EN\" | \"DE\" — falls back to employee.language or IT
     * @type {string}
     * @memberof IssuePreContractDto
     */
    'language'?: string;
}
/**
 * 
 * @export
 * @interface JobEntity
 */
export interface JobEntity {
    /**
     * 
     * @type {number}
     * @memberof JobEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'descriptionEn': string | null;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'descriptionIt': string | null;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'descriptionDe': string | null;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'descriptionFr': string | null;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof JobEntity
     */
    'isPublic': boolean;
    /**
     * 
     * @type {number}
     * @memberof JobEntity
     */
    'workPositionId': number;
    /**
     * 
     * @type {number}
     * @memberof JobEntity
     */
    'departmentId': number;
    /**
     * 
     * @type {number}
     * @memberof JobEntity
     */
    'seasonId': number;
    /**
     * 
     * @type {number}
     * @memberof JobEntity
     */
    'salaryMin': number;
    /**
     * 
     * @type {number}
     * @memberof JobEntity
     */
    'salaryMax': number;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'requirements': string;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'requirementsEn': string | null;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'requirementsIt': string | null;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'requirementsDe': string | null;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'requirementsFr': string | null;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'jobType': string;
    /**
     * 
     * @type {string}
     * @memberof JobEntity
     */
    'deadline': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobEntity
     */
    'images': Array<string>;
}
/**
 * 
 * @export
 * @interface JobExperienceEntity
 */
export interface JobExperienceEntity {
    /**
     * 
     * @type {string}
     * @memberof JobExperienceEntity
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof JobExperienceEntity
     */
    'jobPosition': string;
    /**
     * 
     * @type {string}
     * @memberof JobExperienceEntity
     */
    'address': string;
    /**
     * 
     * @type {JobExperienceEntityPeriod}
     * @memberof JobExperienceEntity
     */
    'period': JobExperienceEntityPeriod;
}
/**
 * 
 * @export
 * @interface JobExperienceEntityPeriod
 */
export interface JobExperienceEntityPeriod {
    /**
     * 
     * @type {string}
     * @memberof JobExperienceEntityPeriod
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof JobExperienceEntityPeriod
     */
    'end'?: string;
}
/**
 * 
 * @export
 * @interface LaborHoursVarianceResponseDto
 */
export interface LaborHoursVarianceResponseDto {
    /**
     * 
     * @type {Array<DailyVariancePointDto>}
     * @memberof LaborHoursVarianceResponseDto
     */
    'daily': Array<DailyVariancePointDto>;
    /**
     * 
     * @type {number}
     * @memberof LaborHoursVarianceResponseDto
     */
    'totalPlannedMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof LaborHoursVarianceResponseDto
     */
    'totalWorkedMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof LaborHoursVarianceResponseDto
     */
    'totalVarianceMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof LaborHoursVarianceResponseDto
     */
    'totalCostoPianificatoCents'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LaborHoursVarianceResponseDto
     */
    'totalCostoEffettivoCents'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LaborHoursVarianceResponseDto
     */
    'totalVariazioneCostoCents'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LaborHoursVarianceResponseDto
     */
    'costMissingForRows': number;
}
/**
 * 
 * @export
 * @interface LicenceEntity
 */
export interface LicenceEntity {
    /**
     * 
     * @type {number}
     * @memberof LicenceEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof LicenceEntity
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface LoginDto
 */
export interface LoginDto {
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface MarkCandidateViewedDto
 */
export interface MarkCandidateViewedDto {
    /**
     * The application ID that was viewed
     * @type {number}
     * @memberof MarkCandidateViewedDto
     */
    'applicationId': number;
}
/**
 * 
 * @export
 * @interface MetaSafetyAreaEntity
 */
export interface MetaSafetyAreaEntity {
    /**
     * The unique identifier of the meta safety area
     * @type {number}
     * @memberof MetaSafetyAreaEntity
     */
    'id': number;
    /**
     * The name of the meta safety area
     * @type {string}
     * @memberof MetaSafetyAreaEntity
     */
    'name': string;
    /**
     * The creation date of the meta safety area
     * @type {string}
     * @memberof MetaSafetyAreaEntity
     */
    'createdAt': string;
    /**
     * The last update date of the meta safety area
     * @type {string}
     * @memberof MetaSafetyAreaEntity
     */
    'updatedAt': string;
    /**
     * The safety areas associated with this meta safety area
     * @type {Array<SafetyAreaEntity>}
     * @memberof MetaSafetyAreaEntity
     */
    'safetyArea'?: Array<SafetyAreaEntity>;
}
/**
 * 
 * @export
 * @interface MigrateLegacyDocsResultDto
 */
export interface MigrateLegacyDocsResultDto {
    /**
     * 
     * @type {number}
     * @memberof MigrateLegacyDocsResultDto
     */
    'migrated': number;
    /**
     * 
     * @type {number}
     * @memberof MigrateLegacyDocsResultDto
     */
    'skipped': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MigrateLegacyDocsResultDto
     */
    'details': Array<string>;
}
/**
 * 
 * @export
 * @interface MissingCertificationDto
 */
export interface MissingCertificationDto {
    /**
     * 
     * @type {number}
     * @memberof MissingCertificationDto
     */
    'employeeId': number;
    /**
     * 
     * @type {string}
     * @memberof MissingCertificationDto
     */
    'employeeName': string;
    /**
     * 
     * @type {string}
     * @memberof MissingCertificationDto
     */
    'departmentName': string;
    /**
     * 
     * @type {number}
     * @memberof MissingCertificationDto
     */
    'missingCourseTypeId': number;
    /**
     * 
     * @type {string}
     * @memberof MissingCertificationDto
     */
    'missingCourseTypeName': string;
}
/**
 * 
 * @export
 * @interface MissingItemDto
 */
export interface MissingItemDto {
    /**
     * 
     * @type {number}
     * @memberof MissingItemDto
     */
    'checkId': number;
    /**
     * 
     * @type {string}
     * @memberof MissingItemDto
     */
    'checkedAt': string;
    /**
     * 
     * @type {string}
     * @memberof MissingItemDto
     */
    'itemName': string;
    /**
     * 
     * @type {string}
     * @memberof MissingItemDto
     */
    'areaName': string;
    /**
     * 
     * @type {string}
     * @memberof MissingItemDto
     */
    'metaAreaName': string;
    /**
     * 
     * @type {string}
     * @memberof MissingItemDto
     */
    'contentName': string;
    /**
     * 
     * @type {number}
     * @memberof MissingItemDto
     */
    'expectedQuantity': number;
    /**
     * 
     * @type {number}
     * @memberof MissingItemDto
     */
    'actualQuantity': number;
    /**
     * 
     * @type {string}
     * @memberof MissingItemDto
     */
    'checkedBy': string;
    /**
     * 
     * @type {number}
     * @memberof MissingItemDto
     */
    'safetyAreaItemId': number;
    /**
     * 
     * @type {number}
     * @memberof MissingItemDto
     */
    'areaId': number;
    /**
     * 
     * @type {number}
     * @memberof MissingItemDto
     */
    'metaAreaId': number;
}
/**
 * 
 * @export
 * @interface MonthlyExportBodyDto
 */
export interface MonthlyExportBodyDto {
    /**
     * Optional map of employeeId → costPerHourCents (frontend-decrypted). Merged on top of plain DB values.
     * @type {object}
     * @memberof MonthlyExportBodyDto
     */
    'decryptedCostCentsByEmployee'?: object;
}
/**
 * 
 * @export
 * @interface MoveApplicationDto
 */
export interface MoveApplicationDto {
    /**
     * The application to move
     * @type {number}
     * @memberof MoveApplicationDto
     */
    'applicationId': number;
    /**
     * Target pipeline stage ID
     * @type {number}
     * @memberof MoveApplicationDto
     */
    'stageId': number;
    /**
     * Skip sending automated emails for this stage move
     * @type {boolean}
     * @memberof MoveApplicationDto
     */
    'skipEmail'?: boolean;
}
/**
 * 
 * @export
 * @interface MoveApplicationStageDto
 */
export interface MoveApplicationStageDto {
    /**
     * The application to move to a new stage
     * @type {number}
     * @memberof MoveApplicationStageDto
     */
    'applicationId': number;
    /**
     * The target pipeline stage ID
     * @type {number}
     * @memberof MoveApplicationStageDto
     */
    'newStageId': number;
}
/**
 * 
 * @export
 * @interface NetArrayElementEntity
 */
export interface NetArrayElementEntity {
    /**
     * 
     * @type {number}
     * @memberof NetArrayElementEntity
     */
    'amount': number;
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof NetArrayElementEntity
     */
    'employee': EmployeeEntity;
}
/**
 * 
 * @export
 * @interface NoteEntity
 */
export interface NoteEntity {
    /**
     * 
     * @type {number}
     * @memberof NoteEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof NoteEntity
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof NoteEntity
     */
    'text_encrypted': string;
    /**
     * 
     * @type {boolean}
     * @memberof NoteEntity
     */
    'hidden': boolean;
    /**
     * 
     * @type {string}
     * @memberof NoteEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof NoteEntity
     */
    'editedAt': string;
    /**
     * 
     * @type {number}
     * @memberof NoteEntity
     */
    'authorId': number;
    /**
     * 
     * @type {number}
     * @memberof NoteEntity
     */
    'employeeId': number;
}
/**
 * 
 * @export
 * @interface NotificationEntity
 */
export interface NotificationEntity {
    /**
     * 
     * @type {string}
     * @memberof NotificationEntity
     */
    'type': NotificationEntityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationEntity
     */
    'role': NotificationEntityRoleEnum;
    /**
     * 
     * @type {number}
     * @memberof NotificationEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof NotificationEntity
     */
    'daysUntilExpiry': number;
    /**
     * 
     * @type {string}
     * @memberof NotificationEntity
     */
    'employeeName': string;
    /**
     * 
     * @type {number}
     * @memberof NotificationEntity
     */
    'receiverEmployeeId': number | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationEntity
     */
    'sentAt': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationEntity
     */
    'text': string;
}

export const NotificationEntityTypeEnum = {
    Birthday: 'BIRTHDAY',
    Anniversary: 'ANNIVERSARY',
    Expiring: 'EXPIRING',
    Completedprofile: 'COMPLETEDPROFILE',
    Expiringdocument: 'EXPIRINGDOCUMENT',
    Expiringcertification: 'EXPIRINGCERTIFICATION',
    Startingcontract: 'STARTINGCONTRACT',
    Custom: 'CUSTOM',
    Dailyarrival: 'DAILYARRIVAL',
    Roompreparation: 'ROOMPREPARATION',
    Draftcontract: 'DRAFTCONTRACT',
    Turnover: 'TURNOVER',
    Shiftavailability: 'SHIFTAVAILABILITY',
    OvertimeApprovalRequested: 'OVERTIME_APPROVAL_REQUESTED',
    OvertimeApproved: 'OVERTIME_APPROVED',
    OvertimeRejected: 'OVERTIME_REJECTED'
} as const;

export type NotificationEntityTypeEnum = typeof NotificationEntityTypeEnum[keyof typeof NotificationEntityTypeEnum];
export const NotificationEntityRoleEnum = {
    User: 'USER',
    Manager: 'MANAGER',
    Owner: 'OWNER',
    Developer: 'DEVELOPER',
    Depchief: 'DEPCHIEF',
    Termsnotaccepted: 'TERMSNOTACCEPTED',
    Controller: 'CONTROLLER'
} as const;

export type NotificationEntityRoleEnum = typeof NotificationEntityRoleEnum[keyof typeof NotificationEntityRoleEnum];

/**
 * 
 * @export
 * @interface OfferLetterEntity
 */
export interface OfferLetterEntity {
    /**
     * 
     * @type {number}
     * @memberof OfferLetterEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof OfferLetterEntity
     */
    'tenantId': string;
    /**
     * 
     * @type {number}
     * @memberof OfferLetterEntity
     */
    'applicationId': number;
    /**
     * 
     * @type {number}
     * @memberof OfferLetterEntity
     */
    'salaryOffer': number;
    /**
     * NETTO_TUTTO_COMPRESO | LORDO_MENSILE | RAL
     * @type {string}
     * @memberof OfferLetterEntity
     */
    'salaryType': string;
    /**
     * 
     * @type {string}
     * @memberof OfferLetterEntity
     */
    'startDate': string;
    /**
     * PENDING | ACCEPTED | DECLINED
     * @type {string}
     * @memberof OfferLetterEntity
     */
    'status': string;
    /**
     * Additional offer details as JSON
     * @type {object}
     * @memberof OfferLetterEntity
     */
    'content'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof OfferLetterEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof OfferLetterEntity
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface PaymentDataDto
 */
export interface PaymentDataDto {
    /**
     * Payment date
     * @type {string}
     * @memberof PaymentDataDto
     */
    'date': string;
    /**
     * Amount to be paid
     * @type {number}
     * @memberof PaymentDataDto
     */
    'toBePayed': number;
    /**
     * Amount paid
     * @type {number}
     * @memberof PaymentDataDto
     */
    'payed': number;
    /**
     * Remaining credit
     * @type {number}
     * @memberof PaymentDataDto
     */
    'remainingCredit': number;
    /**
     * Payment ID
     * @type {number}
     * @memberof PaymentDataDto
     */
    'paymentId': number;
    /**
     * Receipt file path
     * @type {string}
     * @memberof PaymentDataDto
     */
    'receiptPath'?: string;
    /**
     * Is payment encrypted
     * @type {boolean}
     * @memberof PaymentDataDto
     */
    'isEncrypted': boolean;
    /**
     * Payment static type
     * @type {object}
     * @memberof PaymentDataDto
     */
    'paymentStaticType': object;
}
/**
 * 
 * @export
 * @interface PaymentEntity
 */
export interface PaymentEntity {
    /**
     * 
     * @type {number}
     * @memberof PaymentEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentEntity
     */
    'authoriserId': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    'authorisationDate': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    'paymentDate': string;
    /**
     * 
     * @type {object}
     * @memberof PaymentEntity
     */
    'paid': object;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    'paid_encrypted': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    'filePath': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentEntity
     */
    'seasonId': number;
    /**
     * 
     * @type {object}
     * @memberof PaymentEntity
     */
    'paymentStaticType': object;
}
/**
 * 
 * @export
 * @interface PaymentMethodEntity
 */
export interface PaymentMethodEntity {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodEntity
     */
    'type': PaymentMethodEntityTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodEntity
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodEntity
     */
    'depositable': boolean;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodEntity
     */
    'tenantBankingInformationId': number;
    /**
     * 
     * @type {TenantBankingInformationEntity}
     * @memberof PaymentMethodEntity
     */
    'tenantBankingInformation'?: TenantBankingInformationEntity;
}

export const PaymentMethodEntityTypeEnum = {
    Cash: 'CASH',
    Debitcard: 'DEBITCARD',
    Creditcard: 'CREDITCARD',
    Bancomat: 'BANCOMAT',
    Check: 'CHECK',
    Transfer: 'TRANSFER',
    Satispay: 'SATISPAY',
    Paypal: 'PAYPAL',
    Foodstamps: 'FOODSTAMPS',
    Crypto: 'CRYPTO',
    Klarna: 'KLARNA',
    Giftcard: 'GIFTCARD',
    Carddownpayment: 'CARDDOWNPAYMENT',
    Wiredownpayment: 'WIREDOWNPAYMENT',
    Cashdownpayment: 'CASHDOWNPAYMENT',
    Paypaldownpayment: 'PAYPALDOWNPAYMENT',
    Checkdownpayment: 'CHECKDOWNPAYMENT'
} as const;

export type PaymentMethodEntityTypeEnum = typeof PaymentMethodEntityTypeEnum[keyof typeof PaymentMethodEntityTypeEnum];

/**
 * 
 * @export
 * @interface PaymentPageDataEntity
 */
export interface PaymentPageDataEntity {
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof PaymentPageDataEntity
     */
    'employee'?: EmployeeEntity;
    /**
     * 
     * @type {string}
     * @memberof PaymentPageDataEntity
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPageDataEntity
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentPageDataEntity
     */
    'pageIndex': number;
    /**
     * 
     * @type {Array<PaymentEntity>}
     * @memberof PaymentPageDataEntity
     */
    'payments': Array<PaymentEntity>;
    /**
     * 
     * @type {PaymentEntity}
     * @memberof PaymentPageDataEntity
     */
    'selectedPayment'?: PaymentEntity;
}
/**
 * 
 * @export
 * @interface PendingApprovalListResponseDto
 */
export interface PendingApprovalListResponseDto {
    /**
     * 
     * @type {Array<PendingApprovalResponseDto>}
     * @memberof PendingApprovalListResponseDto
     */
    'items': Array<PendingApprovalResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof PendingApprovalListResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PendingApprovalListResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PendingApprovalListResponseDto
     */
    'limit': number;
}
/**
 * 
 * @export
 * @interface PendingApprovalResponseDto
 */
export interface PendingApprovalResponseDto {
    /**
     * 
     * @type {number}
     * @memberof PendingApprovalResponseDto
     */
    'approvalId': number;
    /**
     * 
     * @type {number}
     * @memberof PendingApprovalResponseDto
     */
    'timeEntryId': number;
    /**
     * 
     * @type {number}
     * @memberof PendingApprovalResponseDto
     */
    'employeeId': number;
    /**
     * 
     * @type {string}
     * @memberof PendingApprovalResponseDto
     */
    'employeeFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof PendingApprovalResponseDto
     */
    'employeeLastName': string;
    /**
     * 
     * @type {number}
     * @memberof PendingApprovalResponseDto
     */
    'seasonId': number;
    /**
     * 
     * @type {string}
     * @memberof PendingApprovalResponseDto
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PendingApprovalResponseDto
     */
    'endedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PendingApprovalResponseDto
     */
    'varianceReason'?: PendingApprovalResponseDtoVarianceReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof PendingApprovalResponseDto
     */
    'varianceNote'?: string | null;
    /**
     * Pre-computed overtime minutes (late-out for PLANNED, full duration for UNPLANNED)
     * @type {number}
     * @memberof PendingApprovalResponseDto
     */
    'overtimeMinutes'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PendingApprovalResponseDto
     */
    'requiredRole': PendingApprovalResponseDtoRequiredRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof PendingApprovalResponseDto
     */
    'status': PendingApprovalResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PendingApprovalResponseDto
     */
    'createdAt': string;
}

export const PendingApprovalResponseDtoVarianceReasonEnum = {
    Nominal: 'NOMINAL',
    LateIn: 'LATE_IN',
    EarlyIn: 'EARLY_IN',
    EarlyOut: 'EARLY_OUT',
    OvertimePlanned: 'OVERTIME_PLANNED',
    OvertimeUnplanned: 'OVERTIME_UNPLANNED',
    MissedShift: 'MISSED_SHIFT',
    PartialShift: 'PARTIAL_SHIFT',
    RestDayWork: 'REST_DAY_WORK',
    Ambiguous: 'AMBIGUOUS'
} as const;

export type PendingApprovalResponseDtoVarianceReasonEnum = typeof PendingApprovalResponseDtoVarianceReasonEnum[keyof typeof PendingApprovalResponseDtoVarianceReasonEnum];
export const PendingApprovalResponseDtoRequiredRoleEnum = {
    User: 'USER',
    Manager: 'MANAGER',
    Owner: 'OWNER',
    Developer: 'DEVELOPER',
    Depchief: 'DEPCHIEF',
    Termsnotaccepted: 'TERMSNOTACCEPTED',
    Controller: 'CONTROLLER'
} as const;

export type PendingApprovalResponseDtoRequiredRoleEnum = typeof PendingApprovalResponseDtoRequiredRoleEnum[keyof typeof PendingApprovalResponseDtoRequiredRoleEnum];
export const PendingApprovalResponseDtoStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
} as const;

export type PendingApprovalResponseDtoStatusEnum = typeof PendingApprovalResponseDtoStatusEnum[keyof typeof PendingApprovalResponseDtoStatusEnum];

/**
 * 
 * @export
 * @interface PendingUserEntity
 */
export interface PendingUserEntity {
    /**
     * 
     * @type {string}
     * @memberof PendingUserEntity
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PendingUserEntity
     */
    'issueTime': string;
    /**
     * 
     * @type {object}
     * @memberof PendingUserEntity
     */
    'language': object;
    /**
     * 
     * @type {string}
     * @memberof PendingUserEntity
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof PendingUserEntity
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof PendingUserEntity
     */
    'username': string;
    /**
     * 
     * @type {boolean}
     * @memberof PendingUserEntity
     */
    'isValid': boolean;
}
/**
 * 
 * @export
 * @interface PeriodSummaryResponseDto
 */
export interface PeriodSummaryResponseDto {
    /**
     * 
     * @type {Array<EmployeePeriodSummaryDto>}
     * @memberof PeriodSummaryResponseDto
     */
    'employees': Array<EmployeePeriodSummaryDto>;
    /**
     * 
     * @type {number}
     * @memberof PeriodSummaryResponseDto
     */
    'totalWorkedMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof PeriodSummaryResponseDto
     */
    'totalPlannedMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof PeriodSummaryResponseDto
     */
    'totalOvertimeMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof PeriodSummaryResponseDto
     */
    'totalContractualMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof PeriodSummaryResponseDto
     */
    'totalExpectedMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof PeriodSummaryResponseDto
     */
    'totalAbsenceMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof PeriodSummaryResponseDto
     */
    'totalCostoPianificatoCents'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PeriodSummaryResponseDto
     */
    'totalCostoEffettivoCents'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PeriodSummaryResponseDto
     */
    'totalCostoStraordinarioCents'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PeriodSummaryResponseDto
     */
    'costMissingForRows': number;
    /**
     * 
     * @type {string}
     * @memberof PeriodSummaryResponseDto
     */
    'costMissingReason'?: PeriodSummaryResponseDtoCostMissingReasonEnum;
}

export const PeriodSummaryResponseDtoCostMissingReasonEnum = {
    NoCostConfigured: 'no_cost_configured',
    EncryptedNoKey: 'encrypted_no_key',
    Mixed: 'mixed'
} as const;

export type PeriodSummaryResponseDtoCostMissingReasonEnum = typeof PeriodSummaryResponseDtoCostMissingReasonEnum[keyof typeof PeriodSummaryResponseDtoCostMissingReasonEnum];

/**
 * 
 * @export
 * @interface PersonalInfoEntity
 */
export interface PersonalInfoEntity {
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoEntity
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoEntity
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoEntity
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoEntity
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoEntity
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoEntity
     */
    'gender': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoEntity
     */
    'dateOfBirth': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalInfoEntity
     */
    'nationality': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PersonalInfoEntity
     */
    'languages': Array<string>;
}
/**
 * 
 * @export
 * @interface PipelineStageEntity
 */
export interface PipelineStageEntity {
    /**
     * 
     * @type {number}
     * @memberof PipelineStageEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof PipelineStageEntity
     */
    'pipelineId': number;
    /**
     * 
     * @type {string}
     * @memberof PipelineStageEntity
     */
    'name': string;
    /**
     * Display order of the stage in the pipeline
     * @type {number}
     * @memberof PipelineStageEntity
     */
    'order': number;
    /**
     * Stage type, e.g. APPLIED, SCREENING, INTERVIEW, OFFER, HIRED, REJECTED
     * @type {string}
     * @memberof PipelineStageEntity
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof PipelineStageEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof PipelineStageEntity
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface PlanAccuracyResponseDto
 */
export interface PlanAccuracyResponseDto {
    /**
     * 
     * @type {Array<DailyAccuracyPointDto>}
     * @memberof PlanAccuracyResponseDto
     */
    'daily': Array<DailyAccuracyPointDto>;
    /**
     * 
     * @type {number}
     * @memberof PlanAccuracyResponseDto
     */
    'overallAccuracyPct': number;
    /**
     * 
     * @type {number}
     * @memberof PlanAccuracyResponseDto
     */
    'totalPlannedShifts': number;
    /**
     * 
     * @type {number}
     * @memberof PlanAccuracyResponseDto
     */
    'totalWorkedShifts': number;
    /**
     * 
     * @type {number}
     * @memberof PlanAccuracyResponseDto
     */
    'totalMissedShifts': number;
}
/**
 *
 * @export
 * @interface PlannedBreakDto
 */
export interface PlannedBreakDto {
    /**
     *
     * @type {string}
     * @memberof PlannedBreakDto
     */
    'startUtc': string;
    /**
     *
     * @type {string}
     * @memberof PlannedBreakDto
     */
    'endUtc': string;
}
/**
 *
 * @export
 * @interface PlannedShiftSummaryDto
 */
export interface PlannedShiftSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof PlannedShiftSummaryDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PlannedShiftSummaryDto
     */
    'startUtc': string;
    /**
     * 
     * @type {string}
     * @memberof PlannedShiftSummaryDto
     */
    'endUtc': string;
    /**
     * Planned break minutes (main + additional breaks)
     * @type {number}
     * @memberof PlannedShiftSummaryDto
     */
    'breakMinutes': number;
    /**
     * Individual planned break intervals (main + additional)
     * @type {Array<PlannedBreakDto>}
     * @memberof PlannedShiftSummaryDto
     */
    'breaks': Array<PlannedBreakDto>;
    /**
     *
     * @type {number}
     * @memberof PlannedShiftSummaryDto
     */
    'workPositionId': number;
    /**
     * 
     * @type {string}
     * @memberof PlannedShiftSummaryDto
     */
    'workPositionName': string;
    /**
     * 
     * @type {boolean}
     * @memberof PlannedShiftSummaryDto
     */
    'deleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PlannedShiftSummaryDto
     */
    'published': boolean;
}
/**
 * 
 * @export
 * @interface PublicDocumentEntity
 */
export interface PublicDocumentEntity {
    /**
     * 
     * @type {number}
     * @memberof PublicDocumentEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PublicDocumentEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PublicDocumentEntity
     */
    'filePath': string;
    /**
     * 
     * @type {string}
     * @memberof PublicDocumentEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {Array<SegmentEntity>}
     * @memberof PublicDocumentEntity
     */
    'segments'?: Array<SegmentEntity>;
    /**
     * 
     * @type {Array<DepartmentEntity>}
     * @memberof PublicDocumentEntity
     */
    'departments'?: Array<DepartmentEntity>;
    /**
     * 
     * @type {Array<SeasonEntity>}
     * @memberof PublicDocumentEntity
     */
    'seasons'?: Array<SeasonEntity>;
}
/**
 * 
 * @export
 * @interface PublicHolidayEntity
 */
export interface PublicHolidayEntity {
    /**
     * 
     * @type {number}
     * @memberof PublicHolidayEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayEntity
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayEntity
     */
    'region'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PublicHolidayEntity
     */
    'isCustom': boolean;
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayEntity
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface RecruitmentStatsEntity
 */
export interface RecruitmentStatsEntity {
    /**
     * 
     * @type {ApplicationCountDto}
     * @memberof RecruitmentStatsEntity
     */
    'totalApplications': ApplicationCountDto;
    /**
     * 
     * @type {TimeToHireDto}
     * @memberof RecruitmentStatsEntity
     */
    'averageTimeToHire': TimeToHireDto;
    /**
     * 
     * @type {FunnelDto}
     * @memberof RecruitmentStatsEntity
     */
    'funnel': FunnelDto;
    /**
     * 
     * @type {Array<TopJobAdDto>}
     * @memberof RecruitmentStatsEntity
     */
    'topJobAds': Array<TopJobAdDto>;
}
/**
 * 
 * @export
 * @interface RegisterDto
 */
export interface RegisterDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'password': string;
    /**
     * 
     * @type {object}
     * @memberof RegisterDto
     */
    'language': object;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface RejectApplicationDto
 */
export interface RejectApplicationDto {
    /**
     * The application to reject
     * @type {number}
     * @memberof RejectApplicationDto
     */
    'applicationId': number;
    /**
     * Reason for rejecting the candidate
     * @type {string}
     * @memberof RejectApplicationDto
     */
    'reason'?: string;
    /**
     * Whether to send a rejection email to the candidate
     * @type {boolean}
     * @memberof RejectApplicationDto
     */
    'sendEmail': boolean;
    /**
     * Email template ID to use for the rejection email (required if sendEmail is true)
     * @type {number}
     * @memberof RejectApplicationDto
     */
    'emailTemplateId'?: number;
}
/**
 * 
 * @export
 * @interface RejectMultipleApplicationsDto
 */
export interface RejectMultipleApplicationsDto {
    /**
     * Application IDs to reject
     * @type {Array<number>}
     * @memberof RejectMultipleApplicationsDto
     */
    'applicationIds': Array<number>;
    /**
     * Reason for rejecting the candidates
     * @type {string}
     * @memberof RejectMultipleApplicationsDto
     */
    'reason'?: string;
    /**
     * Whether to send rejection emails to the candidates
     * @type {boolean}
     * @memberof RejectMultipleApplicationsDto
     */
    'sendEmail': boolean;
    /**
     * Email template ID to use for the rejection emails (required if sendEmail is true)
     * @type {number}
     * @memberof RejectMultipleApplicationsDto
     */
    'emailTemplateId'?: number;
}
/**
 * 
 * @export
 * @interface RejectTimeEntryDto
 */
export interface RejectTimeEntryDto {
    /**
     * 
     * @type {string}
     * @memberof RejectTimeEntryDto
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface RemoveShiftDetailWithChoiceDto
 */
export interface RemoveShiftDetailWithChoiceDto {
    /**
     * 
     * @type {string}
     * @memberof RemoveShiftDetailWithChoiceDto
     */
    'choice': RemoveShiftDetailWithChoiceDtoChoiceEnum;
    /**
     * 
     * @type {string}
     * @memberof RemoveShiftDetailWithChoiceDto
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof RemoveShiftDetailWithChoiceDto
     */
    'departmentId': number;
    /**
     * 
     * @type {number}
     * @memberof RemoveShiftDetailWithChoiceDto
     */
    'seasonId': number;
}

export const RemoveShiftDetailWithChoiceDtoChoiceEnum = {
    Single: 'single',
    All: 'all',
    Future: 'future'
} as const;

export type RemoveShiftDetailWithChoiceDtoChoiceEnum = typeof RemoveShiftDetailWithChoiceDtoChoiceEnum[keyof typeof RemoveShiftDetailWithChoiceDtoChoiceEnum];

/**
 * 
 * @export
 * @interface ReorderStagesDto
 */
export interface ReorderStagesDto {
    /**
     * Array of stage IDs with their new order values
     * @type {Array<StageOrderItem>}
     * @memberof ReorderStagesDto
     */
    'stages': Array<StageOrderItem>;
}
/**
 * 
 * @export
 * @interface RepeatShiftPlanDto
 */
export interface RepeatShiftPlanDto {
    /**
     * 
     * @type {number}
     * @memberof RepeatShiftPlanDto
     */
    'departmentId': number;
    /**
     * 
     * @type {number}
     * @memberof RepeatShiftPlanDto
     */
    'seasonId': number;
    /**
     * 
     * @type {string}
     * @memberof RepeatShiftPlanDto
     */
    'copyFromStartDate': string;
    /**
     * 
     * @type {string}
     * @memberof RepeatShiftPlanDto
     */
    'copyFromEndDate': string;
    /**
     * 
     * @type {string}
     * @memberof RepeatShiftPlanDto
     */
    'copyToStartDate': string;
    /**
     *
     * @type {string}
     * @memberof RepeatShiftPlanDto
     */
    'copyToEndDate': string;
    /**
     *
     * @type {boolean}
     * @memberof RepeatShiftPlanDto
     */
    'copyCalendarEntries'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof RepeatShiftPlanDto
     */
    'replaceCalendarEntries'?: boolean;
    /**
     *
     * @type {Array<number>}
     * @memberof RepeatShiftPlanDto
     */
    'employeeIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface RequestPasswordResetDto
 */
export interface RequestPasswordResetDto {
    /**
     * 
     * @type {string}
     * @memberof RequestPasswordResetDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ResetPasswordDto
 */
export interface ResetPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface RespondOfferLetterDto
 */
export interface RespondOfferLetterDto {
    /**
     * ACCEPTED or DECLINED
     * @type {string}
     * @memberof RespondOfferLetterDto
     */
    'status': RespondOfferLetterDtoStatusEnum;
}

export const RespondOfferLetterDtoStatusEnum = {
    Accepted: 'ACCEPTED',
    Declined: 'DECLINED'
} as const;

export type RespondOfferLetterDtoStatusEnum = typeof RespondOfferLetterDtoStatusEnum[keyof typeof RespondOfferLetterDtoStatusEnum];

/**
 * 
 * @export
 * @interface RestViolationDto
 */
export interface RestViolationDto {
    /**
     * 
     * @type {number}
     * @memberof RestViolationDto
     */
    'employeeId': number;
    /**
     * 
     * @type {string}
     * @memberof RestViolationDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof RestViolationDto
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof RestViolationDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof RestViolationDto
     */
    'previousShiftEndedAt': string;
    /**
     * 
     * @type {string}
     * @memberof RestViolationDto
     */
    'nextShiftStartedAt': string;
    /**
     * 
     * @type {number}
     * @memberof RestViolationDto
     */
    'restMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof RestViolationDto
     */
    'requiredRestMinutes': number;
}
/**
 * 
 * @export
 * @interface RestViolationsResponseDto
 */
export interface RestViolationsResponseDto {
    /**
     * 
     * @type {Array<RestViolationDto>}
     * @memberof RestViolationsResponseDto
     */
    'violations': Array<RestViolationDto>;
    /**
     * 
     * @type {number}
     * @memberof RestViolationsResponseDto
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface ResumeEntity
 */
export interface ResumeEntity {
    /**
     * 
     * @type {PersonalInfoEntity}
     * @memberof ResumeEntity
     */
    'personalInfo': PersonalInfoEntity;
    /**
     * 
     * @type {Array<JobExperienceEntity>}
     * @memberof ResumeEntity
     */
    'jobExperience': Array<JobExperienceEntity>;
    /**
     * 
     * @type {Array<EducationEntity>}
     * @memberof ResumeEntity
     */
    'education': Array<EducationEntity>;
}
/**
 * 
 * @export
 * @interface RewardDto
 */
export interface RewardDto {
    /**
     * Reward ID
     * @type {number}
     * @memberof RewardDto
     */
    'id': number;
    /**
     * Reward amount
     * @type {number}
     * @memberof RewardDto
     */
    'amount': number;
    /**
     * Recorded at
     * @type {string}
     * @memberof RewardDto
     */
    'recordedAt': string;
    /**
     * Earned on date
     * @type {string}
     * @memberof RewardDto
     */
    'earnedOn': string;
    /**
     * Reward name
     * @type {object}
     * @memberof RewardDto
     */
    'name'?: object;
    /**
     * Reward notes
     * @type {string}
     * @memberof RewardDto
     */
    'notes'?: string;
    /**
     * Contract ID
     * @type {number}
     * @memberof RewardDto
     */
    'contractId': number;
}
/**
 * 
 * @export
 * @interface RewardEntity
 */
export interface RewardEntity {
    /**
     * 
     * @type {number}
     * @memberof RewardEntity
     */
    'id': number;
    /**
     * 
     * @type {object}
     * @memberof RewardEntity
     */
    'amount': object;
    /**
     * 
     * @type {number}
     * @memberof RewardEntity
     */
    'contractId': number;
    /**
     * 
     * @type {string}
     * @memberof RewardEntity
     */
    'earnedOn': string;
    /**
     * 
     * @type {number}
     * @memberof RewardEntity
     */
    'nameId': number;
    /**
     * 
     * @type {string}
     * @memberof RewardEntity
     */
    'notes': string;
    /**
     * 
     * @type {string}
     * @memberof RewardEntity
     */
    'recordedAt': string;
    /**
     * 
     * @type {UsedRewardNameEntity}
     * @memberof RewardEntity
     */
    'name': UsedRewardNameEntity;
}
/**
 * 
 * @export
 * @interface RoomEntity
 */
export interface RoomEntity {
    /**
     * 
     * @type {number}
     * @memberof RoomEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof RoomEntity
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof RoomEntity
     */
    'buildingId': number;
    /**
     * 
     * @type {number}
     * @memberof RoomEntity
     */
    'maxTenants': number;
    /**
     * 
     * @type {number}
     * @memberof RoomEntity
     */
    'floor': number;
    /**
     * 
     * @type {string}
     * @memberof RoomEntity
     */
    'accessMode': string;
    /**
     * 
     * @type {number}
     * @memberof RoomEntity
     */
    'bathrooms': number;
    /**
     * 
     * @type {boolean}
     * @memberof RoomEntity
     */
    'hasKitchen': boolean;
    /**
     * 
     * @type {string}
     * @memberof RoomEntity
     */
    'notes': string;
    /**
     * 
     * @type {Array<object>}
     * @memberof RoomEntity
     */
    'employees'?: Array<object>;
    /**
     * 
     * @type {Array<RoomToSeasonEntity>}
     * @memberof RoomEntity
     */
    'seasonNotes'?: Array<RoomToSeasonEntity>;
}
/**
 * 
 * @export
 * @interface RoomToSeasonEntity
 */
export interface RoomToSeasonEntity {
    /**
     * 
     * @type {string}
     * @memberof RoomToSeasonEntity
     */
    'notes': string;
    /**
     * 
     * @type {number}
     * @memberof RoomToSeasonEntity
     */
    'roomId': number;
    /**
     * 
     * @type {number}
     * @memberof RoomToSeasonEntity
     */
    'seasonId': number;
}
/**
 * 
 * @export
 * @interface SafetyAreaEntity
 */
export interface SafetyAreaEntity {
    /**
     * The unique identifier of the safety area
     * @type {number}
     * @memberof SafetyAreaEntity
     */
    'id': number;
    /**
     * The name of the safety area
     * @type {string}
     * @memberof SafetyAreaEntity
     */
    'name': string;
    /**
     * The path to the safety area image
     * @type {string}
     * @memberof SafetyAreaEntity
     */
    'imagePath'?: string;
    /**
     * The creation date of the safety area
     * @type {string}
     * @memberof SafetyAreaEntity
     */
    'createdAt': string;
    /**
     * The last update date of the safety area
     * @type {string}
     * @memberof SafetyAreaEntity
     */
    'updatedAt': string;
    /**
     * The ID of the associated meta safety area
     * @type {number}
     * @memberof SafetyAreaEntity
     */
    'metaSafetyAreaId': number;
    /**
     * 
     * @type {SafetyAreaEntityMetaSafetyArea}
     * @memberof SafetyAreaEntity
     */
    'metaSafetyArea'?: SafetyAreaEntityMetaSafetyArea;
    /**
     * The safety area items associated with this area
     * @type {Array<SafetyAreaItemEntity>}
     * @memberof SafetyAreaEntity
     */
    'items'?: Array<SafetyAreaItemEntity>;
}
/**
 * The associated meta safety area
 * @export
 * @interface SafetyAreaEntityMetaSafetyArea
 */
export interface SafetyAreaEntityMetaSafetyArea {
    /**
     * The unique identifier of the meta safety area
     * @type {number}
     * @memberof SafetyAreaEntityMetaSafetyArea
     */
    'id': number;
    /**
     * The name of the meta safety area
     * @type {string}
     * @memberof SafetyAreaEntityMetaSafetyArea
     */
    'name': string;
    /**
     * The creation date of the meta safety area
     * @type {string}
     * @memberof SafetyAreaEntityMetaSafetyArea
     */
    'createdAt': string;
    /**
     * The last update date of the meta safety area
     * @type {string}
     * @memberof SafetyAreaEntityMetaSafetyArea
     */
    'updatedAt': string;
    /**
     * The safety areas associated with this meta safety area
     * @type {Array<SafetyAreaEntity>}
     * @memberof SafetyAreaEntityMetaSafetyArea
     */
    'safetyArea'?: Array<SafetyAreaEntity>;
}
/**
 * 
 * @export
 * @interface SafetyAreaItemEntity
 */
export interface SafetyAreaItemEntity {
    /**
     * 
     * @type {number}
     * @memberof SafetyAreaItemEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SafetyAreaItemEntity
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SafetyAreaItemEntity
     */
    'safetyAreaId': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyAreaItemEntity
     */
    'safetyItemId': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyAreaItemEntity
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyAreaItemEntity
     */
    'y': number;
    /**
     * 
     * @type {string}
     * @memberof SafetyAreaItemEntity
     */
    'addedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SafetyAreaItemEntity
     */
    'serialNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof SafetyAreaItemEntity
     */
    'description': string | null;
    /**
     * 
     * @type {number}
     * @memberof SafetyAreaItemEntity
     */
    'checkIntervalDays': number | null;
    /**
     * 
     * @type {SafetyItemEntity}
     * @memberof SafetyAreaItemEntity
     */
    'safetyItem'?: SafetyItemEntity;
    /**
     * 
     * @type {SafetyAreaEntity}
     * @memberof SafetyAreaItemEntity
     */
    'safetyArea'?: SafetyAreaEntity;
    /**
     * 
     * @type {Array<SafetyItemPeriodicCheckEntity>}
     * @memberof SafetyAreaItemEntity
     */
    'safetyPeriodicCheck'?: Array<SafetyItemPeriodicCheckEntity>;
    /**
     * 
     * @type {Array<SafetyItemCheckIntervalEntity>}
     * @memberof SafetyAreaItemEntity
     */
    'safetyItemCheckInterval'?: Array<SafetyItemCheckIntervalEntity>;
    /**
     * 
     * @type {Array<SafetyItemAreaContentEntity>}
     * @memberof SafetyAreaItemEntity
     */
    'safetyItemAreaContent'?: Array<SafetyItemAreaContentEntity>;
    /**
     * 
     * @type {Array<SafetyItemAreaChecklistItemEntity>}
     * @memberof SafetyAreaItemEntity
     */
    'safetyItemAreaChecklistItem'?: Array<SafetyItemAreaChecklistItemEntity>;
}
/**
 * 
 * @export
 * @interface SafetyAreaItemPictureEntity
 */
export interface SafetyAreaItemPictureEntity {
    /**
     * 
     * @type {number}
     * @memberof SafetyAreaItemPictureEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SafetyAreaItemPictureEntity
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof SafetyAreaItemPictureEntity
     */
    'safetyPeriodicCheckId': number;
}
/**
 * 
 * @export
 * @interface SafetyItemAreaChecklistItemEntity
 */
export interface SafetyItemAreaChecklistItemEntity {
    /**
     * 
     * @type {number}
     * @memberof SafetyItemAreaChecklistItemEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SafetyItemAreaChecklistItemEntity
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemAreaChecklistItemEntity
     */
    'safetyItemAreaId': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemAreaChecklistItemEntity
     */
    'safetyItemId': number;
    /**
     * 
     * @type {Array<SafetyItemAreaChecklistItemPeriodicCheckEntity>}
     * @memberof SafetyItemAreaChecklistItemEntity
     */
    'SafetyItemAreaChecklistItemPeriodicCheck'?: Array<SafetyItemAreaChecklistItemPeriodicCheckEntity>;
}
/**
 * 
 * @export
 * @interface SafetyItemAreaChecklistItemPeriodicCheckEntity
 */
export interface SafetyItemAreaChecklistItemPeriodicCheckEntity {
    /**
     * 
     * @type {number}
     * @memberof SafetyItemAreaChecklistItemPeriodicCheckEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemAreaChecklistItemPeriodicCheckEntity
     */
    'periodicCheckId': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemAreaChecklistItemPeriodicCheckEntity
     */
    'safetyItemAreaChecklistItemId': number;
    /**
     * 
     * @type {SafetyItemPeriodicCheckEntity}
     * @memberof SafetyItemAreaChecklistItemPeriodicCheckEntity
     */
    'periodicCheck'?: SafetyItemPeriodicCheckEntity;
    /**
     * 
     * @type {SafetyItemAreaChecklistItemEntity}
     * @memberof SafetyItemAreaChecklistItemPeriodicCheckEntity
     */
    'safetyItemAreaChecklistItem'?: SafetyItemAreaChecklistItemEntity;
}
/**
 * 
 * @export
 * @interface SafetyItemAreaContentEntity
 */
export interface SafetyItemAreaContentEntity {
    /**
     * 
     * @type {number}
     * @memberof SafetyItemAreaContentEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemAreaContentEntity
     */
    'safetyItemAreaId': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemAreaContentEntity
     */
    'safetyItemId': number;
    /**
     * 
     * @type {string}
     * @memberof SafetyItemAreaContentEntity
     */
    'itemName': string;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyItemAreaContentEntity
     */
    'isPerishable': boolean;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemAreaContentEntity
     */
    'expectedQuantity': number;
}
/**
 * 
 * @export
 * @interface SafetyItemAreaContentPeriodicCheckEntity
 */
export interface SafetyItemAreaContentPeriodicCheckEntity {
    /**
     * 
     * @type {number}
     * @memberof SafetyItemAreaContentPeriodicCheckEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemAreaContentPeriodicCheckEntity
     */
    'periodicCheckId': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemAreaContentPeriodicCheckEntity
     */
    'actualQuantity': number;
    /**
     * 
     * @type {string}
     * @memberof SafetyItemAreaContentPeriodicCheckEntity
     */
    'expirationDate': string;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemAreaContentPeriodicCheckEntity
     */
    'safetyItemAreaContentId': number;
    /**
     * 
     * @type {SafetyItemAreaContentEntity}
     * @memberof SafetyItemAreaContentPeriodicCheckEntity
     */
    'safetyItemAreaContent': SafetyItemAreaContentEntity;
}
/**
 * 
 * @export
 * @interface SafetyItemCheckIntervalEntity
 */
export interface SafetyItemCheckIntervalEntity {
    /**
     * 
     * @type {number}
     * @memberof SafetyItemCheckIntervalEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SafetyItemCheckIntervalEntity
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemCheckIntervalEntity
     */
    'safetyItemAreaId': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemCheckIntervalEntity
     */
    'safetyItemId': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemCheckIntervalEntity
     */
    'intervalDays': number;
}
/**
 * 
 * @export
 * @interface SafetyItemEntity
 */
export interface SafetyItemEntity {
    /**
     * The unique identifier of the safety item
     * @type {number}
     * @memberof SafetyItemEntity
     */
    'id': number;
    /**
     * The name of the safety item
     * @type {string}
     * @memberof SafetyItemEntity
     */
    'name': string;
    /**
     * 
     * @type {Array<SafetyAreaItemEntity>}
     * @memberof SafetyItemEntity
     */
    'items'?: Array<SafetyAreaItemEntity>;
    /**
     * 
     * @type {Array<SafetyAreaEntity>}
     * @memberof SafetyItemEntity
     */
    'safetyAreas'?: Array<SafetyAreaEntity>;
    /**
     * The path to the safety item image
     * @type {string}
     * @memberof SafetyItemEntity
     */
    'imagePath': string;
    /**
     * 
     * @type {string}
     * @memberof SafetyItemEntity
     */
    'serialNumber'?: string;
    /**
     * The number of days between required checks
     * @type {number}
     * @memberof SafetyItemEntity
     */
    'checkIntervalDays': number;
    /**
     * 
     * @type {Array<SafetyItemCheckIntervalEntity>}
     * @memberof SafetyItemEntity
     */
    'safetyItemCheckInterval'?: Array<SafetyItemCheckIntervalEntity>;
    /**
     * 
     * @type {Array<SafetyItemAreaContentEntity>}
     * @memberof SafetyItemEntity
     */
    'safetyItemAreaContent'?: Array<SafetyItemAreaContentEntity>;
    /**
     * 
     * @type {Array<SafetyItemAreaChecklistItemEntity>}
     * @memberof SafetyItemEntity
     */
    'safetyItemAreaChecklistItem'?: Array<SafetyItemAreaChecklistItemEntity>;
    /**
     * The creation date of the safety item
     * @type {string}
     * @memberof SafetyItemEntity
     */
    'createdAt': string;
    /**
     * The last update date of the safety item
     * @type {string}
     * @memberof SafetyItemEntity
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface SafetyItemPeriodicCheckEntity
 */
export interface SafetyItemPeriodicCheckEntity {
    /**
     * 
     * @type {number}
     * @memberof SafetyItemPeriodicCheckEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SafetyItemPeriodicCheckEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemPeriodicCheckEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof SafetyItemPeriodicCheckEntity
     */
    'employee'?: EmployeeEntity;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemPeriodicCheckEntity
     */
    'safetyAreaItemId': number;
    /**
     * 
     * @type {string}
     * @memberof SafetyItemPeriodicCheckEntity
     */
    'checkedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SafetyItemPeriodicCheckEntity
     */
    'notes': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyItemPeriodicCheckEntity
     */
    'checklistCompleted': boolean;
    /**
     * 
     * @type {number}
     * @memberof SafetyItemPeriodicCheckEntity
     */
    'safetyItemAreaCheckIntervalId': number | null;
    /**
     * 
     * @type {SafetyItemCheckIntervalEntity}
     * @memberof SafetyItemPeriodicCheckEntity
     */
    'safetyItemAreaCheckInterval'?: SafetyItemCheckIntervalEntity;
    /**
     * 
     * @type {Array<SafetyItemAreaContentPeriodicCheckEntity>}
     * @memberof SafetyItemPeriodicCheckEntity
     */
    'SafetyItemAreaContentPeriodicCheck'?: Array<SafetyItemAreaContentPeriodicCheckEntity>;
    /**
     * 
     * @type {Array<SafetyItemAreaChecklistItemPeriodicCheckEntity>}
     * @memberof SafetyItemPeriodicCheckEntity
     */
    'SafetyItemAreaChecklistItemPeriodicCheck'?: Array<SafetyItemAreaChecklistItemPeriodicCheckEntity>;
    /**
     * 
     * @type {Array<SafetyAreaItemPictureEntity>}
     * @memberof SafetyItemPeriodicCheckEntity
     */
    'SafetyAreaItemPicture'?: Array<SafetyAreaItemPictureEntity>;
}
/**
 * 
 * @export
 * @interface SafetyProblemItemDto
 */
export interface SafetyProblemItemDto {
    /**
     * 
     * @type {number}
     * @memberof SafetyProblemItemDto
     */
    'checkId': number;
    /**
     * 
     * @type {string}
     * @memberof SafetyProblemItemDto
     */
    'checkedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SafetyProblemItemDto
     */
    'itemName': string;
    /**
     * 
     * @type {string}
     * @memberof SafetyProblemItemDto
     */
    'areaName': string;
    /**
     * 
     * @type {string}
     * @memberof SafetyProblemItemDto
     */
    'metaAreaName': string;
    /**
     * 
     * @type {string}
     * @memberof SafetyProblemItemDto
     */
    'contentName': string;
    /**
     * 
     * @type {string}
     * @memberof SafetyProblemItemDto
     */
    'expirationDate': string;
    /**
     * 
     * @type {number}
     * @memberof SafetyProblemItemDto
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof SafetyProblemItemDto
     */
    'checkedBy': string;
    /**
     * 
     * @type {number}
     * @memberof SafetyProblemItemDto
     */
    'safetyAreaItemId': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyProblemItemDto
     */
    'areaId': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyProblemItemDto
     */
    'metaAreaId': number;
}
/**
 * 
 * @export
 * @interface SafetyProblemsResponseDto
 */
export interface SafetyProblemsResponseDto {
    /**
     * 
     * @type {Array<SafetyProblemItemDto>}
     * @memberof SafetyProblemsResponseDto
     */
    'expiredItems': Array<SafetyProblemItemDto>;
    /**
     * 
     * @type {Array<SafetyProblemItemDto>}
     * @memberof SafetyProblemsResponseDto
     */
    'expiringItems': Array<SafetyProblemItemDto>;
    /**
     * 
     * @type {Array<IncompleteChecklistDto>}
     * @memberof SafetyProblemsResponseDto
     */
    'incompleteChecklists': Array<IncompleteChecklistDto>;
    /**
     * 
     * @type {Array<MissingItemDto>}
     * @memberof SafetyProblemsResponseDto
     */
    'missingItems': Array<MissingItemDto>;
    /**
     * 
     * @type {SafetyProblemsSummaryDto}
     * @memberof SafetyProblemsResponseDto
     */
    'summary': SafetyProblemsSummaryDto;
}
/**
 * 
 * @export
 * @interface SafetyProblemsSummaryDto
 */
export interface SafetyProblemsSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof SafetyProblemsSummaryDto
     */
    'totalExpired': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyProblemsSummaryDto
     */
    'totalExpiring': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyProblemsSummaryDto
     */
    'totalIncomplete': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyProblemsSummaryDto
     */
    'totalMissing': number;
    /**
     * 
     * @type {number}
     * @memberof SafetyProblemsSummaryDto
     */
    'totalProblems': number;
}
/**
 * 
 * @export
 * @interface SearchEmployeesDto
 */
export interface SearchEmployeesDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchEmployeesDto
     */
    'taxCodes': Array<string>;
}
/**
 * 
 * @export
 * @interface SeasonEntity
 */
export interface SeasonEntity {
    /**
     * 
     * @type {number}
     * @memberof SeasonEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SeasonEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SeasonEntity
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof SeasonEntity
     */
    'endDate': string;
}
/**
 * 
 * @export
 * @interface SectionDepositSumEntity
 */
export interface SectionDepositSumEntity {
    /**
     * 
     * @type {number}
     * @memberof SectionDepositSumEntity
     */
    'paymentSectionId': number;
    /**
     * 
     * @type {TurnoverDepositableSumEntitySum}
     * @memberof SectionDepositSumEntity
     */
    '_sum': TurnoverDepositableSumEntitySum;
}
/**
 * 
 * @export
 * @interface SectionEntity
 */
export interface SectionEntity {
    /**
     * 
     * @type {number}
     * @memberof SectionEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SectionEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SectionEntity
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof SectionEntity
     */
    'taxPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof SectionEntity
     */
    'departmentId': number;
    /**
     * 
     * @type {boolean}
     * @memberof SectionEntity
     */
    'onlyToBeShowed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SectionEntity
     */
    'stillCountsDepositable': boolean;
    /**
     * 
     * @type {DepartmentEntity}
     * @memberof SectionEntity
     */
    'department'?: DepartmentEntity;
    /**
     * 
     * @type {Array<TurnoverItemEntity>}
     * @memberof SectionEntity
     */
    'turnoverItems'?: Array<TurnoverItemEntity>;
    /**
     * 
     * @type {Array<PaymentMethodEntity>}
     * @memberof SectionEntity
     */
    'paymentMethods'?: Array<PaymentMethodEntity>;
    /**
     * 
     * @type {boolean}
     * @memberof SectionEntity
     */
    'hasTickets'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SectionEntity
     */
    'hidden': boolean;
}
/**
 * 
 * @export
 * @interface SegmentEntity
 */
export interface SegmentEntity {
    /**
     * 
     * @type {number}
     * @memberof SegmentEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SegmentEntity
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SegmentEntity
     */
    'employeesNumber'?: number;
}
/**
 * 
 * @export
 * @interface SendEmailTemplateDto
 */
export interface SendEmailTemplateDto {
    /**
     * Application ID to send the email for
     * @type {number}
     * @memberof SendEmailTemplateDto
     */
    'applicationId': number;
}
/**
 * 
 * @export
 * @interface SetExpoTokenDto
 */
export interface SetExpoTokenDto {
    /**
     * 
     * @type {string}
     * @memberof SetExpoTokenDto
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface SetLanguageDto
 */
export interface SetLanguageDto {
    /**
     * 
     * @type {string}
     * @memberof SetLanguageDto
     */
    'language': SetLanguageDtoLanguageEnum;
    /**
     * 
     * @type {number}
     * @memberof SetLanguageDto
     */
    'id': number;
}

export const SetLanguageDtoLanguageEnum = {
    En: 'EN',
    It: 'IT',
    De: 'DE',
    Fr: 'FR'
} as const;

export type SetLanguageDtoLanguageEnum = typeof SetLanguageDtoLanguageEnum[keyof typeof SetLanguageDtoLanguageEnum];

/**
 * 
 * @export
 * @interface SetSeasonToDisplayDto
 */
export interface SetSeasonToDisplayDto {
    /**
     * 
     * @type {number}
     * @memberof SetSeasonToDisplayDto
     */
    'seasonId': number;
    /**
     * 
     * @type {number}
     * @memberof SetSeasonToDisplayDto
     */
    'employeeId': number;
}
/**
 * 
 * @export
 * @interface ShiftAssignmentEntity
 */
export interface ShiftAssignmentEntity {
    /**
     * 
     * @type {number}
     * @memberof ShiftAssignmentEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ShiftAssignmentEntity
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof ShiftAssignmentEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof ShiftAssignmentEntity
     */
    'employee'?: EmployeeEntity;
    /**
     * 
     * @type {boolean}
     * @memberof ShiftAssignmentEntity
     */
    'deleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShiftAssignmentEntity
     */
    'published': boolean;
    /**
     * 
     * @type {number}
     * @memberof ShiftAssignmentEntity
     */
    'shiftDetailId': number;
}
/**
 * 
 * @export
 * @interface ShiftAvailabilityEntity
 */
export interface ShiftAvailabilityEntity {
    /**
     * 
     * @type {number}
     * @memberof ShiftAvailabilityEntity
     */
    'id': number;
    /**
     * 
     * @type {boolean}
     * @memberof ShiftAvailabilityEntity
     */
    'confirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof ShiftAvailabilityEntity
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof ShiftAvailabilityEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof ShiftAvailabilityEntity
     */
    'shiftId': number;
    /**
     * 
     * @type {boolean}
     * @memberof ShiftAvailabilityEntity
     */
    'answer': boolean;
    /**
     * 
     * @type {ShiftEntity}
     * @memberof ShiftAvailabilityEntity
     */
    'shift'?: ShiftEntity;
    /**
     * 
     * @type {number}
     * @memberof ShiftAvailabilityEntity
     */
    'requestId': number;
    /**
     * 
     * @type {ShiftAvailabilityEntity}
     * @memberof ShiftAvailabilityEntity
     */
    'ShiftAvailabilityEntity'?: ShiftAvailabilityEntity;
}
/**
 * 
 * @export
 * @interface ShiftAvailabilityRequestEntity
 */
export interface ShiftAvailabilityRequestEntity {
    /**
     * 
     * @type {number}
     * @memberof ShiftAvailabilityRequestEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ShiftAvailabilityRequestEntity
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof ShiftAvailabilityRequestEntity
     */
    'endDate': string;
    /**
     * 
     * @type {string}
     * @memberof ShiftAvailabilityRequestEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof ShiftAvailabilityRequestEntity
     */
    'createdById': number;
    /**
     * 
     * @type {number}
     * @memberof ShiftAvailabilityRequestEntity
     */
    'departmentId': number;
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof ShiftAvailabilityRequestEntity
     */
    'createdBy'?: EmployeeEntity;
    /**
     * 
     * @type {DepartmentEntity}
     * @memberof ShiftAvailabilityRequestEntity
     */
    'department'?: DepartmentEntity;
    /**
     * 
     * @type {boolean}
     * @memberof ShiftAvailabilityRequestEntity
     */
    'closed': boolean;
    /**
     * 
     * @type {string}
     * @memberof ShiftAvailabilityRequestEntity
     */
    'expiration': string;
}
/**
 * 
 * @export
 * @interface ShiftDetailEntity
 */
export interface ShiftDetailEntity {
    /**
     * 
     * @type {number}
     * @memberof ShiftDetailEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ShiftDetailEntity
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof ShiftDetailEntity
     */
    'endTime': string;
    /**
     * 
     * @type {string}
     * @memberof ShiftDetailEntity
     */
    'breakStart': string;
    /**
     * 
     * @type {string}
     * @memberof ShiftDetailEntity
     */
    'breakEnd': string;
    /**
     * 
     * @type {number}
     * @memberof ShiftDetailEntity
     */
    'shiftId': number;
    /**
     * 
     * @type {number}
     * @memberof ShiftDetailEntity
     */
    'workPositionId': number;
    /**
     * 
     * @type {WorkPositionEntity}
     * @memberof ShiftDetailEntity
     */
    'workPosition'?: WorkPositionEntity;
    /**
     * 
     * @type {Array<ShiftAssignmentEntity>}
     * @memberof ShiftDetailEntity
     */
    'shiftAssignments'?: Array<ShiftAssignmentEntity>;
}
/**
 * 
 * @export
 * @interface ShiftEntity
 */
export interface ShiftEntity {
    /**
     * 
     * @type {number}
     * @memberof ShiftEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof ShiftEntity
     */
    'templateId': number;
    /**
     * 
     * @type {string}
     * @memberof ShiftEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ShiftEntity
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof ShiftEntity
     */
    'endTime': string;
    /**
     * 
     * @type {string}
     * @memberof ShiftEntity
     */
    'notes': string | null;
    /**
     * 
     * @type {Array<ShiftDetailEntity>}
     * @memberof ShiftEntity
     */
    'shiftDetails'?: Array<ShiftDetailEntity>;
}
/**
 * 
 * @export
 * @interface ShiftStatisticsEntity
 */
export interface ShiftStatisticsEntity {
    /**
     * Total number of employees currently on duty across all departments (only for current day)
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'totalEmployeesOnDuty': number;
    /**
     * Employees on duty broken down by department (only for current day)
     * @type {Array<DepartmentOnDutyDto>}
     * @memberof ShiftStatisticsEntity
     */
    'employeesOnDutyByDepartment': Array<DepartmentOnDutyDto>;
    /**
     * Average daily hours per department over the period
     * @type {Array<DepartmentHoursStatisticsDto>}
     * @memberof ShiftStatisticsEntity
     */
    'averageDailyHoursByDepartment': Array<DepartmentHoursStatisticsDto>;
    /**
     * 15-minute interval breakdown of average employees on duty (96 intervals per day)
     * @type {Array<IntervalEmployeeCountDto>}
     * @memberof ShiftStatisticsEntity
     */
    'intervalEmployeeCount': Array<IntervalEmployeeCountDto>;
    /**
     * Total number of shifts scheduled for the period
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'totalShiftsScheduled': number;
    /**
     * Number of published shifts
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'publishedShifts': number;
    /**
     * Number of unpublished shifts
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'unpublishedShifts': number;
    /**
     * Peak time interval (15-minute interval with most employees on duty on average)
     * @type {string}
     * @memberof ShiftStatisticsEntity
     */
    'peakInterval': string;
    /**
     * Average number of employees at peak interval
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'peakIntervalEmployeeCount': number;
    /**
     * Average shift duration in hours across all departments
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'averageShiftDuration': number;
    /**
     * Total hours worked across all departments for the period
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'totalHoursWorked': number;
    /**
     * Average daily hours worked per employee across all departments
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'averageDailyHoursAllEmployees': number;
    /**
     * Average daily employee count over the period
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'averageDailyEmployeeCount': number;
    /**
     * Comparison with previous period - average daily employee count (positive = increase, negative = decrease)
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'previousPeriodComparison': number;
    /**
     * Comparison with previous period - total shifts scheduled (positive = increase, negative = decrease)
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'totalShiftsScheduledComparison': number;
    /**
     * Comparison with previous period - published shifts (positive = increase, negative = decrease)
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'publishedShiftsComparison': number;
    /**
     * Comparison with previous period - unpublished shifts (positive = increase, negative = decrease)
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'unpublishedShiftsComparison': number;
    /**
     * Comparison with previous period - peak interval employee count (positive = increase, negative = decrease)
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'peakIntervalEmployeeCountComparison': number;
    /**
     * Comparison with previous period - average shift duration (positive = increase, negative = decrease)
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'averageShiftDurationComparison': number;
    /**
     * Comparison with previous period - total hours worked (positive = increase, negative = decrease)
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'totalHoursWorkedComparison': number;
    /**
     * Comparison with previous period - average daily hours all employees (positive = increase, negative = decrease)
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'averageDailyHoursAllEmployeesComparison': number;
    /**
     * Start date of the period
     * @type {string}
     * @memberof ShiftStatisticsEntity
     */
    'startDate': string;
    /**
     * End date of the period
     * @type {string}
     * @memberof ShiftStatisticsEntity
     */
    'endDate': string;
    /**
     * Number of days in the period
     * @type {number}
     * @memberof ShiftStatisticsEntity
     */
    'periodDays': number;
}
/**
 * 
 * @export
 * @interface ShiftTemplateEntity
 */
export interface ShiftTemplateEntity {
    /**
     * 
     * @type {number}
     * @memberof ShiftTemplateEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ShiftTemplateEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ShiftTemplateEntity
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof ShiftTemplateEntity
     */
    'departmentId': number;
    /**
     * 
     * @type {string}
     * @memberof ShiftTemplateEntity
     */
    'repeatStart': string;
    /**
     * 
     * @type {string}
     * @memberof ShiftTemplateEntity
     */
    'repeatEnd': string;
    /**
     * 
     * @type {Array<object>}
     * @memberof ShiftTemplateEntity
     */
    'days': Array<object>;
    /**
     * 
     * @type {Array<ShiftEntity>}
     * @memberof ShiftTemplateEntity
     */
    'shifts'?: Array<ShiftEntity>;
    /**
     * 
     * @type {number}
     * @memberof ShiftTemplateEntity
     */
    'generatedFromShiftTemplateId': number;
}
/**
 * 
 * @export
 * @interface SignPreContractDto
 */
export interface SignPreContractDto {
    /**
     * \"data:image/png;base64,...\" — hand-drawn signature exported from canvas
     * @type {string}
     * @memberof SignPreContractDto
     */
    'signatureDataUrl': string;
    /**
     * Name typed by the signer; placed under the signature line on the PDF
     * @type {string}
     * @memberof SignPreContractDto
     */
    'fullName': string;
    /**
     * Explicit agreement checkbox
     * @type {boolean}
     * @memberof SignPreContractDto
     */
    'agreed': boolean;
}
/**
 * 
 * @export
 * @interface SimpleDepositEntity
 */
export interface SimpleDepositEntity {
    /**
     * 
     * @type {number}
     * @memberof SimpleDepositEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SimpleDepositEntity
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof SimpleDepositEntity
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof SimpleDepositEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof SimpleDepositEntity
     */
    'createdById': number;
    /**
     * 
     * @type {string}
     * @memberof SimpleDepositEntity
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof SimpleDepositEntity
     */
    'updatedById': number;
}
/**
 * 
 * @export
 * @interface SimpleWorkPositionEntity
 */
export interface SimpleWorkPositionEntity {
    /**
     * 
     * @type {string}
     * @memberof SimpleWorkPositionEntity
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SimpleWorkPositionEntity
     */
    'workPositionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SimpleWorkPositionEntity
     */
    'bossId'?: number | null;
}
/**
 * 
 * @export
 * @interface SpecialDailyNetDto
 */
export interface SpecialDailyNetDto {
    /**
     * Special daily net ID
     * @type {number}
     * @memberof SpecialDailyNetDto
     */
    'id': number;
    /**
     * Employee ID
     * @type {number}
     * @memberof SpecialDailyNetDto
     */
    'employeeId': number;
    /**
     * Agreement ID
     * @type {number}
     * @memberof SpecialDailyNetDto
     */
    'agreementId': number;
    /**
     * Net amount
     * @type {number}
     * @memberof SpecialDailyNetDto
     */
    'net': number;
    /**
     * Encrypted net amount
     * @type {string}
     * @memberof SpecialDailyNetDto
     */
    'net_encrypted'?: string;
    /**
     * Date
     * @type {string}
     * @memberof SpecialDailyNetDto
     */
    'date': string;
    /**
     * Notes
     * @type {string}
     * @memberof SpecialDailyNetDto
     */
    'notes'?: string;
    /**
     * Created at
     * @type {string}
     * @memberof SpecialDailyNetDto
     */
    'createdAt': string;
    /**
     * Created by ID
     * @type {number}
     * @memberof SpecialDailyNetDto
     */
    'createdById': number;
}
/**
 * 
 * @export
 * @interface StageOrderItem
 */
export interface StageOrderItem {
    /**
     * Pipeline stage ID
     * @type {number}
     * @memberof StageOrderItem
     */
    'id': number;
    /**
     * New order position (0-based)
     * @type {number}
     * @memberof StageOrderItem
     */
    'order': number;
}
/**
 * 
 * @export
 * @interface StatusChangeEntity
 */
export interface StatusChangeEntity {
    /**
     * 
     * @type {number}
     * @memberof StatusChangeEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof StatusChangeEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof StatusChangeEntity
     */
    'seasonId': number;
    /**
     * 
     * @type {string}
     * @memberof StatusChangeEntity
     */
    'timeStamp': string;
    /**
     * 
     * @type {string}
     * @memberof StatusChangeEntity
     */
    'date': string;
    /**
     * 
     * @type {boolean}
     * @memberof StatusChangeEntity
     */
    'applied': boolean;
    /**
     * 
     * @type {string}
     * @memberof StatusChangeEntity
     */
    'note': string;
    /**
     * 
     * @type {number}
     * @memberof StatusChangeEntity
     */
    'authorId': number;
    /**
     * 
     * @type {object}
     * @memberof StatusChangeEntity
     */
    'newStatustype': object;
    /**
     * 
     * @type {object}
     * @memberof StatusChangeEntity
     */
    'previousStatusType': object;
    /**
     * 
     * @type {number}
     * @memberof StatusChangeEntity
     */
    'newStatusId': number;
    /**
     * 
     * @type {number}
     * @memberof StatusChangeEntity
     */
    'previousStatusId': number;
    /**
     * 
     * @type {string}
     * @memberof StatusChangeEntity
     */
    'filePath': string;
    /**
     * 
     * @type {StatusEntity}
     * @memberof StatusChangeEntity
     */
    'previusStatus'?: StatusEntity;
    /**
     * 
     * @type {StatusEntity}
     * @memberof StatusChangeEntity
     */
    'newStatus'?: StatusEntity;
}
/**
 * 
 * @export
 * @interface StatusEntity
 */
export interface StatusEntity {
    /**
     * 
     * @type {number}
     * @memberof StatusEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof StatusEntity
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof StatusEntity
     */
    'color': string;
}
/**
 * 
 * @export
 * @interface SubordinateOrderEntity
 */
export interface SubordinateOrderEntity {
    /**
     * 
     * @type {number}
     * @memberof SubordinateOrderEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof SubordinateOrderEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof SubordinateOrderEntity
     */
    'departmentId': number;
    /**
     * 
     * @type {number}
     * @memberof SubordinateOrderEntity
     */
    'seasonId': number;
    /**
     * 
     * @type {number}
     * @memberof SubordinateOrderEntity
     */
    'subordinateId': number;
    /**
     * 
     * @type {number}
     * @memberof SubordinateOrderEntity
     */
    'order': number;
    /**
     *
     * @type {boolean}
     * @memberof SubordinateOrderEntity
     */
    'isHidden': boolean;
}
/**
 * 
 * @export
 * @interface SubordinateOrderItemDto
 */
export interface SubordinateOrderItemDto {
    /**
     * 
     * @type {number}
     * @memberof SubordinateOrderItemDto
     */
    'subordinateId': number;
    /**
     * 
     * @type {number}
     * @memberof SubordinateOrderItemDto
     */
    'departmentId': number;
    /**
     * 
     * @type {number}
     * @memberof SubordinateOrderItemDto
     */
    'seasonId': number;
    /**
     * 
     * @type {number}
     * @memberof SubordinateOrderItemDto
     */
    'order': number;
    /**
     *
     * @type {boolean}
     * @memberof SubordinateOrderItemDto
     */
    'isHidden'?: boolean;
}
/**
 * 
 * @export
 * @interface TenantBankingInformationEntity
 */
export interface TenantBankingInformationEntity {
    /**
     * 
     * @type {number}
     * @memberof TenantBankingInformationEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TenantBankingInformationEntity
     */
    'iban': string;
    /**
     * 
     * @type {string}
     * @memberof TenantBankingInformationEntity
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof TenantBankingInformationEntity
     */
    'bicSwift': string;
}
/**
 * 
 * @export
 * @interface TenantConfigEntity
 */
export interface TenantConfigEntity {
    /**
     * 
     * @type {number}
     * @memberof TenantConfigEntity
     */
    'id': number;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigEntity
     */
    'isEncryptionMandatory': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigEntity
     */
    'isPasswordSet': boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    'encryptedPassword': string;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    'testPasswordValue': string;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    'testBackupPasswordValue': string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigEntity
     */
    'emailsToEmployees': boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    'housekeepingManagerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    'monthlyMailReport': string;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    'jobsEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigEntity
     */
    'sendHouseKeepingEMail': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigEntity
     */
    'sendMontlhyMailReport': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigEntity
     */
    'sendDailyMails': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigEntity
     */
    'sendTurnoverMails': boolean;
    /**
     * 
     * @type {number}
     * @memberof TenantConfigEntity
     */
    'daysToConfirmAvailability': number;
    /**
     * 
     * @type {object}
     * @memberof TenantConfigEntity
     */
    'shiftInhertianceBehaviour': object;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigEntity
     */
    'requireContractForShifts': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigEntity
     */
    'isHRModuleActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigEntity
     */
    'isTurnoverModuleActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigEntity
     */
    'encryptDocumentsByDefault': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigEntity
     */
    'shiftsArePublic': boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    'whatsappEndpoint': string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    'whatsappToken': string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    'whatsappInstanceId': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigEntity
     */
    'vacatioinInHours': boolean;
    /**
     * 
     * @type {number}
     * @memberof TenantConfigEntity
     */
    'defaultHoursVacation': number;
    /**
     * 
     * @type {number}
     * @memberof TenantConfigEntity
     */
    'defaultDaysVacation': number;
    /**
     * 
     * @type {number}
     * @memberof TenantConfigEntity
     */
    'defaultWeeklyHours': number;
    /**
     * 
     * @type {number}
     * @memberof TenantConfigEntity
     */
    'safetyAreaZoomFactor': number;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    'globalJobDescription': string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    'companyBenefits': string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    'logoUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    'coverImageUrl': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantConfigEntity
     */
    'isTimeAttendanceActive': boolean;
    /**
     * 
     * @type {object}
     * @memberof TenantConfigEntity
     */
    'timeTrackingPolicy': object | null;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    'holidayRegionCode': string | null;
}
/**
 * 
 * @export
 * @interface TenantConfigResponseDto
 */
export interface TenantConfigResponseDto {
    /**
     * Whether HR module is active
     * @type {boolean}
     * @memberof TenantConfigResponseDto
     */
    'isHRModuleActive': boolean;
    /**
     * Whether turnover module is active
     * @type {boolean}
     * @memberof TenantConfigResponseDto
     */
    'isTurnoverModuleActive': boolean;
    /**
     * Whether shifts are public
     * @type {boolean}
     * @memberof TenantConfigResponseDto
     */
    'shiftsArePublic': boolean;
    /**
     * Whether vacation is calculated in hours
     * @type {boolean}
     * @memberof TenantConfigResponseDto
     */
    'vacatioinInHours': boolean;
    /**
     * Default hours of vacation
     * @type {number}
     * @memberof TenantConfigResponseDto
     */
    'defaultHoursVacation': number;
    /**
     * Default days of vacation
     * @type {number}
     * @memberof TenantConfigResponseDto
     */
    'defaultDaysVacation': number;
    /**
     * Default weekly working hours
     * @type {number}
     * @memberof TenantConfigResponseDto
     */
    'defaultWeeklyHours': number;
    /**
     * Shift inheritance behaviour
     * @type {string}
     * @memberof TenantConfigResponseDto
     */
    'shiftInhertianceBehaviour': TenantConfigResponseDtoShiftInhertianceBehaviourEnum;
    /**
     * 
     * @type {number}
     * @memberof TenantConfigResponseDto
     */
    'safetyAreaZoomFactor': number;
    /**
     * Whether time & attendance (Presenze) module is active
     * @type {boolean}
     * @memberof TenantConfigResponseDto
     */
    'isTimeAttendanceActive': boolean;
    /**
     * Public holiday region code (ISO 3166-2 style, e.g. IT, IT-BZ, IT-TN)
     * @type {string}
     * @memberof TenantConfigResponseDto
     */
    'holidayRegionCode'?: string | null;
    /**
     * Tenant config ID
     * @type {number}
     * @memberof TenantConfigResponseDto
     */
    'id'?: number;
    /**
     * Whether encryption is mandatory
     * @type {boolean}
     * @memberof TenantConfigResponseDto
     */
    'isEncryptionMandatory'?: boolean;
    /**
     * Whether password is set
     * @type {boolean}
     * @memberof TenantConfigResponseDto
     */
    'isPasswordSet'?: boolean;
    /**
     * Encrypted password (sensitive)
     * @type {string}
     * @memberof TenantConfigResponseDto
     */
    'encryptedPassword'?: string;
    /**
     * Test password value (sensitive)
     * @type {string}
     * @memberof TenantConfigResponseDto
     */
    'testPasswordValue'?: string;
    /**
     * Test backup password value (sensitive)
     * @type {string}
     * @memberof TenantConfigResponseDto
     */
    'testBackupPasswordValue'?: string;
    /**
     * Whether to email employees
     * @type {boolean}
     * @memberof TenantConfigResponseDto
     */
    'emailsToEmployees'?: boolean;
    /**
     * Housekeeping manager email
     * @type {string}
     * @memberof TenantConfigResponseDto
     */
    'housekeepingManagerEmail'?: string;
    /**
     * Monthly mail report email
     * @type {string}
     * @memberof TenantConfigResponseDto
     */
    'monthlyMailReport'?: string;
    /**
     * Reply-to address used for emails sent from the recruitment / applications module
     * @type {string}
     * @memberof TenantConfigResponseDto
     */
    'jobsEmail'?: string | null;
    /**
     * Whether to send housekeeping emails
     * @type {boolean}
     * @memberof TenantConfigResponseDto
     */
    'sendHouseKeepingEMail'?: boolean;
    /**
     * Whether to send monthly mail report
     * @type {boolean}
     * @memberof TenantConfigResponseDto
     */
    'sendMontlhyMailReport'?: boolean;
    /**
     * Whether to send daily mails
     * @type {boolean}
     * @memberof TenantConfigResponseDto
     */
    'sendDailyMails'?: boolean;
    /**
     * Whether to send turnover mails
     * @type {boolean}
     * @memberof TenantConfigResponseDto
     */
    'sendTurnoverMails'?: boolean;
    /**
     * Days to confirm availability
     * @type {number}
     * @memberof TenantConfigResponseDto
     */
    'daysToConfirmAvailability'?: number;
    /**
     * Whether contract is required for shifts
     * @type {boolean}
     * @memberof TenantConfigResponseDto
     */
    'requireContractForShifts'?: boolean;
    /**
     * Whether to encrypt documents by default
     * @type {boolean}
     * @memberof TenantConfigResponseDto
     */
    'encryptDocumentsByDefault'?: boolean;
    /**
     * WhatsApp endpoint
     * @type {string}
     * @memberof TenantConfigResponseDto
     */
    'whatsappEndpoint'?: string | null;
    /**
     * WhatsApp token
     * @type {string}
     * @memberof TenantConfigResponseDto
     */
    'whatsappToken'?: string | null;
    /**
     * WhatsApp instance ID
     * @type {string}
     * @memberof TenantConfigResponseDto
     */
    'whatsappInstanceId'?: string | null;
    /**
     * Global job description (rich HTML)
     * @type {string}
     * @memberof TenantConfigResponseDto
     */
    'globalJobDescription'?: string | null;
    /**
     * Company benefits (rich HTML)
     * @type {string}
     * @memberof TenantConfigResponseDto
     */
    'companyBenefits'?: string | null;
    /**
     * Company logo URL
     * @type {string}
     * @memberof TenantConfigResponseDto
     */
    'logoUrl'?: string | null;
    /**
     * Company cover image URL
     * @type {string}
     * @memberof TenantConfigResponseDto
     */
    'coverImageUrl'?: string | null;
}

export const TenantConfigResponseDtoShiftInhertianceBehaviourEnum = {
    None: 'NONE',
    Upwards: 'UPWARDS',
    Downwards: 'DOWNWARDS',
    Both: 'BOTH'
} as const;

export type TenantConfigResponseDtoShiftInhertianceBehaviourEnum = typeof TenantConfigResponseDtoShiftInhertianceBehaviourEnum[keyof typeof TenantConfigResponseDtoShiftInhertianceBehaviourEnum];

/**
 * 
 * @export
 * @interface TicketItemEntity
 */
export interface TicketItemEntity {
    /**
     * 
     * @type {number}
     * @memberof TicketItemEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TicketItemEntity
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof TicketItemEntity
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof TicketItemEntity
     */
    'resetAtDate': string;
    /**
     * 
     * @type {number}
     * @memberof TicketItemEntity
     */
    'resetAtValue': number;
    /**
     * 
     * @type {number}
     * @memberof TicketItemEntity
     */
    'taxPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof TicketItemEntity
     */
    'paymentSectionId': number;
    /**
     * 
     * @type {number}
     * @memberof TicketItemEntity
     */
    'paymentSectionToExcludeId': number | null;
    /**
     * 
     * @type {SectionEntity}
     * @memberof TicketItemEntity
     */
    'paymentSection'?: SectionEntity;
}
/**
 * 
 * @export
 * @interface TicketItemWithDailyEntity
 */
export interface TicketItemWithDailyEntity {
    /**
     * 
     * @type {number}
     * @memberof TicketItemWithDailyEntity
     */
    'dailyTurnoverSum': number;
    /**
     * 
     * @type {number}
     * @memberof TicketItemWithDailyEntity
     */
    'dailyTurnoverSumToExclude': number;
    /**
     * 
     * @type {Array<DailyTicketingEntity>}
     * @memberof TicketItemWithDailyEntity
     */
    'DailyTicketing': Array<DailyTicketingEntity>;
    /**
     * 
     * @type {SectionEntity}
     * @memberof TicketItemWithDailyEntity
     */
    'paymentSection'?: SectionEntity;
    /**
     * 
     * @type {number}
     * @memberof TicketItemWithDailyEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TicketItemWithDailyEntity
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof TicketItemWithDailyEntity
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof TicketItemWithDailyEntity
     */
    'resetAtDate': string;
    /**
     * 
     * @type {number}
     * @memberof TicketItemWithDailyEntity
     */
    'resetAtValue': number;
    /**
     * 
     * @type {number}
     * @memberof TicketItemWithDailyEntity
     */
    'taxPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof TicketItemWithDailyEntity
     */
    'paymentSectionId': number;
    /**
     * 
     * @type {number}
     * @memberof TicketItemWithDailyEntity
     */
    'paymentSectionToExcludeId': number | null;
}
/**
 * 
 * @export
 * @interface TimeEntryBreakResponseDto
 */
export interface TimeEntryBreakResponseDto {
    /**
     * 
     * @type {number}
     * @memberof TimeEntryBreakResponseDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TimeEntryBreakResponseDto
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TimeEntryBreakResponseDto
     */
    'endedAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TimeEntryBreakResponseDto
     */
    'isAutoDeducted': boolean;
}
/**
 * 
 * @export
 * @interface TimeEntryGridCellDto
 */
export interface TimeEntryGridCellDto {
    /**
     * YYYY-MM-DD local date in tenant TZ
     * @type {string}
     * @memberof TimeEntryGridCellDto
     */
    'date': string;
    /**
     * 
     * @type {Array<PlannedShiftSummaryDto>}
     * @memberof TimeEntryGridCellDto
     */
    'plannedShiftAssignments': Array<PlannedShiftSummaryDto>;
    /**
     * 
     * @type {Array<TimeEntryResponseDto>}
     * @memberof TimeEntryGridCellDto
     */
    'actualEntries': Array<TimeEntryResponseDto>;
}
/**
 * 
 * @export
 * @interface TimeEntryGridResponseDto
 */
export interface TimeEntryGridResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TimeEntryGridResponseDto
     */
    'fromDate': string;
    /**
     * 
     * @type {string}
     * @memberof TimeEntryGridResponseDto
     */
    'toDate': string;
    /**
     * 
     * @type {Array<TimeEntryGridRowDto>}
     * @memberof TimeEntryGridResponseDto
     */
    'rows': Array<TimeEntryGridRowDto>;
}
/**
 * 
 * @export
 * @interface TimeEntryGridRowDto
 */
export interface TimeEntryGridRowDto {
    /**
     * 
     * @type {number}
     * @memberof TimeEntryGridRowDto
     */
    'employeeId': number;
    /**
     * 
     * @type {string}
     * @memberof TimeEntryGridRowDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof TimeEntryGridRowDto
     */
    'lastName': string;
    /**
     * 
     * @type {Array<TimeEntryGridCellDto>}
     * @memberof TimeEntryGridRowDto
     */
    'cells': Array<TimeEntryGridCellDto>;
}
/**
 * 
 * @export
 * @interface TimeEntryResponseDto
 */
export interface TimeEntryResponseDto {
    /**
     * 
     * @type {number}
     * @memberof TimeEntryResponseDto
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof TimeEntryResponseDto
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof TimeEntryResponseDto
     */
    'seasonId': number;
    /**
     * 
     * @type {string}
     * @memberof TimeEntryResponseDto
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TimeEntryResponseDto
     */
    'endedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TimeEntryResponseDto
     */
    'status': TimeEntryResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TimeEntryResponseDto
     */
    'varianceReason'?: TimeEntryResponseDtoVarianceReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof TimeEntryResponseDto
     */
    'varianceNote'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TimeEntryResponseDto
     */
    'matchedShiftAssignmentId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TimeEntryResponseDto
     */
    'matchConfidence'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TimeEntryResponseDto
     */
    'clockInSource': TimeEntryResponseDtoClockInSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof TimeEntryResponseDto
     */
    'clockOutSource'?: TimeEntryResponseDtoClockOutSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof TimeEntryResponseDto
     */
    'enteredByEmployeeId'?: number | null;
    /**
     * 
     * @type {Array<TimeEntryBreakResponseDto>}
     * @memberof TimeEntryResponseDto
     */
    'breaks': Array<TimeEntryBreakResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof TimeEntryResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TimeEntryResponseDto
     */
    'updatedAt': string;
}

export const TimeEntryResponseDtoStatusEnum = {
    Draft: 'DRAFT',
    Recorded: 'RECORDED',
    Validated: 'VALIDATED',
    PendingReview: 'PENDING_REVIEW',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
} as const;

export type TimeEntryResponseDtoStatusEnum = typeof TimeEntryResponseDtoStatusEnum[keyof typeof TimeEntryResponseDtoStatusEnum];
export const TimeEntryResponseDtoVarianceReasonEnum = {
    Nominal: 'NOMINAL',
    LateIn: 'LATE_IN',
    EarlyIn: 'EARLY_IN',
    EarlyOut: 'EARLY_OUT',
    OvertimePlanned: 'OVERTIME_PLANNED',
    OvertimeUnplanned: 'OVERTIME_UNPLANNED',
    MissedShift: 'MISSED_SHIFT',
    PartialShift: 'PARTIAL_SHIFT',
    RestDayWork: 'REST_DAY_WORK',
    Ambiguous: 'AMBIGUOUS'
} as const;

export type TimeEntryResponseDtoVarianceReasonEnum = typeof TimeEntryResponseDtoVarianceReasonEnum[keyof typeof TimeEntryResponseDtoVarianceReasonEnum];
export const TimeEntryResponseDtoClockInSourceEnum = {
    ManagerManual: 'MANAGER_MANUAL',
    MobileApp: 'MOBILE_APP',
    External: 'EXTERNAL',
    System: 'SYSTEM'
} as const;

export type TimeEntryResponseDtoClockInSourceEnum = typeof TimeEntryResponseDtoClockInSourceEnum[keyof typeof TimeEntryResponseDtoClockInSourceEnum];
export const TimeEntryResponseDtoClockOutSourceEnum = {
    ManagerManual: 'MANAGER_MANUAL',
    MobileApp: 'MOBILE_APP',
    External: 'EXTERNAL',
    System: 'SYSTEM'
} as const;

export type TimeEntryResponseDtoClockOutSourceEnum = typeof TimeEntryResponseDtoClockOutSourceEnum[keyof typeof TimeEntryResponseDtoClockOutSourceEnum];

/**
 * 
 * @export
 * @interface TimeToHireDto
 */
export interface TimeToHireDto {
    /**
     * Average days from application to hire
     * @type {number}
     * @memberof TimeToHireDto
     */
    'days': number;
    /**
     * Number of hired candidates in the calculation
     * @type {number}
     * @memberof TimeToHireDto
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface TokensEntity
 */
export interface TokensEntity {
    /**
     * 
     * @type {string}
     * @memberof TokensEntity
     */
    'access_token': string;
    /**
     * 
     * @type {string}
     * @memberof TokensEntity
     */
    'refresh_token': string;
}
/**
 * 
 * @export
 * @interface TopJobAdDto
 */
export interface TopJobAdDto {
    /**
     * 
     * @type {number}
     * @memberof TopJobAdDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TopJobAdDto
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof TopJobAdDto
     */
    'applicationCount': number;
}
/**
 * 
 * @export
 * @interface TrainingCourseEntity
 */
export interface TrainingCourseEntity {
    /**
     * 
     * @type {number}
     * @memberof TrainingCourseEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof TrainingCourseEntity
     */
    'courseTypeId': number;
    /**
     * 
     * @type {string}
     * @memberof TrainingCourseEntity
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof TrainingCourseEntity
     */
    'provider'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingCourseEntity
     */
    'location'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingCourseEntity
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof TrainingCourseEntity
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrainingCourseEntity
     */
    'hours'?: number | null;
    /**
     * 
     * @type {object}
     * @memberof TrainingCourseEntity
     */
    'cost'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingCourseEntity
     */
    'notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrainingCourseEntity
     */
    'seasonId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingCourseEntity
     */
    'status': TrainingCourseEntityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TrainingCourseEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrainingCourseEntity
     */
    'updatedAt': string;
}

export const TrainingCourseEntityStatusEnum = {
    Scheduled: 'SCHEDULED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED'
} as const;

export type TrainingCourseEntityStatusEnum = typeof TrainingCourseEntityStatusEnum[keyof typeof TrainingCourseEntityStatusEnum];

/**
 * 
 * @export
 * @interface TrainingRequirementEntity
 */
export interface TrainingRequirementEntity {
    /**
     * 
     * @type {number}
     * @memberof TrainingRequirementEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof TrainingRequirementEntity
     */
    'courseTypeId': number;
    /**
     * 
     * @type {number}
     * @memberof TrainingRequirementEntity
     */
    'departmentId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrainingRequirementEntity
     */
    'workPositionId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingRequirementEntity
     */
    'isRequired': boolean;
}
/**
 * 
 * @export
 * @interface TurnoverComparisonDto
 */
export interface TurnoverComparisonDto {
    /**
     * 
     * @type {DateRange}
     * @memberof TurnoverComparisonDto
     */
    'periodA': DateRange;
    /**
     * 
     * @type {DateRange}
     * @memberof TurnoverComparisonDto
     */
    'periodB': DateRange;
    /**
     * 
     * @type {Array<number>}
     * @memberof TurnoverComparisonDto
     */
    'sectionIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof TurnoverComparisonDto
     */
    'paymentMethodIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof TurnoverComparisonDto
     */
    'departmentIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface TurnoverDepositableSumEntity
 */
export interface TurnoverDepositableSumEntity {
    /**
     * 
     * @type {number}
     * @memberof TurnoverDepositableSumEntity
     */
    'paymentSectionId': number;
    /**
     * 
     * @type {TurnoverDepositableSumEntitySum}
     * @memberof TurnoverDepositableSumEntity
     */
    '_sum': TurnoverDepositableSumEntitySum;
}
/**
 * 
 * @export
 * @interface TurnoverDepositableSumEntitySum
 */
export interface TurnoverDepositableSumEntitySum {
    /**
     * 
     * @type {number}
     * @memberof TurnoverDepositableSumEntitySum
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface TurnoverItemEntity
 */
export interface TurnoverItemEntity {
    /**
     * 
     * @type {string}
     * @memberof TurnoverItemEntity
     */
    'status': TurnoverItemEntityStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof TurnoverItemEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TurnoverItemEntity
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof TurnoverItemEntity
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof TurnoverItemEntity
     */
    'paymentMethodId': number;
    /**
     * 
     * @type {number}
     * @memberof TurnoverItemEntity
     */
    'paymentSectionId': number;
    /**
     * 
     * @type {SectionEntity}
     * @memberof TurnoverItemEntity
     */
    'paymentSection'?: SectionEntity;
    /**
     * 
     * @type {number}
     * @memberof TurnoverItemEntity
     */
    'createdById': number;
    /**
     * 
     * @type {number}
     * @memberof TurnoverItemEntity
     */
    'updatedById': number;
    /**
     * 
     * @type {string}
     * @memberof TurnoverItemEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TurnoverItemEntity
     */
    'updatedAt': string | null;
    /**
     * 
     * @type {number}
     * @memberof TurnoverItemEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {number}
     * @memberof TurnoverItemEntity
     */
    'controllerId': number;
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof TurnoverItemEntity
     */
    'controller'?: EmployeeEntity;
    /**
     * 
     * @type {boolean}
     * @memberof TurnoverItemEntity
     */
    'wasModifiedByController': boolean;
}

export const TurnoverItemEntityStatusEnum = {
    Cashed: 'CASHED',
    Received: 'RECEIVED',
    Confirmed: 'CONFIRMED'
} as const;

export type TurnoverItemEntityStatusEnum = typeof TurnoverItemEntityStatusEnum[keyof typeof TurnoverItemEntityStatusEnum];

/**
 * 
 * @export
 * @interface UpdateAccountDto
 */
export interface UpdateAccountDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountDto
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountDto
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface UpdateAdditionalInformationDto
 */
export interface UpdateAdditionalInformationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAdditionalInformationDto
     */
    'foodRequirments'?: UpdateAdditionalInformationDtoFoodRequirmentsEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdditionalInformationDto
     */
    'shirtSize'?: UpdateAdditionalInformationDtoShirtSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdditionalInformationDto
     */
    'customFoodRequirments'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAdditionalInformationDto
     */
    'pantsSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdditionalInformationDto
     */
    'typeName'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAdditionalInformationDto
     */
    'employeeId'?: number;
}

export const UpdateAdditionalInformationDtoFoodRequirmentsEnum = {
    Gluten: 'GLUTEN',
    Dairy: 'DAIRY',
    Egg: 'EGG',
    Fish: 'FISH',
    Soy: 'SOY',
    Peanut: 'PEANUT',
    Vegeterian: 'VEGETERIAN',
    Vegan: 'VEGAN',
    Halal: 'HALAL',
    Kosher: 'KOSHER',
    Crustacean: 'CRUSTACEAN',
    Nut: 'NUT',
    Celery: 'CELERY',
    Mustard: 'MUSTARD',
    Sesame: 'SESAME',
    Clam: 'CLAM',
    Lupine: 'LUPINE',
    Solfite: 'SOLFITE'
} as const;

export type UpdateAdditionalInformationDtoFoodRequirmentsEnum = typeof UpdateAdditionalInformationDtoFoodRequirmentsEnum[keyof typeof UpdateAdditionalInformationDtoFoodRequirmentsEnum];
export const UpdateAdditionalInformationDtoShirtSizeEnum = {
    Xxs: 'XXS',
    Xs: 'XS',
    S: 'S',
    M: 'M',
    L: 'L',
    Xl: 'XL',
    Xxl: 'XXL',
    Xxxl: 'XXXL'
} as const;

export type UpdateAdditionalInformationDtoShirtSizeEnum = typeof UpdateAdditionalInformationDtoShirtSizeEnum[keyof typeof UpdateAdditionalInformationDtoShirtSizeEnum];

/**
 * 
 * @export
 * @interface UpdateAgreementDto
 */
export interface UpdateAgreementDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateAgreementDto
     */
    'net_daily'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgreementDto
     */
    'startedOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgreementDto
     */
    'endedOn'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAgreementDto
     */
    'isLongTheWholeContract'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgreementDto
     */
    'notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAgreementDto
     */
    'downpayment'?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof UpdateAgreementDto
     */
    'freeDays'?: Array<object>;
    /**
     * 
     * @type {number}
     * @memberof UpdateAgreementDto
     */
    'contractId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgreementDto
     */
    'net_daily_encrypted'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAgreementDto
     */
    'createDaysAutomatically'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateAgreementDto
     */
    'daysOff'?: number;
    /**
     * Vacation hours - cannot be set if daysVacation is provided
     * @type {number}
     * @memberof UpdateAgreementDto
     */
    'hoursVacation'?: number;
    /**
     * Vacation days - cannot be set if hoursVacation is provided
     * @type {number}
     * @memberof UpdateAgreementDto
     */
    'daysVacation'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAgreementDto
     */
    'balance730'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgreementDto
     */
    'balance730_encrypted'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgreementDto
     */
    'balance730_date'?: string;
    /**
     * Weekly work hours for this agreement
     * @type {number}
     * @memberof UpdateAgreementDto
     */
    'weeklyWorkHours'?: number;
    /**
     * Fully-loaded employer cost per worked hour, in EUR (plain).
     * @type {number}
     * @memberof UpdateAgreementDto
     */
    'costPerHour'?: number;
    /**
     * Encrypted costPerHour blob (frontend-encrypted).
     * @type {string}
     * @memberof UpdateAgreementDto
     */
    'costPerHour_encrypted'?: string;
}
/**
 * 
 * @export
 * @interface UpdateAvailabilityRequestDto
 */
export interface UpdateAvailabilityRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailabilityRequestDto
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailabilityRequestDto
     */
    'endDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailabilityRequestDto
     */
    'departmentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailabilityRequestDto
     */
    'seasonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailabilityRequestDto
     */
    'expirationDate'?: string;
}
/**
 * 
 * @export
 * @interface UpdateBankingInformationDto
 */
export interface UpdateBankingInformationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateBankingInformationDto
     */
    'bankName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBankingInformationDto
     */
    'iban'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBankingInformationDto
     */
    'bicSwift'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateBankingInformationDto
     */
    'employeeId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateBreakDto
 */
export interface UpdateBreakDto {
    /**
     * Existing break ID to update; omit for new breaks
     * @type {number}
     * @memberof UpdateBreakDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBreakDto
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBreakDto
     */
    'endedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBreakDto
     */
    'isAutoDeducted'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateBuildingDto
 */
export interface UpdateBuildingDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateBuildingDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBuildingDto
     */
    'address'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateBuildingDto
     */
    'cost'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBuildingDto
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBuildingDto
     */
    'endDate'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateCandidateDto
 */
export interface UpdateCandidateDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCandidateDto
     */
    'tenantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCandidateDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCandidateDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCandidateDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCandidateDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCandidateDto
     */
    'gender'?: UpdateCandidateDtoGenderEnum;
}

export const UpdateCandidateDtoGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Undefined: 'UNDEFINED'
} as const;

export type UpdateCandidateDtoGenderEnum = typeof UpdateCandidateDtoGenderEnum[keyof typeof UpdateCandidateDtoGenderEnum];

/**
 * 
 * @export
 * @interface UpdateContractDto
 */
export interface UpdateContractDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateContractDto
     */
    'legalContractType'?: UpdateContractDtoLegalContractTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractDto
     */
    'startedOn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractDto
     */
    'endedOn'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateContractDto
     */
    'isAllIncluded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateContractDto
     */
    'isFoodIncluded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateContractDto
     */
    'isHousingIncluded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateContractDto
     */
    'isPartTime'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateContractDto
     */
    'workPercentage'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractDto
     */
    'probationPeriod'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateContractDto
     */
    'probationPeriodDays'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateContractDto
     */
    'employeeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractDto
     */
    'levelName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractDto
     */
    'typeName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateContractDto
     */
    'isDraft'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateContractDto
     */
    'seasonId'?: number;
}

export const UpdateContractDtoLegalContractTypeEnum = {
    Limited: 'LIMITED',
    Unlimited: 'UNLIMITED',
    Internship: 'INTERNSHIP',
    Call: 'CALL',
    Apprenticeship: 'APPRENTICESHIP'
} as const;

export type UpdateContractDtoLegalContractTypeEnum = typeof UpdateContractDtoLegalContractTypeEnum[keyof typeof UpdateContractDtoLegalContractTypeEnum];

/**
 * 
 * @export
 * @interface UpdateContractTypeDto
 */
export interface UpdateContractTypeDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateContractTypeDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UpdateCourseTypeDto
 */
export interface UpdateCourseTypeDto {
    /**
     * Unique name of the course type
     * @type {string}
     * @memberof UpdateCourseTypeDto
     */
    'name'?: string;
    /**
     * Description of the course type
     * @type {string}
     * @memberof UpdateCourseTypeDto
     */
    'description'?: string;
    /**
     * Category of the course
     * @type {string}
     * @memberof UpdateCourseTypeDto
     */
    'category'?: UpdateCourseTypeDtoCategoryEnum;
    /**
     * Validity period in months (null = never expires)
     * @type {number}
     * @memberof UpdateCourseTypeDto
     */
    'validityMonths'?: number;
    /**
     * Required training hours
     * @type {number}
     * @memberof UpdateCourseTypeDto
     */
    'requiredHours'?: number;
    /**
     * Whether this course is legally mandatory
     * @type {boolean}
     * @memberof UpdateCourseTypeDto
     */
    'isMandatory'?: boolean;
    /**
     * Whether this course type is active
     * @type {boolean}
     * @memberof UpdateCourseTypeDto
     */
    'isActive'?: boolean;
}

export const UpdateCourseTypeDtoCategoryEnum = {
    Haccp: 'HACCP',
    Safety: 'SAFETY',
    FirstAid: 'FIRST_AID',
    FirePrevention: 'FIRE_PREVENTION',
    Equipment: 'EQUIPMENT',
    Language: 'LANGUAGE',
    Professional: 'PROFESSIONAL',
    Other: 'OTHER'
} as const;

export type UpdateCourseTypeDtoCategoryEnum = typeof UpdateCourseTypeDtoCategoryEnum[keyof typeof UpdateCourseTypeDtoCategoryEnum];

/**
 * 
 * @export
 * @interface UpdateDailyNoteDto
 */
export interface UpdateDailyNoteDto {
    /**
     * The text content of the daily note
     * @type {string}
     * @memberof UpdateDailyNoteDto
     */
    'text'?: string;
    /**
     * The date of the daily note
     * @type {string}
     * @memberof UpdateDailyNoteDto
     */
    'date'?: string;
    /**
     * The path to the uploaded image (optional)
     * @type {string}
     * @memberof UpdateDailyNoteDto
     */
    'imagePath'?: string;
}
/**
 * 
 * @export
 * @interface UpdateDailySpecialNetDto
 */
export interface UpdateDailySpecialNetDto {
    /**
     * Employee ID
     * @type {number}
     * @memberof UpdateDailySpecialNetDto
     */
    'employeeId'?: number;
    /**
     * Agreement ID
     * @type {number}
     * @memberof UpdateDailySpecialNetDto
     */
    'agreementId'?: number;
    /**
     * Date (YYYY-MM-DD)
     * @type {string}
     * @memberof UpdateDailySpecialNetDto
     */
    'date'?: string;
    /**
     * Net value
     * @type {number}
     * @memberof UpdateDailySpecialNetDto
     */
    'net'?: number;
    /**
     * Encrypted net value
     * @type {string}
     * @memberof UpdateDailySpecialNetDto
     */
    'net_encrypted'?: string;
    /**
     * Optional notes
     * @type {string}
     * @memberof UpdateDailySpecialNetDto
     */
    'notes'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateDailyTicketDto
 */
export interface UpdateDailyTicketDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyTicketDto
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyTicketDto
     */
    'itemId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyTicketDto
     */
    'value'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyTicketDto
     */
    'employeeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDailyTicketDto
     */
    'createdById'?: number;
}
/**
 * 
 * @export
 * @interface UpdateDepartmentDto
 */
export interface UpdateDepartmentDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDepartmentDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDepartmentDto
     */
    'segmentId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateDepartmentEmployeeDto
 */
export interface UpdateDepartmentEmployeeDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateDepartmentEmployeeDto
     */
    'workPositionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDepartmentEmployeeDto
     */
    'bossEmployeeId'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateDepositDto
 */
export interface UpdateDepositDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDepositDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDepositDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDepositDto
     */
    'paymentSectionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDepositDto
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface UpdateDocumentTypeDto
 */
export interface UpdateDocumentTypeDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDocumentTypeDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UpdateEmailTemplateDto
 */
export interface UpdateEmailTemplateDto {
    /**
     * Template name (e.g. \"Interview Invitation\")
     * @type {string}
     * @memberof UpdateEmailTemplateDto
     */
    'name'?: string;
    /**
     * Email subject line, supports {{placeholders}}
     * @type {string}
     * @memberof UpdateEmailTemplateDto
     */
    'subject'?: string;
    /**
     * HTML body, supports {{placeholders}} like {{candidateName}}, {{jobTitle}}
     * @type {string}
     * @memberof UpdateEmailTemplateDto
     */
    'body'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailTemplateDto
     */
    'triggerType'?: UpdateEmailTemplateDtoTriggerTypeEnum;
    /**
     * Pipeline stage name that triggers this email automatically (e.g. \"Applied\", \"Interview\")
     * @type {string}
     * @memberof UpdateEmailTemplateDto
     */
    'triggerStageName'?: string;
    /**
     * Number of days before contract start/end to send the email
     * @type {number}
     * @memberof UpdateEmailTemplateDto
     */
    'triggerDaysBefore'?: number;
}

export const UpdateEmailTemplateDtoTriggerTypeEnum = {
    Stage: 'STAGE',
    Rejection: 'REJECTION',
    ContractStartReminder: 'CONTRACT_START_REMINDER',
    ContractEndReminder: 'CONTRACT_END_REMINDER',
    JobInvitation: 'JOB_INVITATION'
} as const;

export type UpdateEmailTemplateDtoTriggerTypeEnum = typeof UpdateEmailTemplateDtoTriggerTypeEnum[keyof typeof UpdateEmailTemplateDtoTriggerTypeEnum];

/**
 * 
 * @export
 * @interface UpdateEmployeeCertificationDto
 */
export interface UpdateEmployeeCertificationDto {
    /**
     * Employee ID
     * @type {number}
     * @memberof UpdateEmployeeCertificationDto
     */
    'employeeId'?: number;
    /**
     * Course type ID
     * @type {number}
     * @memberof UpdateEmployeeCertificationDto
     */
    'courseTypeId'?: number;
    /**
     * Date the certification was obtained
     * @type {string}
     * @memberof UpdateEmployeeCertificationDto
     */
    'obtainedDate'?: string;
    /**
     * Expiration date (null = never expires)
     * @type {string}
     * @memberof UpdateEmployeeCertificationDto
     */
    'expirationDate'?: string;
    /**
     * Certificate number or reference
     * @type {string}
     * @memberof UpdateEmployeeCertificationDto
     */
    'certificateNumber'?: string;
    /**
     * Issuing authority or training provider
     * @type {string}
     * @memberof UpdateEmployeeCertificationDto
     */
    'issuingAuthority'?: string;
    /**
     * Additional notes
     * @type {string}
     * @memberof UpdateEmployeeCertificationDto
     */
    'notes'?: string;
}
/**
 * 
 * @export
 * @interface UpdateEmployeeDocumentDto
 */
export interface UpdateEmployeeDocumentDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateEmployeeDocumentDto
     */
    'employeeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDocumentDto
     */
    'typeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDocumentDto
     */
    'expiringDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEmployeeDocumentDto
     */
    'isEncrypted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEmployeeDocumentDto
     */
    'isVisibleForUser'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDocumentDto
     */
    'documentName'?: string;
}
/**
 * 
 * @export
 * @interface UpdateEmployeeDto
 */
export interface UpdateEmployeeDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'role'?: UpdateEmployeeDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'gender'?: UpdateEmployeeDtoGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'filePath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'countryOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'provinceOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'townshipOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'taxcode'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmployeeDto
     */
    'lastPayment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateEmployeeDto
     */
    'seasonId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEmployeeDto
     */
    'canViewShifts'?: boolean;
}

export const UpdateEmployeeDtoRoleEnum = {
    User: 'USER',
    Manager: 'MANAGER',
    Owner: 'OWNER',
    Developer: 'DEVELOPER',
    Depchief: 'DEPCHIEF',
    Termsnotaccepted: 'TERMSNOTACCEPTED',
    Controller: 'CONTROLLER'
} as const;

export type UpdateEmployeeDtoRoleEnum = typeof UpdateEmployeeDtoRoleEnum[keyof typeof UpdateEmployeeDtoRoleEnum];
export const UpdateEmployeeDtoGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Undefined: 'UNDEFINED'
} as const;

export type UpdateEmployeeDtoGenderEnum = typeof UpdateEmployeeDtoGenderEnum[keyof typeof UpdateEmployeeDtoGenderEnum];

/**
 * 
 * @export
 * @interface UpdateExperienceLevelDto
 */
export interface UpdateExperienceLevelDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateExperienceLevelDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UpdateHolidayDto
 */
export interface UpdateHolidayDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateHolidayDto
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateHolidayDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateHolidayDto
     */
    'region'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateInterviewDto
 */
export interface UpdateInterviewDto {
    /**
     * Application this interview belongs to
     * @type {number}
     * @memberof UpdateInterviewDto
     */
    'applicationId'?: number;
    /**
     * Optional calendar entry ID to link
     * @type {number}
     * @memberof UpdateInterviewDto
     */
    'calendarEntryId'?: number;
    /**
     * Interview type, e.g. PHONE, VIDEO, ONSITE
     * @type {string}
     * @memberof UpdateInterviewDto
     */
    'type'?: string;
    /**
     * Interview status, e.g. SCHEDULED, COMPLETED, CANCELLED
     * @type {string}
     * @memberof UpdateInterviewDto
     */
    'status'?: string;
    /**
     * Scheduled date/time for the interview
     * @type {string}
     * @memberof UpdateInterviewDto
     */
    'scheduledAt'?: string;
    /**
     * Optional notes about the interview
     * @type {string}
     * @memberof UpdateInterviewDto
     */
    'notes'?: string;
    /**
     * Optional video conference link for VIDEO interviews
     * @type {string}
     * @memberof UpdateInterviewDto
     */
    'videoLink'?: string;
}
/**
 * 
 * @export
 * @interface UpdateJobAdDto
 */
export interface UpdateJobAdDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateJobAdDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobAdDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobAdDto
     */
    'descriptionEn'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobAdDto
     */
    'descriptionIt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobAdDto
     */
    'descriptionDe'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobAdDto
     */
    'descriptionFr'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateJobAdDto
     */
    'workPositionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateJobAdDto
     */
    'departmentId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateJobAdDto
     */
    'isPublic'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateJobAdDto
     */
    'seasonId'?: number;
    /**
     * Minimum salary
     * @type {number}
     * @memberof UpdateJobAdDto
     */
    'salaryMin'?: number;
    /**
     * Maximum salary
     * @type {number}
     * @memberof UpdateJobAdDto
     */
    'salaryMax'?: number;
    /**
     * Currency code (e.g. EUR, USD)
     * @type {string}
     * @memberof UpdateJobAdDto
     */
    'currency'?: string;
    /**
     * Job requirements
     * @type {string}
     * @memberof UpdateJobAdDto
     */
    'requirements'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobAdDto
     */
    'requirementsEn'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobAdDto
     */
    'requirementsIt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobAdDto
     */
    'requirementsDe'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobAdDto
     */
    'requirementsFr'?: string;
    /**
     * Job type (e.g. FULL_TIME, PART_TIME, SEASONAL)
     * @type {string}
     * @memberof UpdateJobAdDto
     */
    'jobType'?: string;
    /**
     * Application deadline (ISO 8601 date string)
     * @type {string}
     * @memberof UpdateJobAdDto
     */
    'deadline'?: string;
    /**
     * Array of image URLs for workplace gallery
     * @type {Array<string>}
     * @memberof UpdateJobAdDto
     */
    'images'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateLicenceDto
 */
export interface UpdateLicenceDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateLicenceDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UpdateMetaSafetyAreaDto
 */
export interface UpdateMetaSafetyAreaDto {
    /**
     * The name of the meta safety area
     * @type {string}
     * @memberof UpdateMetaSafetyAreaDto
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UpdateMyBankingInformationDto
 */
export interface UpdateMyBankingInformationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBankingInformationDto
     */
    'bankName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBankingInformationDto
     */
    'iban'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyBankingInformationDto
     */
    'bicSwift'?: string;
}
/**
 * 
 * @export
 * @interface UpdateNoteDto
 */
export interface UpdateNoteDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateNoteDto
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNoteDto
     */
    'text_encrypted'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateNoteDto
     */
    'authorId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateNoteDto
     */
    'employeeId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateNotesDto
 */
export interface UpdateNotesDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateNotesDto
     */
    'roomId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateNotesDto
     */
    'seasonId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateNotesDto
     */
    'notes': string;
}
/**
 * 
 * @export
 * @interface UpdateOfferLetterDto
 */
export interface UpdateOfferLetterDto {
    /**
     * Application this offer belongs to
     * @type {number}
     * @memberof UpdateOfferLetterDto
     */
    'applicationId'?: number;
    /**
     * Salary offer amount
     * @type {number}
     * @memberof UpdateOfferLetterDto
     */
    'salaryOffer'?: number;
    /**
     * Salary type: NETTO_TUTTO_COMPRESO, LORDO_MENSILE, or RAL
     * @type {string}
     * @memberof UpdateOfferLetterDto
     */
    'salaryType'?: string;
    /**
     * Proposed start date (ISO 8601)
     * @type {string}
     * @memberof UpdateOfferLetterDto
     */
    'startDate'?: string;
    /**
     * Additional offer details as JSON
     * @type {object}
     * @memberof UpdateOfferLetterDto
     */
    'content'?: object;
    /**
     * PENDING | ACCEPTED | DECLINED
     * @type {string}
     * @memberof UpdateOfferLetterDto
     */
    'status'?: UpdateOfferLetterDtoStatusEnum;
}

export const UpdateOfferLetterDtoStatusEnum = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Declined: 'DECLINED'
} as const;

export type UpdateOfferLetterDtoStatusEnum = typeof UpdateOfferLetterDtoStatusEnum[keyof typeof UpdateOfferLetterDtoStatusEnum];

/**
 * 
 * @export
 * @interface UpdatePaymentMethodDto
 */
export interface UpdatePaymentMethodDto {
    /**
     * 
     * @type {object}
     * @memberof UpdatePaymentMethodDto
     */
    'type'?: object;
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentMethodDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaymentMethodDto
     */
    'depositable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdatePaymentMethodDto
     */
    'tenantBankingInformationId'?: number;
}
/**
 * 
 * @export
 * @interface UpdatePublicDocumentDto
 */
export interface UpdatePublicDocumentDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePublicDocumentDto
     */
    'name'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdatePublicDocumentDto
     */
    'departmentIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdatePublicDocumentDto
     */
    'segmentIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdatePublicDocumentDto
     */
    'seasonIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface UpdateRoomAssignmentDto
 */
export interface UpdateRoomAssignmentDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateRoomAssignmentDto
     */
    'employeeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRoomAssignmentDto
     */
    'roomId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRoomAssignmentDto
     */
    'seasonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoomAssignmentDto
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoomAssignmentDto
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoomAssignmentDto
     */
    'notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateRoomAssignmentDto
     */
    'bedIndex'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRoomAssignmentDto
     */
    'previousBookingId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateRoomDto
 */
export interface UpdateRoomDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoomDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateRoomDto
     */
    'buildingId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRoomDto
     */
    'maxTenants'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRoomDto
     */
    'floor'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoomDto
     */
    'accessMode'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateRoomDto
     */
    'bathrooms'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRoomDto
     */
    'hasKitchen'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoomDto
     */
    'notes'?: string;
}
/**
 * 
 * @export
 * @interface UpdateSafetyAreaDto
 */
export interface UpdateSafetyAreaDto {
    /**
     * The name of the safety area
     * @type {string}
     * @memberof UpdateSafetyAreaDto
     */
    'name'?: string;
    /**
     * The ID of the associated meta safety area
     * @type {number}
     * @memberof UpdateSafetyAreaDto
     */
    'metaSafetyAreaId'?: number;
    /**
     * The path to the safety area image
     * @type {string}
     * @memberof UpdateSafetyAreaDto
     */
    'imagePath'?: string;
}
/**
 * 
 * @export
 * @interface UpdateSafetyAreaItemDto
 */
export interface UpdateSafetyAreaItemDto {
    /**
     * The ID of the safety area
     * @type {number}
     * @memberof UpdateSafetyAreaItemDto
     */
    'safetyAreaId'?: number;
    /**
     * The ID of the safety item
     * @type {number}
     * @memberof UpdateSafetyAreaItemDto
     */
    'safetyItemId'?: number;
    /**
     * The X coordinate
     * @type {number}
     * @memberof UpdateSafetyAreaItemDto
     */
    'x'?: number;
    /**
     * The Y coordinate
     * @type {number}
     * @memberof UpdateSafetyAreaItemDto
     */
    'y'?: number;
    /**
     * The name of the safety area item
     * @type {string}
     * @memberof UpdateSafetyAreaItemDto
     */
    'name'?: string;
    /**
     * The serial number
     * @type {string}
     * @memberof UpdateSafetyAreaItemDto
     */
    'serialNumber'?: string;
    /**
     * The description
     * @type {string}
     * @memberof UpdateSafetyAreaItemDto
     */
    'description'?: string;
    /**
     * The check interval in days
     * @type {number}
     * @memberof UpdateSafetyAreaItemDto
     */
    'checkIntervalDays'?: number;
    /**
     * Check intervals to create
     * @type {Array<CreateSafetyItemCheckIntervalDto>}
     * @memberof UpdateSafetyAreaItemDto
     */
    'checkIntervals'?: Array<CreateSafetyItemCheckIntervalDto>;
    /**
     * Area content items to create
     * @type {Array<CreateSafetyItemAreaContentDto>}
     * @memberof UpdateSafetyAreaItemDto
     */
    'areaContents'?: Array<CreateSafetyItemAreaContentDto>;
    /**
     * Checklist items to create
     * @type {Array<CreateSafetyItemAreaChecklistItemDto>}
     * @memberof UpdateSafetyAreaItemDto
     */
    'checklistItems'?: Array<CreateSafetyItemAreaChecklistItemDto>;
}
/**
 * 
 * @export
 * @interface UpdateSafetyItemDto
 */
export interface UpdateSafetyItemDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSafetyItemDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSafetyItemDto
     */
    'imagePath'?: string;
    /**
     * 
     * @type {Array<SafetyItemCheckIntervalEntity>}
     * @memberof UpdateSafetyItemDto
     */
    'safetyItemCheckInterval'?: Array<SafetyItemCheckIntervalEntity>;
    /**
     * 
     * @type {Array<SafetyItemAreaContentEntity>}
     * @memberof UpdateSafetyItemDto
     */
    'safetyItemAreaContent'?: Array<SafetyItemAreaContentEntity>;
    /**
     * 
     * @type {Array<SafetyItemAreaChecklistItemEntity>}
     * @memberof UpdateSafetyItemDto
     */
    'safetyItemAreaChecklistItem'?: Array<SafetyItemAreaChecklistItemEntity>;
}
/**
 * 
 * @export
 * @interface UpdateSeasonDto
 */
export interface UpdateSeasonDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSeasonDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSeasonDto
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSeasonDto
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface UpdateSectionDto
 */
export interface UpdateSectionDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSectionDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSectionDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateSectionDto
     */
    'taxPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSectionDto
     */
    'departmentId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSectionDto
     */
    'onlyToBeShowed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSectionDto
     */
    'stillCountsDepositable'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateShiftAndDetailsWithChoiceDto
 */
export interface UpdateShiftAndDetailsWithChoiceDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftAndDetailsWithChoiceDto
     */
    'choice': UpdateShiftAndDetailsWithChoiceDtoChoiceEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftAndDetailsWithChoiceDto
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftAndDetailsWithChoiceDto
     */
    'departmentId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftAndDetailsWithChoiceDto
     */
    'seasonId': number;
    /**
     * 
     * @type {UpdateShiftDto}
     * @memberof UpdateShiftAndDetailsWithChoiceDto
     */
    'updateShiftDto': UpdateShiftDto;
    /**
     * 
     * @type {Array<UpdateShiftDetailLocalDto>}
     * @memberof UpdateShiftAndDetailsWithChoiceDto
     */
    'updateShiftDetails': Array<UpdateShiftDetailLocalDto>;
}

export const UpdateShiftAndDetailsWithChoiceDtoChoiceEnum = {
    Single: 'single',
    All: 'all',
    Future: 'future'
} as const;

export type UpdateShiftAndDetailsWithChoiceDtoChoiceEnum = typeof UpdateShiftAndDetailsWithChoiceDtoChoiceEnum[keyof typeof UpdateShiftAndDetailsWithChoiceDtoChoiceEnum];

/**
 * 
 * @export
 * @interface UpdateShiftDetailDto
 */
export interface UpdateShiftDetailDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftDetailDto
     */
    'startTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftDetailDto
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftDetailDto
     */
    'breakStart'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftDetailDto
     */
    'breakEnd'?: string | null;
    /**
     * Array of additional breaks
     * @type {Array<AdditionalBreakDto>}
     * @memberof UpdateShiftDetailDto
     */
    'additionalBreaks'?: Array<AdditionalBreakDto>;
}
/**
 * 
 * @export
 * @interface UpdateShiftDetailLocalDto
 */
export interface UpdateShiftDetailLocalDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftDetailLocalDto
     */
    'startTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftDetailLocalDto
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftDetailLocalDto
     */
    'breakStart'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftDetailLocalDto
     */
    'breakEnd'?: string | null;
    /**
     * Array of additional breaks
     * @type {Array<AdditionalBreakDto>}
     * @memberof UpdateShiftDetailLocalDto
     */
    'additionalBreaks'?: Array<AdditionalBreakDto>;
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftDetailLocalDto
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftDetailLocalDto
     */
    'workPositionId': number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateShiftDetailLocalDto
     */
    '_isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateShiftDetailWithChoiceDto
 */
export interface UpdateShiftDetailWithChoiceDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftDetailWithChoiceDto
     */
    'choice': UpdateShiftDetailWithChoiceDtoChoiceEnum;
    /**
     * 
     * @type {UpdateShiftDetailDto}
     * @memberof UpdateShiftDetailWithChoiceDto
     */
    'updateShiftDetailDto': UpdateShiftDetailDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftDetailWithChoiceDto
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftDetailWithChoiceDto
     */
    'departmentId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftDetailWithChoiceDto
     */
    'seasonId': number;
}

export const UpdateShiftDetailWithChoiceDtoChoiceEnum = {
    Single: 'single',
    All: 'all',
    Future: 'future'
} as const;

export type UpdateShiftDetailWithChoiceDtoChoiceEnum = typeof UpdateShiftDetailWithChoiceDtoChoiceEnum[keyof typeof UpdateShiftDetailWithChoiceDtoChoiceEnum];

/**
 * 
 * @export
 * @interface UpdateShiftDto
 */
export interface UpdateShiftDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftDto
     */
    'templateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftDto
     */
    'seasonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftDto
     */
    'notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftDto
     */
    'departmentId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateShiftTemplateDto
 */
export interface UpdateShiftTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftTemplateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftTemplateDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftTemplateDto
     */
    'departmentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftTemplateDto
     */
    'repeatStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftTemplateDto
     */
    'repeatEnd'?: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof UpdateShiftTemplateDto
     */
    'days'?: Array<object>;
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftTemplateDto
     */
    'seasonId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateShiftWithChoiceDto
 */
export interface UpdateShiftWithChoiceDto {
    /**
     * How the update should be applied: single day, all occurrences, or from this day onward
     * @type {string}
     * @memberof UpdateShiftWithChoiceDto
     */
    'choice': UpdateShiftWithChoiceDtoChoiceEnum;
    /**
     * 
     * @type {UpdateShiftWithChoiceDtoUpdateShiftDto}
     * @memberof UpdateShiftWithChoiceDto
     */
    'updateShiftDto': UpdateShiftWithChoiceDtoUpdateShiftDto;
    /**
     * The specific date from which changes should apply
     * @type {string}
     * @memberof UpdateShiftWithChoiceDto
     */
    'date': string;
    /**
     * Department ID for security checks
     * @type {number}
     * @memberof UpdateShiftWithChoiceDto
     */
    'departmentId': number;
    /**
     * Season ID if needed for additional validation or logic
     * @type {number}
     * @memberof UpdateShiftWithChoiceDto
     */
    'seasonId': number;
}

export const UpdateShiftWithChoiceDtoChoiceEnum = {
    Single: 'single',
    All: 'all',
    Future: 'future'
} as const;

export type UpdateShiftWithChoiceDtoChoiceEnum = typeof UpdateShiftWithChoiceDtoChoiceEnum[keyof typeof UpdateShiftWithChoiceDtoChoiceEnum];

/**
 * The updated shift data
 * @export
 * @interface UpdateShiftWithChoiceDtoUpdateShiftDto
 */
export interface UpdateShiftWithChoiceDtoUpdateShiftDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftWithChoiceDtoUpdateShiftDto
     */
    'templateId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftWithChoiceDtoUpdateShiftDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftWithChoiceDtoUpdateShiftDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftWithChoiceDtoUpdateShiftDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftWithChoiceDtoUpdateShiftDto
     */
    'seasonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftWithChoiceDtoUpdateShiftDto
     */
    'notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftWithChoiceDtoUpdateShiftDto
     */
    'departmentId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateSimpleDepositDto
 */
export interface UpdateSimpleDepositDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSimpleDepositDto
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateSimpleDepositDto
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface UpdateTenantBankingInformationDto
 */
export interface UpdateTenantBankingInformationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantBankingInformationDto
     */
    'iban'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantBankingInformationDto
     */
    'bankName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantBankingInformationDto
     */
    'bicSwift'?: string;
}
/**
 * 
 * @export
 * @interface UpdateTenantConfigDto
 */
export interface UpdateTenantConfigDto {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantConfigDto
     */
    'isPasswordSet'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantConfigDto
     */
    'encryptedPassword'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantConfigDto
     */
    'testPasswordValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantConfigDto
     */
    'testBackupPasswordValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantConfigDto
     */
    'housekeepingManagerEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantConfigDto
     */
    'monthlyMailReport'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantConfigDto
     */
    'jobsEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantConfigDto
     */
    'sendHouseKeepingEMail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantConfigDto
     */
    'sendMontlhyMailReport'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantConfigDto
     */
    'sendDailyMails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantConfigDto
     */
    'sendTurnoverMails'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantConfigDto
     */
    'shiftsArePublic'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantConfigDto
     */
    'whatsappEndpoint'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantConfigDto
     */
    'whatsappToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantConfigDto
     */
    'whatsappInstanceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantConfigDto
     */
    'globalJobDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantConfigDto
     */
    'companyBenefits'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantConfigDto
     */
    'logoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantConfigDto
     */
    'coverImageUrl'?: string;
}
/**
 * 
 * @export
 * @interface UpdateTenantOptions
 */
export interface UpdateTenantOptions {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantOptions
     */
    'emailsToEmployees': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantOptions
     */
    'housekeepingManagerEmail': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantOptions
     */
    'monthlyMailReport': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantOptions
     */
    'sendHouseKeepingEMail': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantOptions
     */
    'sendMontlhyMailReport': boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateTenantOptions
     */
    'daysToConfirmAvailability': number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantOptions
     */
    'encryptDocumentsByDefault': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantOptions
     */
    'shiftsArePublic'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantOptions
     */
    'whatsappEndpoint'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantOptions
     */
    'whatsappToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantOptions
     */
    'whatsappInstanceId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTenantOptions
     */
    'isTimeAttendanceActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateTenantOptions
     */
    'holidayRegionCode'?: string;
}
/**
 * 
 * @export
 * @interface UpdateTicketDto
 */
export interface UpdateTicketDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTicketDto
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTicketDto
     */
    'resetAtDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTicketDto
     */
    'resetAtValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTicketDto
     */
    'taxPercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTicketDto
     */
    'paymentSectionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTicketDto
     */
    'paymentSectionToExcludeId'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateTimeEntryDto
 */
export interface UpdateTimeEntryDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTimeEntryDto
     */
    'startedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTimeEntryDto
     */
    'endedAt'?: string;
    /**
     * Explicit match override. Pass null to clear the match. Skips the auto-matcher when present.
     * @type {number}
     * @memberof UpdateTimeEntryDto
     */
    'matchedShiftAssignmentId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTimeEntryDto
     */
    'varianceNote'?: string;
    /**
     * 
     * @type {Array<UpdateBreakDto>}
     * @memberof UpdateTimeEntryDto
     */
    'breaks'?: Array<UpdateBreakDto>;
}
/**
 * 
 * @export
 * @interface UpdateTodoResolutionDto
 */
export interface UpdateTodoResolutionDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTodoResolutionDto
     */
    'resolutionNotes': string;
}
/**
 * 
 * @export
 * @interface UpdateTodoStatusDefinitionDto
 */
export interface UpdateTodoStatusDefinitionDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTodoStatusDefinitionDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTodoStatusDefinitionDto
     */
    'departmentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTodoStatusDefinitionDto
     */
    'nextStatusChoiceId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateTodoStatusDto
 */
export interface UpdateTodoStatusDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateTodoStatusDto
     */
    'statusId': number;
}
/**
 * 
 * @export
 * @interface UpdateTrainingCourseDto
 */
export interface UpdateTrainingCourseDto {
    /**
     * ID of the course type
     * @type {number}
     * @memberof UpdateTrainingCourseDto
     */
    'courseTypeId'?: number;
    /**
     * Title of the training session
     * @type {string}
     * @memberof UpdateTrainingCourseDto
     */
    'title'?: string;
    /**
     * Training provider / instructor
     * @type {string}
     * @memberof UpdateTrainingCourseDto
     */
    'provider'?: string;
    /**
     * Training location
     * @type {string}
     * @memberof UpdateTrainingCourseDto
     */
    'location'?: string;
    /**
     * Start date of the course
     * @type {string}
     * @memberof UpdateTrainingCourseDto
     */
    'startDate'?: string;
    /**
     * End date of the course
     * @type {string}
     * @memberof UpdateTrainingCourseDto
     */
    'endDate'?: string;
    /**
     * Total training hours
     * @type {number}
     * @memberof UpdateTrainingCourseDto
     */
    'hours'?: number;
    /**
     * Total cost of the course session
     * @type {string}
     * @memberof UpdateTrainingCourseDto
     */
    'cost'?: string;
    /**
     * Additional notes
     * @type {string}
     * @memberof UpdateTrainingCourseDto
     */
    'notes'?: string;
    /**
     * Season ID to link this course to
     * @type {number}
     * @memberof UpdateTrainingCourseDto
     */
    'seasonId'?: number;
    /**
     * Course status
     * @type {string}
     * @memberof UpdateTrainingCourseDto
     */
    'status'?: UpdateTrainingCourseDtoStatusEnum;
}

export const UpdateTrainingCourseDtoStatusEnum = {
    Scheduled: 'SCHEDULED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED'
} as const;

export type UpdateTrainingCourseDtoStatusEnum = typeof UpdateTrainingCourseDtoStatusEnum[keyof typeof UpdateTrainingCourseDtoStatusEnum];

/**
 * 
 * @export
 * @interface UpdateTurnoverItemDto
 */
export interface UpdateTurnoverItemDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTurnoverItemDto
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTurnoverItemDto
     */
    'value'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTurnoverItemDto
     */
    'paymentMethodId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTurnoverItemDto
     */
    'paymentSectionId'?: number;
    /**
     * 
     * @type {object}
     * @memberof UpdateTurnoverItemDto
     */
    'status'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTurnoverItemDto
     */
    'wasModifiedByController'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateWorkPositionDto
 */
export interface UpdateWorkPositionDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkPositionDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkPositionDto
     */
    'departmentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkPositionDto
     */
    'bossId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkPositionDto
     */
    'desiredResources'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateZoomFactorDto
 */
export interface UpdateZoomFactorDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateZoomFactorDto
     */
    'safetyAreaZoomFactor': number;
}
/**
 * 
 * @export
 * @interface UploadedZipEntity
 */
export interface UploadedZipEntity {
    /**
     * 
     * @type {number}
     * @memberof UploadedZipEntity
     */
    'count': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadedZipEntity
     */
    'badFiles': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadedZipEntity
     */
    'badPayments': Array<string>;
    /**
     * 
     * @type {Array<NetArrayElementEntity>}
     * @memberof UploadedZipEntity
     */
    'netArray': Array<NetArrayElementEntity>;
    /**
     * 
     * @type {Array<UploadedZipEntitySuccessfulFilesInner>}
     * @memberof UploadedZipEntity
     */
    'successfulFiles'?: Array<UploadedZipEntitySuccessfulFilesInner>;
    /**
     * 
     * @type {Array<UploadedZipEntityFailedFilesInner>}
     * @memberof UploadedZipEntity
     */
    'failedFiles'?: Array<UploadedZipEntityFailedFilesInner>;
    /**
     * 
     * @type {object}
     * @memberof UploadedZipEntity
     */
    'summary'?: object;
}
/**
 * 
 * @export
 * @interface UploadedZipEntityFailedFilesInner
 */
export interface UploadedZipEntityFailedFilesInner {
    /**
     * 
     * @type {string}
     * @memberof UploadedZipEntityFailedFilesInner
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadedZipEntityFailedFilesInner
     */
    'error'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadedZipEntityFailedFilesInner
     */
    'errorCode'?: string;
}
/**
 * 
 * @export
 * @interface UploadedZipEntitySuccessfulFilesInner
 */
export interface UploadedZipEntitySuccessfulFilesInner {
    /**
     * 
     * @type {string}
     * @memberof UploadedZipEntitySuccessfulFilesInner
     */
    'fileName'?: string;
    /**
     * 
     * @type {number}
     * @memberof UploadedZipEntitySuccessfulFilesInner
     */
    'employeeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UploadedZipEntitySuccessfulFilesInner
     */
    'employeeName'?: string;
    /**
     * 
     * @type {number}
     * @memberof UploadedZipEntitySuccessfulFilesInner
     */
    'documentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UploadedZipEntitySuccessfulFilesInner
     */
    'netAmount'?: number;
}
/**
 * 
 * @export
 * @interface UpsertPreContractTemplateConfigDto
 */
export interface UpsertPreContractTemplateConfigDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertPreContractTemplateConfigDto
     */
    'ownerFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertPreContractTemplateConfigDto
     */
    'ownerLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertPreContractTemplateConfigDto
     */
    'ownerTaxcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertPreContractTemplateConfigDto
     */
    'companyLegalName'?: string | null;
}
/**
 * 
 * @export
 * @interface UsedDocumentNameEntity
 */
export interface UsedDocumentNameEntity {
    /**
     * 
     * @type {number}
     * @memberof UsedDocumentNameEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UsedDocumentNameEntity
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UsedDocumentNameEntity
     */
    'documentTypeId': number;
}
/**
 * 
 * @export
 * @interface UsedRewardNameEntity
 */
export interface UsedRewardNameEntity {
    /**
     * 
     * @type {number}
     * @memberof UsedRewardNameEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UsedRewardNameEntity
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface UserEntity
 */
export interface UserEntity {
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    'username': string;
    /**
     * 
     * @type {number}
     * @memberof UserEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    'password': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    'provider': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    'providerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    'refreshToken': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    'lastIp': string | null;
    /**
     * 
     * @type {object}
     * @memberof UserEntity
     */
    'language': object;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    'lastTenantName': string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    'privacyAcceptedAt': string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    'termsAcceptedAt': string;
}
/**
 * 
 * @export
 * @interface UserVacationAgreementDto
 */
export interface UserVacationAgreementDto {
    /**
     * Agreement ID
     * @type {number}
     * @memberof UserVacationAgreementDto
     */
    'agreementId': number;
    /**
     * Agreement start date
     * @type {string}
     * @memberof UserVacationAgreementDto
     */
    'startedOn': string;
    /**
     * Agreement end date
     * @type {string}
     * @memberof UserVacationAgreementDto
     */
    'endedOn': string | null;
    /**
     * Season ID for this agreement
     * @type {number}
     * @memberof UserVacationAgreementDto
     */
    'seasonId': number | null;
    /**
     * Vacation hours if set, otherwise null
     * @type {number}
     * @memberof UserVacationAgreementDto
     */
    'hoursVacation': number | null;
    /**
     * Vacation days if set, otherwise null
     * @type {number}
     * @memberof UserVacationAgreementDto
     */
    'daysVacation': number | null;
    /**
     * Type of vacation configuration (hours or days)
     * @type {string}
     * @memberof UserVacationAgreementDto
     */
    'vacationType': UserVacationAgreementDtoVacationTypeEnum;
}

export const UserVacationAgreementDtoVacationTypeEnum = {
    Hours: 'hours',
    Days: 'days',
    None: 'none'
} as const;

export type UserVacationAgreementDtoVacationTypeEnum = typeof UserVacationAgreementDtoVacationTypeEnum[keyof typeof UserVacationAgreementDtoVacationTypeEnum];

/**
 * 
 * @export
 * @interface VacationConfigDto
 */
export interface VacationConfigDto {
    /**
     * Whether vacation is calculated in hours
     * @type {boolean}
     * @memberof VacationConfigDto
     */
    'vacatioinInHours': boolean;
    /**
     * Default hours of vacation
     * @type {number}
     * @memberof VacationConfigDto
     */
    'defaultHoursVacation': number;
    /**
     * Default days of vacation
     * @type {number}
     * @memberof VacationConfigDto
     */
    'defaultDaysVacation': number;
}
/**
 * 
 * @export
 * @interface VacationStatusSummaryDto
 */
export interface VacationStatusSummaryDto {
    /**
     * Total vacation hours in the past
     * @type {number}
     * @memberof VacationStatusSummaryDto
     */
    'pastHours': number;
    /**
     * Total vacation hours in the future
     * @type {number}
     * @memberof VacationStatusSummaryDto
     */
    'futureHours': number;
    /**
     * Total vacation hours (past + future)
     * @type {number}
     * @memberof VacationStatusSummaryDto
     */
    'totalHours': number;
}
/**
 * 
 * @export
 * @interface VacationSummaryDto
 */
export interface VacationSummaryDto {
    /**
     * 
     * @type {VacationSummaryDtoApproved}
     * @memberof VacationSummaryDto
     */
    'approved': VacationSummaryDtoApproved;
    /**
     * 
     * @type {VacationSummaryDtoPending}
     * @memberof VacationSummaryDto
     */
    'pending': VacationSummaryDtoPending;
    /**
     * Grand total of all vacation hours
     * @type {number}
     * @memberof VacationSummaryDto
     */
    'grandTotal': number;
    /**
     * Monthly breakdown of vacation hours
     * @type {Array<string>}
     * @memberof VacationSummaryDto
     */
    'monthlyBreakdown': Array<string>;
    /**
     * Upcoming 5 vacation entries closest to today
     * @type {Array<string>}
     * @memberof VacationSummaryDto
     */
    'upcomingEntries': Array<string>;
    /**
     * Current year being analyzed
     * @type {number}
     * @memberof VacationSummaryDto
     */
    'currentYear': number;
    /**
     * Total available vacation hours for the year (from agreement)
     * @type {number}
     * @memberof VacationSummaryDto
     */
    'availableHours': number | null;
    /**
     * Matured vacation hours up to today (pro-rata based on contract start date)
     * @type {number}
     * @memberof VacationSummaryDto
     */
    'maturedHours': number | null;
    /**
     * Remaining vacation hours for the year
     * @type {number}
     * @memberof VacationSummaryDto
     */
    'remainingHours': number | null;
    /**
     * Percentage of vacation used
     * @type {number}
     * @memberof VacationSummaryDto
     */
    'usagePercentage': number;
}
/**
 * Vacation summary for approved events
 * @export
 * @interface VacationSummaryDtoApproved
 */
export interface VacationSummaryDtoApproved {
    /**
     * Total vacation hours in the past
     * @type {number}
     * @memberof VacationSummaryDtoApproved
     */
    'pastHours': number;
    /**
     * Total vacation hours in the future
     * @type {number}
     * @memberof VacationSummaryDtoApproved
     */
    'futureHours': number;
    /**
     * Total vacation hours (past + future)
     * @type {number}
     * @memberof VacationSummaryDtoApproved
     */
    'totalHours': number;
}
/**
 * Vacation summary for pending events
 * @export
 * @interface VacationSummaryDtoPending
 */
export interface VacationSummaryDtoPending {
    /**
     * Total vacation hours in the past
     * @type {number}
     * @memberof VacationSummaryDtoPending
     */
    'pastHours': number;
    /**
     * Total vacation hours in the future
     * @type {number}
     * @memberof VacationSummaryDtoPending
     */
    'futureHours': number;
    /**
     * Total vacation hours (past + future)
     * @type {number}
     * @memberof VacationSummaryDtoPending
     */
    'totalHours': number;
}
/**
 * 
 * @export
 * @interface WorkPositionEntity
 */
export interface WorkPositionEntity {
    /**
     * 
     * @type {number}
     * @memberof WorkPositionEntity
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof WorkPositionEntity
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof WorkPositionEntity
     */
    'departmentId': number;
    /**
     * 
     * @type {DepartmentEntity}
     * @memberof WorkPositionEntity
     */
    'department'?: DepartmentEntity;
    /**
     * 
     * @type {number}
     * @memberof WorkPositionEntity
     */
    'bossId': number | null;
    /**
     * 
     * @type {Array<WorkPositionToSeasonEntity>}
     * @memberof WorkPositionEntity
     */
    'workPositionToSeason'?: Array<WorkPositionToSeasonEntity> | null;
    /**
     * 
     * @type {Array<WorkPositionEntity>}
     * @memberof WorkPositionEntity
     */
    'secondaryBosses'?: Array<WorkPositionEntity> | null;
    /**
     * 
     * @type {Array<WorkPositionEntity>}
     * @memberof WorkPositionEntity
     */
    'secondarySubordinates'?: Array<WorkPositionEntity> | null;
}
/**
 * 
 * @export
 * @interface WorkPositionToSeasonEntity
 */
export interface WorkPositionToSeasonEntity {
    /**
     * 
     * @type {number}
     * @memberof WorkPositionToSeasonEntity
     */
    'seasonId': number;
    /**
     * 
     * @type {number}
     * @memberof WorkPositionToSeasonEntity
     */
    'workPositionId': number;
    /**
     * 
     * @type {number}
     * @memberof WorkPositionToSeasonEntity
     */
    'desiredResources': number;
}

/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        find: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isPasswordSet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account/isPasswordSet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateAccountDto} updateAccountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (updateAccountDto: UpdateAccountDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAccountDto' is not null or undefined
            assertParamExists('update', 'updateAccountDto', updateAccountDto)
            const localVarPath = `/api/v1/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async find(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.find(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isPasswordSet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isPasswordSet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateAccountDto} updateAccountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(updateAccountDto: UpdateAccountDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(updateAccountDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        find(options?: any): AxiosPromise<AccountEntity> {
            return localVarFp.find(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isPasswordSet(options?: any): AxiosPromise<boolean> {
            return localVarFp.isPasswordSet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(options?: any): AxiosPromise<AccountEntity> {
            return localVarFp.remove(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateAccountDto} updateAccountDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(updateAccountDto: UpdateAccountDto, options?: any): AxiosPromise<AccountEntity> {
            return localVarFp.update(updateAccountDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public find(options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).find(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public isPasswordSet(options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).isPasswordSet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public remove(options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).remove(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateAccountDto} updateAccountDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public update(updateAccountDto: UpdateAccountDto, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).update(updateAccountDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdditionalInformationApi - axios parameter creator
 * @export
 */
export const AdditionalInformationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateAdditionalInformationDto} createAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createAdditionalInformationDto: CreateAdditionalInformationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAdditionalInformationDto' is not null or undefined
            assertParamExists('create', 'createAdditionalInformationDto', createAdditionalInformationDto)
            const localVarPath = `/api/v1/additional-information`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAdditionalInformationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateAdditionalInformationDto} createAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createByMyself: async (createAdditionalInformationDto: CreateAdditionalInformationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAdditionalInformationDto' is not null or undefined
            assertParamExists('createByMyself', 'createAdditionalInformationDto', createAdditionalInformationDto)
            const localVarPath = `/api/v1/additional-information/createByMyself`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAdditionalInformationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateEmergencyContactDto} createEmergencyContactDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmergencyContact: async (createEmergencyContactDto: CreateEmergencyContactDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmergencyContactDto' is not null or undefined
            assertParamExists('createEmergencyContact', 'createEmergencyContactDto', createEmergencyContactDto)
            const localVarPath = `/api/v1/additional-information/emergencyContact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmergencyContactDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenant 
         * @param {CreateEmergencyContactDto} createEmergencyContactDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmergencyContactWithToken: async (tenant: string, createEmergencyContactDto: CreateEmergencyContactDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('createEmergencyContactWithToken', 'tenant', tenant)
            // verify required parameter 'createEmergencyContactDto' is not null or undefined
            assertParamExists('createEmergencyContactWithToken', 'createEmergencyContactDto', createEmergencyContactDto)
            const localVarPath = `/api/v1/additional-information/emergencyContactWithToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmergencyContactDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenant 
         * @param {CreateAdditionalInformationDto} createAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithToken: async (tenant: string, createAdditionalInformationDto: CreateAdditionalInformationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('createWithToken', 'tenant', tenant)
            // verify required parameter 'createAdditionalInformationDto' is not null or undefined
            assertParamExists('createWithToken', 'createAdditionalInformationDto', createAdditionalInformationDto)
            const localVarPath = `/api/v1/additional-information/withToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAdditionalInformationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/additional-information`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEmergencyContactByAdditionalInfomrationsID: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findEmergencyContactByAdditionalInfomrationsID', 'id', id)
            const localVarPath = `/api/v1/additional-information/emergencyContacts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEmergencyContactByAdditionalInfomrationsIDWithToken: async (id: number, tenant: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findEmergencyContactByAdditionalInfomrationsIDWithToken', 'id', id)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('findEmergencyContactByAdditionalInfomrationsIDWithToken', 'tenant', tenant)
            const localVarPath = `/api/v1/additional-information/emergencyContactsWithToken/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneByEmployee: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOneByEmployee', 'id', id)
            const localVarPath = `/api/v1/additional-information/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneByMyself: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/additional-information/findOneByMyself`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByTokenAndEmployee: async (id: string, tenant: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getByTokenAndEmployee', 'id', id)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('getByTokenAndEmployee', 'tenant', tenant)
            const localVarPath = `/api/v1/additional-information/{id}/withToken`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/additional-information/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEmergencyContact: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeEmergencyContact', 'id', id)
            const localVarPath = `/api/v1/additional-information/contact/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEmergencyContactWithToken: async (id: number, tenant: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeEmergencyContactWithToken', 'id', id)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('removeEmergencyContactWithToken', 'tenant', tenant)
            const localVarPath = `/api/v1/additional-information/contactWithToken/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateAdditionalInformationDto} updateAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateAdditionalInformationDto: UpdateAdditionalInformationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateAdditionalInformationDto' is not null or undefined
            assertParamExists('update', 'updateAdditionalInformationDto', updateAdditionalInformationDto)
            const localVarPath = `/api/v1/additional-information/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAdditionalInformationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateAdditionalInformationDto} updateAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateByMyself: async (updateAdditionalInformationDto: UpdateAdditionalInformationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAdditionalInformationDto' is not null or undefined
            assertParamExists('updateByMyself', 'updateAdditionalInformationDto', updateAdditionalInformationDto)
            const localVarPath = `/api/v1/additional-information/updateByMyself`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAdditionalInformationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {UpdateAdditionalInformationDto} updateAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWithToken: async (id: string, tenant: string, updateAdditionalInformationDto: UpdateAdditionalInformationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWithToken', 'id', id)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('updateWithToken', 'tenant', tenant)
            // verify required parameter 'updateAdditionalInformationDto' is not null or undefined
            assertParamExists('updateWithToken', 'updateAdditionalInformationDto', updateAdditionalInformationDto)
            const localVarPath = `/api/v1/additional-information/{id}/withToken`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAdditionalInformationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdditionalInformationApi - functional programming interface
 * @export
 */
export const AdditionalInformationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdditionalInformationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateAdditionalInformationDto} createAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createAdditionalInformationDto: CreateAdditionalInformationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalInformationsEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createAdditionalInformationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateAdditionalInformationDto} createAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createByMyself(createAdditionalInformationDto: CreateAdditionalInformationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalInformationsEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createByMyself(createAdditionalInformationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateEmergencyContactDto} createEmergencyContactDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmergencyContact(createEmergencyContactDto: CreateEmergencyContactDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyContactEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmergencyContact(createEmergencyContactDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenant 
         * @param {CreateEmergencyContactDto} createEmergencyContactDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmergencyContactWithToken(tenant: string, createEmergencyContactDto: CreateEmergencyContactDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyContactEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmergencyContactWithToken(tenant, createEmergencyContactDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenant 
         * @param {CreateAdditionalInformationDto} createAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWithToken(tenant: string, createAdditionalInformationDto: CreateAdditionalInformationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalInformationsEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWithToken(tenant, createAdditionalInformationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdditionalInformationsEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findEmergencyContactByAdditionalInfomrationsID(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmergencyContactEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findEmergencyContactByAdditionalInfomrationsID(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findEmergencyContactByAdditionalInfomrationsIDWithToken(id: number, tenant: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmergencyContactEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findEmergencyContactByAdditionalInfomrationsIDWithToken(id, tenant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOneByEmployee(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalInformationsEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOneByEmployee(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOneByMyself(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalInformationsEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOneByMyself(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByTokenAndEmployee(id: string, tenant: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalInformationsEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByTokenAndEmployee(id, tenant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalInformationsEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEmergencyContact(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyContactEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEmergencyContact(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEmergencyContactWithToken(id: number, tenant: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyContactEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEmergencyContactWithToken(id, tenant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateAdditionalInformationDto} updateAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateAdditionalInformationDto: UpdateAdditionalInformationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalInformationsEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateAdditionalInformationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateAdditionalInformationDto} updateAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateByMyself(updateAdditionalInformationDto: UpdateAdditionalInformationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalInformationsEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateByMyself(updateAdditionalInformationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {UpdateAdditionalInformationDto} updateAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWithToken(id: string, tenant: string, updateAdditionalInformationDto: UpdateAdditionalInformationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalInformationsEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWithToken(id, tenant, updateAdditionalInformationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdditionalInformationApi - factory interface
 * @export
 */
export const AdditionalInformationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdditionalInformationApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateAdditionalInformationDto} createAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createAdditionalInformationDto: CreateAdditionalInformationDto, options?: any): AxiosPromise<AdditionalInformationsEntity> {
            return localVarFp.create(createAdditionalInformationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateAdditionalInformationDto} createAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createByMyself(createAdditionalInformationDto: CreateAdditionalInformationDto, options?: any): AxiosPromise<AdditionalInformationsEntity> {
            return localVarFp.createByMyself(createAdditionalInformationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateEmergencyContactDto} createEmergencyContactDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmergencyContact(createEmergencyContactDto: CreateEmergencyContactDto, options?: any): AxiosPromise<EmergencyContactEntity> {
            return localVarFp.createEmergencyContact(createEmergencyContactDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenant 
         * @param {CreateEmergencyContactDto} createEmergencyContactDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmergencyContactWithToken(tenant: string, createEmergencyContactDto: CreateEmergencyContactDto, options?: any): AxiosPromise<EmergencyContactEntity> {
            return localVarFp.createEmergencyContactWithToken(tenant, createEmergencyContactDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenant 
         * @param {CreateAdditionalInformationDto} createAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithToken(tenant: string, createAdditionalInformationDto: CreateAdditionalInformationDto, options?: any): AxiosPromise<AdditionalInformationsEntity> {
            return localVarFp.createWithToken(tenant, createAdditionalInformationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<AdditionalInformationsEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEmergencyContactByAdditionalInfomrationsID(id: number, options?: any): AxiosPromise<Array<EmergencyContactEntity>> {
            return localVarFp.findEmergencyContactByAdditionalInfomrationsID(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEmergencyContactByAdditionalInfomrationsIDWithToken(id: number, tenant: string, options?: any): AxiosPromise<Array<EmergencyContactEntity>> {
            return localVarFp.findEmergencyContactByAdditionalInfomrationsIDWithToken(id, tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneByEmployee(id: string, options?: any): AxiosPromise<AdditionalInformationsEntity> {
            return localVarFp.findOneByEmployee(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneByMyself(options?: any): AxiosPromise<AdditionalInformationsEntity> {
            return localVarFp.findOneByMyself(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByTokenAndEmployee(id: string, tenant: string, options?: any): AxiosPromise<AdditionalInformationsEntity> {
            return localVarFp.getByTokenAndEmployee(id, tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<AdditionalInformationsEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEmergencyContact(id: number, options?: any): AxiosPromise<EmergencyContactEntity> {
            return localVarFp.removeEmergencyContact(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEmergencyContactWithToken(id: number, tenant: string, options?: any): AxiosPromise<EmergencyContactEntity> {
            return localVarFp.removeEmergencyContactWithToken(id, tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateAdditionalInformationDto} updateAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateAdditionalInformationDto: UpdateAdditionalInformationDto, options?: any): AxiosPromise<AdditionalInformationsEntity> {
            return localVarFp.update(id, updateAdditionalInformationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateAdditionalInformationDto} updateAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateByMyself(updateAdditionalInformationDto: UpdateAdditionalInformationDto, options?: any): AxiosPromise<AdditionalInformationsEntity> {
            return localVarFp.updateByMyself(updateAdditionalInformationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {UpdateAdditionalInformationDto} updateAdditionalInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWithToken(id: string, tenant: string, updateAdditionalInformationDto: UpdateAdditionalInformationDto, options?: any): AxiosPromise<AdditionalInformationsEntity> {
            return localVarFp.updateWithToken(id, tenant, updateAdditionalInformationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdditionalInformationApi - object-oriented interface
 * @export
 * @class AdditionalInformationApi
 * @extends {BaseAPI}
 */
export class AdditionalInformationApi extends BaseAPI {
    /**
     * 
     * @param {CreateAdditionalInformationDto} createAdditionalInformationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public create(createAdditionalInformationDto: CreateAdditionalInformationDto, options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).create(createAdditionalInformationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateAdditionalInformationDto} createAdditionalInformationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public createByMyself(createAdditionalInformationDto: CreateAdditionalInformationDto, options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).createByMyself(createAdditionalInformationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateEmergencyContactDto} createEmergencyContactDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public createEmergencyContact(createEmergencyContactDto: CreateEmergencyContactDto, options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).createEmergencyContact(createEmergencyContactDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenant 
     * @param {CreateEmergencyContactDto} createEmergencyContactDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public createEmergencyContactWithToken(tenant: string, createEmergencyContactDto: CreateEmergencyContactDto, options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).createEmergencyContactWithToken(tenant, createEmergencyContactDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenant 
     * @param {CreateAdditionalInformationDto} createAdditionalInformationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public createWithToken(tenant: string, createAdditionalInformationDto: CreateAdditionalInformationDto, options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).createWithToken(tenant, createAdditionalInformationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public findEmergencyContactByAdditionalInfomrationsID(id: number, options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).findEmergencyContactByAdditionalInfomrationsID(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} tenant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public findEmergencyContactByAdditionalInfomrationsIDWithToken(id: number, tenant: string, options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).findEmergencyContactByAdditionalInfomrationsIDWithToken(id, tenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public findOneByEmployee(id: string, options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).findOneByEmployee(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public findOneByMyself(options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).findOneByMyself(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} tenant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public getByTokenAndEmployee(id: string, tenant: string, options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).getByTokenAndEmployee(id, tenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public removeEmergencyContact(id: number, options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).removeEmergencyContact(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} tenant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public removeEmergencyContactWithToken(id: number, tenant: string, options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).removeEmergencyContactWithToken(id, tenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateAdditionalInformationDto} updateAdditionalInformationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public update(id: string, updateAdditionalInformationDto: UpdateAdditionalInformationDto, options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).update(id, updateAdditionalInformationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateAdditionalInformationDto} updateAdditionalInformationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public updateByMyself(updateAdditionalInformationDto: UpdateAdditionalInformationDto, options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).updateByMyself(updateAdditionalInformationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} tenant 
     * @param {UpdateAdditionalInformationDto} updateAdditionalInformationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdditionalInformationApi
     */
    public updateWithToken(id: string, tenant: string, updateAdditionalInformationDto: UpdateAdditionalInformationDto, options?: AxiosRequestConfig) {
        return AdditionalInformationApiFp(this.configuration).updateWithToken(id, tenant, updateAdditionalInformationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AgreementsApi - axios parameter creator
 * @export
 */
export const AgreementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new agreement. Only one of hoursVacation or daysVacation can be set, not both.
         * @summary Create a new agreement
         * @param {CreateAgreementDto} createAgreementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createAgreementDto: CreateAgreementDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAgreementDto' is not null or undefined
            assertParamExists('create', 'createAgreementDto', createAgreementDto)
            const localVarPath = `/api/v1/agreements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAgreementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDailySpecialNetDto} createDailySpecialNetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpecialDailyNet: async (createDailySpecialNetDto: CreateDailySpecialNetDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDailySpecialNetDto' is not null or undefined
            assertParamExists('createSpecialDailyNet', 'createDailySpecialNetDto', createDailySpecialNetDto)
            const localVarPath = `/api/v1/agreements/special-daily-net`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDailySpecialNetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {number} [seasonId] 
         * @param {number} [contractId] 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (employeeId?: number, seasonId?: number, contractId?: number, departmentId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/agreements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (contractId !== undefined) {
                localVarQueryParameter['contractId'] = contractId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches all agreements for specified employees. This is a bulk endpoint to reduce the number of requests when fetching agreements for multiple employees. Each agreement in the response includes an employeeId field to identify which employee it belongs to.
         * @summary Get agreements for multiple employees in a single request
         * @param {FindByEmployeesDto} findByEmployeesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByEmployees: async (findByEmployeesDto: FindByEmployeesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'findByEmployeesDto' is not null or undefined
            assertParamExists('findByEmployees', 'findByEmployeesDto', findByEmployeesDto)
            const localVarPath = `/api/v1/agreements/findByEmployees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findByEmployeesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/agreements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all data needed for the employee report page in a single API call, including employee info, contract, agreements, payments, calendar events, and metadata. This endpoint consolidates multiple API calls into one optimized request.
         * @summary Get complete employee report data
         * @param {string} employeeId 
         * @param {string} seasonId 
         * @param {string} selectedDate 
         * @param {string} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompleteEmployeeReport: async (employeeId: string, seasonId: string, selectedDate: string, year: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getCompleteEmployeeReport', 'employeeId', employeeId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getCompleteEmployeeReport', 'seasonId', seasonId)
            // verify required parameter 'selectedDate' is not null or undefined
            assertParamExists('getCompleteEmployeeReport', 'selectedDate', selectedDate)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getCompleteEmployeeReport', 'year', year)
            const localVarPath = `/api/v1/agreements/complete-employee-report/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (selectedDate !== undefined) {
                localVarQueryParameter['selectedDate'] = selectedDate;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all agreements for the authenticated user with their vacation configurations and dates
         * @summary Get all user agreements with vacation configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserVacation: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/agreements/my-vacation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isEncryptionKeySet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/agreements/isEncryptionKeySet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/agreements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an agreement. If hoursVacation is set, daysVacation will be cleared and vice versa.
         * @summary Update an agreement
         * @param {string} id 
         * @param {UpdateAgreementDto} updateAgreementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateAgreementDto: UpdateAgreementDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateAgreementDto' is not null or undefined
            assertParamExists('update', 'updateAgreementDto', updateAgreementDto)
            const localVarPath = `/api/v1/agreements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAgreementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDailySpecialNetDto} updateDailySpecialNetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSpecialDailyNet: async (id: string, updateDailySpecialNetDto: UpdateDailySpecialNetDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSpecialDailyNet', 'id', id)
            // verify required parameter 'updateDailySpecialNetDto' is not null or undefined
            assertParamExists('updateSpecialDailyNet', 'updateDailySpecialNetDto', updateDailySpecialNetDto)
            const localVarPath = `/api/v1/agreements/special-daily-net/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDailySpecialNetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgreementsApi - functional programming interface
 * @export
 */
export const AgreementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgreementsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new agreement. Only one of hoursVacation or daysVacation can be set, not both.
         * @summary Create a new agreement
         * @param {CreateAgreementDto} createAgreementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createAgreementDto: CreateAgreementDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgreementEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createAgreementDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateDailySpecialNetDto} createDailySpecialNetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSpecialDailyNet(createDailySpecialNetDto: CreateDailySpecialNetDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSpecialDailyNet(createDailySpecialNetDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {number} [seasonId] 
         * @param {number} [contractId] 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(employeeId?: number, seasonId?: number, contractId?: number, departmentId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgreementEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(employeeId, seasonId, contractId, departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetches all agreements for specified employees. This is a bulk endpoint to reduce the number of requests when fetching agreements for multiple employees. Each agreement in the response includes an employeeId field to identify which employee it belongs to.
         * @summary Get agreements for multiple employees in a single request
         * @param {FindByEmployeesDto} findByEmployeesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByEmployees(findByEmployeesDto: FindByEmployeesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgreementWithEmployeeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByEmployees(findByEmployeesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgreementEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all data needed for the employee report page in a single API call, including employee info, contract, agreements, payments, calendar events, and metadata. This endpoint consolidates multiple API calls into one optimized request.
         * @summary Get complete employee report data
         * @param {string} employeeId 
         * @param {string} seasonId 
         * @param {string} selectedDate 
         * @param {string} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompleteEmployeeReport(employeeId: string, seasonId: string, selectedDate: string, year: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteEmployeeReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompleteEmployeeReport(employeeId, seasonId, selectedDate, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all agreements for the authenticated user with their vacation configurations and dates
         * @summary Get all user agreements with vacation configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserVacation(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserVacationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserVacation(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isEncryptionKeySet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isEncryptionKeySet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgreementEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates an agreement. If hoursVacation is set, daysVacation will be cleared and vice versa.
         * @summary Update an agreement
         * @param {string} id 
         * @param {UpdateAgreementDto} updateAgreementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateAgreementDto: UpdateAgreementDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgreementEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateAgreementDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDailySpecialNetDto} updateDailySpecialNetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSpecialDailyNet(id: string, updateDailySpecialNetDto: UpdateDailySpecialNetDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSpecialDailyNet(id, updateDailySpecialNetDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgreementsApi - factory interface
 * @export
 */
export const AgreementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgreementsApiFp(configuration)
    return {
        /**
         * Creates a new agreement. Only one of hoursVacation or daysVacation can be set, not both.
         * @summary Create a new agreement
         * @param {CreateAgreementDto} createAgreementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createAgreementDto: CreateAgreementDto, options?: any): AxiosPromise<AgreementEntity> {
            return localVarFp.create(createAgreementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateDailySpecialNetDto} createDailySpecialNetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpecialDailyNet(createDailySpecialNetDto: CreateDailySpecialNetDto, options?: any): AxiosPromise<void> {
            return localVarFp.createSpecialDailyNet(createDailySpecialNetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {number} [seasonId] 
         * @param {number} [contractId] 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(employeeId?: number, seasonId?: number, contractId?: number, departmentId?: number, options?: any): AxiosPromise<Array<AgreementEntity>> {
            return localVarFp.findAll(employeeId, seasonId, contractId, departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches all agreements for specified employees. This is a bulk endpoint to reduce the number of requests when fetching agreements for multiple employees. Each agreement in the response includes an employeeId field to identify which employee it belongs to.
         * @summary Get agreements for multiple employees in a single request
         * @param {FindByEmployeesDto} findByEmployeesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByEmployees(findByEmployeesDto: FindByEmployeesDto, options?: any): AxiosPromise<Array<AgreementWithEmployeeDto>> {
            return localVarFp.findByEmployees(findByEmployeesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<AgreementEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all data needed for the employee report page in a single API call, including employee info, contract, agreements, payments, calendar events, and metadata. This endpoint consolidates multiple API calls into one optimized request.
         * @summary Get complete employee report data
         * @param {string} employeeId 
         * @param {string} seasonId 
         * @param {string} selectedDate 
         * @param {string} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompleteEmployeeReport(employeeId: string, seasonId: string, selectedDate: string, year: string, options?: any): AxiosPromise<CompleteEmployeeReportDto> {
            return localVarFp.getCompleteEmployeeReport(employeeId, seasonId, selectedDate, year, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all agreements for the authenticated user with their vacation configurations and dates
         * @summary Get all user agreements with vacation configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserVacation(options?: any): AxiosPromise<GetUserVacationDto> {
            return localVarFp.getUserVacation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isEncryptionKeySet(options?: any): AxiosPromise<boolean> {
            return localVarFp.isEncryptionKeySet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<AgreementEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an agreement. If hoursVacation is set, daysVacation will be cleared and vice versa.
         * @summary Update an agreement
         * @param {string} id 
         * @param {UpdateAgreementDto} updateAgreementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateAgreementDto: UpdateAgreementDto, options?: any): AxiosPromise<AgreementEntity> {
            return localVarFp.update(id, updateAgreementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDailySpecialNetDto} updateDailySpecialNetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSpecialDailyNet(id: string, updateDailySpecialNetDto: UpdateDailySpecialNetDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateSpecialDailyNet(id, updateDailySpecialNetDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgreementsApi - object-oriented interface
 * @export
 * @class AgreementsApi
 * @extends {BaseAPI}
 */
export class AgreementsApi extends BaseAPI {
    /**
     * Creates a new agreement. Only one of hoursVacation or daysVacation can be set, not both.
     * @summary Create a new agreement
     * @param {CreateAgreementDto} createAgreementDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    public create(createAgreementDto: CreateAgreementDto, options?: AxiosRequestConfig) {
        return AgreementsApiFp(this.configuration).create(createAgreementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateDailySpecialNetDto} createDailySpecialNetDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    public createSpecialDailyNet(createDailySpecialNetDto: CreateDailySpecialNetDto, options?: AxiosRequestConfig) {
        return AgreementsApiFp(this.configuration).createSpecialDailyNet(createDailySpecialNetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [employeeId] 
     * @param {number} [seasonId] 
     * @param {number} [contractId] 
     * @param {number} [departmentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    public findAll(employeeId?: number, seasonId?: number, contractId?: number, departmentId?: number, options?: AxiosRequestConfig) {
        return AgreementsApiFp(this.configuration).findAll(employeeId, seasonId, contractId, departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches all agreements for specified employees. This is a bulk endpoint to reduce the number of requests when fetching agreements for multiple employees. Each agreement in the response includes an employeeId field to identify which employee it belongs to.
     * @summary Get agreements for multiple employees in a single request
     * @param {FindByEmployeesDto} findByEmployeesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    public findByEmployees(findByEmployeesDto: FindByEmployeesDto, options?: AxiosRequestConfig) {
        return AgreementsApiFp(this.configuration).findByEmployees(findByEmployeesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return AgreementsApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all data needed for the employee report page in a single API call, including employee info, contract, agreements, payments, calendar events, and metadata. This endpoint consolidates multiple API calls into one optimized request.
     * @summary Get complete employee report data
     * @param {string} employeeId 
     * @param {string} seasonId 
     * @param {string} selectedDate 
     * @param {string} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    public getCompleteEmployeeReport(employeeId: string, seasonId: string, selectedDate: string, year: string, options?: AxiosRequestConfig) {
        return AgreementsApiFp(this.configuration).getCompleteEmployeeReport(employeeId, seasonId, selectedDate, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all agreements for the authenticated user with their vacation configurations and dates
     * @summary Get all user agreements with vacation configurations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    public getUserVacation(options?: AxiosRequestConfig) {
        return AgreementsApiFp(this.configuration).getUserVacation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    public isEncryptionKeySet(options?: AxiosRequestConfig) {
        return AgreementsApiFp(this.configuration).isEncryptionKeySet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return AgreementsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an agreement. If hoursVacation is set, daysVacation will be cleared and vice versa.
     * @summary Update an agreement
     * @param {string} id 
     * @param {UpdateAgreementDto} updateAgreementDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    public update(id: string, updateAgreementDto: UpdateAgreementDto, options?: AxiosRequestConfig) {
        return AgreementsApiFp(this.configuration).update(id, updateAgreementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateDailySpecialNetDto} updateDailySpecialNetDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    public updateSpecialDailyNet(id: string, updateDailySpecialNetDto: UpdateDailySpecialNetDto, options?: AxiosRequestConfig) {
        return AgreementsApiFp(this.configuration).updateSpecialDailyNet(id, updateDailySpecialNetDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApplicationsApi - axios parameter creator
 * @export
 */
export const ApplicationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Manually add an existing candidate to a job pipeline at the APPLIED stage (e.g. verbal confirmation)
         * @param {AddToPipelineDto} addToPipelineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToPipeline: async (addToPipelineDto: AddToPipelineDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addToPipelineDto' is not null or undefined
            assertParamExists('addToPipeline', 'addToPipelineDto', addToPipelineDto)
            const localVarPath = `/api/v1/applications/add-to-pipeline`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addToPipelineDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive a hired application, removing it from the Kanban board
         * @param {ArchiveApplicationDto} archiveApplicationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archive: async (archiveApplicationDto: ArchiveApplicationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'archiveApplicationDto' is not null or undefined
            assertParamExists('archive', 'archiveApplicationDto', archiveApplicationDto)
            const localVarPath = `/api/v1/applications/archive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(archiveApplicationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get work history of a candidate across seasons, matched by email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidateHistory: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('candidateHistory', 'email', email)
            const localVarPath = `/api/v1/applications/candidate-history/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all applications with candidate, job, and current stage data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List archived applications, optionally filtered by job advertisement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findArchived: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/applications/archived`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List archived applications for a specific job advertisement
         * @param {string} jobAdvertisementsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findArchivedByJob: async (jobAdvertisementsId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobAdvertisementsId' is not null or undefined
            assertParamExists('findArchivedByJob', 'jobAdvertisementsId', jobAdvertisementsId)
            const localVarPath = `/api/v1/applications/archived/by-job/{jobAdvertisementsId}`
                .replace(`{${"jobAdvertisementsId"}}`, encodeURIComponent(String(jobAdvertisementsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List applications for a specific candidate
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByCandidate: async (candidateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('findByCandidate', 'candidateId', candidateId)
            const localVarPath = `/api/v1/applications/by-candidate/{candidateId}`
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List applications for a specific job advertisement
         * @param {string} jobAdvertisementsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByJob: async (jobAdvertisementsId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobAdvertisementsId' is not null or undefined
            assertParamExists('findByJob', 'jobAdvertisementsId', jobAdvertisementsId)
            const localVarPath = `/api/v1/applications/by-job/{jobAdvertisementsId}`
                .replace(`{${"jobAdvertisementsId"}}`, encodeURIComponent(String(jobAdvertisementsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single application with full details (interviews, comments)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/applications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get application IDs not yet viewed by the current manager for a job
         * @param {string} jobAdvertisementsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnviewedByJob: async (jobAdvertisementsId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobAdvertisementsId' is not null or undefined
            assertParamExists('getUnviewedByJob', 'jobAdvertisementsId', jobAdvertisementsId)
            const localVarPath = `/api/v1/applications/unviewed-by-job/{jobAdvertisementsId}`
                .replace(`{${"jobAdvertisementsId"}}`, encodeURIComponent(String(jobAdvertisementsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send a JOB_INVITATION email to an existing candidate with a link to a job posting
         * @param {InviteToJobDto} inviteToJobDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteToJob: async (inviteToJobDto: InviteToJobDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteToJobDto' is not null or undefined
            assertParamExists('inviteToJob', 'inviteToJobDto', inviteToJobDto)
            const localVarPath = `/api/v1/applications/invite-to-job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteToJobDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark multiple applications as viewed by the current manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markMultipleViewed: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/applications/mark-multiple-viewed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark an application as viewed by the current manager
         * @param {MarkCandidateViewedDto} markCandidateViewedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markViewed: async (markCandidateViewedDto: MarkCandidateViewedDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'markCandidateViewedDto' is not null or undefined
            assertParamExists('markViewed', 'markCandidateViewedDto', markCandidateViewedDto)
            const localVarPath = `/api/v1/applications/mark-viewed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markCandidateViewedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move an application to a new pipeline stage (Kanban drag-and-drop)
         * @param {MoveApplicationStageDto} moveApplicationStageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveStage: async (moveApplicationStageDto: MoveApplicationStageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moveApplicationStageDto' is not null or undefined
            assertParamExists('moveStage', 'moveApplicationStageDto', moveApplicationStageDto)
            const localVarPath = `/api/v1/applications/move-stage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveApplicationStageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject a single application, optionally sending a rejection email
         * @param {RejectApplicationDto} rejectApplicationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reject: async (rejectApplicationDto: RejectApplicationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rejectApplicationDto' is not null or undefined
            assertParamExists('reject', 'rejectApplicationDto', rejectApplicationDto)
            const localVarPath = `/api/v1/applications/reject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectApplicationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject multiple applications at once (e.g. after hiring a candidate for the job)
         * @param {RejectMultipleApplicationsDto} rejectMultipleApplicationsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectMultiple: async (rejectMultipleApplicationsDto: RejectMultipleApplicationsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rejectMultipleApplicationsDto' is not null or undefined
            assertParamExists('rejectMultiple', 'rejectMultipleApplicationsDto', rejectMultipleApplicationsDto)
            const localVarPath = `/api/v1/applications/reject-multiple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectMultipleApplicationsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unarchive an application, restoring it to the Kanban board as HIRED
         * @param {ArchiveApplicationDto} archiveApplicationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchive: async (archiveApplicationDto: ArchiveApplicationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'archiveApplicationDto' is not null or undefined
            assertParamExists('unarchive', 'archiveApplicationDto', archiveApplicationDto)
            const localVarPath = `/api/v1/applications/unarchive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(archiveApplicationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationsApi - functional programming interface
 * @export
 */
export const ApplicationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApplicationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Manually add an existing candidate to a job pipeline at the APPLIED stage (e.g. verbal confirmation)
         * @param {AddToPipelineDto} addToPipelineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addToPipeline(addToPipelineDto: AddToPipelineDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addToPipeline(addToPipelineDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Archive a hired application, removing it from the Kanban board
         * @param {ArchiveApplicationDto} archiveApplicationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archive(archiveApplicationDto: ArchiveApplicationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archive(archiveApplicationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get work history of a candidate across seasons, matched by email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async candidateHistory(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.candidateHistory(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all applications with candidate, job, and current stage data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List archived applications, optionally filtered by job advertisement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findArchived(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findArchived(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List archived applications for a specific job advertisement
         * @param {string} jobAdvertisementsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findArchivedByJob(jobAdvertisementsId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findArchivedByJob(jobAdvertisementsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List applications for a specific candidate
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByCandidate(candidateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByCandidate(candidateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List applications for a specific job advertisement
         * @param {string} jobAdvertisementsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByJob(jobAdvertisementsId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByJob(jobAdvertisementsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a single application with full details (interviews, comments)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get application IDs not yet viewed by the current manager for a job
         * @param {string} jobAdvertisementsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnviewedByJob(jobAdvertisementsId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnviewedByJob(jobAdvertisementsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send a JOB_INVITATION email to an existing candidate with a link to a job posting
         * @param {InviteToJobDto} inviteToJobDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteToJob(inviteToJobDto: InviteToJobDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteToJob(inviteToJobDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Mark multiple applications as viewed by the current manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markMultipleViewed(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markMultipleViewed(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Mark an application as viewed by the current manager
         * @param {MarkCandidateViewedDto} markCandidateViewedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markViewed(markCandidateViewedDto: MarkCandidateViewedDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markViewed(markCandidateViewedDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Move an application to a new pipeline stage (Kanban drag-and-drop)
         * @param {MoveApplicationStageDto} moveApplicationStageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveStage(moveApplicationStageDto: MoveApplicationStageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveStage(moveApplicationStageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject a single application, optionally sending a rejection email
         * @param {RejectApplicationDto} rejectApplicationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reject(rejectApplicationDto: RejectApplicationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reject(rejectApplicationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject multiple applications at once (e.g. after hiring a candidate for the job)
         * @param {RejectMultipleApplicationsDto} rejectMultipleApplicationsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectMultiple(rejectMultipleApplicationsDto: RejectMultipleApplicationsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectMultiple(rejectMultipleApplicationsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unarchive an application, restoring it to the Kanban board as HIRED
         * @param {ArchiveApplicationDto} archiveApplicationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unarchive(archiveApplicationDto: ArchiveApplicationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unarchive(archiveApplicationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApplicationsApi - factory interface
 * @export
 */
export const ApplicationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApplicationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Manually add an existing candidate to a job pipeline at the APPLIED stage (e.g. verbal confirmation)
         * @param {AddToPipelineDto} addToPipelineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToPipeline(addToPipelineDto: AddToPipelineDto, options?: any): AxiosPromise<ApplicationEntity> {
            return localVarFp.addToPipeline(addToPipelineDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive a hired application, removing it from the Kanban board
         * @param {ArchiveApplicationDto} archiveApplicationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archive(archiveApplicationDto: ArchiveApplicationDto, options?: any): AxiosPromise<ApplicationEntity> {
            return localVarFp.archive(archiveApplicationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get work history of a candidate across seasons, matched by email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidateHistory(email: string, options?: any): AxiosPromise<void> {
            return localVarFp.candidateHistory(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all applications with candidate, job, and current stage data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<ApplicationEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List archived applications, optionally filtered by job advertisement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findArchived(options?: any): AxiosPromise<Array<ApplicationEntity>> {
            return localVarFp.findArchived(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List archived applications for a specific job advertisement
         * @param {string} jobAdvertisementsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findArchivedByJob(jobAdvertisementsId: string, options?: any): AxiosPromise<Array<ApplicationEntity>> {
            return localVarFp.findArchivedByJob(jobAdvertisementsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List applications for a specific candidate
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByCandidate(candidateId: string, options?: any): AxiosPromise<Array<ApplicationEntity>> {
            return localVarFp.findByCandidate(candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List applications for a specific job advertisement
         * @param {string} jobAdvertisementsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByJob(jobAdvertisementsId: string, options?: any): AxiosPromise<Array<ApplicationEntity>> {
            return localVarFp.findByJob(jobAdvertisementsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single application with full details (interviews, comments)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<ApplicationEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get application IDs not yet viewed by the current manager for a job
         * @param {string} jobAdvertisementsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnviewedByJob(jobAdvertisementsId: string, options?: any): AxiosPromise<Array<number>> {
            return localVarFp.getUnviewedByJob(jobAdvertisementsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send a JOB_INVITATION email to an existing candidate with a link to a job posting
         * @param {InviteToJobDto} inviteToJobDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteToJob(inviteToJobDto: InviteToJobDto, options?: any): AxiosPromise<void> {
            return localVarFp.inviteToJob(inviteToJobDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark multiple applications as viewed by the current manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markMultipleViewed(options?: any): AxiosPromise<void> {
            return localVarFp.markMultipleViewed(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark an application as viewed by the current manager
         * @param {MarkCandidateViewedDto} markCandidateViewedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markViewed(markCandidateViewedDto: MarkCandidateViewedDto, options?: any): AxiosPromise<void> {
            return localVarFp.markViewed(markCandidateViewedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move an application to a new pipeline stage (Kanban drag-and-drop)
         * @param {MoveApplicationStageDto} moveApplicationStageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveStage(moveApplicationStageDto: MoveApplicationStageDto, options?: any): AxiosPromise<ApplicationEntity> {
            return localVarFp.moveStage(moveApplicationStageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject a single application, optionally sending a rejection email
         * @param {RejectApplicationDto} rejectApplicationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reject(rejectApplicationDto: RejectApplicationDto, options?: any): AxiosPromise<ApplicationEntity> {
            return localVarFp.reject(rejectApplicationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject multiple applications at once (e.g. after hiring a candidate for the job)
         * @param {RejectMultipleApplicationsDto} rejectMultipleApplicationsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectMultiple(rejectMultipleApplicationsDto: RejectMultipleApplicationsDto, options?: any): AxiosPromise<void> {
            return localVarFp.rejectMultiple(rejectMultipleApplicationsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unarchive an application, restoring it to the Kanban board as HIRED
         * @param {ArchiveApplicationDto} archiveApplicationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchive(archiveApplicationDto: ArchiveApplicationDto, options?: any): AxiosPromise<ApplicationEntity> {
            return localVarFp.unarchive(archiveApplicationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApplicationsApi - object-oriented interface
 * @export
 * @class ApplicationsApi
 * @extends {BaseAPI}
 */
export class ApplicationsApi extends BaseAPI {
    /**
     * 
     * @summary Manually add an existing candidate to a job pipeline at the APPLIED stage (e.g. verbal confirmation)
     * @param {AddToPipelineDto} addToPipelineDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public addToPipeline(addToPipelineDto: AddToPipelineDto, options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).addToPipeline(addToPipelineDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive a hired application, removing it from the Kanban board
     * @param {ArchiveApplicationDto} archiveApplicationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public archive(archiveApplicationDto: ArchiveApplicationDto, options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).archive(archiveApplicationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get work history of a candidate across seasons, matched by email
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public candidateHistory(email: string, options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).candidateHistory(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all applications with candidate, job, and current stage data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List archived applications, optionally filtered by job advertisement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public findArchived(options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).findArchived(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List archived applications for a specific job advertisement
     * @param {string} jobAdvertisementsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public findArchivedByJob(jobAdvertisementsId: string, options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).findArchivedByJob(jobAdvertisementsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List applications for a specific candidate
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public findByCandidate(candidateId: string, options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).findByCandidate(candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List applications for a specific job advertisement
     * @param {string} jobAdvertisementsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public findByJob(jobAdvertisementsId: string, options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).findByJob(jobAdvertisementsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single application with full details (interviews, comments)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get application IDs not yet viewed by the current manager for a job
     * @param {string} jobAdvertisementsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public getUnviewedByJob(jobAdvertisementsId: string, options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).getUnviewedByJob(jobAdvertisementsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send a JOB_INVITATION email to an existing candidate with a link to a job posting
     * @param {InviteToJobDto} inviteToJobDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public inviteToJob(inviteToJobDto: InviteToJobDto, options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).inviteToJob(inviteToJobDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark multiple applications as viewed by the current manager
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public markMultipleViewed(options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).markMultipleViewed(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark an application as viewed by the current manager
     * @param {MarkCandidateViewedDto} markCandidateViewedDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public markViewed(markCandidateViewedDto: MarkCandidateViewedDto, options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).markViewed(markCandidateViewedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move an application to a new pipeline stage (Kanban drag-and-drop)
     * @param {MoveApplicationStageDto} moveApplicationStageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public moveStage(moveApplicationStageDto: MoveApplicationStageDto, options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).moveStage(moveApplicationStageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject a single application, optionally sending a rejection email
     * @param {RejectApplicationDto} rejectApplicationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public reject(rejectApplicationDto: RejectApplicationDto, options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).reject(rejectApplicationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject multiple applications at once (e.g. after hiring a candidate for the job)
     * @param {RejectMultipleApplicationsDto} rejectMultipleApplicationsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public rejectMultiple(rejectMultipleApplicationsDto: RejectMultipleApplicationsDto, options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).rejectMultiple(rejectMultipleApplicationsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unarchive an application, restoring it to the Kanban board as HIRED
     * @param {ArchiveApplicationDto} archiveApplicationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    public unarchive(archiveApplicationDto: ArchiveApplicationDto, options?: AxiosRequestConfig) {
        return ApplicationsApiFp(this.configuration).unarchive(archiveApplicationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTerms: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/acceptTerms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmUser: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('confirmUser', 'token', token)
            const localVarPath = `/api/v1/auth/confirmUser/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facebookCallback: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/facebook/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facebookLogin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/facebook/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleCallback: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/google/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GoogleCallbackMobileRequest} googleCallbackMobileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleCallbackMobile: async (googleCallbackMobileRequest: GoogleCallbackMobileRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'googleCallbackMobileRequest' is not null or undefined
            assertParamExists('googleCallbackMobile', 'googleCallbackMobileRequest', googleCallbackMobileRequest)
            const localVarPath = `/api/v1/auth/google/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(googleCallbackMobileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/google/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isTokenValid: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('isTokenValid', 'token', token)
            const localVarPath = `/api/v1/auth/isTokenValid/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginDto: LoginDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDto' is not null or undefined
            assertParamExists('login', 'loginDto', loginDto)
            const localVarPath = `/api/v1/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterDto} registerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (registerDto: RegisterDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerDto' is not null or undefined
            assertParamExists('register', 'registerDto', registerDto)
            const localVarPath = `/api/v1/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RequestPasswordResetDto} requestPasswordResetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset: async (requestPasswordResetDto: RequestPasswordResetDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPasswordResetDto' is not null or undefined
            assertParamExists('requestPasswordReset', 'requestPasswordResetDto', requestPasswordResetDto)
            const localVarPath = `/api/v1/auth/request-password-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPasswordResetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (resetPasswordDto: ResetPasswordDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordDto' is not null or undefined
            assertParamExists('resetPassword', 'resetPasswordDto', resetPasswordDto)
            const localVarPath = `/api/v1/auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectTenant: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenants: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/tenants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptTerms(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokensEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptTerms(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmUser(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmUser(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facebookCallback(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facebookCallback(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facebookLogin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facebookLogin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleCallback(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleCallback(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GoogleCallbackMobileRequest} googleCallbackMobileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleCallbackMobile(googleCallbackMobileRequest: GoogleCallbackMobileRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokensEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleCallbackMobile(googleCallbackMobileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleLogin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleLogin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isTokenValid(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendingUserEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isTokenValid(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginDto: LoginDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokensEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refresh(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokensEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refresh(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RegisterDto} registerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(registerDto: RegisterDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(registerDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RequestPasswordResetDto} requestPasswordResetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestPasswordReset(requestPasswordResetDto: RequestPasswordResetDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestPasswordReset(requestPasswordResetDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(resetPasswordDto: ResetPasswordDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(resetPasswordDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selectTenant(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokensEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selectTenant(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenants(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenants(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTerms(options?: any): AxiosPromise<TokensEntity> {
            return localVarFp.acceptTerms(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmUser(token: string, options?: any): AxiosPromise<UserEntity> {
            return localVarFp.confirmUser(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facebookCallback(options?: any): AxiosPromise<object> {
            return localVarFp.facebookCallback(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facebookLogin(options?: any): AxiosPromise<void> {
            return localVarFp.facebookLogin(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleCallback(options?: any): AxiosPromise<object> {
            return localVarFp.googleCallback(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GoogleCallbackMobileRequest} googleCallbackMobileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleCallbackMobile(googleCallbackMobileRequest: GoogleCallbackMobileRequest, options?: any): AxiosPromise<TokensEntity> {
            return localVarFp.googleCallbackMobile(googleCallbackMobileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin(options?: any): AxiosPromise<void> {
            return localVarFp.googleLogin(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isTokenValid(token: string, options?: any): AxiosPromise<PendingUserEntity> {
            return localVarFp.isTokenValid(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginDto: LoginDto, options?: any): AxiosPromise<TokensEntity> {
            return localVarFp.login(loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): AxiosPromise<void> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh(options?: any): AxiosPromise<TokensEntity> {
            return localVarFp.refresh(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterDto} registerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(registerDto: RegisterDto, options?: any): AxiosPromise<void> {
            return localVarFp.register(registerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RequestPasswordResetDto} requestPasswordResetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(requestPasswordResetDto: RequestPasswordResetDto, options?: any): AxiosPromise<void> {
            return localVarFp.requestPasswordReset(requestPasswordResetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(resetPasswordDto: ResetPasswordDto, options?: any): AxiosPromise<void> {
            return localVarFp.resetPassword(resetPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selectTenant(options?: any): AxiosPromise<TokensEntity> {
            return localVarFp.selectTenant(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenants(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.tenants(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public acceptTerms(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).acceptTerms(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public confirmUser(token: string, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).confirmUser(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public facebookCallback(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).facebookCallback(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public facebookLogin(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).facebookLogin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public googleCallback(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).googleCallback(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GoogleCallbackMobileRequest} googleCallbackMobileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public googleCallbackMobile(googleCallbackMobileRequest: GoogleCallbackMobileRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).googleCallbackMobile(googleCallbackMobileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public googleLogin(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).googleLogin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public isTokenValid(token: string, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).isTokenValid(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginDto} loginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public login(loginDto: LoginDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).login(loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public logout(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public refresh(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).refresh(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterDto} registerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public register(registerDto: RegisterDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).register(registerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RequestPasswordResetDto} requestPasswordResetDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public requestPasswordReset(requestPasswordResetDto: RequestPasswordResetDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).requestPasswordReset(requestPasswordResetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResetPasswordDto} resetPasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resetPassword(resetPasswordDto: ResetPasswordDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).resetPassword(resetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public selectTenant(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).selectTenant(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public tenants(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).tenants(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BankingInformationApi - axios parameter creator
 * @export
 */
export const BankingInformationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateBankingInformationDto} createBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createBankingInformationDto: CreateBankingInformationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBankingInformationDto' is not null or undefined
            assertParamExists('create', 'createBankingInformationDto', createBankingInformationDto)
            const localVarPath = `/api/v1/banking-information`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBankingInformationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateMyBankingInformationDto} createMyBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMyself: async (createMyBankingInformationDto: CreateMyBankingInformationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMyBankingInformationDto' is not null or undefined
            assertParamExists('createMyself', 'createMyBankingInformationDto', createMyBankingInformationDto)
            const localVarPath = `/api/v1/banking-information/createMyself`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMyBankingInformationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenant 
         * @param {string} token 
         * @param {CreateBankingInformationDto} createBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithToken: async (tenant: string, token: string, createBankingInformationDto: CreateBankingInformationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('createWithToken', 'tenant', tenant)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('createWithToken', 'token', token)
            // verify required parameter 'createBankingInformationDto' is not null or undefined
            assertParamExists('createWithToken', 'createBankingInformationDto', createBankingInformationDto)
            const localVarPath = `/api/v1/banking-information/withToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBankingInformationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/banking-information`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/banking-information/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeesWithoutIban: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/banking-information/no-iban`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/banking-information/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBankingInformationDto} updateBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateBankingInformationDto: UpdateBankingInformationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateBankingInformationDto' is not null or undefined
            assertParamExists('update', 'updateBankingInformationDto', updateBankingInformationDto)
            const localVarPath = `/api/v1/banking-information/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBankingInformationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateMyBankingInformationDto} updateMyBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyself: async (id: number, updateMyBankingInformationDto: UpdateMyBankingInformationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMyself', 'id', id)
            // verify required parameter 'updateMyBankingInformationDto' is not null or undefined
            assertParamExists('updateMyself', 'updateMyBankingInformationDto', updateMyBankingInformationDto)
            const localVarPath = `/api/v1/banking-information/{id}/updateMyself`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMyBankingInformationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {string} token 
         * @param {UpdateBankingInformationDto} updateBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWithToken: async (id: string, tenant: string, token: string, updateBankingInformationDto: UpdateBankingInformationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWithToken', 'id', id)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('updateWithToken', 'tenant', tenant)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('updateWithToken', 'token', token)
            // verify required parameter 'updateBankingInformationDto' is not null or undefined
            assertParamExists('updateWithToken', 'updateBankingInformationDto', updateBankingInformationDto)
            const localVarPath = `/api/v1/banking-information/{id}/withToken`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBankingInformationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BankingInformationApi - functional programming interface
 * @export
 */
export const BankingInformationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BankingInformationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateBankingInformationDto} createBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createBankingInformationDto: CreateBankingInformationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankingInformationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createBankingInformationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateMyBankingInformationDto} createMyBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMyself(createMyBankingInformationDto: CreateMyBankingInformationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankingInformationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMyself(createMyBankingInformationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenant 
         * @param {string} token 
         * @param {CreateBankingInformationDto} createBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWithToken(tenant: string, token: string, createBankingInformationDto: CreateBankingInformationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankingInformationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWithToken(tenant, token, createBankingInformationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BankingInformationEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankingInformationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeesWithoutIban(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeesWithoutIban(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankingInformationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBankingInformationDto} updateBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateBankingInformationDto: UpdateBankingInformationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankingInformationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateBankingInformationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateMyBankingInformationDto} updateMyBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyself(id: number, updateMyBankingInformationDto: UpdateMyBankingInformationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankingInformationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyself(id, updateMyBankingInformationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {string} token 
         * @param {UpdateBankingInformationDto} updateBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWithToken(id: string, tenant: string, token: string, updateBankingInformationDto: UpdateBankingInformationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankingInformationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWithToken(id, tenant, token, updateBankingInformationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BankingInformationApi - factory interface
 * @export
 */
export const BankingInformationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BankingInformationApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateBankingInformationDto} createBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createBankingInformationDto: CreateBankingInformationDto, options?: any): AxiosPromise<BankingInformationEntity> {
            return localVarFp.create(createBankingInformationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateMyBankingInformationDto} createMyBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMyself(createMyBankingInformationDto: CreateMyBankingInformationDto, options?: any): AxiosPromise<BankingInformationEntity> {
            return localVarFp.createMyself(createMyBankingInformationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenant 
         * @param {string} token 
         * @param {CreateBankingInformationDto} createBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithToken(tenant: string, token: string, createBankingInformationDto: CreateBankingInformationDto, options?: any): AxiosPromise<BankingInformationEntity> {
            return localVarFp.createWithToken(tenant, token, createBankingInformationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<BankingInformationEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<BankingInformationEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeesWithoutIban(options?: any): AxiosPromise<Array<object>> {
            return localVarFp.getEmployeesWithoutIban(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<BankingInformationEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBankingInformationDto} updateBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateBankingInformationDto: UpdateBankingInformationDto, options?: any): AxiosPromise<BankingInformationEntity> {
            return localVarFp.update(id, updateBankingInformationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateMyBankingInformationDto} updateMyBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyself(id: number, updateMyBankingInformationDto: UpdateMyBankingInformationDto, options?: any): AxiosPromise<BankingInformationEntity> {
            return localVarFp.updateMyself(id, updateMyBankingInformationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {string} token 
         * @param {UpdateBankingInformationDto} updateBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWithToken(id: string, tenant: string, token: string, updateBankingInformationDto: UpdateBankingInformationDto, options?: any): AxiosPromise<BankingInformationEntity> {
            return localVarFp.updateWithToken(id, tenant, token, updateBankingInformationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BankingInformationApi - object-oriented interface
 * @export
 * @class BankingInformationApi
 * @extends {BaseAPI}
 */
export class BankingInformationApi extends BaseAPI {
    /**
     * 
     * @param {CreateBankingInformationDto} createBankingInformationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingInformationApi
     */
    public create(createBankingInformationDto: CreateBankingInformationDto, options?: AxiosRequestConfig) {
        return BankingInformationApiFp(this.configuration).create(createBankingInformationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateMyBankingInformationDto} createMyBankingInformationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingInformationApi
     */
    public createMyself(createMyBankingInformationDto: CreateMyBankingInformationDto, options?: AxiosRequestConfig) {
        return BankingInformationApiFp(this.configuration).createMyself(createMyBankingInformationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenant 
     * @param {string} token 
     * @param {CreateBankingInformationDto} createBankingInformationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingInformationApi
     */
    public createWithToken(tenant: string, token: string, createBankingInformationDto: CreateBankingInformationDto, options?: AxiosRequestConfig) {
        return BankingInformationApiFp(this.configuration).createWithToken(tenant, token, createBankingInformationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingInformationApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return BankingInformationApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingInformationApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return BankingInformationApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingInformationApi
     */
    public getEmployeesWithoutIban(options?: AxiosRequestConfig) {
        return BankingInformationApiFp(this.configuration).getEmployeesWithoutIban(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingInformationApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return BankingInformationApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateBankingInformationDto} updateBankingInformationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingInformationApi
     */
    public update(id: string, updateBankingInformationDto: UpdateBankingInformationDto, options?: AxiosRequestConfig) {
        return BankingInformationApiFp(this.configuration).update(id, updateBankingInformationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateMyBankingInformationDto} updateMyBankingInformationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingInformationApi
     */
    public updateMyself(id: number, updateMyBankingInformationDto: UpdateMyBankingInformationDto, options?: AxiosRequestConfig) {
        return BankingInformationApiFp(this.configuration).updateMyself(id, updateMyBankingInformationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} tenant 
     * @param {string} token 
     * @param {UpdateBankingInformationDto} updateBankingInformationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankingInformationApi
     */
    public updateWithToken(id: string, tenant: string, token: string, updateBankingInformationDto: UpdateBankingInformationDto, options?: AxiosRequestConfig) {
        return BankingInformationApiFp(this.configuration).updateWithToken(id, tenant, token, updateBankingInformationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BuildingsApi - axios parameter creator
 * @export
 */
export const BuildingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateBuildingDto} createBuildingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createBuildingDto: CreateBuildingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBuildingDto' is not null or undefined
            assertParamExists('create', 'createBuildingDto', createBuildingDto)
            const localVarPath = `/api/v1/buildings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBuildingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [seasonId] 
         * @param {boolean} [all] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (seasonId?: number, all?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/buildings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/buildings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/buildings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBuildingDto} updateBuildingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateBuildingDto: UpdateBuildingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateBuildingDto' is not null or undefined
            assertParamExists('update', 'updateBuildingDto', updateBuildingDto)
            const localVarPath = `/api/v1/buildings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBuildingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuildingsApi - functional programming interface
 * @export
 */
export const BuildingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuildingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateBuildingDto} createBuildingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createBuildingDto: CreateBuildingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createBuildingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [seasonId] 
         * @param {boolean} [all] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(seasonId?: number, all?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BuildingEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(seasonId, all, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBuildingDto} updateBuildingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateBuildingDto: UpdateBuildingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateBuildingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BuildingsApi - factory interface
 * @export
 */
export const BuildingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuildingsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateBuildingDto} createBuildingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createBuildingDto: CreateBuildingDto, options?: any): AxiosPromise<BuildingEntity> {
            return localVarFp.create(createBuildingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [seasonId] 
         * @param {boolean} [all] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(seasonId?: number, all?: boolean, options?: any): AxiosPromise<Array<BuildingEntity>> {
            return localVarFp.findAll(seasonId, all, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<BuildingEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<BuildingEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBuildingDto} updateBuildingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateBuildingDto: UpdateBuildingDto, options?: any): AxiosPromise<BuildingEntity> {
            return localVarFp.update(id, updateBuildingDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BuildingsApi - object-oriented interface
 * @export
 * @class BuildingsApi
 * @extends {BaseAPI}
 */
export class BuildingsApi extends BaseAPI {
    /**
     * 
     * @param {CreateBuildingDto} createBuildingDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildingsApi
     */
    public create(createBuildingDto: CreateBuildingDto, options?: AxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).create(createBuildingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [seasonId] 
     * @param {boolean} [all] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildingsApi
     */
    public findAll(seasonId?: number, all?: boolean, options?: AxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).findAll(seasonId, all, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildingsApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildingsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateBuildingDto} updateBuildingDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildingsApi
     */
    public update(id: string, updateBuildingDto: UpdateBuildingDto, options?: AxiosRequestConfig) {
        return BuildingsApiFp(this.configuration).update(id, updateBuildingDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CalendarEntryShiftTemplateApi - axios parameter creator
 * @export
 */
export const CalendarEntryShiftTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} allowOverwrite 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {AssignShiftTemplateDto} assignShiftTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignShiftTemplate: async (allowOverwrite: string, departmentId: number, seasonId: number, assignShiftTemplateDto: AssignShiftTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'allowOverwrite' is not null or undefined
            assertParamExists('assignShiftTemplate', 'allowOverwrite', allowOverwrite)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('assignShiftTemplate', 'departmentId', departmentId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('assignShiftTemplate', 'seasonId', seasonId)
            // verify required parameter 'assignShiftTemplateDto' is not null or undefined
            assertParamExists('assignShiftTemplate', 'assignShiftTemplateDto', assignShiftTemplateDto)
            const localVarPath = `/api/v1/calendar-entry-shift-template/assignShiftTemplate/{allowOverwrite}/{departmentId}/{seasonId}`
                .replace(`{${"allowOverwrite"}}`, encodeURIComponent(String(allowOverwrite)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignShiftTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCalendarEntryShiftTemplateDto} createCalendarEntryShiftTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createCalendarEntryShiftTemplateDto: CreateCalendarEntryShiftTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCalendarEntryShiftTemplateDto' is not null or undefined
            assertParamExists('create', 'createCalendarEntryShiftTemplateDto', createCalendarEntryShiftTemplateDto)
            const localVarPath = `/api/v1/calendar-entry-shift-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCalendarEntryShiftTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all shift assignments that would be deleted if the specified calendarEntryShiftTemplate was deleted. This is a read-only operation that does not actually delete anything.
         * @summary Dry-run deletion of a calendar entry shift template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dryRunDelete', 'id', id)
            const localVarPath = `/api/v1/calendar-entry-shift-template/{id}/dry-run-delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAll', 'seasonId', seasonId)
            const localVarPath = `/api/v1/calendar-entry-shift-template/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllWhereIsBoss: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAllWhereIsBoss', 'seasonId', seasonId)
            const localVarPath = `/api/v1/calendar-entry-shift-template/whereIsBoss/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByDate: async (date: string, departmentId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('findByDate', 'date', date)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('findByDate', 'departmentId', departmentId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findByDate', 'seasonId', seasonId)
            const localVarPath = `/api/v1/calendar-entry-shift-template/byDate/{date}/{departmentId}/{seasonId}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches all calendar entry shift templates for a date range. This is a bulk endpoint to reduce the number of requests when fetching templates for multiple dates. Returns an array of calendar entries with their shift templates, shifts, shift details, and assignments.
         * @summary Get calendar entry shift templates for multiple dates in a single request
         * @param {FindByDateRangeDto} findByDateRangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByDateRange: async (findByDateRangeDto: FindByDateRangeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'findByDateRangeDto' is not null or undefined
            assertParamExists('findByDateRange', 'findByDateRangeDto', findByDateRangeDto)
            const localVarPath = `/api/v1/calendar-entry-shift-template/findByDateRange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findByDateRangeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} start 
         * @param {string} end 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByMultipleDates: async (start: string, end: string, departmentId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'start' is not null or undefined
            assertParamExists('findByMultipleDates', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('findByMultipleDates', 'end', end)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('findByMultipleDates', 'departmentId', departmentId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findByMultipleDates', 'seasonId', seasonId)
            const localVarPath = `/api/v1/calendar-entry-shift-template/byMultipleDates/{start}/{end}/{departmentId}/{seasonId}`
                .replace(`{${"start"}}`, encodeURIComponent(String(start)))
                .replace(`{${"end"}}`, encodeURIComponent(String(end)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPublicShifts: async (date: string, departmentId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('findPublicShifts', 'date', date)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('findPublicShifts', 'departmentId', departmentId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findPublicShifts', 'seasonId', seasonId)
            const localVarPath = `/api/v1/calendar-entry-shift-template/publicByDate/{date}/{departmentId}/{seasonId}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('remove', 'seasonId', seasonId)
            const localVarPath = `/api/v1/calendar-entry-shift-template/{id}/{seasonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalendarEntryShiftTemplateApi - functional programming interface
 * @export
 */
export const CalendarEntryShiftTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalendarEntryShiftTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} allowOverwrite 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {AssignShiftTemplateDto} assignShiftTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignShiftTemplate(allowOverwrite: string, departmentId: number, seasonId: number, assignShiftTemplateDto: AssignShiftTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignShiftTemplate(allowOverwrite, departmentId, seasonId, assignShiftTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateCalendarEntryShiftTemplateDto} createCalendarEntryShiftTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createCalendarEntryShiftTemplateDto: CreateCalendarEntryShiftTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEntryShiftTemplateEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createCalendarEntryShiftTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all shift assignments that would be deleted if the specified calendarEntryShiftTemplate was deleted. This is a read-only operation that does not actually delete anything.
         * @summary Dry-run deletion of a calendar entry shift template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dryRunDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dryRunDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEntryShiftTemplateEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllWhereIsBoss(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEntryShiftTemplateEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllWhereIsBoss(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByDate(date: string, departmentId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEntryShiftTemplateEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByDate(date, departmentId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetches all calendar entry shift templates for a date range. This is a bulk endpoint to reduce the number of requests when fetching templates for multiple dates. Returns an array of calendar entries with their shift templates, shifts, shift details, and assignments.
         * @summary Get calendar entry shift templates for multiple dates in a single request
         * @param {FindByDateRangeDto} findByDateRangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByDateRange(findByDateRangeDto: FindByDateRangeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEntryShiftTemplateEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByDateRange(findByDateRangeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} start 
         * @param {string} end 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByMultipleDates(start: string, end: string, departmentId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEntryShiftTemplateEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByMultipleDates(start, end, departmentId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPublicShifts(date: string, departmentId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEntryShiftTemplateEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPublicShifts(date, departmentId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEntryShiftTemplateEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CalendarEntryShiftTemplateApi - factory interface
 * @export
 */
export const CalendarEntryShiftTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalendarEntryShiftTemplateApiFp(configuration)
    return {
        /**
         * 
         * @param {string} allowOverwrite 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {AssignShiftTemplateDto} assignShiftTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignShiftTemplate(allowOverwrite: string, departmentId: number, seasonId: number, assignShiftTemplateDto: AssignShiftTemplateDto, options?: any): AxiosPromise<void> {
            return localVarFp.assignShiftTemplate(allowOverwrite, departmentId, seasonId, assignShiftTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCalendarEntryShiftTemplateDto} createCalendarEntryShiftTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createCalendarEntryShiftTemplateDto: CreateCalendarEntryShiftTemplateDto, options?: any): AxiosPromise<CalendarEntryShiftTemplateEntity> {
            return localVarFp.create(createCalendarEntryShiftTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all shift assignments that would be deleted if the specified calendarEntryShiftTemplate was deleted. This is a read-only operation that does not actually delete anything.
         * @summary Dry-run deletion of a calendar entry shift template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.dryRunDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(seasonId: number, options?: any): AxiosPromise<Array<CalendarEntryShiftTemplateEntity>> {
            return localVarFp.findAll(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllWhereIsBoss(seasonId: number, options?: any): AxiosPromise<Array<CalendarEntryShiftTemplateEntity>> {
            return localVarFp.findAllWhereIsBoss(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByDate(date: string, departmentId: number, seasonId: number, options?: any): AxiosPromise<CalendarEntryShiftTemplateEntity> {
            return localVarFp.findByDate(date, departmentId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches all calendar entry shift templates for a date range. This is a bulk endpoint to reduce the number of requests when fetching templates for multiple dates. Returns an array of calendar entries with their shift templates, shifts, shift details, and assignments.
         * @summary Get calendar entry shift templates for multiple dates in a single request
         * @param {FindByDateRangeDto} findByDateRangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByDateRange(findByDateRangeDto: FindByDateRangeDto, options?: any): AxiosPromise<Array<CalendarEntryShiftTemplateEntity>> {
            return localVarFp.findByDateRange(findByDateRangeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} start 
         * @param {string} end 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByMultipleDates(start: string, end: string, departmentId: number, seasonId: number, options?: any): AxiosPromise<Array<CalendarEntryShiftTemplateEntity>> {
            return localVarFp.findByMultipleDates(start, end, departmentId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPublicShifts(date: string, departmentId: number, seasonId: number, options?: any): AxiosPromise<CalendarEntryShiftTemplateEntity> {
            return localVarFp.findPublicShifts(date, departmentId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: number, seasonId: number, options?: any): AxiosPromise<CalendarEntryShiftTemplateEntity> {
            return localVarFp.remove(id, seasonId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalendarEntryShiftTemplateApi - object-oriented interface
 * @export
 * @class CalendarEntryShiftTemplateApi
 * @extends {BaseAPI}
 */
export class CalendarEntryShiftTemplateApi extends BaseAPI {
    /**
     * 
     * @param {string} allowOverwrite 
     * @param {number} departmentId 
     * @param {number} seasonId 
     * @param {AssignShiftTemplateDto} assignShiftTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarEntryShiftTemplateApi
     */
    public assignShiftTemplate(allowOverwrite: string, departmentId: number, seasonId: number, assignShiftTemplateDto: AssignShiftTemplateDto, options?: AxiosRequestConfig) {
        return CalendarEntryShiftTemplateApiFp(this.configuration).assignShiftTemplate(allowOverwrite, departmentId, seasonId, assignShiftTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCalendarEntryShiftTemplateDto} createCalendarEntryShiftTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarEntryShiftTemplateApi
     */
    public create(createCalendarEntryShiftTemplateDto: CreateCalendarEntryShiftTemplateDto, options?: AxiosRequestConfig) {
        return CalendarEntryShiftTemplateApiFp(this.configuration).create(createCalendarEntryShiftTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all shift assignments that would be deleted if the specified calendarEntryShiftTemplate was deleted. This is a read-only operation that does not actually delete anything.
     * @summary Dry-run deletion of a calendar entry shift template
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarEntryShiftTemplateApi
     */
    public dryRunDelete(id: number, options?: AxiosRequestConfig) {
        return CalendarEntryShiftTemplateApiFp(this.configuration).dryRunDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarEntryShiftTemplateApi
     */
    public findAll(seasonId: number, options?: AxiosRequestConfig) {
        return CalendarEntryShiftTemplateApiFp(this.configuration).findAll(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarEntryShiftTemplateApi
     */
    public findAllWhereIsBoss(seasonId: number, options?: AxiosRequestConfig) {
        return CalendarEntryShiftTemplateApiFp(this.configuration).findAllWhereIsBoss(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {number} departmentId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarEntryShiftTemplateApi
     */
    public findByDate(date: string, departmentId: number, seasonId: number, options?: AxiosRequestConfig) {
        return CalendarEntryShiftTemplateApiFp(this.configuration).findByDate(date, departmentId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches all calendar entry shift templates for a date range. This is a bulk endpoint to reduce the number of requests when fetching templates for multiple dates. Returns an array of calendar entries with their shift templates, shifts, shift details, and assignments.
     * @summary Get calendar entry shift templates for multiple dates in a single request
     * @param {FindByDateRangeDto} findByDateRangeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarEntryShiftTemplateApi
     */
    public findByDateRange(findByDateRangeDto: FindByDateRangeDto, options?: AxiosRequestConfig) {
        return CalendarEntryShiftTemplateApiFp(this.configuration).findByDateRange(findByDateRangeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} start 
     * @param {string} end 
     * @param {number} departmentId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarEntryShiftTemplateApi
     */
    public findByMultipleDates(start: string, end: string, departmentId: number, seasonId: number, options?: AxiosRequestConfig) {
        return CalendarEntryShiftTemplateApiFp(this.configuration).findByMultipleDates(start, end, departmentId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {number} departmentId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarEntryShiftTemplateApi
     */
    public findPublicShifts(date: string, departmentId: number, seasonId: number, options?: AxiosRequestConfig) {
        return CalendarEntryShiftTemplateApiFp(this.configuration).findPublicShifts(date, departmentId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarEntryShiftTemplateApi
     */
    public remove(id: number, seasonId: number, options?: AxiosRequestConfig) {
        return CalendarEntryShiftTemplateApiFp(this.configuration).remove(id, seasonId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CandidateCommentsApi - axios parameter creator
 * @export
 */
export const CandidateCommentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a comment/rating to an application
         * @param {CreateCandidateCommentDto} createCandidateCommentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createCandidateCommentDto: CreateCandidateCommentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCandidateCommentDto' is not null or undefined
            assertParamExists('create', 'createCandidateCommentDto', createCandidateCommentDto)
            const localVarPath = `/api/v1/candidate-comments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCandidateCommentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all comments for a specific application
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByApplication: async (applicationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicationId' is not null or undefined
            assertParamExists('findByApplication', 'applicationId', applicationId)
            const localVarPath = `/api/v1/candidate-comments/by-application/{applicationId}`
                .replace(`{${"applicationId"}}`, encodeURIComponent(String(applicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a comment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/candidate-comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CandidateCommentsApi - functional programming interface
 * @export
 */
export const CandidateCommentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CandidateCommentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a comment/rating to an application
         * @param {CreateCandidateCommentDto} createCandidateCommentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createCandidateCommentDto: CreateCandidateCommentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidateCommentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createCandidateCommentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all comments for a specific application
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByApplication(applicationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CandidateCommentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByApplication(applicationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a comment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidateCommentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CandidateCommentsApi - factory interface
 * @export
 */
export const CandidateCommentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CandidateCommentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a comment/rating to an application
         * @param {CreateCandidateCommentDto} createCandidateCommentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createCandidateCommentDto: CreateCandidateCommentDto, options?: any): AxiosPromise<CandidateCommentEntity> {
            return localVarFp.create(createCandidateCommentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all comments for a specific application
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByApplication(applicationId: string, options?: any): AxiosPromise<Array<CandidateCommentEntity>> {
            return localVarFp.findByApplication(applicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a comment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<CandidateCommentEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CandidateCommentsApi - object-oriented interface
 * @export
 * @class CandidateCommentsApi
 * @extends {BaseAPI}
 */
export class CandidateCommentsApi extends BaseAPI {
    /**
     * 
     * @summary Add a comment/rating to an application
     * @param {CreateCandidateCommentDto} createCandidateCommentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateCommentsApi
     */
    public create(createCandidateCommentDto: CreateCandidateCommentDto, options?: AxiosRequestConfig) {
        return CandidateCommentsApiFp(this.configuration).create(createCandidateCommentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all comments for a specific application
     * @param {string} applicationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateCommentsApi
     */
    public findByApplication(applicationId: string, options?: AxiosRequestConfig) {
        return CandidateCommentsApiFp(this.configuration).findByApplication(applicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a comment
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidateCommentsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return CandidateCommentsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CandidatesApi - axios parameter creator
 * @export
 */
export const CandidatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Convert a candidate to an employee
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convert: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('convert', 'id', id)
            const localVarPath = `/api/v1/candidates/{id}/convert`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCandidateDto} createCandidateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createCandidateDto: CreateCandidateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCandidateDto' is not null or undefined
            assertParamExists('create', 'createCandidateDto', createCandidateDto)
            const localVarPath = `/api/v1/candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCandidateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/candidates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/candidates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search across all candidates with optional matchScore and skills filters
         * @param {number} [minMatchScore] Minimum match score (0-100)
         * @param {string} [skills] Comma-separated skill keywords to search in resumeData
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        talentPool: async (minMatchScore?: number, skills?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/candidates/talent-pool`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (minMatchScore !== undefined) {
                localVarQueryParameter['minMatchScore'] = minMatchScore;
            }

            if (skills !== undefined) {
                localVarQueryParameter['skills'] = skills;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCandidateDto} updateCandidateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateCandidateDto: UpdateCandidateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateCandidateDto' is not null or undefined
            assertParamExists('update', 'updateCandidateDto', updateCandidateDto)
            const localVarPath = `/api/v1/candidates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCandidateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CandidatesApi - functional programming interface
 * @export
 */
export const CandidatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CandidatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Convert a candidate to an employee
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convert(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convert(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateCandidateDto} createCandidateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createCandidateDto: CreateCandidateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidateEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createCandidateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CandidateEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidateEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidateEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search across all candidates with optional matchScore and skills filters
         * @param {number} [minMatchScore] Minimum match score (0-100)
         * @param {string} [skills] Comma-separated skill keywords to search in resumeData
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async talentPool(minMatchScore?: number, skills?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.talentPool(minMatchScore, skills, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCandidateDto} updateCandidateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateCandidateDto: UpdateCandidateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidateEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateCandidateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CandidatesApi - factory interface
 * @export
 */
export const CandidatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CandidatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Convert a candidate to an employee
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convert(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.convert(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateCandidateDto} createCandidateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createCandidateDto: CreateCandidateDto, options?: any): AxiosPromise<CandidateEntity> {
            return localVarFp.create(createCandidateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<CandidateEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<CandidateEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<CandidateEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search across all candidates with optional matchScore and skills filters
         * @param {number} [minMatchScore] Minimum match score (0-100)
         * @param {string} [skills] Comma-separated skill keywords to search in resumeData
         * @param {number} [page] Page number (1-based)
         * @param {number} [limit] Items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        talentPool(minMatchScore?: number, skills?: string, page?: number, limit?: number, options?: any): AxiosPromise<void> {
            return localVarFp.talentPool(minMatchScore, skills, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCandidateDto} updateCandidateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateCandidateDto: UpdateCandidateDto, options?: any): AxiosPromise<CandidateEntity> {
            return localVarFp.update(id, updateCandidateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CandidatesApi - object-oriented interface
 * @export
 * @class CandidatesApi
 * @extends {BaseAPI}
 */
export class CandidatesApi extends BaseAPI {
    /**
     * 
     * @summary Convert a candidate to an employee
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatesApi
     */
    public convert(id: string, options?: AxiosRequestConfig) {
        return CandidatesApiFp(this.configuration).convert(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateCandidateDto} createCandidateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatesApi
     */
    public create(createCandidateDto: CreateCandidateDto, options?: AxiosRequestConfig) {
        return CandidatesApiFp(this.configuration).create(createCandidateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatesApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return CandidatesApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatesApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return CandidatesApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatesApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return CandidatesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search across all candidates with optional matchScore and skills filters
     * @param {number} [minMatchScore] Minimum match score (0-100)
     * @param {string} [skills] Comma-separated skill keywords to search in resumeData
     * @param {number} [page] Page number (1-based)
     * @param {number} [limit] Items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatesApi
     */
    public talentPool(minMatchScore?: number, skills?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return CandidatesApiFp(this.configuration).talentPool(minMatchScore, skills, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateCandidateDto} updateCandidateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CandidatesApi
     */
    public update(id: string, updateCandidateDto: UpdateCandidateDto, options?: AxiosRequestConfig) {
        return CandidatesApiFp(this.configuration).update(id, updateCandidateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CloudApi - axios parameter creator
 * @export
 */
export const CloudApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPublic: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cloud/upload-public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CloudApi - functional programming interface
 * @export
 */
export const CloudApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CloudApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPublic(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPublic(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CloudApi - factory interface
 * @export
 */
export const CloudApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CloudApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPublic(options?: any): AxiosPromise<void> {
            return localVarFp.uploadPublic(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CloudApi - object-oriented interface
 * @export
 * @class CloudApi
 * @extends {BaseAPI}
 */
export class CloudApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CloudApi
     */
    public uploadPublic(options?: AxiosRequestConfig) {
        return CloudApiFp(this.configuration).uploadPublic(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CommunicationsApi - axios parameter creator
 * @export
 */
export const CommunicationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCommunicationDto} createCommunicationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createCommunicationDto: CreateCommunicationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCommunicationDto' is not null or undefined
            assertParamExists('create', 'createCommunicationDto', createCommunicationDto)
            const localVarPath = `/api/v1/communications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCommunicationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        find: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('find', 'id', id)
            const localVarPath = `/api/v1/communications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommunicationsApi - functional programming interface
 * @export
 */
export const CommunicationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommunicationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateCommunicationDto} createCommunicationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createCommunicationDto: CreateCommunicationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createCommunicationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async find(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommunicationEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.find(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CommunicationsApi - factory interface
 * @export
 */
export const CommunicationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommunicationsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateCommunicationDto} createCommunicationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createCommunicationDto: CreateCommunicationDto, options?: any): AxiosPromise<object> {
            return localVarFp.create(createCommunicationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        find(id: number, options?: any): AxiosPromise<Array<CommunicationEntity>> {
            return localVarFp.find(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommunicationsApi - object-oriented interface
 * @export
 * @class CommunicationsApi
 * @extends {BaseAPI}
 */
export class CommunicationsApi extends BaseAPI {
    /**
     * 
     * @param {CreateCommunicationDto} createCommunicationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationsApi
     */
    public create(createCommunicationDto: CreateCommunicationDto, options?: AxiosRequestConfig) {
        return CommunicationsApiFp(this.configuration).create(createCommunicationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationsApi
     */
    public find(id: number, options?: AxiosRequestConfig) {
        return CommunicationsApiFp(this.configuration).find(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContractTypesApi - axios parameter creator
 * @export
 */
export const ContractTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateContractTypeDto} createContractTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createContractTypeDto: CreateContractTypeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createContractTypeDto' is not null or undefined
            assertParamExists('create', 'createContractTypeDto', createContractTypeDto)
            const localVarPath = `/api/v1/contract-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContractTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/contract-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/contract-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/contract-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateContractTypeDto} updateContractTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateContractTypeDto: UpdateContractTypeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateContractTypeDto' is not null or undefined
            assertParamExists('update', 'updateContractTypeDto', updateContractTypeDto)
            const localVarPath = `/api/v1/contract-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateContractTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractTypesApi - functional programming interface
 * @export
 */
export const ContractTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateContractTypeDto} createContractTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createContractTypeDto: CreateContractTypeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractTypeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createContractTypeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContractTypeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractTypeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractTypeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateContractTypeDto} updateContractTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateContractTypeDto: UpdateContractTypeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractTypeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateContractTypeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContractTypesApi - factory interface
 * @export
 */
export const ContractTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateContractTypeDto} createContractTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createContractTypeDto: CreateContractTypeDto, options?: any): AxiosPromise<ContractTypeEntity> {
            return localVarFp.create(createContractTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<ContractTypeEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<ContractTypeEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<ContractTypeEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateContractTypeDto} updateContractTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateContractTypeDto: UpdateContractTypeDto, options?: any): AxiosPromise<ContractTypeEntity> {
            return localVarFp.update(id, updateContractTypeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContractTypesApi - object-oriented interface
 * @export
 * @class ContractTypesApi
 * @extends {BaseAPI}
 */
export class ContractTypesApi extends BaseAPI {
    /**
     * 
     * @param {CreateContractTypeDto} createContractTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractTypesApi
     */
    public create(createContractTypeDto: CreateContractTypeDto, options?: AxiosRequestConfig) {
        return ContractTypesApiFp(this.configuration).create(createContractTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractTypesApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return ContractTypesApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractTypesApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return ContractTypesApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractTypesApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return ContractTypesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateContractTypeDto} updateContractTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractTypesApi
     */
    public update(id: string, updateContractTypeDto: UpdateContractTypeDto, options?: AxiosRequestConfig) {
        return ContractTypesApiFp(this.configuration).update(id, updateContractTypeDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContractsApi - axios parameter creator
 * @export
 */
export const ContractsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateContractDto} createContractDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createContractDto: CreateContractDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createContractDto' is not null or undefined
            assertParamExists('create', 'createContractDto', createContractDto)
            const localVarPath = `/api/v1/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContractDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFile: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createFile', 'id', id)
            const localVarPath = `/api/v1/contracts/{id}/file`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContract: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteContract', 'id', id)
            const localVarPath = `/api/v1/contracts/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (employeeId?: number, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} [employeeId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, employeeId?: number, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/contracts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateContractDto} updateContractDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateContractDto: UpdateContractDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateContractDto' is not null or undefined
            assertParamExists('update', 'updateContractDto', updateContractDto)
            const localVarPath = `/api/v1/contracts/{id}/{seasonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateContractDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractsApi - functional programming interface
 * @export
 */
export const ContractsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateContractDto} createContractDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createContractDto: CreateContractDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createContractDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFile(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContract(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContract(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(employeeId?: number, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} [employeeId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, employeeId?: number, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateContractDto} updateContractDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateContractDto: UpdateContractDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateContractDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContractsApi - factory interface
 * @export
 */
export const ContractsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateContractDto} createContractDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createContractDto: CreateContractDto, options?: any): AxiosPromise<ContractEntity> {
            return localVarFp.create(createContractDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFile(id: string, options?: any): AxiosPromise<FileEntity> {
            return localVarFp.createFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContract(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteContract(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(employeeId?: number, seasonId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.findAll(employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {number} [employeeId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, employeeId?: number, seasonId?: number, options?: any): AxiosPromise<ContractEntity> {
            return localVarFp.findOne(id, employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateContractDto} updateContractDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateContractDto: UpdateContractDto, options?: any): AxiosPromise<ContractEntity> {
            return localVarFp.update(id, updateContractDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContractsApi - object-oriented interface
 * @export
 * @class ContractsApi
 * @extends {BaseAPI}
 */
export class ContractsApi extends BaseAPI {
    /**
     * 
     * @param {CreateContractDto} createContractDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public create(createContractDto: CreateContractDto, options?: AxiosRequestConfig) {
        return ContractsApiFp(this.configuration).create(createContractDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public createFile(id: string, options?: AxiosRequestConfig) {
        return ContractsApiFp(this.configuration).createFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public deleteContract(id: number, options?: AxiosRequestConfig) {
        return ContractsApiFp(this.configuration).deleteContract(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [employeeId] 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public findAll(employeeId?: number, seasonId?: number, options?: AxiosRequestConfig) {
        return ContractsApiFp(this.configuration).findAll(employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {number} [employeeId] 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public findOne(id: string, employeeId?: number, seasonId?: number, options?: AxiosRequestConfig) {
        return ContractsApiFp(this.configuration).findOne(id, employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateContractDto} updateContractDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    public update(id: string, updateContractDto: UpdateContractDto, options?: AxiosRequestConfig) {
        return ContractsApiFp(this.configuration).update(id, updateContractDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CourseTypesApi - axios parameter creator
 * @export
 */
export const CourseTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new course type
         * @param {CreateCourseTypeDto} createCourseTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createCourseTypeDto: CreateCourseTypeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCourseTypeDto' is not null or undefined
            assertParamExists('create', 'createCourseTypeDto', createCourseTypeDto)
            const localVarPath = `/api/v1/course-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCourseTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all course types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/course-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a course type by ID (includes training requirements)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/course-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a course type
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/course-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Seed standard Italian compliance course types (HACCP, safety, etc.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seedItalianDefaults: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/course-types/seed-italian-defaults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a course type
         * @param {string} id 
         * @param {UpdateCourseTypeDto} updateCourseTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateCourseTypeDto: UpdateCourseTypeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateCourseTypeDto' is not null or undefined
            assertParamExists('update', 'updateCourseTypeDto', updateCourseTypeDto)
            const localVarPath = `/api/v1/course-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCourseTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CourseTypesApi - functional programming interface
 * @export
 */
export const CourseTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CourseTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new course type
         * @param {CreateCourseTypeDto} createCourseTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createCourseTypeDto: CreateCourseTypeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseTypeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createCourseTypeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all course types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CourseTypeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a course type by ID (includes training requirements)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseTypeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a course type
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseTypeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Seed standard Italian compliance course types (HACCP, safety, etc.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seedItalianDefaults(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CourseTypeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seedItalianDefaults(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a course type
         * @param {string} id 
         * @param {UpdateCourseTypeDto} updateCourseTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateCourseTypeDto: UpdateCourseTypeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseTypeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateCourseTypeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CourseTypesApi - factory interface
 * @export
 */
export const CourseTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CourseTypesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new course type
         * @param {CreateCourseTypeDto} createCourseTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createCourseTypeDto: CreateCourseTypeDto, options?: any): AxiosPromise<CourseTypeEntity> {
            return localVarFp.create(createCourseTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all course types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<CourseTypeEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a course type by ID (includes training requirements)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<CourseTypeEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a course type
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<CourseTypeEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Seed standard Italian compliance course types (HACCP, safety, etc.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seedItalianDefaults(options?: any): AxiosPromise<Array<CourseTypeEntity>> {
            return localVarFp.seedItalianDefaults(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a course type
         * @param {string} id 
         * @param {UpdateCourseTypeDto} updateCourseTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateCourseTypeDto: UpdateCourseTypeDto, options?: any): AxiosPromise<CourseTypeEntity> {
            return localVarFp.update(id, updateCourseTypeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CourseTypesApi - object-oriented interface
 * @export
 * @class CourseTypesApi
 * @extends {BaseAPI}
 */
export class CourseTypesApi extends BaseAPI {
    /**
     * 
     * @summary Create a new course type
     * @param {CreateCourseTypeDto} createCourseTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseTypesApi
     */
    public create(createCourseTypeDto: CreateCourseTypeDto, options?: AxiosRequestConfig) {
        return CourseTypesApiFp(this.configuration).create(createCourseTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all course types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseTypesApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return CourseTypesApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a course type by ID (includes training requirements)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseTypesApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return CourseTypesApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a course type
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseTypesApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return CourseTypesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Seed standard Italian compliance course types (HACCP, safety, etc.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseTypesApi
     */
    public seedItalianDefaults(options?: AxiosRequestConfig) {
        return CourseTypesApiFp(this.configuration).seedItalianDefaults(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a course type
     * @param {string} id 
     * @param {UpdateCourseTypeDto} updateCourseTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseTypesApi
     */
    public update(id: string, updateCourseTypeDto: UpdateCourseTypeDto, options?: AxiosRequestConfig) {
        return CourseTypesApiFp(this.configuration).update(id, updateCourseTypeDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DailyNotesApi - axios parameter creator
 * @export
 */
export const DailyNotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateDailyNoteDto} createDailyNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createDailyNoteDto: CreateDailyNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDailyNoteDto' is not null or undefined
            assertParamExists('create', 'createDailyNoteDto', createDailyNoteDto)
            const localVarPath = `/api/v1/daily-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDailyNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload an image along with the daily note data. The image will be stored in the cloud and a presigned URL will be returned.
         * @summary Create a new daily note with an uploaded image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithImage: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/daily-notes/with-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/daily-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/daily-notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/daily-notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolve: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resolve', 'id', id)
            const localVarPath = `/api/v1/daily-notes/resolve/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unresolve: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unresolve', 'id', id)
            const localVarPath = `/api/v1/daily-notes/unresolve/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDailyNoteDto} updateDailyNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateDailyNoteDto: UpdateDailyNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateDailyNoteDto' is not null or undefined
            assertParamExists('update', 'updateDailyNoteDto', updateDailyNoteDto)
            const localVarPath = `/api/v1/daily-notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDailyNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DailyNotesApi - functional programming interface
 * @export
 */
export const DailyNotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DailyNotesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateDailyNoteDto} createDailyNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createDailyNoteDto: CreateDailyNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createDailyNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload an image along with the daily note data. The image will be stored in the cloud and a presigned URL will be returned.
         * @summary Create a new daily note with an uploaded image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWithImage(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWithImage(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DailyNoteEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolve(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unresolve(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unresolve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDailyNoteDto} updateDailyNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateDailyNoteDto: UpdateDailyNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateDailyNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DailyNotesApi - factory interface
 * @export
 */
export const DailyNotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DailyNotesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateDailyNoteDto} createDailyNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createDailyNoteDto: CreateDailyNoteDto, options?: any): AxiosPromise<DailyNoteEntity> {
            return localVarFp.create(createDailyNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload an image along with the daily note data. The image will be stored in the cloud and a presigned URL will be returned.
         * @summary Create a new daily note with an uploaded image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithImage(options?: any): AxiosPromise<void> {
            return localVarFp.createWithImage(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<DailyNoteEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<DailyNoteEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<DailyNoteEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolve(id: string, options?: any): AxiosPromise<DailyNoteEntity> {
            return localVarFp.resolve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unresolve(id: string, options?: any): AxiosPromise<DailyNoteEntity> {
            return localVarFp.unresolve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDailyNoteDto} updateDailyNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateDailyNoteDto: UpdateDailyNoteDto, options?: any): AxiosPromise<DailyNoteEntity> {
            return localVarFp.update(id, updateDailyNoteDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DailyNotesApi - object-oriented interface
 * @export
 * @class DailyNotesApi
 * @extends {BaseAPI}
 */
export class DailyNotesApi extends BaseAPI {
    /**
     * 
     * @param {CreateDailyNoteDto} createDailyNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyNotesApi
     */
    public create(createDailyNoteDto: CreateDailyNoteDto, options?: AxiosRequestConfig) {
        return DailyNotesApiFp(this.configuration).create(createDailyNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload an image along with the daily note data. The image will be stored in the cloud and a presigned URL will be returned.
     * @summary Create a new daily note with an uploaded image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyNotesApi
     */
    public createWithImage(options?: AxiosRequestConfig) {
        return DailyNotesApiFp(this.configuration).createWithImage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyNotesApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return DailyNotesApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyNotesApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return DailyNotesApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyNotesApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return DailyNotesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyNotesApi
     */
    public resolve(id: string, options?: AxiosRequestConfig) {
        return DailyNotesApiFp(this.configuration).resolve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyNotesApi
     */
    public unresolve(id: string, options?: AxiosRequestConfig) {
        return DailyNotesApiFp(this.configuration).unresolve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateDailyNoteDto} updateDailyNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyNotesApi
     */
    public update(id: string, updateDailyNoteDto: UpdateDailyNoteDto, options?: AxiosRequestConfig) {
        return DailyNotesApiFp(this.configuration).update(id, updateDailyNoteDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DailyTicketsApi - axios parameter creator
 * @export
 */
export const DailyTicketsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} dateEpoc 
         * @param {number} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDailyTickets: async (dateEpoc: number, sectionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dateEpoc' is not null or undefined
            assertParamExists('confirmDailyTickets', 'dateEpoc', dateEpoc)
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('confirmDailyTickets', 'sectionId', sectionId)
            const localVarPath = `/api/v1/daily-tickets/status/{dateEpoc}/{sectionId}`
                .replace(`{${"dateEpoc"}}`, encodeURIComponent(String(dateEpoc)))
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTicketItemDto} createTicketItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createTicketItemDto: CreateTicketItemDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTicketItemDto' is not null or undefined
            assertParamExists('create', 'createTicketItemDto', createTicketItemDto)
            const localVarPath = `/api/v1/daily-tickets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTicketItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {CreateDailyTicketDto} createDailyTicketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDaily: async (seasonId: number, createDailyTicketDto: CreateDailyTicketDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('createDaily', 'seasonId', seasonId)
            // verify required parameter 'createDailyTicketDto' is not null or undefined
            assertParamExists('createDaily', 'createDailyTicketDto', createDailyTicketDto)
            const localVarPath = `/api/v1/daily-tickets/daily/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDailyTicketDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/daily-tickets/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDaily: async (fromDate: string, toDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('findAllDaily', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('findAllDaily', 'toDate', toDate)
            const localVarPath = `/api/v1/daily-tickets/findIntervall`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/daily-tickets/findOne/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneDaily: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOneDaily', 'id', id)
            const localVarPath = `/api/v1/daily-tickets/daily/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} startDateEpoc 
         * @param {number} endDateEpoc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStatuses: async (startDateEpoc: number, endDateEpoc: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDateEpoc' is not null or undefined
            assertParamExists('findStatuses', 'startDateEpoc', startDateEpoc)
            // verify required parameter 'endDateEpoc' is not null or undefined
            assertParamExists('findStatuses', 'endDateEpoc', endDateEpoc)
            const localVarPath = `/api/v1/daily-tickets/allStatus/{startDateEpoc}/{endDateEpoc}`
                .replace(`{${"startDateEpoc"}}`, encodeURIComponent(String(startDateEpoc)))
                .replace(`{${"endDateEpoc"}}`, encodeURIComponent(String(endDateEpoc)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastValues: async (date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getLastValues', 'date', date)
            const localVarPath = `/api/v1/daily-tickets/daily/last-values/{date}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/daily-tickets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDaily: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeDaily', 'id', id)
            const localVarPath = `/api/v1/daily-tickets/daily/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTicketDto} updateTicketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateTicketDto: UpdateTicketDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateTicketDto' is not null or undefined
            assertParamExists('update', 'updateTicketDto', updateTicketDto)
            const localVarPath = `/api/v1/daily-tickets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTicketDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDailyTicketDto} updateDailyTicketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDaily: async (id: string, updateDailyTicketDto: UpdateDailyTicketDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDaily', 'id', id)
            // verify required parameter 'updateDailyTicketDto' is not null or undefined
            assertParamExists('updateDaily', 'updateDailyTicketDto', updateDailyTicketDto)
            const localVarPath = `/api/v1/daily-tickets/daily/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDailyTicketDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DailyTicketsApi - functional programming interface
 * @export
 */
export const DailyTicketsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DailyTicketsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} dateEpoc 
         * @param {number} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDailyTickets(dateEpoc: number, sectionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmDailyTickets(dateEpoc, sectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateTicketItemDto} createTicketItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createTicketItemDto: CreateTicketItemDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketItemEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createTicketItemDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {CreateDailyTicketDto} createDailyTicketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDaily(seasonId: number, createDailyTicketDto: CreateDailyTicketDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyTicketEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDaily(seasonId, createDailyTicketDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TicketItemEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllDaily(fromDate: string, toDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DailyTicketEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllDaily(fromDate, toDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketItemEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOneDaily(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyTicketEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOneDaily(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} startDateEpoc 
         * @param {number} endDateEpoc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findStatuses(startDateEpoc: number, endDateEpoc: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DailyTicketingStatusEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findStatuses(startDateEpoc, endDateEpoc, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLastValues(date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TicketItemWithDailyEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLastValues(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDaily(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyTicketEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDaily(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTicketDto} updateTicketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateTicketDto: UpdateTicketDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketItemEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateTicketDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDailyTicketDto} updateDailyTicketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDaily(id: string, updateDailyTicketDto: UpdateDailyTicketDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyTicketEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDaily(id, updateDailyTicketDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DailyTicketsApi - factory interface
 * @export
 */
export const DailyTicketsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DailyTicketsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} dateEpoc 
         * @param {number} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDailyTickets(dateEpoc: number, sectionId: number, options?: any): AxiosPromise<void> {
            return localVarFp.confirmDailyTickets(dateEpoc, sectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateTicketItemDto} createTicketItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createTicketItemDto: CreateTicketItemDto, options?: any): AxiosPromise<TicketItemEntity> {
            return localVarFp.create(createTicketItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {CreateDailyTicketDto} createDailyTicketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDaily(seasonId: number, createDailyTicketDto: CreateDailyTicketDto, options?: any): AxiosPromise<DailyTicketEntity> {
            return localVarFp.createDaily(seasonId, createDailyTicketDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<TicketItemEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDaily(fromDate: string, toDate: string, options?: any): AxiosPromise<Array<DailyTicketEntity>> {
            return localVarFp.findAllDaily(fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<TicketItemEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneDaily(id: string, options?: any): AxiosPromise<DailyTicketEntity> {
            return localVarFp.findOneDaily(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} startDateEpoc 
         * @param {number} endDateEpoc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findStatuses(startDateEpoc: number, endDateEpoc: number, options?: any): AxiosPromise<Array<DailyTicketingStatusEntity>> {
            return localVarFp.findStatuses(startDateEpoc, endDateEpoc, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastValues(date: string, options?: any): AxiosPromise<Array<TicketItemWithDailyEntity>> {
            return localVarFp.getLastValues(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDaily(id: string, options?: any): AxiosPromise<DailyTicketEntity> {
            return localVarFp.removeDaily(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTicketDto} updateTicketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateTicketDto: UpdateTicketDto, options?: any): AxiosPromise<TicketItemEntity> {
            return localVarFp.update(id, updateTicketDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDailyTicketDto} updateDailyTicketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDaily(id: string, updateDailyTicketDto: UpdateDailyTicketDto, options?: any): AxiosPromise<DailyTicketEntity> {
            return localVarFp.updateDaily(id, updateDailyTicketDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DailyTicketsApi - object-oriented interface
 * @export
 * @class DailyTicketsApi
 * @extends {BaseAPI}
 */
export class DailyTicketsApi extends BaseAPI {
    /**
     * 
     * @param {number} dateEpoc 
     * @param {number} sectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyTicketsApi
     */
    public confirmDailyTickets(dateEpoc: number, sectionId: number, options?: AxiosRequestConfig) {
        return DailyTicketsApiFp(this.configuration).confirmDailyTickets(dateEpoc, sectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateTicketItemDto} createTicketItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyTicketsApi
     */
    public create(createTicketItemDto: CreateTicketItemDto, options?: AxiosRequestConfig) {
        return DailyTicketsApiFp(this.configuration).create(createTicketItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {CreateDailyTicketDto} createDailyTicketDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyTicketsApi
     */
    public createDaily(seasonId: number, createDailyTicketDto: CreateDailyTicketDto, options?: AxiosRequestConfig) {
        return DailyTicketsApiFp(this.configuration).createDaily(seasonId, createDailyTicketDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyTicketsApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return DailyTicketsApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyTicketsApi
     */
    public findAllDaily(fromDate: string, toDate: string, options?: AxiosRequestConfig) {
        return DailyTicketsApiFp(this.configuration).findAllDaily(fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyTicketsApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return DailyTicketsApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyTicketsApi
     */
    public findOneDaily(id: string, options?: AxiosRequestConfig) {
        return DailyTicketsApiFp(this.configuration).findOneDaily(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} startDateEpoc 
     * @param {number} endDateEpoc 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyTicketsApi
     */
    public findStatuses(startDateEpoc: number, endDateEpoc: number, options?: AxiosRequestConfig) {
        return DailyTicketsApiFp(this.configuration).findStatuses(startDateEpoc, endDateEpoc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyTicketsApi
     */
    public getLastValues(date: string, options?: AxiosRequestConfig) {
        return DailyTicketsApiFp(this.configuration).getLastValues(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyTicketsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return DailyTicketsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyTicketsApi
     */
    public removeDaily(id: string, options?: AxiosRequestConfig) {
        return DailyTicketsApiFp(this.configuration).removeDaily(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateTicketDto} updateTicketDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyTicketsApi
     */
    public update(id: string, updateTicketDto: UpdateTicketDto, options?: AxiosRequestConfig) {
        return DailyTicketsApiFp(this.configuration).update(id, updateTicketDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateDailyTicketDto} updateDailyTicketDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DailyTicketsApi
     */
    public updateDaily(id: string, updateDailyTicketDto: UpdateDailyTicketDto, options?: AxiosRequestConfig) {
        return DailyTicketsApiFp(this.configuration).updateDaily(id, updateDailyTicketDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get recruitment dashboard statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentStats: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/recruitment-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get recruitment dashboard statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecruitmentStats(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecruitmentStatsEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecruitmentStats(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * 
         * @summary Get recruitment dashboard statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecruitmentStats(options?: any): AxiosPromise<RecruitmentStatsEntity> {
            return localVarFp.getRecruitmentStats(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * 
     * @summary Get recruitment dashboard statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public getRecruitmentStats(options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getRecruitmentStats(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('create', 'body', body)
            const localVarPath = `/api/v1/whatsapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/whatsapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/whatsapp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Serve the embeddable JS widget script. MUST be defined BEFORE any parameterized routes so NestJS doesn\'t treat \"embed.js\" as a :tenantId param.
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbedScript: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/widgets/embed.js`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return public job listings for a given tenant, optionally filtered by department.
         * @summary 
         * @param {string} tenantId 
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicJobs: async (tenantId: string, departmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getPublicJobs', 'tenantId', tenantId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('getPublicJobs', 'departmentId', departmentId)
            const localVarPath = `/api/v1/widgets/{tenantId}/jobs`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/whatsapp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('update', 'body', body)
            const localVarPath = `/api/v1/whatsapp/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Serve the embeddable JS widget script. MUST be defined BEFORE any parameterized routes so NestJS doesn\'t treat \"embed.js\" as a :tenantId param.
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmbedScript(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmbedScript(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Return public job listings for a given tenant, optionally filtered by department.
         * @summary 
         * @param {string} tenantId 
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicJobs(tenantId: string, departmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicJobs(tenantId, departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body: object, options?: any): AxiosPromise<string> {
            return localVarFp.create(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<string> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Serve the embeddable JS widget script. MUST be defined BEFORE any parameterized routes so NestJS doesn\'t treat \"embed.js\" as a :tenantId param.
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbedScript(options?: any): AxiosPromise<void> {
            return localVarFp.getEmbedScript(options).then((request) => request(axios, basePath));
        },
        /**
         * Return public job listings for a given tenant, optionally filtered by department.
         * @summary 
         * @param {string} tenantId 
         * @param {string} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicJobs(tenantId: string, departmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.getPublicJobs(tenantId, departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, body: object, options?: any): AxiosPromise<string> {
            return localVarFp.update(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public create(body: object, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).create(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Serve the embeddable JS widget script. MUST be defined BEFORE any parameterized routes so NestJS doesn\'t treat \"embed.js\" as a :tenantId param.
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getEmbedScript(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getEmbedScript(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return public job listings for a given tenant, optionally filtered by department.
     * @summary 
     * @param {string} tenantId 
     * @param {string} departmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPublicJobs(tenantId: string, departmentId: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPublicJobs(tenantId, departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public update(id: string, body: object, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).update(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DepartmentsApi - axios parameter creator
 * @export
 */
export const DepartmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateDepartmentDto} createDepartmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createDepartmentDto: CreateDepartmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDepartmentDto' is not null or undefined
            assertParamExists('create', 'createDepartmentDto', createDepartmentDto)
            const localVarPath = `/api/v1/departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDepartmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByRole: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findByRole', 'seasonId', seasonId)
            const localVarPath = `/api/v1/departments/byRole/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {number} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBySection: async (seasonId: number, sectionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findBySection', 'seasonId', seasonId)
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('findBySection', 'sectionId', sectionId)
            const localVarPath = `/api/v1/departments/bySection/{seasonId}/{sectionId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)))
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/departments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWhereIsBoss: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findWhereIsBoss', 'seasonId', seasonId)
            const localVarPath = `/api/v1/departments/whereBossId/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicFindAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/departments/public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/departments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDepartmentDto} updateDepartmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateDepartmentDto: UpdateDepartmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateDepartmentDto' is not null or undefined
            assertParamExists('update', 'updateDepartmentDto', updateDepartmentDto)
            const localVarPath = `/api/v1/departments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDepartmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepartmentsApi - functional programming interface
 * @export
 */
export const DepartmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepartmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateDepartmentDto} createDepartmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createDepartmentDto: CreateDepartmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createDepartmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DepartmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByRole(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DepartmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByRole(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {number} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findBySection(seasonId: number, sectionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findBySection(seasonId, sectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findWhereIsBoss(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DepartmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findWhereIsBoss(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicFindAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DepartmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicFindAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDepartmentDto} updateDepartmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateDepartmentDto: UpdateDepartmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateDepartmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DepartmentsApi - factory interface
 * @export
 */
export const DepartmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepartmentsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateDepartmentDto} createDepartmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createDepartmentDto: CreateDepartmentDto, options?: any): AxiosPromise<DepartmentEntity> {
            return localVarFp.create(createDepartmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<DepartmentEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByRole(seasonId: number, options?: any): AxiosPromise<Array<DepartmentEntity>> {
            return localVarFp.findByRole(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {number} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBySection(seasonId: number, sectionId: number, options?: any): AxiosPromise<DepartmentEntity> {
            return localVarFp.findBySection(seasonId, sectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<DepartmentEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWhereIsBoss(seasonId: number, options?: any): AxiosPromise<Array<DepartmentEntity>> {
            return localVarFp.findWhereIsBoss(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicFindAll(options?: any): AxiosPromise<Array<DepartmentEntity>> {
            return localVarFp.publicFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDepartmentDto} updateDepartmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateDepartmentDto: UpdateDepartmentDto, options?: any): AxiosPromise<DepartmentEntity> {
            return localVarFp.update(id, updateDepartmentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepartmentsApi - object-oriented interface
 * @export
 * @class DepartmentsApi
 * @extends {BaseAPI}
 */
export class DepartmentsApi extends BaseAPI {
    /**
     * 
     * @param {CreateDepartmentDto} createDepartmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public create(createDepartmentDto: CreateDepartmentDto, options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).create(createDepartmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public findByRole(seasonId: number, options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).findByRole(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {number} sectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public findBySection(seasonId: number, sectionId: number, options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).findBySection(seasonId, sectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public findWhereIsBoss(seasonId: number, options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).findWhereIsBoss(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public publicFindAll(options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).publicFindAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateDepartmentDto} updateDepartmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public update(id: string, updateDepartmentDto: UpdateDepartmentDto, options?: AxiosRequestConfig) {
        return DepartmentsApiFp(this.configuration).update(id, updateDepartmentDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DepartmentsEmployeesApi - axios parameter creator
 * @export
 */
export const DepartmentsEmployeesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCanChangeDate: async (departmentId: number, employeeId: number, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('assignCanChangeDate', 'departmentId', departmentId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('assignCanChangeDate', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/{departmentId}/employees/assignCanChangeDate/{employeeId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCanMakeTurnover: async (departmentId: number, employeeId: number, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('assignCanMakeTurnover', 'departmentId', departmentId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('assignCanMakeTurnover', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/{departmentId}/employees/assignCanMakeTurnover/{employeeId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignIsManager: async (departmentId: number, employeeId: number, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('assignIsManager', 'departmentId', departmentId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('assignIsManager', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/{departmentId}/employees/assignIsManager/{employeeId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canChangeTurnoversDate: async (departmentId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('canChangeTurnoversDate', 'departmentId', departmentId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('canChangeTurnoversDate', 'seasonId', seasonId)
            const localVarPath = `/api/v1/departments/{departmentId}/employees/canChangeTurnoversDate/{seasonId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} id 
         * @param {CreateDepartmentEmployeeDto} createDepartmentEmployeeDto 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (departmentId: string, id: string, createDepartmentEmployeeDto: CreateDepartmentEmployeeDto, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('create', 'departmentId', departmentId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('create', 'id', id)
            // verify required parameter 'createDepartmentEmployeeDto' is not null or undefined
            assertParamExists('create', 'createDepartmentEmployeeDto', createDepartmentEmployeeDto)
            const localVarPath = `/api/v1/departments/{departmentId}/employees/{id}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDepartmentEmployeeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} excludeEmployeesWithoutContract 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (departmentId: string, excludeEmployeesWithoutContract: string, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('findAll', 'departmentId', departmentId)
            // verify required parameter 'excludeEmployeesWithoutContract' is not null or undefined
            assertParamExists('findAll', 'excludeEmployeesWithoutContract', excludeEmployeesWithoutContract)
            const localVarPath = `/api/v1/departments/{departmentId}/employees`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (excludeEmployeesWithoutContract !== undefined) {
                localVarQueryParameter['excludeEmployeesWithoutContract'] = excludeEmployeesWithoutContract;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} id 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (departmentId: string, id: string, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('findOne', 'departmentId', departmentId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/departments/{departmentId}/employees/{id}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isDepchief: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('isDepchief', 'seasonId', seasonId)
            const localVarPath = `/api/v1/departments/{departmentId}/employees/isDepchief/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} id 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (departmentId: string, id: string, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('remove', 'departmentId', departmentId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/departments/{departmentId}/employees/{id}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeCanChangeDate: async (departmentId: number, employeeId: number, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('revokeCanChangeDate', 'departmentId', departmentId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('revokeCanChangeDate', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/{departmentId}/employees/revokeCanChangeDate/{employeeId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeCanMakeTurnover: async (departmentId: number, employeeId: number, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('revokeCanMakeTurnover', 'departmentId', departmentId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('revokeCanMakeTurnover', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/{departmentId}/employees/revokeCanMakeTurnover/{employeeId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeIsManager: async (departmentId: number, employeeId: number, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('revokeIsManager', 'departmentId', departmentId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('revokeIsManager', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/{departmentId}/employees/revokeIsManager/{employeeId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} id 
         * @param {UpdateDepartmentEmployeeDto} updateDepartmentEmployeeDto 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (departmentId: string, id: string, updateDepartmentEmployeeDto: UpdateDepartmentEmployeeDto, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('update', 'departmentId', departmentId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateDepartmentEmployeeDto' is not null or undefined
            assertParamExists('update', 'updateDepartmentEmployeeDto', updateDepartmentEmployeeDto)
            const localVarPath = `/api/v1/departments/{departmentId}/employees/{id}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDepartmentEmployeeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepartmentsEmployeesApi - functional programming interface
 * @export
 */
export const DepartmentsEmployeesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepartmentsEmployeesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignCanChangeDate(departmentId: number, employeeId: number, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignCanChangeDate(departmentId, employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignCanMakeTurnover(departmentId: number, employeeId: number, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignCanMakeTurnover(departmentId, employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignIsManager(departmentId: number, employeeId: number, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignIsManager(departmentId, employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async canChangeTurnoversDate(departmentId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.canChangeTurnoversDate(departmentId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} id 
         * @param {CreateDepartmentEmployeeDto} createDepartmentEmployeeDto 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(departmentId: string, id: string, createDepartmentEmployeeDto: CreateDepartmentEmployeeDto, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentEmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(departmentId, id, createDepartmentEmployeeDto, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} excludeEmployeesWithoutContract 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(departmentId: string, excludeEmployeesWithoutContract: string, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DepartmentEmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(departmentId, excludeEmployeesWithoutContract, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} id 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(departmentId: string, id: string, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentEmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(departmentId, id, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isDepchief(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isDepchief(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} id 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(departmentId: string, id: string, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentEmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(departmentId, id, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeCanChangeDate(departmentId: number, employeeId: number, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeCanChangeDate(departmentId, employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeCanMakeTurnover(departmentId: number, employeeId: number, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeCanMakeTurnover(departmentId, employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeIsManager(departmentId: number, employeeId: number, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeIsManager(departmentId, employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} id 
         * @param {UpdateDepartmentEmployeeDto} updateDepartmentEmployeeDto 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(departmentId: string, id: string, updateDepartmentEmployeeDto: UpdateDepartmentEmployeeDto, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentEmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(departmentId, id, updateDepartmentEmployeeDto, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DepartmentsEmployeesApi - factory interface
 * @export
 */
export const DepartmentsEmployeesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepartmentsEmployeesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCanChangeDate(departmentId: number, employeeId: number, seasonId?: number, options?: any): AxiosPromise<object> {
            return localVarFp.assignCanChangeDate(departmentId, employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCanMakeTurnover(departmentId: number, employeeId: number, seasonId?: number, options?: any): AxiosPromise<object> {
            return localVarFp.assignCanMakeTurnover(departmentId, employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignIsManager(departmentId: number, employeeId: number, seasonId?: number, options?: any): AxiosPromise<object> {
            return localVarFp.assignIsManager(departmentId, employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canChangeTurnoversDate(departmentId: number, seasonId: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.canChangeTurnoversDate(departmentId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} id 
         * @param {CreateDepartmentEmployeeDto} createDepartmentEmployeeDto 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(departmentId: string, id: string, createDepartmentEmployeeDto: CreateDepartmentEmployeeDto, seasonId?: number, options?: any): AxiosPromise<DepartmentEmployeeEntity> {
            return localVarFp.create(departmentId, id, createDepartmentEmployeeDto, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} excludeEmployeesWithoutContract 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(departmentId: string, excludeEmployeesWithoutContract: string, seasonId?: number, options?: any): AxiosPromise<Array<DepartmentEmployeeEntity>> {
            return localVarFp.findAll(departmentId, excludeEmployeesWithoutContract, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} id 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(departmentId: string, id: string, seasonId?: number, options?: any): AxiosPromise<DepartmentEmployeeEntity> {
            return localVarFp.findOne(departmentId, id, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isDepchief(seasonId: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.isDepchief(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} id 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(departmentId: string, id: string, seasonId?: number, options?: any): AxiosPromise<DepartmentEmployeeEntity> {
            return localVarFp.remove(departmentId, id, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeCanChangeDate(departmentId: number, employeeId: number, seasonId?: number, options?: any): AxiosPromise<object> {
            return localVarFp.revokeCanChangeDate(departmentId, employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeCanMakeTurnover(departmentId: number, employeeId: number, seasonId?: number, options?: any): AxiosPromise<object> {
            return localVarFp.revokeCanMakeTurnover(departmentId, employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeIsManager(departmentId: number, employeeId: number, seasonId?: number, options?: any): AxiosPromise<object> {
            return localVarFp.revokeIsManager(departmentId, employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} departmentId 
         * @param {string} id 
         * @param {UpdateDepartmentEmployeeDto} updateDepartmentEmployeeDto 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(departmentId: string, id: string, updateDepartmentEmployeeDto: UpdateDepartmentEmployeeDto, seasonId?: number, options?: any): AxiosPromise<DepartmentEmployeeEntity> {
            return localVarFp.update(departmentId, id, updateDepartmentEmployeeDto, seasonId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepartmentsEmployeesApi - object-oriented interface
 * @export
 * @class DepartmentsEmployeesApi
 * @extends {BaseAPI}
 */
export class DepartmentsEmployeesApi extends BaseAPI {
    /**
     * 
     * @param {number} departmentId 
     * @param {number} employeeId 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesApi
     */
    public assignCanChangeDate(departmentId: number, employeeId: number, seasonId?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesApiFp(this.configuration).assignCanChangeDate(departmentId, employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} departmentId 
     * @param {number} employeeId 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesApi
     */
    public assignCanMakeTurnover(departmentId: number, employeeId: number, seasonId?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesApiFp(this.configuration).assignCanMakeTurnover(departmentId, employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} departmentId 
     * @param {number} employeeId 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesApi
     */
    public assignIsManager(departmentId: number, employeeId: number, seasonId?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesApiFp(this.configuration).assignIsManager(departmentId, employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} departmentId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesApi
     */
    public canChangeTurnoversDate(departmentId: number, seasonId: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesApiFp(this.configuration).canChangeTurnoversDate(departmentId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} departmentId 
     * @param {string} id 
     * @param {CreateDepartmentEmployeeDto} createDepartmentEmployeeDto 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesApi
     */
    public create(departmentId: string, id: string, createDepartmentEmployeeDto: CreateDepartmentEmployeeDto, seasonId?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesApiFp(this.configuration).create(departmentId, id, createDepartmentEmployeeDto, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} departmentId 
     * @param {string} excludeEmployeesWithoutContract 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesApi
     */
    public findAll(departmentId: string, excludeEmployeesWithoutContract: string, seasonId?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesApiFp(this.configuration).findAll(departmentId, excludeEmployeesWithoutContract, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} departmentId 
     * @param {string} id 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesApi
     */
    public findOne(departmentId: string, id: string, seasonId?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesApiFp(this.configuration).findOne(departmentId, id, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesApi
     */
    public isDepchief(seasonId: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesApiFp(this.configuration).isDepchief(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} departmentId 
     * @param {string} id 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesApi
     */
    public remove(departmentId: string, id: string, seasonId?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesApiFp(this.configuration).remove(departmentId, id, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} departmentId 
     * @param {number} employeeId 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesApi
     */
    public revokeCanChangeDate(departmentId: number, employeeId: number, seasonId?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesApiFp(this.configuration).revokeCanChangeDate(departmentId, employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} departmentId 
     * @param {number} employeeId 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesApi
     */
    public revokeCanMakeTurnover(departmentId: number, employeeId: number, seasonId?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesApiFp(this.configuration).revokeCanMakeTurnover(departmentId, employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} departmentId 
     * @param {number} employeeId 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesApi
     */
    public revokeIsManager(departmentId: number, employeeId: number, seasonId?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesApiFp(this.configuration).revokeIsManager(departmentId, employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} departmentId 
     * @param {string} id 
     * @param {UpdateDepartmentEmployeeDto} updateDepartmentEmployeeDto 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesApi
     */
    public update(departmentId: string, id: string, updateDepartmentEmployeeDto: UpdateDepartmentEmployeeDto, seasonId?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesApiFp(this.configuration).update(departmentId, id, updateDepartmentEmployeeDto, seasonId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DepartmentsEmployeesCalendarEntriesApi - axios parameter creator
 * @export
 */
export const DepartmentsEmployeesCalendarEntriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accept: async (id: string, seasonId: number, employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accept', 'id', id)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('accept', 'seasonId', seasonId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('accept', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/{id}/{seasonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {CreateCalendarEntryDto} createCalendarEntryDto 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (employeeId: string, createCalendarEntryDto: CreateCalendarEntryDto, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('create', 'employeeId', employeeId)
            // verify required parameter 'createCalendarEntryDto' is not null or undefined
            assertParamExists('create', 'createCalendarEntryDto', createCalendarEntryDto)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCalendarEntryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {CreateCalendarEntryDto} createCalendarEntryDto 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createByMyself: async (employeeId: string, createCalendarEntryDto: CreateCalendarEntryDto, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('createByMyself', 'employeeId', employeeId)
            // verify required parameter 'createCalendarEntryDto' is not null or undefined
            assertParamExists('createByMyself', 'createCalendarEntryDto', createCalendarEntryDto)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/createByMyself`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCalendarEntryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows managers and above to create new custom types for calendar entries
         * @summary Create a new custom calendar entry type
         * @param {CreateCustomTypeDto} createCustomTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomType: async (createCustomTypeDto: CreateCustomTypeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCustomTypeDto' is not null or undefined
            assertParamExists('createCustomType', 'createCustomTypeDto', createCustomTypeDto)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/custom-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMany: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/createMany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows managers and above to delete custom types
         * @summary Delete a custom calendar entry type
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomType: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCustomType', 'id', id)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/custom-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (employeeId: string, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findAll', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByMyself: async (employeeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findAllByMyself', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/findAllByMyself`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} seasonId 
         * @param {number} month 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllEvents: async (employeeId: string, seasonId: string, month: number, year: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findAllEvents', 'employeeId', employeeId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAllEvents', 'seasonId', seasonId)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('findAllEvents', 'month', month)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('findAllEvents', 'year', year)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/{seasonId}/{month}/{year}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)))
                .replace(`{${"month"}}`, encodeURIComponent(String(month)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {number} month 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllEventsByMyself: async (employeeId: string, month: number, year: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findAllEventsByMyself', 'employeeId', employeeId)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('findAllEventsByMyself', 'month', month)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('findAllEventsByMyself', 'year', year)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/findAllEventsByMyself/{seasonId}/{month}/{year}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"month"}}`, encodeURIComponent(String(month)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {string} date 
         * @param {number} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByDate: async (seasonId: number, date: string, departmentId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findByDate', 'seasonId', seasonId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('findByDate', 'date', date)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('findByDate', 'departmentId', departmentId)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/findByDate/{seasonId}/{date}/{departmentId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)))
                .replace(`{${"date"}}`, encodeURIComponent(String(date)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches all accepted calendar entries for specified employees that overlap with the given date range. This is a bulk endpoint to reduce the number of requests when fetching entries for multiple employees and dates.
         * @summary Get calendar entries for multiple employees within a date range
         * @param {FindByDateRangeDto} findByDateRangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByDateRange: async (findByDateRangeDto: FindByDateRangeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'findByDateRangeDto' is not null or undefined
            assertParamExists('findByDateRange', 'findByDateRangeDto', findByDateRangeDto)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/findByDateRange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findByDateRangeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEmployeeCalendarStatusByWeek: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('findEmployeeCalendarStatusByWeek', 'body', body)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/findEmployeeCalendarStasus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEmployeeCalendarStatusByWeekOfSubordinates: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('findEmployeeCalendarStatusByWeekOfSubordinates', 'body', body)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/findEmployeeCalendarStatusByWeekOfSubordinates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} employeeId 
         * @param {string} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEventsPerPeriodOfTime: async (startDate: string, endDate: string, employeeId: number, seasonId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('findEventsPerPeriodOfTime', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('findEventsPerPeriodOfTime', 'endDate', endDate)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findEventsPerPeriodOfTime', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/eventsPerPeriodOfTime`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findNotAccepted: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findNotAccepted', 'seasonId', seasonId)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/findNotAccepted/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, employeeId: string, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findOne', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneByMyself: async (id: string, employeeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOneByMyself', 'id', id)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findOneByMyself', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/findOneByMyself/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} seasonId 
         * @param {string} monday 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWeekFreeDays: async (employeeId: number, seasonId: number, monday: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findWeekFreeDays', 'employeeId', employeeId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findWeekFreeDays', 'seasonId', seasonId)
            // verify required parameter 'monday' is not null or undefined
            assertParamExists('findWeekFreeDays', 'monday', monday)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/weekFreeDays/{seasonId}/{monday}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)))
                .replace(`{${"monday"}}`, encodeURIComponent(String(monday)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows users to fetch all available custom types
         * @summary Get all custom calendar entry types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomTypes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/custom-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns detailed vacation statistics for the current user
         * @summary Get vacation summary for the authenticated user
         * @param {string} employeeId 
         * @param {number} [seasonId] 
         * @param {number} [year] Year to analyze (defaults to current year)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyVacationSummary: async (employeeId: string, seasonId?: number, year?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getMyVacationSummary', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/vacation-summary/my`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns counts of all event types (standard and custom) for a given employee and period
         * @summary Get aggregated calendar entry stats for an employee
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} employeeId 
         * @param {string} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatsSummary: async (startDate: string, endDate: string, employeeId: number, seasonId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getStatsSummary', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getStatsSummary', 'endDate', endDate)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getStatsSummary', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/stats-summary`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns detailed vacation statistics including past/future hours, monthly breakdown, upcoming entries, and usage metrics
         * @summary Get comprehensive vacation summary for an employee
         * @param {string} employeeId 
         * @param {number} [seasonId] 
         * @param {number} [year] Year to analyze (defaults to current year)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVacationSummary: async (employeeId: string, seasonId?: number, year?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getVacationSummary', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/vacation-summary`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refuse: async (id: string, seasonId: number, employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('refuse', 'id', id)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('refuse', 'seasonId', seasonId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('refuse', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/refuse/{id}/{seasonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, seasonId: number, employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('remove', 'seasonId', seasonId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('remove', 'employeeId', employeeId)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/{id}/{seasonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('update', 'body', body)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows managers and above to update existing custom types
         * @summary Update a custom calendar entry type
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomType: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCustomType', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateCustomType', 'body', body)
            const localVarPath = `/api/v1/departments/employees/{employeeId}/calendar-entries/custom-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepartmentsEmployeesCalendarEntriesApi - functional programming interface
 * @export
 */
export const DepartmentsEmployeesCalendarEntriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepartmentsEmployeesCalendarEntriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accept(id: string, seasonId: number, employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEntryEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accept(id, seasonId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {CreateCalendarEntryDto} createCalendarEntryDto 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(employeeId: string, createCalendarEntryDto: CreateCalendarEntryDto, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEntryEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(employeeId, createCalendarEntryDto, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {CreateCalendarEntryDto} createCalendarEntryDto 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createByMyself(employeeId: string, createCalendarEntryDto: CreateCalendarEntryDto, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEntryEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createByMyself(employeeId, createCalendarEntryDto, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows managers and above to create new custom types for calendar entries
         * @summary Create a new custom calendar entry type
         * @param {CreateCustomTypeDto} createCustomTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomType(createCustomTypeDto: CreateCustomTypeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomCalendarEntryTypesEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomType(createCustomTypeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMany(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMany(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows managers and above to delete custom types
         * @summary Delete a custom calendar entry type
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomType(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomType(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(employeeId: string, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEntryEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllByMyself(employeeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEntryEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllByMyself(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} seasonId 
         * @param {number} month 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllEvents(employeeId: string, seasonId: string, month: number, year: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllEvents(employeeId, seasonId, month, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {number} month 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllEventsByMyself(employeeId: string, month: number, year: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllEventsByMyself(employeeId, month, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {string} date 
         * @param {number} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByDate(seasonId: number, date: string, departmentId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEntryEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByDate(seasonId, date, departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetches all accepted calendar entries for specified employees that overlap with the given date range. This is a bulk endpoint to reduce the number of requests when fetching entries for multiple employees and dates.
         * @summary Get calendar entries for multiple employees within a date range
         * @param {FindByDateRangeDto} findByDateRangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByDateRange(findByDateRangeDto: FindByDateRangeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEntryEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByDateRange(findByDateRangeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findEmployeeCalendarStatusByWeek(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findEmployeeCalendarStatusByWeek(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findEmployeeCalendarStatusByWeekOfSubordinates(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findEmployeeCalendarStatusByWeekOfSubordinates(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} employeeId 
         * @param {string} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findEventsPerPeriodOfTime(startDate: string, endDate: string, employeeId: number, seasonId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findEventsPerPeriodOfTime(startDate, endDate, employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findNotAccepted(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEntryEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findNotAccepted(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, employeeId: string, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEntryEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOneByMyself(id: string, employeeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEntryEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOneByMyself(id, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} seasonId 
         * @param {string} monday 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findWeekFreeDays(employeeId: number, seasonId: number, monday: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findWeekFreeDays(employeeId, seasonId, monday, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows users to fetch all available custom types
         * @summary Get all custom calendar entry types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCustomTypes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomCalendarEntryTypesEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCustomTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns detailed vacation statistics for the current user
         * @summary Get vacation summary for the authenticated user
         * @param {string} employeeId 
         * @param {number} [seasonId] 
         * @param {number} [year] Year to analyze (defaults to current year)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyVacationSummary(employeeId: string, seasonId?: number, year?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VacationSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyVacationSummary(employeeId, seasonId, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns counts of all event types (standard and custom) for a given employee and period
         * @summary Get aggregated calendar entry stats for an employee
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} employeeId 
         * @param {string} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatsSummary(startDate: string, endDate: string, employeeId: number, seasonId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatsSummary(startDate, endDate, employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns detailed vacation statistics including past/future hours, monthly breakdown, upcoming entries, and usage metrics
         * @summary Get comprehensive vacation summary for an employee
         * @param {string} employeeId 
         * @param {number} [seasonId] 
         * @param {number} [year] Year to analyze (defaults to current year)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVacationSummary(employeeId: string, seasonId?: number, year?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VacationSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVacationSummary(employeeId, seasonId, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refuse(id: string, seasonId: number, employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEntryEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refuse(id, seasonId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, seasonId: number, employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEntryEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, seasonId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEntryEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows managers and above to update existing custom types
         * @summary Update a custom calendar entry type
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomType(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomCalendarEntryTypesEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomType(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DepartmentsEmployeesCalendarEntriesApi - factory interface
 * @export
 */
export const DepartmentsEmployeesCalendarEntriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepartmentsEmployeesCalendarEntriesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accept(id: string, seasonId: number, employeeId: number, options?: any): AxiosPromise<CalendarEntryEntity> {
            return localVarFp.accept(id, seasonId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {CreateCalendarEntryDto} createCalendarEntryDto 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(employeeId: string, createCalendarEntryDto: CreateCalendarEntryDto, seasonId?: number, options?: any): AxiosPromise<CalendarEntryEntity> {
            return localVarFp.create(employeeId, createCalendarEntryDto, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {CreateCalendarEntryDto} createCalendarEntryDto 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createByMyself(employeeId: string, createCalendarEntryDto: CreateCalendarEntryDto, seasonId?: number, options?: any): AxiosPromise<CalendarEntryEntity> {
            return localVarFp.createByMyself(employeeId, createCalendarEntryDto, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows managers and above to create new custom types for calendar entries
         * @summary Create a new custom calendar entry type
         * @param {CreateCustomTypeDto} createCustomTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomType(createCustomTypeDto: CreateCustomTypeDto, options?: any): AxiosPromise<CustomCalendarEntryTypesEntity> {
            return localVarFp.createCustomType(createCustomTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMany(options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createMany(options).then((request) => request(axios, basePath));
        },
        /**
         * Allows managers and above to delete custom types
         * @summary Delete a custom calendar entry type
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomType(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCustomType(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(employeeId: string, seasonId?: number, options?: any): AxiosPromise<Array<CalendarEntryEntity>> {
            return localVarFp.findAll(employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByMyself(employeeId: string, options?: any): AxiosPromise<Array<CalendarEntryEntity>> {
            return localVarFp.findAllByMyself(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} seasonId 
         * @param {number} month 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllEvents(employeeId: string, seasonId: string, month: number, year: number, options?: any): AxiosPromise<object> {
            return localVarFp.findAllEvents(employeeId, seasonId, month, year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {number} month 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllEventsByMyself(employeeId: string, month: number, year: number, options?: any): AxiosPromise<object> {
            return localVarFp.findAllEventsByMyself(employeeId, month, year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {string} date 
         * @param {number} departmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByDate(seasonId: number, date: string, departmentId: number, options?: any): AxiosPromise<Array<CalendarEntryEntity>> {
            return localVarFp.findByDate(seasonId, date, departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches all accepted calendar entries for specified employees that overlap with the given date range. This is a bulk endpoint to reduce the number of requests when fetching entries for multiple employees and dates.
         * @summary Get calendar entries for multiple employees within a date range
         * @param {FindByDateRangeDto} findByDateRangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByDateRange(findByDateRangeDto: FindByDateRangeDto, options?: any): AxiosPromise<Array<CalendarEntryEntity>> {
            return localVarFp.findByDateRange(findByDateRangeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEmployeeCalendarStatusByWeek(body: object, options?: any): AxiosPromise<Array<number>> {
            return localVarFp.findEmployeeCalendarStatusByWeek(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEmployeeCalendarStatusByWeekOfSubordinates(body: object, options?: any): AxiosPromise<Array<number>> {
            return localVarFp.findEmployeeCalendarStatusByWeekOfSubordinates(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} employeeId 
         * @param {string} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEventsPerPeriodOfTime(startDate: string, endDate: string, employeeId: number, seasonId?: string, options?: any): AxiosPromise<object> {
            return localVarFp.findEventsPerPeriodOfTime(startDate, endDate, employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findNotAccepted(seasonId: number, options?: any): AxiosPromise<Array<CalendarEntryEntity>> {
            return localVarFp.findNotAccepted(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} employeeId 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, employeeId: string, seasonId?: number, options?: any): AxiosPromise<CalendarEntryEntity> {
            return localVarFp.findOne(id, employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneByMyself(id: string, employeeId: string, options?: any): AxiosPromise<CalendarEntryEntity> {
            return localVarFp.findOneByMyself(id, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} seasonId 
         * @param {string} monday 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWeekFreeDays(employeeId: number, seasonId: number, monday: string, options?: any): AxiosPromise<void> {
            return localVarFp.findWeekFreeDays(employeeId, seasonId, monday, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows users to fetch all available custom types
         * @summary Get all custom calendar entry types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomTypes(options?: any): AxiosPromise<Array<CustomCalendarEntryTypesEntity>> {
            return localVarFp.getAllCustomTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns detailed vacation statistics for the current user
         * @summary Get vacation summary for the authenticated user
         * @param {string} employeeId 
         * @param {number} [seasonId] 
         * @param {number} [year] Year to analyze (defaults to current year)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyVacationSummary(employeeId: string, seasonId?: number, year?: number, options?: any): AxiosPromise<VacationSummaryDto> {
            return localVarFp.getMyVacationSummary(employeeId, seasonId, year, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns counts of all event types (standard and custom) for a given employee and period
         * @summary Get aggregated calendar entry stats for an employee
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} employeeId 
         * @param {string} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatsSummary(startDate: string, endDate: string, employeeId: number, seasonId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.getStatsSummary(startDate, endDate, employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns detailed vacation statistics including past/future hours, monthly breakdown, upcoming entries, and usage metrics
         * @summary Get comprehensive vacation summary for an employee
         * @param {string} employeeId 
         * @param {number} [seasonId] 
         * @param {number} [year] Year to analyze (defaults to current year)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVacationSummary(employeeId: string, seasonId?: number, year?: number, options?: any): AxiosPromise<VacationSummaryDto> {
            return localVarFp.getVacationSummary(employeeId, seasonId, year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refuse(id: string, seasonId: number, employeeId: number, options?: any): AxiosPromise<CalendarEntryEntity> {
            return localVarFp.refuse(id, seasonId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, seasonId: number, employeeId: number, options?: any): AxiosPromise<CalendarEntryEntity> {
            return localVarFp.remove(id, seasonId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, body: object, options?: any): AxiosPromise<CalendarEntryEntity> {
            return localVarFp.update(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows managers and above to update existing custom types
         * @summary Update a custom calendar entry type
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomType(id: string, body: object, options?: any): AxiosPromise<CustomCalendarEntryTypesEntity> {
            return localVarFp.updateCustomType(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepartmentsEmployeesCalendarEntriesApi - object-oriented interface
 * @export
 * @class DepartmentsEmployeesCalendarEntriesApi
 * @extends {BaseAPI}
 */
export class DepartmentsEmployeesCalendarEntriesApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {number} seasonId 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public accept(id: string, seasonId: number, employeeId: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).accept(id, seasonId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {CreateCalendarEntryDto} createCalendarEntryDto 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public create(employeeId: string, createCalendarEntryDto: CreateCalendarEntryDto, seasonId?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).create(employeeId, createCalendarEntryDto, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {CreateCalendarEntryDto} createCalendarEntryDto 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public createByMyself(employeeId: string, createCalendarEntryDto: CreateCalendarEntryDto, seasonId?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).createByMyself(employeeId, createCalendarEntryDto, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows managers and above to create new custom types for calendar entries
     * @summary Create a new custom calendar entry type
     * @param {CreateCustomTypeDto} createCustomTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public createCustomType(createCustomTypeDto: CreateCustomTypeDto, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).createCustomType(createCustomTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public createMany(options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).createMany(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows managers and above to delete custom types
     * @summary Delete a custom calendar entry type
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public deleteCustomType(id: string, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).deleteCustomType(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public findAll(employeeId: string, seasonId?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).findAll(employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public findAllByMyself(employeeId: string, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).findAllByMyself(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {string} seasonId 
     * @param {number} month 
     * @param {number} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public findAllEvents(employeeId: string, seasonId: string, month: number, year: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).findAllEvents(employeeId, seasonId, month, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {number} month 
     * @param {number} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public findAllEventsByMyself(employeeId: string, month: number, year: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).findAllEventsByMyself(employeeId, month, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {string} date 
     * @param {number} departmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public findByDate(seasonId: number, date: string, departmentId: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).findByDate(seasonId, date, departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches all accepted calendar entries for specified employees that overlap with the given date range. This is a bulk endpoint to reduce the number of requests when fetching entries for multiple employees and dates.
     * @summary Get calendar entries for multiple employees within a date range
     * @param {FindByDateRangeDto} findByDateRangeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public findByDateRange(findByDateRangeDto: FindByDateRangeDto, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).findByDateRange(findByDateRangeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public findEmployeeCalendarStatusByWeek(body: object, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).findEmployeeCalendarStatusByWeek(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public findEmployeeCalendarStatusByWeekOfSubordinates(body: object, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).findEmployeeCalendarStatusByWeekOfSubordinates(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {number} employeeId 
     * @param {string} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public findEventsPerPeriodOfTime(startDate: string, endDate: string, employeeId: number, seasonId?: string, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).findEventsPerPeriodOfTime(startDate, endDate, employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public findNotAccepted(seasonId: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).findNotAccepted(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} employeeId 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public findOne(id: string, employeeId: string, seasonId?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).findOne(id, employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public findOneByMyself(id: string, employeeId: string, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).findOneByMyself(id, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} employeeId 
     * @param {number} seasonId 
     * @param {string} monday 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public findWeekFreeDays(employeeId: number, seasonId: number, monday: string, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).findWeekFreeDays(employeeId, seasonId, monday, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows users to fetch all available custom types
     * @summary Get all custom calendar entry types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public getAllCustomTypes(options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).getAllCustomTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns detailed vacation statistics for the current user
     * @summary Get vacation summary for the authenticated user
     * @param {string} employeeId 
     * @param {number} [seasonId] 
     * @param {number} [year] Year to analyze (defaults to current year)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public getMyVacationSummary(employeeId: string, seasonId?: number, year?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).getMyVacationSummary(employeeId, seasonId, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns counts of all event types (standard and custom) for a given employee and period
     * @summary Get aggregated calendar entry stats for an employee
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {number} employeeId 
     * @param {string} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public getStatsSummary(startDate: string, endDate: string, employeeId: number, seasonId?: string, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).getStatsSummary(startDate, endDate, employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns detailed vacation statistics including past/future hours, monthly breakdown, upcoming entries, and usage metrics
     * @summary Get comprehensive vacation summary for an employee
     * @param {string} employeeId 
     * @param {number} [seasonId] 
     * @param {number} [year] Year to analyze (defaults to current year)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public getVacationSummary(employeeId: string, seasonId?: number, year?: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).getVacationSummary(employeeId, seasonId, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {number} seasonId 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public refuse(id: string, seasonId: number, employeeId: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).refuse(id, seasonId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {number} seasonId 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public remove(id: string, seasonId: number, employeeId: number, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).remove(id, seasonId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public update(id: string, body: object, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).update(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows managers and above to update existing custom types
     * @summary Update a custom calendar entry type
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsEmployeesCalendarEntriesApi
     */
    public updateCustomType(id: string, body: object, options?: AxiosRequestConfig) {
        return DepartmentsEmployeesCalendarEntriesApiFp(this.configuration).updateCustomType(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DepositsApi - axios parameter creator
 * @export
 */
export const DepositsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} seasonId 
         * @param {CreateDepositDto} createDepositDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (seasonId: number, createDepositDto: CreateDepositDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('create', 'seasonId', seasonId)
            // verify required parameter 'createDepositDto' is not null or undefined
            assertParamExists('create', 'createDepositDto', createDepositDto)
            const localVarPath = `/api/v1/deposits/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDepositDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/deposits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} sectionIds 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBySeasons: async (sectionIds: Array<string>, dateTimeStamp: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionIds' is not null or undefined
            assertParamExists('findBySeasons', 'sectionIds', sectionIds)
            // verify required parameter 'dateTimeStamp' is not null or undefined
            assertParamExists('findBySeasons', 'dateTimeStamp', dateTimeStamp)
            const localVarPath = `/api/v1/deposits/bySeasons/{dateTimeStamp}`
                .replace(`{${"dateTimeStamp"}}`, encodeURIComponent(String(dateTimeStamp)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sectionIds) {
                localVarQueryParameter['sectionIds'] = sectionIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} sectionId 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUnique: async (sectionId: number, dateTimeStamp: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('findUnique', 'sectionId', sectionId)
            // verify required parameter 'dateTimeStamp' is not null or undefined
            assertParamExists('findUnique', 'dateTimeStamp', dateTimeStamp)
            const localVarPath = `/api/v1/deposits/{sectionId}:/{dateTimeStamp}`
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)))
                .replace(`{${"dateTimeStamp"}}`, encodeURIComponent(String(dateTimeStamp)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} dateTimeStamp 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDateSum: async (dateTimeStamp: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dateTimeStamp' is not null or undefined
            assertParamExists('getDateSum', 'dateTimeStamp', dateTimeStamp)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getDateSum', 'seasonId', seasonId)
            const localVarPath = `/api/v1/deposits/dateSum/{dateTimeStamp}/{seasonId}`
                .replace(`{${"dateTimeStamp"}}`, encodeURIComponent(String(dateTimeStamp)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDateSums: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getDateSums', 'seasonId', seasonId)
            const localVarPath = `/api/v1/deposits/dateSums/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} sectionId 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSum: async (sectionId: number, dateTimeStamp: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('getSum', 'sectionId', sectionId)
            // verify required parameter 'dateTimeStamp' is not null or undefined
            assertParamExists('getSum', 'dateTimeStamp', dateTimeStamp)
            const localVarPath = `/api/v1/deposits/sum/{sectionId}/{dateTimeStamp}`
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)))
                .replace(`{${"dateTimeStamp"}}`, encodeURIComponent(String(dateTimeStamp)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} sectionIds 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSums: async (sectionIds: Array<string>, dateTimeStamp: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionIds' is not null or undefined
            assertParamExists('getSums', 'sectionIds', sectionIds)
            // verify required parameter 'dateTimeStamp' is not null or undefined
            assertParamExists('getSums', 'dateTimeStamp', dateTimeStamp)
            const localVarPath = `/api/v1/deposits/sums/{dateTimeStamp}`
                .replace(`{${"dateTimeStamp"}}`, encodeURIComponent(String(dateTimeStamp)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sectionIds) {
                localVarQueryParameter['sectionIds'] = sectionIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/deposits/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateDepositDto} updateDepositDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: number, updateDepositDto: UpdateDepositDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateDepositDto' is not null or undefined
            assertParamExists('update', 'updateDepositDto', updateDepositDto)
            const localVarPath = `/api/v1/deposits/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDepositDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepositsApi - functional programming interface
 * @export
 */
export const DepositsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepositsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} seasonId 
         * @param {CreateDepositDto} createDepositDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(seasonId: number, createDepositDto: CreateDepositDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepositEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(seasonId, createDepositDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DepositEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} sectionIds 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findBySeasons(sectionIds: Array<string>, dateTimeStamp: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DepositEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findBySeasons(sectionIds, dateTimeStamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} sectionId 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUnique(sectionId: number, dateTimeStamp: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepositEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUnique(sectionId, dateTimeStamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} dateTimeStamp 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDateSum(dateTimeStamp: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDateSum(dateTimeStamp, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDateSums(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DateSumEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDateSums(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} sectionId 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSum(sectionId: number, dateTimeStamp: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSum(sectionId, dateTimeStamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} sectionIds 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSums(sectionIds: Array<string>, dateTimeStamp: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SectionDepositSumEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSums(sectionIds, dateTimeStamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepositEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateDepositDto} updateDepositDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: number, updateDepositDto: UpdateDepositDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepositEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateDepositDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DepositsApi - factory interface
 * @export
 */
export const DepositsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepositsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} seasonId 
         * @param {CreateDepositDto} createDepositDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(seasonId: number, createDepositDto: CreateDepositDto, options?: any): AxiosPromise<DepositEntity> {
            return localVarFp.create(seasonId, createDepositDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<DepositEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} sectionIds 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBySeasons(sectionIds: Array<string>, dateTimeStamp: number, options?: any): AxiosPromise<Array<DepositEntity>> {
            return localVarFp.findBySeasons(sectionIds, dateTimeStamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} sectionId 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUnique(sectionId: number, dateTimeStamp: number, options?: any): AxiosPromise<DepositEntity> {
            return localVarFp.findUnique(sectionId, dateTimeStamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} dateTimeStamp 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDateSum(dateTimeStamp: number, seasonId: number, options?: any): AxiosPromise<number> {
            return localVarFp.getDateSum(dateTimeStamp, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDateSums(seasonId: number, options?: any): AxiosPromise<Array<DateSumEntity>> {
            return localVarFp.getDateSums(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} sectionId 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSum(sectionId: number, dateTimeStamp: number, options?: any): AxiosPromise<number> {
            return localVarFp.getSum(sectionId, dateTimeStamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} sectionIds 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSums(sectionIds: Array<string>, dateTimeStamp: number, options?: any): AxiosPromise<Array<SectionDepositSumEntity>> {
            return localVarFp.getSums(sectionIds, dateTimeStamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: number, options?: any): AxiosPromise<DepositEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateDepositDto} updateDepositDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: number, updateDepositDto: UpdateDepositDto, options?: any): AxiosPromise<DepositEntity> {
            return localVarFp.update(id, updateDepositDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepositsApi - object-oriented interface
 * @export
 * @class DepositsApi
 * @extends {BaseAPI}
 */
export class DepositsApi extends BaseAPI {
    /**
     * 
     * @param {number} seasonId 
     * @param {CreateDepositDto} createDepositDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositsApi
     */
    public create(seasonId: number, createDepositDto: CreateDepositDto, options?: AxiosRequestConfig) {
        return DepositsApiFp(this.configuration).create(seasonId, createDepositDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositsApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return DepositsApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} sectionIds 
     * @param {number} dateTimeStamp 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositsApi
     */
    public findBySeasons(sectionIds: Array<string>, dateTimeStamp: number, options?: AxiosRequestConfig) {
        return DepositsApiFp(this.configuration).findBySeasons(sectionIds, dateTimeStamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} sectionId 
     * @param {number} dateTimeStamp 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositsApi
     */
    public findUnique(sectionId: number, dateTimeStamp: number, options?: AxiosRequestConfig) {
        return DepositsApiFp(this.configuration).findUnique(sectionId, dateTimeStamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} dateTimeStamp 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositsApi
     */
    public getDateSum(dateTimeStamp: number, seasonId: number, options?: AxiosRequestConfig) {
        return DepositsApiFp(this.configuration).getDateSum(dateTimeStamp, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositsApi
     */
    public getDateSums(seasonId: number, options?: AxiosRequestConfig) {
        return DepositsApiFp(this.configuration).getDateSums(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} sectionId 
     * @param {number} dateTimeStamp 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositsApi
     */
    public getSum(sectionId: number, dateTimeStamp: number, options?: AxiosRequestConfig) {
        return DepositsApiFp(this.configuration).getSum(sectionId, dateTimeStamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} sectionIds 
     * @param {number} dateTimeStamp 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositsApi
     */
    public getSums(sectionIds: Array<string>, dateTimeStamp: number, options?: AxiosRequestConfig) {
        return DepositsApiFp(this.configuration).getSums(sectionIds, dateTimeStamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositsApi
     */
    public remove(id: number, options?: AxiosRequestConfig) {
        return DepositsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateDepositDto} updateDepositDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositsApi
     */
    public update(id: number, updateDepositDto: UpdateDepositDto, options?: AxiosRequestConfig) {
        return DepositsApiFp(this.configuration).update(id, updateDepositDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentTypesApi - axios parameter creator
 * @export
 */
export const DocumentTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateDocumentTypeDto} createDocumentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createDocumentTypeDto: CreateDocumentTypeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDocumentTypeDto' is not null or undefined
            assertParamExists('create', 'createDocumentTypeDto', createDocumentTypeDto)
            const localVarPath = `/api/v1/document-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDocumentTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/document-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllWithToken: async (tenant: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('findAllWithToken', 'tenant', tenant)
            const localVarPath = `/api/v1/document-types/withToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/document-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneByName: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('findOneByName', 'name', name)
            const localVarPath = `/api/v1/document-types/byName/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/document-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDocumentTypeDto} updateDocumentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateDocumentTypeDto: UpdateDocumentTypeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateDocumentTypeDto' is not null or undefined
            assertParamExists('update', 'updateDocumentTypeDto', updateDocumentTypeDto)
            const localVarPath = `/api/v1/document-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDocumentTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentTypesApi - functional programming interface
 * @export
 */
export const DocumentTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateDocumentTypeDto} createDocumentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createDocumentTypeDto: CreateDocumentTypeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentTypeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createDocumentTypeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentTypeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllWithToken(tenant: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentTypeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllWithToken(tenant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentTypeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOneByName(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentTypeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOneByName(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDocumentTypeDto} updateDocumentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateDocumentTypeDto: UpdateDocumentTypeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentTypeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateDocumentTypeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentTypesApi - factory interface
 * @export
 */
export const DocumentTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateDocumentTypeDto} createDocumentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createDocumentTypeDto: CreateDocumentTypeDto, options?: any): AxiosPromise<DocumentTypeEntity> {
            return localVarFp.create(createDocumentTypeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<DocumentTypeEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllWithToken(tenant: string, options?: any): AxiosPromise<Array<DocumentTypeEntity>> {
            return localVarFp.findAllWithToken(tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<DocumentTypeEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneByName(name: string, options?: any): AxiosPromise<DocumentTypeEntity> {
            return localVarFp.findOneByName(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateDocumentTypeDto} updateDocumentTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateDocumentTypeDto: UpdateDocumentTypeDto, options?: any): AxiosPromise<DocumentTypeEntity> {
            return localVarFp.update(id, updateDocumentTypeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentTypesApi - object-oriented interface
 * @export
 * @class DocumentTypesApi
 * @extends {BaseAPI}
 */
export class DocumentTypesApi extends BaseAPI {
    /**
     * 
     * @param {CreateDocumentTypeDto} createDocumentTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTypesApi
     */
    public create(createDocumentTypeDto: CreateDocumentTypeDto, options?: AxiosRequestConfig) {
        return DocumentTypesApiFp(this.configuration).create(createDocumentTypeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTypesApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return DocumentTypesApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTypesApi
     */
    public findAllWithToken(tenant: string, options?: AxiosRequestConfig) {
        return DocumentTypesApiFp(this.configuration).findAllWithToken(tenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTypesApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return DocumentTypesApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTypesApi
     */
    public findOneByName(name: string, options?: AxiosRequestConfig) {
        return DocumentTypesApiFp(this.configuration).findOneByName(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTypesApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return DocumentTypesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateDocumentTypeDto} updateDocumentTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTypesApi
     */
    public update(id: string, updateDocumentTypeDto: UpdateDocumentTypeDto, options?: AxiosRequestConfig) {
        return DocumentTypesApiFp(this.configuration).update(id, updateDocumentTypeDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EmailTemplatesApi - axios parameter creator
 * @export
 */
export const EmailTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create an email template
         * @param {CreateEmailTemplateDto} createEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createEmailTemplateDto: CreateEmailTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmailTemplateDto' is not null or undefined
            assertParamExists('create', 'createEmailTemplateDto', createEmailTemplateDto)
            const localVarPath = `/api/v1/email-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmailTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all email templates for the tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/email-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single email template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/email-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an email template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/email-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Manually send an email template for an application
         * @param {string} id 
         * @param {SendEmailTemplateDto} sendEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send: async (id: string, sendEmailTemplateDto: SendEmailTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('send', 'id', id)
            // verify required parameter 'sendEmailTemplateDto' is not null or undefined
            assertParamExists('send', 'sendEmailTemplateDto', sendEmailTemplateDto)
            const localVarPath = `/api/v1/email-templates/{id}/send`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendEmailTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an email template
         * @param {string} id 
         * @param {UpdateEmailTemplateDto} updateEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateEmailTemplateDto: UpdateEmailTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateEmailTemplateDto' is not null or undefined
            assertParamExists('update', 'updateEmailTemplateDto', updateEmailTemplateDto)
            const localVarPath = `/api/v1/email-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailTemplatesApi - functional programming interface
 * @export
 */
export const EmailTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create an email template
         * @param {CreateEmailTemplateDto} createEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createEmailTemplateDto: CreateEmailTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTemplateEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createEmailTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all email templates for the tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmailTemplateEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a single email template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTemplateEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an email template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTemplateEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Manually send an email template for an application
         * @param {string} id 
         * @param {SendEmailTemplateDto} sendEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async send(id: string, sendEmailTemplateDto: SendEmailTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.send(id, sendEmailTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an email template
         * @param {string} id 
         * @param {UpdateEmailTemplateDto} updateEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateEmailTemplateDto: UpdateEmailTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailTemplateEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateEmailTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmailTemplatesApi - factory interface
 * @export
 */
export const EmailTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create an email template
         * @param {CreateEmailTemplateDto} createEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createEmailTemplateDto: CreateEmailTemplateDto, options?: any): AxiosPromise<EmailTemplateEntity> {
            return localVarFp.create(createEmailTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all email templates for the tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<EmailTemplateEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single email template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<EmailTemplateEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an email template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<EmailTemplateEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Manually send an email template for an application
         * @param {string} id 
         * @param {SendEmailTemplateDto} sendEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send(id: string, sendEmailTemplateDto: SendEmailTemplateDto, options?: any): AxiosPromise<void> {
            return localVarFp.send(id, sendEmailTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an email template
         * @param {string} id 
         * @param {UpdateEmailTemplateDto} updateEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateEmailTemplateDto: UpdateEmailTemplateDto, options?: any): AxiosPromise<EmailTemplateEntity> {
            return localVarFp.update(id, updateEmailTemplateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailTemplatesApi - object-oriented interface
 * @export
 * @class EmailTemplatesApi
 * @extends {BaseAPI}
 */
export class EmailTemplatesApi extends BaseAPI {
    /**
     * 
     * @summary Create an email template
     * @param {CreateEmailTemplateDto} createEmailTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApi
     */
    public create(createEmailTemplateDto: CreateEmailTemplateDto, options?: AxiosRequestConfig) {
        return EmailTemplatesApiFp(this.configuration).create(createEmailTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all email templates for the tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return EmailTemplatesApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single email template
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return EmailTemplatesApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an email template
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return EmailTemplatesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Manually send an email template for an application
     * @param {string} id 
     * @param {SendEmailTemplateDto} sendEmailTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApi
     */
    public send(id: string, sendEmailTemplateDto: SendEmailTemplateDto, options?: AxiosRequestConfig) {
        return EmailTemplatesApiFp(this.configuration).send(id, sendEmailTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an email template
     * @param {string} id 
     * @param {UpdateEmailTemplateDto} updateEmailTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplatesApi
     */
    public update(id: string, updateEmailTemplateDto: UpdateEmailTemplateDto, options?: AxiosRequestConfig) {
        return EmailTemplatesApiFp(this.configuration).update(id, updateEmailTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EmployeeCertificationsApi - axios parameter creator
 * @export
 */
export const EmployeeCertificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Analyses a ZIP of PDF certificates. Extracts Codice Fiscale from each PDF (filename or OCR), matches employees, and returns a preview without writing to DB.
         * @summary Dry-run bulk certificate upload (ZIP of PDFs)
         * @param {File} file 
         * @param {number} courseTypeId 
         * @param {string} obtainedDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUploadDryRun: async (file: File, courseTypeId: number, obtainedDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('bulkUploadDryRun', 'file', file)
            // verify required parameter 'courseTypeId' is not null or undefined
            assertParamExists('bulkUploadDryRun', 'courseTypeId', courseTypeId)
            // verify required parameter 'obtainedDate' is not null or undefined
            assertParamExists('bulkUploadDryRun', 'obtainedDate', obtainedDate)
            const localVarPath = `/api/v1/employee-certifications/bulk-upload/dry-run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (courseTypeId !== undefined) { 
                localVarFormParams.append('courseTypeId', courseTypeId as any);
            }
    
            if (obtainedDate !== undefined) { 
                localVarFormParams.append('obtainedDate', obtainedDate as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Processes a ZIP of PDF certificates. For each matched employee: creates an EmployeeCertification, an EmployeeDocument, and uploads the file to cloud storage.
         * @summary Execute bulk certificate upload (ZIP of PDFs)
         * @param {File} file 
         * @param {number} courseTypeId 
         * @param {string} obtainedDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUploadExecute: async (file: File, courseTypeId: number, obtainedDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('bulkUploadExecute', 'file', file)
            // verify required parameter 'courseTypeId' is not null or undefined
            assertParamExists('bulkUploadExecute', 'courseTypeId', courseTypeId)
            // verify required parameter 'obtainedDate' is not null or undefined
            assertParamExists('bulkUploadExecute', 'obtainedDate', obtainedDate)
            const localVarPath = `/api/v1/employee-certifications/bulk-upload/execute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (courseTypeId !== undefined) { 
                localVarFormParams.append('courseTypeId', courseTypeId as any);
            }
    
            if (obtainedDate !== undefined) { 
                localVarFormParams.append('obtainedDate', obtainedDate as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new employee certification
         * @param {CreateEmployeeCertificationDto} createEmployeeCertificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createEmployeeCertificationDto: CreateEmployeeCertificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmployeeCertificationDto' is not null or undefined
            assertParamExists('create', 'createEmployeeCertificationDto', createEmployeeCertificationDto)
            const localVarPath = `/api/v1/employee-certifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeCertificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload certificate files to a certification (creates EmployeeDocument)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFile: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createFile', 'id', id)
            const localVarPath = `/api/v1/employee-certifications/{id}/file`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all employee certifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employee-certifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all certifications for a specific employee
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByEmployeeId: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findByEmployeeId', 'employeeId', employeeId)
            const localVarPath = `/api/v1/employee-certifications/by-employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a certification by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/employee-certifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a certification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/employee-certifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a certification document (EmployeeDocument)
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFile: async (fileId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('removeFile', 'fileId', fileId)
            const localVarPath = `/api/v1/employee-certifications/file/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a certification
         * @param {string} id 
         * @param {UpdateEmployeeCertificationDto} updateEmployeeCertificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateEmployeeCertificationDto: UpdateEmployeeCertificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateEmployeeCertificationDto' is not null or undefined
            assertParamExists('update', 'updateEmployeeCertificationDto', updateEmployeeCertificationDto)
            const localVarPath = `/api/v1/employee-certifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeCertificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeCertificationsApi - functional programming interface
 * @export
 */
export const EmployeeCertificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeCertificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Analyses a ZIP of PDF certificates. Extracts Codice Fiscale from each PDF (filename or OCR), matches employees, and returns a preview without writing to DB.
         * @summary Dry-run bulk certificate upload (ZIP of PDFs)
         * @param {File} file 
         * @param {number} courseTypeId 
         * @param {string} obtainedDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUploadDryRun(file: File, courseTypeId: number, obtainedDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUploadDryRun(file, courseTypeId, obtainedDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Processes a ZIP of PDF certificates. For each matched employee: creates an EmployeeCertification, an EmployeeDocument, and uploads the file to cloud storage.
         * @summary Execute bulk certificate upload (ZIP of PDFs)
         * @param {File} file 
         * @param {number} courseTypeId 
         * @param {string} obtainedDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUploadExecute(file: File, courseTypeId: number, obtainedDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUploadExecute(file, courseTypeId, obtainedDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new employee certification
         * @param {CreateEmployeeCertificationDto} createEmployeeCertificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createEmployeeCertificationDto: CreateEmployeeCertificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeCertificationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createEmployeeCertificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload certificate files to a certification (creates EmployeeDocument)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFile(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CertificationDocumentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all employee certifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeCertificationEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all certifications for a specific employee
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByEmployeeId(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeCertificationEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByEmployeeId(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a certification by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeCertificationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a certification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeCertificationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove a certification document (EmployeeDocument)
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFile(fileId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificationDocumentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFile(fileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a certification
         * @param {string} id 
         * @param {UpdateEmployeeCertificationDto} updateEmployeeCertificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateEmployeeCertificationDto: UpdateEmployeeCertificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeCertificationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateEmployeeCertificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmployeeCertificationsApi - factory interface
 * @export
 */
export const EmployeeCertificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeCertificationsApiFp(configuration)
    return {
        /**
         * Analyses a ZIP of PDF certificates. Extracts Codice Fiscale from each PDF (filename or OCR), matches employees, and returns a preview without writing to DB.
         * @summary Dry-run bulk certificate upload (ZIP of PDFs)
         * @param {File} file 
         * @param {number} courseTypeId 
         * @param {string} obtainedDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUploadDryRun(file: File, courseTypeId: number, obtainedDate: string, options?: any): AxiosPromise<void> {
            return localVarFp.bulkUploadDryRun(file, courseTypeId, obtainedDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Processes a ZIP of PDF certificates. For each matched employee: creates an EmployeeCertification, an EmployeeDocument, and uploads the file to cloud storage.
         * @summary Execute bulk certificate upload (ZIP of PDFs)
         * @param {File} file 
         * @param {number} courseTypeId 
         * @param {string} obtainedDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUploadExecute(file: File, courseTypeId: number, obtainedDate: string, options?: any): AxiosPromise<void> {
            return localVarFp.bulkUploadExecute(file, courseTypeId, obtainedDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new employee certification
         * @param {CreateEmployeeCertificationDto} createEmployeeCertificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createEmployeeCertificationDto: CreateEmployeeCertificationDto, options?: any): AxiosPromise<EmployeeCertificationEntity> {
            return localVarFp.create(createEmployeeCertificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload certificate files to a certification (creates EmployeeDocument)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFile(id: string, options?: any): AxiosPromise<Array<CertificationDocumentEntity>> {
            return localVarFp.createFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all employee certifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<EmployeeCertificationEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all certifications for a specific employee
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByEmployeeId(employeeId: number, options?: any): AxiosPromise<Array<EmployeeCertificationEntity>> {
            return localVarFp.findByEmployeeId(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a certification by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<EmployeeCertificationEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a certification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<EmployeeCertificationEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a certification document (EmployeeDocument)
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFile(fileId: string, options?: any): AxiosPromise<CertificationDocumentEntity> {
            return localVarFp.removeFile(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a certification
         * @param {string} id 
         * @param {UpdateEmployeeCertificationDto} updateEmployeeCertificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateEmployeeCertificationDto: UpdateEmployeeCertificationDto, options?: any): AxiosPromise<EmployeeCertificationEntity> {
            return localVarFp.update(id, updateEmployeeCertificationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeCertificationsApi - object-oriented interface
 * @export
 * @class EmployeeCertificationsApi
 * @extends {BaseAPI}
 */
export class EmployeeCertificationsApi extends BaseAPI {
    /**
     * Analyses a ZIP of PDF certificates. Extracts Codice Fiscale from each PDF (filename or OCR), matches employees, and returns a preview without writing to DB.
     * @summary Dry-run bulk certificate upload (ZIP of PDFs)
     * @param {File} file 
     * @param {number} courseTypeId 
     * @param {string} obtainedDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeCertificationsApi
     */
    public bulkUploadDryRun(file: File, courseTypeId: number, obtainedDate: string, options?: AxiosRequestConfig) {
        return EmployeeCertificationsApiFp(this.configuration).bulkUploadDryRun(file, courseTypeId, obtainedDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Processes a ZIP of PDF certificates. For each matched employee: creates an EmployeeCertification, an EmployeeDocument, and uploads the file to cloud storage.
     * @summary Execute bulk certificate upload (ZIP of PDFs)
     * @param {File} file 
     * @param {number} courseTypeId 
     * @param {string} obtainedDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeCertificationsApi
     */
    public bulkUploadExecute(file: File, courseTypeId: number, obtainedDate: string, options?: AxiosRequestConfig) {
        return EmployeeCertificationsApiFp(this.configuration).bulkUploadExecute(file, courseTypeId, obtainedDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new employee certification
     * @param {CreateEmployeeCertificationDto} createEmployeeCertificationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeCertificationsApi
     */
    public create(createEmployeeCertificationDto: CreateEmployeeCertificationDto, options?: AxiosRequestConfig) {
        return EmployeeCertificationsApiFp(this.configuration).create(createEmployeeCertificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload certificate files to a certification (creates EmployeeDocument)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeCertificationsApi
     */
    public createFile(id: string, options?: AxiosRequestConfig) {
        return EmployeeCertificationsApiFp(this.configuration).createFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all employee certifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeCertificationsApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return EmployeeCertificationsApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all certifications for a specific employee
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeCertificationsApi
     */
    public findByEmployeeId(employeeId: number, options?: AxiosRequestConfig) {
        return EmployeeCertificationsApiFp(this.configuration).findByEmployeeId(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a certification by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeCertificationsApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return EmployeeCertificationsApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a certification
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeCertificationsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return EmployeeCertificationsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a certification document (EmployeeDocument)
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeCertificationsApi
     */
    public removeFile(fileId: string, options?: AxiosRequestConfig) {
        return EmployeeCertificationsApiFp(this.configuration).removeFile(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a certification
     * @param {string} id 
     * @param {UpdateEmployeeCertificationDto} updateEmployeeCertificationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeCertificationsApi
     */
    public update(id: string, updateEmployeeCertificationDto: UpdateEmployeeCertificationDto, options?: AxiosRequestConfig) {
        return EmployeeCertificationsApiFp(this.configuration).update(id, updateEmployeeCertificationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EmployeeDocumentApi - axios parameter creator
 * @export
 */
export const EmployeeDocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateEmployeeDocumentDto} createEmployeeDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createEmployeeDocumentDto: CreateEmployeeDocumentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmployeeDocumentDto' is not null or undefined
            assertParamExists('create', 'createEmployeeDocumentDto', createEmployeeDocumentDto)
            const localVarPath = `/api/v1/employee-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {string} jobAdvertisementsId 
         * @param {string} company 
         * @param {string} fileName 
         * @param {string} [source] Optional platform identifier the application originated from (e.g. INDEED, LINKEDIN).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplication: async (seasonId: number, jobAdvertisementsId: string, company: string, fileName: string, source?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('createApplication', 'seasonId', seasonId)
            // verify required parameter 'jobAdvertisementsId' is not null or undefined
            assertParamExists('createApplication', 'jobAdvertisementsId', jobAdvertisementsId)
            // verify required parameter 'company' is not null or undefined
            assertParamExists('createApplication', 'company', company)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('createApplication', 'fileName', fileName)
            const localVarPath = `/api/v1/employee-document/createApplication/{seasonId}/{jobAdvertisementsId}/{company}/{fileName}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)))
                .replace(`{${"jobAdvertisementsId"}}`, encodeURIComponent(String(jobAdvertisementsId)))
                .replace(`{${"company"}}`, encodeURIComponent(String(company)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} sendEmail 
         * @param {boolean} attachFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFile: async (id: string, sendEmail: boolean, attachFile: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createFile', 'id', id)
            // verify required parameter 'sendEmail' is not null or undefined
            assertParamExists('createFile', 'sendEmail', sendEmail)
            // verify required parameter 'attachFile' is not null or undefined
            assertParamExists('createFile', 'attachFile', attachFile)
            const localVarPath = `/api/v1/employee-document/{id}/{sendEmail}/{attachFile}/file`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"sendEmail"}}`, encodeURIComponent(String(sendEmail)))
                .replace(`{${"attachFile"}}`, encodeURIComponent(String(attachFile)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} category 
         * @param {boolean} isVisible 
         * @param {boolean} lookForNet 
         * @param {boolean} sendEmail 
         * @param {boolean} attachFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileIfTaxCode: async (category: string, isVisible: boolean, lookForNet: boolean, sendEmail: boolean, attachFile: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('createFileIfTaxCode', 'category', category)
            // verify required parameter 'isVisible' is not null or undefined
            assertParamExists('createFileIfTaxCode', 'isVisible', isVisible)
            // verify required parameter 'lookForNet' is not null or undefined
            assertParamExists('createFileIfTaxCode', 'lookForNet', lookForNet)
            // verify required parameter 'sendEmail' is not null or undefined
            assertParamExists('createFileIfTaxCode', 'sendEmail', sendEmail)
            // verify required parameter 'attachFile' is not null or undefined
            assertParamExists('createFileIfTaxCode', 'attachFile', attachFile)
            const localVarPath = `/api/v1/employee-document/createFilesIfTaxCode/{category}/{isVisible}/{lookForNet}/{sendEmail}/{attachFile}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)))
                .replace(`{${"isVisible"}}`, encodeURIComponent(String(isVisible)))
                .replace(`{${"lookForNet"}}`, encodeURIComponent(String(lookForNet)))
                .replace(`{${"sendEmail"}}`, encodeURIComponent(String(sendEmail)))
                .replace(`{${"attachFile"}}`, encodeURIComponent(String(attachFile)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} category 
         * @param {boolean} isVisible 
         * @param {string} prefix 
         * @param {boolean} lookForNet 
         * @param {boolean} sendEmail 
         * @param {boolean} attachFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileIfTaxCodePrefix: async (category: string, isVisible: boolean, prefix: string, lookForNet: boolean, sendEmail: boolean, attachFile: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('createFileIfTaxCodePrefix', 'category', category)
            // verify required parameter 'isVisible' is not null or undefined
            assertParamExists('createFileIfTaxCodePrefix', 'isVisible', isVisible)
            // verify required parameter 'prefix' is not null or undefined
            assertParamExists('createFileIfTaxCodePrefix', 'prefix', prefix)
            // verify required parameter 'lookForNet' is not null or undefined
            assertParamExists('createFileIfTaxCodePrefix', 'lookForNet', lookForNet)
            // verify required parameter 'sendEmail' is not null or undefined
            assertParamExists('createFileIfTaxCodePrefix', 'sendEmail', sendEmail)
            // verify required parameter 'attachFile' is not null or undefined
            assertParamExists('createFileIfTaxCodePrefix', 'attachFile', attachFile)
            const localVarPath = `/api/v1/employee-document/createFilesIfTaxCode/{category}/{isVisible}/{prefix}/{lookForNet}/{sendEmail}/{attachFile}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)))
                .replace(`{${"isVisible"}}`, encodeURIComponent(String(isVisible)))
                .replace(`{${"prefix"}}`, encodeURIComponent(String(prefix)))
                .replace(`{${"lookForNet"}}`, encodeURIComponent(String(lookForNet)))
                .replace(`{${"sendEmail"}}`, encodeURIComponent(String(sendEmail)))
                .replace(`{${"attachFile"}}`, encodeURIComponent(String(attachFile)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileWithToken: async (id: string, tenant: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createFileWithToken', 'id', id)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('createFileWithToken', 'tenant', tenant)
            const localVarPath = `/api/v1/employee-document/{id}/file/withToken`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenant 
         * @param {CreateEmployeeDocumentDto} createEmployeeDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createwithToken: async (tenant: string, createEmployeeDocumentDto: CreateEmployeeDocumentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('createwithToken', 'tenant', tenant)
            // verify required parameter 'createEmployeeDocumentDto' is not null or undefined
            assertParamExists('createwithToken', 'createEmployeeDocumentDto', createEmployeeDocumentDto)
            const localVarPath = `/api/v1/employee-document/withToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} category 
         * @param {boolean} isVisible 
         * @param {boolean} lookForNet 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunFileIfTaxCode: async (category: string, isVisible: boolean, lookForNet: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('dryRunFileIfTaxCode', 'category', category)
            // verify required parameter 'isVisible' is not null or undefined
            assertParamExists('dryRunFileIfTaxCode', 'isVisible', isVisible)
            // verify required parameter 'lookForNet' is not null or undefined
            assertParamExists('dryRunFileIfTaxCode', 'lookForNet', lookForNet)
            const localVarPath = `/api/v1/employee-document/dryRunFileIfTaxCode/{category}/{isVisible}/{lookForNet}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)))
                .replace(`{${"isVisible"}}`, encodeURIComponent(String(isVisible)))
                .replace(`{${"lookForNet"}}`, encodeURIComponent(String(lookForNet)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} category 
         * @param {boolean} isVisible 
         * @param {string} prefix 
         * @param {boolean} lookForNet 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunFileIfTaxCodePrefix: async (category: string, isVisible: boolean, prefix: string, lookForNet: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('dryRunFileIfTaxCodePrefix', 'category', category)
            // verify required parameter 'isVisible' is not null or undefined
            assertParamExists('dryRunFileIfTaxCodePrefix', 'isVisible', isVisible)
            // verify required parameter 'prefix' is not null or undefined
            assertParamExists('dryRunFileIfTaxCodePrefix', 'prefix', prefix)
            // verify required parameter 'lookForNet' is not null or undefined
            assertParamExists('dryRunFileIfTaxCodePrefix', 'lookForNet', lookForNet)
            const localVarPath = `/api/v1/employee-document/dryRunFileIfTaxCode/{category}/{isVisible}/{prefix}/{lookForNet}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)))
                .replace(`{${"isVisible"}}`, encodeURIComponent(String(isVisible)))
                .replace(`{${"prefix"}}`, encodeURIComponent(String(prefix)))
                .replace(`{${"lookForNet"}}`, encodeURIComponent(String(lookForNet)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employee-document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllWithToken: async (tenant: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('findAllWithToken', 'tenant', tenant)
            const localVarPath = `/api/v1/employee-document/withToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyself: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employee-document/findMyself`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/employee-document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOnewithToken: async (id: string, tenant: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOnewithToken', 'id', id)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('findOnewithToken', 'tenant', tenant)
            const localVarPath = `/api/v1/employee-document/{id}/withToken`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/employee-document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFile: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeFile', 'id', id)
            const localVarPath = `/api/v1/employee-document/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFileWithToken: async (id: string, tenant: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeFileWithToken', 'id', id)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('removeFileWithToken', 'tenant', tenant)
            const localVarPath = `/api/v1/employee-document/{id}/deleteWithToken`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} attachFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail: async (id: number, attachFile: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendEmail', 'id', id)
            // verify required parameter 'attachFile' is not null or undefined
            assertParamExists('sendEmail', 'attachFile', attachFile)
            const localVarPath = `/api/v1/employee-document/sendEmail/{id}/{attachFile}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachFile"}}`, encodeURIComponent(String(attachFile)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeDocumentDto} updateEmployeeDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateEmployeeDocumentDto: UpdateEmployeeDocumentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateEmployeeDocumentDto' is not null or undefined
            assertParamExists('update', 'updateEmployeeDocumentDto', updateEmployeeDocumentDto)
            const localVarPath = `/api/v1/employee-document/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeDocumentDto} updateEmployeeDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateByMyself: async (id: string, updateEmployeeDocumentDto: UpdateEmployeeDocumentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateByMyself', 'id', id)
            // verify required parameter 'updateEmployeeDocumentDto' is not null or undefined
            assertParamExists('updateByMyself', 'updateEmployeeDocumentDto', updateEmployeeDocumentDto)
            const localVarPath = `/api/v1/employee-document/{id}/updateByMyself`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {UpdateEmployeeDocumentDto} updateEmployeeDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWithToken: async (id: string, tenant: string, updateEmployeeDocumentDto: UpdateEmployeeDocumentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWithToken', 'id', id)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('updateWithToken', 'tenant', tenant)
            // verify required parameter 'updateEmployeeDocumentDto' is not null or undefined
            assertParamExists('updateWithToken', 'updateEmployeeDocumentDto', updateEmployeeDocumentDto)
            const localVarPath = `/api/v1/employee-document/updateWithToken/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeDocumentApi - functional programming interface
 * @export
 */
export const EmployeeDocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeDocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateEmployeeDocumentDto} createEmployeeDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createEmployeeDocumentDto: CreateEmployeeDocumentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDocumentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createEmployeeDocumentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {string} jobAdvertisementsId 
         * @param {string} company 
         * @param {string} fileName 
         * @param {string} [source] Optional platform identifier the application originated from (e.g. INDEED, LINKEDIN).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createApplication(seasonId: number, jobAdvertisementsId: string, company: string, fileName: string, source?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createApplication(seasonId, jobAdvertisementsId, company, fileName, source, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} sendEmail 
         * @param {boolean} attachFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFile(id: string, sendEmail: boolean, attachFile: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFile(id, sendEmail, attachFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} category 
         * @param {boolean} isVisible 
         * @param {boolean} lookForNet 
         * @param {boolean} sendEmail 
         * @param {boolean} attachFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFileIfTaxCode(category: string, isVisible: boolean, lookForNet: boolean, sendEmail: boolean, attachFile: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedZipEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFileIfTaxCode(category, isVisible, lookForNet, sendEmail, attachFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} category 
         * @param {boolean} isVisible 
         * @param {string} prefix 
         * @param {boolean} lookForNet 
         * @param {boolean} sendEmail 
         * @param {boolean} attachFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFileIfTaxCodePrefix(category: string, isVisible: boolean, prefix: string, lookForNet: boolean, sendEmail: boolean, attachFile: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedZipEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFileIfTaxCodePrefix(category, isVisible, prefix, lookForNet, sendEmail, attachFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFileWithToken(id: string, tenant: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentFileEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFileWithToken(id, tenant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenant 
         * @param {CreateEmployeeDocumentDto} createEmployeeDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createwithToken(tenant: string, createEmployeeDocumentDto: CreateEmployeeDocumentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDocumentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createwithToken(tenant, createEmployeeDocumentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} category 
         * @param {boolean} isVisible 
         * @param {boolean} lookForNet 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dryRunFileIfTaxCode(category: string, isVisible: boolean, lookForNet: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DryRunResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dryRunFileIfTaxCode(category, isVisible, lookForNet, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} category 
         * @param {boolean} isVisible 
         * @param {string} prefix 
         * @param {boolean} lookForNet 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dryRunFileIfTaxCodePrefix(category: string, isVisible: boolean, prefix: string, lookForNet: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DryRunResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dryRunFileIfTaxCodePrefix(category, isVisible, prefix, lookForNet, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeDocumentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllWithToken(tenant: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeDocumentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllWithToken(tenant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findMyself(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeDocumentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findMyself(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDocumentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOnewithToken(id: string, tenant: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDocumentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOnewithToken(id, tenant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFile(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentFileEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFileWithToken(id: string, tenant: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentFileEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFileWithToken(id, tenant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} attachFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmail(id: number, attachFile: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmail(id, attachFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeDocumentDto} updateEmployeeDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateEmployeeDocumentDto: UpdateEmployeeDocumentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDocumentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateEmployeeDocumentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeDocumentDto} updateEmployeeDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateByMyself(id: string, updateEmployeeDocumentDto: UpdateEmployeeDocumentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDocumentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateByMyself(id, updateEmployeeDocumentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {UpdateEmployeeDocumentDto} updateEmployeeDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWithToken(id: string, tenant: string, updateEmployeeDocumentDto: UpdateEmployeeDocumentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDocumentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWithToken(id, tenant, updateEmployeeDocumentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmployeeDocumentApi - factory interface
 * @export
 */
export const EmployeeDocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeDocumentApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateEmployeeDocumentDto} createEmployeeDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createEmployeeDocumentDto: CreateEmployeeDocumentDto, options?: any): AxiosPromise<EmployeeDocumentEntity> {
            return localVarFp.create(createEmployeeDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {string} jobAdvertisementsId 
         * @param {string} company 
         * @param {string} fileName 
         * @param {string} [source] Optional platform identifier the application originated from (e.g. INDEED, LINKEDIN).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApplication(seasonId: number, jobAdvertisementsId: string, company: string, fileName: string, source?: string, options?: any): AxiosPromise<ApplicationEntity> {
            return localVarFp.createApplication(seasonId, jobAdvertisementsId, company, fileName, source, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} sendEmail 
         * @param {boolean} attachFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFile(id: string, sendEmail: boolean, attachFile: boolean, options?: any): AxiosPromise<Array<DocumentFileEntity>> {
            return localVarFp.createFile(id, sendEmail, attachFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} category 
         * @param {boolean} isVisible 
         * @param {boolean} lookForNet 
         * @param {boolean} sendEmail 
         * @param {boolean} attachFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileIfTaxCode(category: string, isVisible: boolean, lookForNet: boolean, sendEmail: boolean, attachFile: boolean, options?: any): AxiosPromise<UploadedZipEntity> {
            return localVarFp.createFileIfTaxCode(category, isVisible, lookForNet, sendEmail, attachFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} category 
         * @param {boolean} isVisible 
         * @param {string} prefix 
         * @param {boolean} lookForNet 
         * @param {boolean} sendEmail 
         * @param {boolean} attachFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileIfTaxCodePrefix(category: string, isVisible: boolean, prefix: string, lookForNet: boolean, sendEmail: boolean, attachFile: boolean, options?: any): AxiosPromise<UploadedZipEntity> {
            return localVarFp.createFileIfTaxCodePrefix(category, isVisible, prefix, lookForNet, sendEmail, attachFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileWithToken(id: string, tenant: string, options?: any): AxiosPromise<Array<DocumentFileEntity>> {
            return localVarFp.createFileWithToken(id, tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenant 
         * @param {CreateEmployeeDocumentDto} createEmployeeDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createwithToken(tenant: string, createEmployeeDocumentDto: CreateEmployeeDocumentDto, options?: any): AxiosPromise<EmployeeDocumentEntity> {
            return localVarFp.createwithToken(tenant, createEmployeeDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} category 
         * @param {boolean} isVisible 
         * @param {boolean} lookForNet 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunFileIfTaxCode(category: string, isVisible: boolean, lookForNet: boolean, options?: any): AxiosPromise<DryRunResult> {
            return localVarFp.dryRunFileIfTaxCode(category, isVisible, lookForNet, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} category 
         * @param {boolean} isVisible 
         * @param {string} prefix 
         * @param {boolean} lookForNet 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRunFileIfTaxCodePrefix(category: string, isVisible: boolean, prefix: string, lookForNet: boolean, options?: any): AxiosPromise<DryRunResult> {
            return localVarFp.dryRunFileIfTaxCodePrefix(category, isVisible, prefix, lookForNet, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<EmployeeDocumentEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllWithToken(tenant: string, options?: any): AxiosPromise<Array<EmployeeDocumentEntity>> {
            return localVarFp.findAllWithToken(tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyself(options?: any): AxiosPromise<Array<EmployeeDocumentEntity>> {
            return localVarFp.findMyself(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<EmployeeDocumentEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOnewithToken(id: string, tenant: string, options?: any): AxiosPromise<EmployeeDocumentEntity> {
            return localVarFp.findOnewithToken(id, tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFile(id: string, options?: any): AxiosPromise<DocumentFileEntity> {
            return localVarFp.removeFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFileWithToken(id: string, tenant: string, options?: any): AxiosPromise<DocumentFileEntity> {
            return localVarFp.removeFileWithToken(id, tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} attachFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail(id: number, attachFile: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.sendEmail(id, attachFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeDocumentDto} updateEmployeeDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateEmployeeDocumentDto: UpdateEmployeeDocumentDto, options?: any): AxiosPromise<EmployeeDocumentEntity> {
            return localVarFp.update(id, updateEmployeeDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeDocumentDto} updateEmployeeDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateByMyself(id: string, updateEmployeeDocumentDto: UpdateEmployeeDocumentDto, options?: any): AxiosPromise<EmployeeDocumentEntity> {
            return localVarFp.updateByMyself(id, updateEmployeeDocumentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {UpdateEmployeeDocumentDto} updateEmployeeDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWithToken(id: string, tenant: string, updateEmployeeDocumentDto: UpdateEmployeeDocumentDto, options?: any): AxiosPromise<EmployeeDocumentEntity> {
            return localVarFp.updateWithToken(id, tenant, updateEmployeeDocumentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeDocumentApi - object-oriented interface
 * @export
 * @class EmployeeDocumentApi
 * @extends {BaseAPI}
 */
export class EmployeeDocumentApi extends BaseAPI {
    /**
     * 
     * @param {CreateEmployeeDocumentDto} createEmployeeDocumentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public create(createEmployeeDocumentDto: CreateEmployeeDocumentDto, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).create(createEmployeeDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {string} jobAdvertisementsId 
     * @param {string} company 
     * @param {string} fileName 
     * @param {string} [source] Optional platform identifier the application originated from (e.g. INDEED, LINKEDIN).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public createApplication(seasonId: number, jobAdvertisementsId: string, company: string, fileName: string, source?: string, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).createApplication(seasonId, jobAdvertisementsId, company, fileName, source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {boolean} sendEmail 
     * @param {boolean} attachFile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public createFile(id: string, sendEmail: boolean, attachFile: boolean, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).createFile(id, sendEmail, attachFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} category 
     * @param {boolean} isVisible 
     * @param {boolean} lookForNet 
     * @param {boolean} sendEmail 
     * @param {boolean} attachFile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public createFileIfTaxCode(category: string, isVisible: boolean, lookForNet: boolean, sendEmail: boolean, attachFile: boolean, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).createFileIfTaxCode(category, isVisible, lookForNet, sendEmail, attachFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} category 
     * @param {boolean} isVisible 
     * @param {string} prefix 
     * @param {boolean} lookForNet 
     * @param {boolean} sendEmail 
     * @param {boolean} attachFile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public createFileIfTaxCodePrefix(category: string, isVisible: boolean, prefix: string, lookForNet: boolean, sendEmail: boolean, attachFile: boolean, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).createFileIfTaxCodePrefix(category, isVisible, prefix, lookForNet, sendEmail, attachFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} tenant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public createFileWithToken(id: string, tenant: string, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).createFileWithToken(id, tenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenant 
     * @param {CreateEmployeeDocumentDto} createEmployeeDocumentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public createwithToken(tenant: string, createEmployeeDocumentDto: CreateEmployeeDocumentDto, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).createwithToken(tenant, createEmployeeDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} category 
     * @param {boolean} isVisible 
     * @param {boolean} lookForNet 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public dryRunFileIfTaxCode(category: string, isVisible: boolean, lookForNet: boolean, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).dryRunFileIfTaxCode(category, isVisible, lookForNet, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} category 
     * @param {boolean} isVisible 
     * @param {string} prefix 
     * @param {boolean} lookForNet 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public dryRunFileIfTaxCodePrefix(category: string, isVisible: boolean, prefix: string, lookForNet: boolean, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).dryRunFileIfTaxCodePrefix(category, isVisible, prefix, lookForNet, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tenant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public findAllWithToken(tenant: string, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).findAllWithToken(tenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public findMyself(options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).findMyself(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} tenant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public findOnewithToken(id: string, tenant: string, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).findOnewithToken(id, tenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public removeFile(id: string, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).removeFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} tenant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public removeFileWithToken(id: string, tenant: string, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).removeFileWithToken(id, tenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} attachFile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public sendEmail(id: number, attachFile: boolean, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).sendEmail(id, attachFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateEmployeeDocumentDto} updateEmployeeDocumentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public update(id: string, updateEmployeeDocumentDto: UpdateEmployeeDocumentDto, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).update(id, updateEmployeeDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateEmployeeDocumentDto} updateEmployeeDocumentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public updateByMyself(id: string, updateEmployeeDocumentDto: UpdateEmployeeDocumentDto, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).updateByMyself(id, updateEmployeeDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} tenant 
     * @param {UpdateEmployeeDocumentDto} updateEmployeeDocumentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDocumentApi
     */
    public updateWithToken(id: string, tenant: string, updateEmployeeDocumentDto: UpdateEmployeeDocumentDto, options?: AxiosRequestConfig) {
        return EmployeeDocumentApiFp(this.configuration).updateWithToken(id, tenant, updateEmployeeDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EmployeeNoteApi - axios parameter creator
 * @export
 */
export const EmployeeNoteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateNoteDto} createNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createNoteDto: CreateNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNoteDto' is not null or undefined
            assertParamExists('create', 'createNoteDto', createNoteDto)
            const localVarPath = `/api/v1/employee-note`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (employeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employee-note`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUnencryptedEmployees: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employee-note/unencrypted-employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/employee-note/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateNoteDto} updateNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: number, updateNoteDto: UpdateNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateNoteDto' is not null or undefined
            assertParamExists('update', 'updateNoteDto', updateNoteDto)
            const localVarPath = `/api/v1/employee-note/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeNoteApi - functional programming interface
 * @export
 */
export const EmployeeNoteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeNoteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateNoteDto} createNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createNoteDto: CreateNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(employeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NoteEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUnencryptedEmployees(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUnencryptedEmployees(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateNoteDto} updateNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: number, updateNoteDto: UpdateNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmployeeNoteApi - factory interface
 * @export
 */
export const EmployeeNoteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeNoteApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateNoteDto} createNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createNoteDto: CreateNoteDto, options?: any): AxiosPromise<NoteEntity> {
            return localVarFp.create(createNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(employeeId?: number, options?: any): AxiosPromise<Array<NoteEntity>> {
            return localVarFp.findAll(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUnencryptedEmployees(options?: any): AxiosPromise<Array<object>> {
            return localVarFp.findUnencryptedEmployees(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateNoteDto} updateNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: number, updateNoteDto: UpdateNoteDto, options?: any): AxiosPromise<NoteEntity> {
            return localVarFp.update(id, updateNoteDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeNoteApi - object-oriented interface
 * @export
 * @class EmployeeNoteApi
 * @extends {BaseAPI}
 */
export class EmployeeNoteApi extends BaseAPI {
    /**
     * 
     * @param {CreateNoteDto} createNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeNoteApi
     */
    public create(createNoteDto: CreateNoteDto, options?: AxiosRequestConfig) {
        return EmployeeNoteApiFp(this.configuration).create(createNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [employeeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeNoteApi
     */
    public findAll(employeeId?: number, options?: AxiosRequestConfig) {
        return EmployeeNoteApiFp(this.configuration).findAll(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeNoteApi
     */
    public findUnencryptedEmployees(options?: AxiosRequestConfig) {
        return EmployeeNoteApiFp(this.configuration).findUnencryptedEmployees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeNoteApi
     */
    public remove(id: number, options?: AxiosRequestConfig) {
        return EmployeeNoteApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateNoteDto} updateNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeNoteApi
     */
    public update(id: number, updateNoteDto: UpdateNoteDto, options?: AxiosRequestConfig) {
        return EmployeeNoteApiFp(this.configuration).update(id, updateNoteDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EmployeePaymentsApi - axios parameter creator
 * @export
 */
export const EmployeePaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            const localVarPath = `/api/v1/employee-payments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employee-payments/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (employeeId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findAll', 'employeeId', employeeId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAll', 'seasonId', seasonId)
            const localVarPath = `/api/v1/employee-payments/{employeeId}/{seasonId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findInPdf: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employee-payments/findInPdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPayment: async (paymentId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('uploadPayment', 'paymentId', paymentId)
            const localVarPath = `/api/v1/employee-payments/updateDocument/{paymentId}`
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeePaymentsApi - functional programming interface
 * @export
 */
export const EmployeePaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeePaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(employeeId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findInPdf(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentPageDataEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findInPdf(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPayment(paymentId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPayment(paymentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmployeePaymentsApi - factory interface
 * @export
 */
export const EmployeePaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeePaymentsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(options?: any): AxiosPromise<object> {
            return localVarFp.create(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(employeeId: number, seasonId: number, options?: any): AxiosPromise<Array<PaymentEntity>> {
            return localVarFp.findAll(employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findInPdf(options?: any): AxiosPromise<Array<PaymentPageDataEntity>> {
            return localVarFp.findInPdf(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} paymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPayment(paymentId: number, options?: any): AxiosPromise<void> {
            return localVarFp.uploadPayment(paymentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeePaymentsApi - object-oriented interface
 * @export
 * @class EmployeePaymentsApi
 * @extends {BaseAPI}
 */
export class EmployeePaymentsApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeePaymentsApi
     */
    public _delete(id: number, options?: AxiosRequestConfig) {
        return EmployeePaymentsApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeePaymentsApi
     */
    public create(options?: AxiosRequestConfig) {
        return EmployeePaymentsApiFp(this.configuration).create(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} employeeId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeePaymentsApi
     */
    public findAll(employeeId: number, seasonId: number, options?: AxiosRequestConfig) {
        return EmployeePaymentsApiFp(this.configuration).findAll(employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeePaymentsApi
     */
    public findInPdf(options?: AxiosRequestConfig) {
        return EmployeePaymentsApiFp(this.configuration).findInPdf(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} paymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeePaymentsApi
     */
    public uploadPayment(paymentId: number, options?: AxiosRequestConfig) {
        return EmployeePaymentsApiFp(this.configuration).uploadPayment(paymentId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * EmployeesApi - axios parameter creator
 * @export
 */
export const EmployeesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignRoom: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees/assignRoom`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignSeason: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees/assignSeason`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignStatus: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees/assignStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canEmployeeBeRemoved: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('canEmployeeBeRemoved', 'employeeId', employeeId)
            const localVarPath = `/api/v1/employees/canBeRemoved/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEmployeeByName: async (firstName: string, lastName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firstName' is not null or undefined
            assertParamExists('checkEmployeeByName', 'firstName', firstName)
            // verify required parameter 'lastName' is not null or undefined
            assertParamExists('checkEmployeeByName', 'lastName', lastName)
            const localVarPath = `/api/v1/employees/checkByName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (firstName !== undefined) {
                localVarQueryParameter['firstName'] = firstName;
            }

            if (lastName !== undefined) {
                localVarQueryParameter['lastName'] = lastName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateEmployeeWithStatusDto} createEmployeeWithStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createEmployeeWithStatusDto: CreateEmployeeWithStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmployeeWithStatusDto' is not null or undefined
            assertParamExists('create', 'createEmployeeWithStatusDto', createEmployeeWithStatusDto)
            const localVarPath = `/api/v1/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeWithStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFile: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createFile', 'id', id)
            const localVarPath = `/api/v1/employees/{id}/file`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileWithToken: async (id: string, tenant: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createFileWithToken', 'id', id)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('createFileWithToken', 'tenant', tenant)
            const localVarPath = `/api/v1/employees/{id}/file/withToken`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTodoDto} createTodoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTodo: async (createTodoDto: CreateTodoDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTodoDto' is not null or undefined
            assertParamExists('createTodo', 'createTodoDto', createTodoDto)
            const localVarPath = `/api/v1/employees/todos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTodoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTodoStatusDto} createTodoStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTodoStatus: async (createTodoStatusDto: CreateTodoStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTodoStatusDto' is not null or undefined
            assertParamExists('createTodoStatus', 'createTodoStatusDto', createTodoStatusDto)
            const localVarPath = `/api/v1/employees/todos/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTodoStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTodoStatus: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTodoStatus', 'id', id)
            const localVarPath = `/api/v1/employees/todos/status/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDepartments: async (id: string, seasonId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findAllDepartments', 'id', id)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAllDepartments', 'seasonId', seasonId)
            const localVarPath = `/api/v1/employees/{id}/departments/{seasonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {boolean} findAuthorizedUsers 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDepchief: async (seasonId: number, findAuthorizedUsers: boolean, departmentId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAllDepchief', 'seasonId', seasonId)
            // verify required parameter 'findAuthorizedUsers' is not null or undefined
            assertParamExists('findAllDepchief', 'findAuthorizedUsers', findAuthorizedUsers)
            const localVarPath = `/api/v1/employees/depchief/{seasonId}/{findAuthorizedUsers}/{departmentId}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (findAuthorizedUsers !== undefined) {
                localVarQueryParameter['findAuthorizedUsers'] = findAuthorizedUsers;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAssignableEmployees: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees/assignable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} includeDepartments 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByIds: async (includeDepartments: boolean, requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'includeDepartments' is not null or undefined
            assertParamExists('findByIds', 'includeDepartments', includeDepartments)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('findByIds', 'requestBody', requestBody)
            const localVarPath = `/api/v1/employees/byIds/{includeDepartments}`
                .replace(`{${"includeDepartments"}}`, encodeURIComponent(String(includeDepartments)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCrossSeasonEmployees: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees/cross-season`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDualSeasonEmployees: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees/dual-season`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyselfWithoutSeaoson: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findMyselfWithoutSeaoson', 'id', id)
            const localVarPath = `/api/v1/employees/findMyselfWithoutSeason/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findNonUnlimitedEmployees: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees/limited`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/employees/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneWithExpiredToken: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOneWithExpiredToken', 'id', id)
            const localVarPath = `/api/v1/employees/{id}/withExpiredToken`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneWithToken: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOneWithToken', 'id', id)
            const localVarPath = `/api/v1/employees/getWithToken/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneWithoutSeaoson: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOneWithoutSeaoson', 'id', id)
            const localVarPath = `/api/v1/employees/findOneWithoutSeason/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRemovedFromTurnovers: async (seasonId: number, fromDate: string, toDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findRemovedFromTurnovers', 'seasonId', seasonId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('findRemovedFromTurnovers', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('findRemovedFromTurnovers', 'toDate', toDate)
            const localVarPath = `/api/v1/employees/removedFromTurnovers/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSubordinates: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findSubordinates', 'seasonId', seasonId)
            const localVarPath = `/api/v1/employees/subordinates/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUnlimitedEmployees: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees/unlimited`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEmployees: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees/allEmployees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {SearchEmployeesDto} searchEmployeesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeesByTaxcode: async (seasonId: number, searchEmployeesDto: SearchEmployeesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getEmployeesByTaxcode', 'seasonId', seasonId)
            // verify required parameter 'searchEmployeesDto' is not null or undefined
            assertParamExists('getEmployeesByTaxcode', 'searchEmployeesDto', searchEmployeesDto)
            const localVarPath = `/api/v1/employees/byTaxCode/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchEmployeesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIfCommunications: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees/getIfCommunications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIfNoCommunications: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees/getIfNoCommunications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySelf: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees/getMyself`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is realized as a POST since the userIds can be a very long array that might exceed the practical limit of 2000 chars in a URL.    For further information on why this endpoint is not implemented as GET please refer to this post: https://stackoverflow.com/a/4203849/18487494
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportForAllUsers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeason: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSeason', 'id', id)
            const localVarPath = `/api/v1/employees/seasonToDisplay/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStats: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getStats', 'employeeId', employeeId)
            const localVarPath = `/api/v1/employees/longevity/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodoStatuses: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employees/todos/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodos: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getTodos', 'seasonId', seasonId)
            const localVarPath = `/api/v1/employees/todos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhatsappProfilePictureUrl: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWhatsappProfilePictureUrl', 'id', id)
            const localVarPath = `/api/v1/employees/{id}/getWhatsappProfilePictureUrl`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithBuildingsInfo: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getWithBuildingsInfo', 'seasonId', seasonId)
            const localVarPath = `/api/v1/employees/getWithBuildingsInfo/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyEmployee: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('notifyEmployee', 'id', id)
            const localVarPath = `/api/v1/employees/todos/{id}/notify`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/employees/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetExpoTokenDto} setExpoTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExpoToken: async (setExpoTokenDto: SetExpoTokenDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setExpoTokenDto' is not null or undefined
            assertParamExists('setExpoToken', 'setExpoTokenDto', setExpoTokenDto)
            const localVarPath = `/api/v1/employees/setExpoToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setExpoTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPictureFromWhatsapp: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setPictureFromWhatsapp', 'id', id)
            const localVarPath = `/api/v1/employees/{id}/setPictureFromWhatsapp`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetSeasonToDisplayDto} setSeasonToDisplayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSeasonToDisplay: async (setSeasonToDisplayDto: SetSeasonToDisplayDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setSeasonToDisplayDto' is not null or undefined
            assertParamExists('setSeasonToDisplay', 'setSeasonToDisplayDto', setSeasonToDisplayDto)
            const localVarPath = `/api/v1/employees/setSeasonToDisplay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setSeasonToDisplayDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignSeason: async (employeeId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('unassignSeason', 'employeeId', employeeId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('unassignSeason', 'seasonId', seasonId)
            const localVarPath = `/api/v1/employees/unassignSeason/{employeeId}/{seasonId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeDto} updateEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateEmployeeDto: UpdateEmployeeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateEmployeeDto' is not null or undefined
            assertParamExists('update', 'updateEmployeeDto', updateEmployeeDto)
            const localVarPath = `/api/v1/employees/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateEmployeeDto} updateEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMySelf: async (updateEmployeeDto: UpdateEmployeeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateEmployeeDto' is not null or undefined
            assertParamExists('updateMySelf', 'updateEmployeeDto', updateEmployeeDto)
            const localVarPath = `/api/v1/employees/updateMyself`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTodoResolutionDto} updateTodoResolutionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTodoResolution: async (id: string, updateTodoResolutionDto: UpdateTodoResolutionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTodoResolution', 'id', id)
            // verify required parameter 'updateTodoResolutionDto' is not null or undefined
            assertParamExists('updateTodoResolution', 'updateTodoResolutionDto', updateTodoResolutionDto)
            const localVarPath = `/api/v1/employees/todos/{id}/resolution`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTodoResolutionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTodoStatusDto} updateTodoStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTodoStatus: async (id: string, updateTodoStatusDto: UpdateTodoStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTodoStatus', 'id', id)
            // verify required parameter 'updateTodoStatusDto' is not null or undefined
            assertParamExists('updateTodoStatus', 'updateTodoStatusDto', updateTodoStatusDto)
            const localVarPath = `/api/v1/employees/todos/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTodoStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTodoStatusDefinitionDto} updateTodoStatusDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTodoStatusDefinition: async (id: string, updateTodoStatusDefinitionDto: UpdateTodoStatusDefinitionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTodoStatusDefinition', 'id', id)
            // verify required parameter 'updateTodoStatusDefinitionDto' is not null or undefined
            assertParamExists('updateTodoStatusDefinition', 'updateTodoStatusDefinitionDto', updateTodoStatusDefinitionDto)
            const localVarPath = `/api/v1/employees/todos/status/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTodoStatusDefinitionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {UpdateEmployeeDto} updateEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWithToken: async (id: string, tenant: string, updateEmployeeDto: UpdateEmployeeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWithToken', 'id', id)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('updateWithToken', 'tenant', tenant)
            // verify required parameter 'updateEmployeeDto' is not null or undefined
            assertParamExists('updateWithToken', 'updateEmployeeDto', updateEmployeeDto)
            const localVarPath = `/api/v1/employees/updateWithToken/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeesApi - functional programming interface
 * @export
 */
export const EmployeesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignRoom(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignRoom(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignSeason(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignSeason(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignStatus(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignStatus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async canEmployeeBeRemoved(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.canEmployeeBeRemoved(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkEmployeeByName(firstName: string, lastName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckEmployeeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkEmployeeByName(firstName, lastName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateEmployeeWithStatusDto} createEmployeeWithStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createEmployeeWithStatusDto: CreateEmployeeWithStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createEmployeeWithStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFile(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFileWithToken(id: string, tenant: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFileWithToken(id, tenant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateTodoDto} createTodoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTodo(createTodoDto: CreateTodoDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTodo(createTodoDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateTodoStatusDto} createTodoStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTodoStatus(createTodoStatusDto: CreateTodoStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTodoStatus(createTodoStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTodoStatus(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTodoStatus(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllDepartments(id: string, seasonId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeesDepartmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllDepartments(id, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {boolean} findAuthorizedUsers 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllDepchief(seasonId: number, findAuthorizedUsers: boolean, departmentId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllDepchief(seasonId, findAuthorizedUsers, departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAssignableEmployees(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAssignableEmployees(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} includeDepartments 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByIds(includeDepartments: boolean, requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByIds(includeDepartments, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCrossSeasonEmployees(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCrossSeasonEmployees(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findDualSeasonEmployees(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findDualSeasonEmployees(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findMyselfWithoutSeaoson(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findMyselfWithoutSeaoson(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findNonUnlimitedEmployees(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findNonUnlimitedEmployees(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOneWithExpiredToken(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOneWithExpiredToken(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOneWithToken(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOneWithToken(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOneWithoutSeaoson(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOneWithoutSeaoson(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findRemovedFromTurnovers(seasonId: number, fromDate: string, toDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRemovedFromTurnovers(seasonId, fromDate, toDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findSubordinates(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findSubordinates(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUnlimitedEmployees(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUnlimitedEmployees(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEmployees(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEmployees(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {SearchEmployeesDto} searchEmployeesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeesByTaxcode(seasonId: number, searchEmployeesDto: SearchEmployeesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeesByTaxcode(seasonId, searchEmployeesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIfCommunications(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIfCommunications(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIfNoCommunications(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIfNoCommunications(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMySelf(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMySelf(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is realized as a POST since the userIds can be a very long array that might exceed the practical limit of 2000 chars in a URL.    For further information on why this endpoint is not implemented as GET please refer to this post: https://stackoverflow.com/a/4203849/18487494
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportForAllUsers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportForAllUsers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSeason(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeasonEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSeason(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStats(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStats(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTodoStatuses(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTodoStatuses(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTodos(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTodos(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhatsappProfilePictureUrl(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhatsappProfilePictureUrl(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWithBuildingsInfo(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeToSeasonEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWithBuildingsInfo(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notifyEmployee(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notifyEmployee(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetExpoTokenDto} setExpoTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setExpoToken(setExpoTokenDto: SetExpoTokenDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setExpoToken(setExpoTokenDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPictureFromWhatsapp(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPictureFromWhatsapp(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetSeasonToDisplayDto} setSeasonToDisplayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSeasonToDisplay(setSeasonToDisplayDto: SetSeasonToDisplayDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setSeasonToDisplay(setSeasonToDisplayDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignSeason(employeeId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignSeason(employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeDto} updateEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateEmployeeDto: UpdateEmployeeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateEmployeeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateEmployeeDto} updateEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMySelf(updateEmployeeDto: UpdateEmployeeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMySelf(updateEmployeeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTodoResolutionDto} updateTodoResolutionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTodoResolution(id: string, updateTodoResolutionDto: UpdateTodoResolutionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTodoResolution(id, updateTodoResolutionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTodoStatusDto} updateTodoStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTodoStatus(id: string, updateTodoStatusDto: UpdateTodoStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTodoStatus(id, updateTodoStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTodoStatusDefinitionDto} updateTodoStatusDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTodoStatusDefinition(id: string, updateTodoStatusDefinitionDto: UpdateTodoStatusDefinitionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTodoStatusDefinition(id, updateTodoStatusDefinitionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {UpdateEmployeeDto} updateEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWithToken(id: string, tenant: string, updateEmployeeDto: UpdateEmployeeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWithToken(id, tenant, updateEmployeeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmployeesApi - factory interface
 * @export
 */
export const EmployeesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeesApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignRoom(options?: any): AxiosPromise<void> {
            return localVarFp.assignRoom(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignSeason(options?: any): AxiosPromise<void> {
            return localVarFp.assignSeason(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignStatus(options?: any): AxiosPromise<void> {
            return localVarFp.assignStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canEmployeeBeRemoved(employeeId: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.canEmployeeBeRemoved(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEmployeeByName(firstName: string, lastName: string, options?: any): AxiosPromise<CheckEmployeeResponseDto> {
            return localVarFp.checkEmployeeByName(firstName, lastName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateEmployeeWithStatusDto} createEmployeeWithStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createEmployeeWithStatusDto: CreateEmployeeWithStatusDto, options?: any): AxiosPromise<EmployeeEntity> {
            return localVarFp.create(createEmployeeWithStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFile(id: string, options?: any): AxiosPromise<FileEntity> {
            return localVarFp.createFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFileWithToken(id: string, tenant: string, options?: any): AxiosPromise<FileEntity> {
            return localVarFp.createFileWithToken(id, tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateTodoDto} createTodoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTodo(createTodoDto: CreateTodoDto, options?: any): AxiosPromise<void> {
            return localVarFp.createTodo(createTodoDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateTodoStatusDto} createTodoStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTodoStatus(createTodoStatusDto: CreateTodoStatusDto, options?: any): AxiosPromise<void> {
            return localVarFp.createTodoStatus(createTodoStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTodoStatus(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTodoStatus(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDepartments(id: string, seasonId: string, options?: any): AxiosPromise<Array<EmployeesDepartmentEntity>> {
            return localVarFp.findAllDepartments(id, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {boolean} findAuthorizedUsers 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDepchief(seasonId: number, findAuthorizedUsers: boolean, departmentId?: number, options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.findAllDepchief(seasonId, findAuthorizedUsers, departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAssignableEmployees(options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.findAssignableEmployees(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} includeDepartments 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByIds(includeDepartments: boolean, requestBody: Array<string>, options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.findByIds(includeDepartments, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCrossSeasonEmployees(options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.findCrossSeasonEmployees(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDualSeasonEmployees(options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.findDualSeasonEmployees(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyselfWithoutSeaoson(id: string, options?: any): AxiosPromise<EmployeeEntity> {
            return localVarFp.findMyselfWithoutSeaoson(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findNonUnlimitedEmployees(options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.findNonUnlimitedEmployees(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: number, options?: any): AxiosPromise<EmployeeEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneWithExpiredToken(id: string, options?: any): AxiosPromise<EmployeeEntity> {
            return localVarFp.findOneWithExpiredToken(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneWithToken(id: string, options?: any): AxiosPromise<EmployeeEntity> {
            return localVarFp.findOneWithToken(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneWithoutSeaoson(id: string, options?: any): AxiosPromise<EmployeeEntity> {
            return localVarFp.findOneWithoutSeaoson(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRemovedFromTurnovers(seasonId: number, fromDate: string, toDate: string, options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.findRemovedFromTurnovers(seasonId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSubordinates(seasonId: number, options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.findSubordinates(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUnlimitedEmployees(options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.findUnlimitedEmployees(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEmployees(options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.getAllEmployees(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {SearchEmployeesDto} searchEmployeesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeesByTaxcode(seasonId: number, searchEmployeesDto: SearchEmployeesDto, options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.getEmployeesByTaxcode(seasonId, searchEmployeesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIfCommunications(options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.getIfCommunications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIfNoCommunications(options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.getIfNoCommunications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySelf(options?: any): AxiosPromise<EmployeeEntity> {
            return localVarFp.getMySelf(options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is realized as a POST since the userIds can be a very long array that might exceed the practical limit of 2000 chars in a URL.    For further information on why this endpoint is not implemented as GET please refer to this post: https://stackoverflow.com/a/4203849/18487494
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportForAllUsers(options?: any): AxiosPromise<object> {
            return localVarFp.getReportForAllUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeason(id: number, options?: any): AxiosPromise<SeasonEntity> {
            return localVarFp.getSeason(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStats(employeeId: number, options?: any): AxiosPromise<number> {
            return localVarFp.getStats(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodoStatuses(options?: any): AxiosPromise<Array<object>> {
            return localVarFp.getTodoStatuses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTodos(seasonId: number, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.getTodos(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhatsappProfilePictureUrl(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getWhatsappProfilePictureUrl(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWithBuildingsInfo(seasonId: number, options?: any): AxiosPromise<Array<EmployeeToSeasonEntity>> {
            return localVarFp.getWithBuildingsInfo(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyEmployee(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.notifyEmployee(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<EmployeeEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetExpoTokenDto} setExpoTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExpoToken(setExpoTokenDto: SetExpoTokenDto, options?: any): AxiosPromise<EmployeeEntity> {
            return localVarFp.setExpoToken(setExpoTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPictureFromWhatsapp(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.setPictureFromWhatsapp(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetSeasonToDisplayDto} setSeasonToDisplayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSeasonToDisplay(setSeasonToDisplayDto: SetSeasonToDisplayDto, options?: any): AxiosPromise<void> {
            return localVarFp.setSeasonToDisplay(setSeasonToDisplayDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignSeason(employeeId: number, seasonId: number, options?: any): AxiosPromise<void> {
            return localVarFp.unassignSeason(employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeDto} updateEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateEmployeeDto: UpdateEmployeeDto, options?: any): AxiosPromise<EmployeeEntity> {
            return localVarFp.update(id, updateEmployeeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateEmployeeDto} updateEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMySelf(updateEmployeeDto: UpdateEmployeeDto, options?: any): AxiosPromise<EmployeeEntity> {
            return localVarFp.updateMySelf(updateEmployeeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTodoResolutionDto} updateTodoResolutionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTodoResolution(id: string, updateTodoResolutionDto: UpdateTodoResolutionDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateTodoResolution(id, updateTodoResolutionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTodoStatusDto} updateTodoStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTodoStatus(id: string, updateTodoStatusDto: UpdateTodoStatusDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateTodoStatus(id, updateTodoStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTodoStatusDefinitionDto} updateTodoStatusDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTodoStatusDefinition(id: string, updateTodoStatusDefinitionDto: UpdateTodoStatusDefinitionDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateTodoStatusDefinition(id, updateTodoStatusDefinitionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} tenant 
         * @param {UpdateEmployeeDto} updateEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWithToken(id: string, tenant: string, updateEmployeeDto: UpdateEmployeeDto, options?: any): AxiosPromise<EmployeeEntity> {
            return localVarFp.updateWithToken(id, tenant, updateEmployeeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeesApi - object-oriented interface
 * @export
 * @class EmployeesApi
 * @extends {BaseAPI}
 */
export class EmployeesApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public assignRoom(options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).assignRoom(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public assignSeason(options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).assignSeason(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public assignStatus(options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).assignStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public canEmployeeBeRemoved(employeeId: number, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).canEmployeeBeRemoved(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} firstName 
     * @param {string} lastName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public checkEmployeeByName(firstName: string, lastName: string, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).checkEmployeeByName(firstName, lastName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateEmployeeWithStatusDto} createEmployeeWithStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public create(createEmployeeWithStatusDto: CreateEmployeeWithStatusDto, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).create(createEmployeeWithStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public createFile(id: string, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).createFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} tenant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public createFileWithToken(id: string, tenant: string, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).createFileWithToken(id, tenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateTodoDto} createTodoDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public createTodo(createTodoDto: CreateTodoDto, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).createTodo(createTodoDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateTodoStatusDto} createTodoStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public createTodoStatus(createTodoStatusDto: CreateTodoStatusDto, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).createTodoStatus(createTodoStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public deleteTodoStatus(id: string, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).deleteTodoStatus(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findAllDepartments(id: string, seasonId: string, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findAllDepartments(id, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {boolean} findAuthorizedUsers 
     * @param {number} [departmentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findAllDepchief(seasonId: number, findAuthorizedUsers: boolean, departmentId?: number, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findAllDepchief(seasonId, findAuthorizedUsers, departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findAssignableEmployees(options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findAssignableEmployees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} includeDepartments 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findByIds(includeDepartments: boolean, requestBody: Array<string>, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findByIds(includeDepartments, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findCrossSeasonEmployees(options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findCrossSeasonEmployees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findDualSeasonEmployees(options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findDualSeasonEmployees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findMyselfWithoutSeaoson(id: string, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findMyselfWithoutSeaoson(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findNonUnlimitedEmployees(options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findNonUnlimitedEmployees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findOne(id: number, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findOneWithExpiredToken(id: string, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findOneWithExpiredToken(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findOneWithToken(id: string, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findOneWithToken(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findOneWithoutSeaoson(id: string, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findOneWithoutSeaoson(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findRemovedFromTurnovers(seasonId: number, fromDate: string, toDate: string, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findRemovedFromTurnovers(seasonId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findSubordinates(seasonId: number, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findSubordinates(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public findUnlimitedEmployees(options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).findUnlimitedEmployees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getAllEmployees(options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getAllEmployees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {SearchEmployeesDto} searchEmployeesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getEmployeesByTaxcode(seasonId: number, searchEmployeesDto: SearchEmployeesDto, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getEmployeesByTaxcode(seasonId, searchEmployeesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getIfCommunications(options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getIfCommunications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getIfNoCommunications(options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getIfNoCommunications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getMySelf(options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getMySelf(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is realized as a POST since the userIds can be a very long array that might exceed the practical limit of 2000 chars in a URL.    For further information on why this endpoint is not implemented as GET please refer to this post: https://stackoverflow.com/a/4203849/18487494
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getReportForAllUsers(options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getReportForAllUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getSeason(id: number, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getSeason(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getStats(employeeId: number, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getStats(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getTodoStatuses(options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getTodoStatuses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getTodos(seasonId: number, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getTodos(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getWhatsappProfilePictureUrl(id: string, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getWhatsappProfilePictureUrl(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public getWithBuildingsInfo(seasonId: number, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).getWithBuildingsInfo(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public notifyEmployee(id: string, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).notifyEmployee(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetExpoTokenDto} setExpoTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public setExpoToken(setExpoTokenDto: SetExpoTokenDto, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).setExpoToken(setExpoTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public setPictureFromWhatsapp(id: string, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).setPictureFromWhatsapp(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetSeasonToDisplayDto} setSeasonToDisplayDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public setSeasonToDisplay(setSeasonToDisplayDto: SetSeasonToDisplayDto, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).setSeasonToDisplay(setSeasonToDisplayDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} employeeId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public unassignSeason(employeeId: number, seasonId: number, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).unassignSeason(employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateEmployeeDto} updateEmployeeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public update(id: string, updateEmployeeDto: UpdateEmployeeDto, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).update(id, updateEmployeeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateEmployeeDto} updateEmployeeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public updateMySelf(updateEmployeeDto: UpdateEmployeeDto, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).updateMySelf(updateEmployeeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateTodoResolutionDto} updateTodoResolutionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public updateTodoResolution(id: string, updateTodoResolutionDto: UpdateTodoResolutionDto, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).updateTodoResolution(id, updateTodoResolutionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateTodoStatusDto} updateTodoStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public updateTodoStatus(id: string, updateTodoStatusDto: UpdateTodoStatusDto, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).updateTodoStatus(id, updateTodoStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateTodoStatusDefinitionDto} updateTodoStatusDefinitionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public updateTodoStatusDefinition(id: string, updateTodoStatusDefinitionDto: UpdateTodoStatusDefinitionDto, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).updateTodoStatusDefinition(id, updateTodoStatusDefinitionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} tenant 
     * @param {UpdateEmployeeDto} updateEmployeeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeesApi
     */
    public updateWithToken(id: string, tenant: string, updateEmployeeDto: UpdateEmployeeDto, options?: AxiosRequestConfig) {
        return EmployeesApiFp(this.configuration).updateWithToken(id, tenant, updateEmployeeDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ExperienceLevelApi - axios parameter creator
 * @export
 */
export const ExperienceLevelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateExperienceLevelDto} createExperienceLevelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createExperienceLevelDto: CreateExperienceLevelDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createExperienceLevelDto' is not null or undefined
            assertParamExists('create', 'createExperienceLevelDto', createExperienceLevelDto)
            const localVarPath = `/api/v1/experience-level`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExperienceLevelDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/experience-level`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/experience-level/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/experience-level/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateExperienceLevelDto} updateExperienceLevelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateExperienceLevelDto: UpdateExperienceLevelDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateExperienceLevelDto' is not null or undefined
            assertParamExists('update', 'updateExperienceLevelDto', updateExperienceLevelDto)
            const localVarPath = `/api/v1/experience-level/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateExperienceLevelDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExperienceLevelApi - functional programming interface
 * @export
 */
export const ExperienceLevelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExperienceLevelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateExperienceLevelDto} createExperienceLevelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createExperienceLevelDto: CreateExperienceLevelDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExperienceLevelEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createExperienceLevelDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExperienceLevelEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExperienceLevelEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateExperienceLevelDto} updateExperienceLevelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateExperienceLevelDto: UpdateExperienceLevelDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExperienceLevelEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateExperienceLevelDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExperienceLevelApi - factory interface
 * @export
 */
export const ExperienceLevelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExperienceLevelApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateExperienceLevelDto} createExperienceLevelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createExperienceLevelDto: CreateExperienceLevelDto, options?: any): AxiosPromise<ExperienceLevelEntity> {
            return localVarFp.create(createExperienceLevelDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<ExperienceLevelEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<ExperienceLevelEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateExperienceLevelDto} updateExperienceLevelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateExperienceLevelDto: UpdateExperienceLevelDto, options?: any): AxiosPromise<ExperienceLevelEntity> {
            return localVarFp.update(id, updateExperienceLevelDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExperienceLevelApi - object-oriented interface
 * @export
 * @class ExperienceLevelApi
 * @extends {BaseAPI}
 */
export class ExperienceLevelApi extends BaseAPI {
    /**
     * 
     * @param {CreateExperienceLevelDto} createExperienceLevelDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperienceLevelApi
     */
    public create(createExperienceLevelDto: CreateExperienceLevelDto, options?: AxiosRequestConfig) {
        return ExperienceLevelApiFp(this.configuration).create(createExperienceLevelDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperienceLevelApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return ExperienceLevelApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperienceLevelApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return ExperienceLevelApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperienceLevelApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return ExperienceLevelApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateExperienceLevelDto} updateExperienceLevelDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExperienceLevelApi
     */
    public update(id: string, updateExperienceLevelDto: UpdateExperienceLevelDto, options?: AxiosRequestConfig) {
        return ExperienceLevelApiFp(this.configuration).update(id, updateExperienceLevelDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InterviewsApi - axios parameter creator
 * @export
 */
export const InterviewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel an interview and notify the candidate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancel', 'id', id)
            const localVarPath = `/api/v1/interviews/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Schedule a new interview for an application
         * @param {CreateInterviewDto} createInterviewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createInterviewDto: CreateInterviewDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createInterviewDto' is not null or undefined
            assertParamExists('create', 'createInterviewDto', createInterviewDto)
            const localVarPath = `/api/v1/interviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInterviewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all interviews
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/interviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all interviews for a specific application
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByApplication: async (applicationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicationId' is not null or undefined
            assertParamExists('findByApplication', 'applicationId', applicationId)
            const localVarPath = `/api/v1/interviews/by-application/{applicationId}`
                .replace(`{${"applicationId"}}`, encodeURIComponent(String(applicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single interview by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/interviews/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel/delete an interview
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/interviews/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an interview (reschedule, change status, etc.)
         * @param {string} id 
         * @param {UpdateInterviewDto} updateInterviewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateInterviewDto: UpdateInterviewDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateInterviewDto' is not null or undefined
            assertParamExists('update', 'updateInterviewDto', updateInterviewDto)
            const localVarPath = `/api/v1/interviews/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInterviewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InterviewsApi - functional programming interface
 * @export
 */
export const InterviewsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InterviewsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel an interview and notify the candidate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancel(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterviewEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Schedule a new interview for an application
         * @param {CreateInterviewDto} createInterviewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createInterviewDto: CreateInterviewDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterviewEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createInterviewDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all interviews
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InterviewEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all interviews for a specific application
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByApplication(applicationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InterviewEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByApplication(applicationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a single interview by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterviewEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancel/delete an interview
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterviewEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an interview (reschedule, change status, etc.)
         * @param {string} id 
         * @param {UpdateInterviewDto} updateInterviewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateInterviewDto: UpdateInterviewDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterviewEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateInterviewDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InterviewsApi - factory interface
 * @export
 */
export const InterviewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InterviewsApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel an interview and notify the candidate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel(id: string, options?: any): AxiosPromise<InterviewEntity> {
            return localVarFp.cancel(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Schedule a new interview for an application
         * @param {CreateInterviewDto} createInterviewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createInterviewDto: CreateInterviewDto, options?: any): AxiosPromise<InterviewEntity> {
            return localVarFp.create(createInterviewDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all interviews
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<InterviewEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all interviews for a specific application
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByApplication(applicationId: string, options?: any): AxiosPromise<Array<InterviewEntity>> {
            return localVarFp.findByApplication(applicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single interview by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<InterviewEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel/delete an interview
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<InterviewEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an interview (reschedule, change status, etc.)
         * @param {string} id 
         * @param {UpdateInterviewDto} updateInterviewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateInterviewDto: UpdateInterviewDto, options?: any): AxiosPromise<InterviewEntity> {
            return localVarFp.update(id, updateInterviewDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InterviewsApi - object-oriented interface
 * @export
 * @class InterviewsApi
 * @extends {BaseAPI}
 */
export class InterviewsApi extends BaseAPI {
    /**
     * 
     * @summary Cancel an interview and notify the candidate
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewsApi
     */
    public cancel(id: string, options?: AxiosRequestConfig) {
        return InterviewsApiFp(this.configuration).cancel(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Schedule a new interview for an application
     * @param {CreateInterviewDto} createInterviewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewsApi
     */
    public create(createInterviewDto: CreateInterviewDto, options?: AxiosRequestConfig) {
        return InterviewsApiFp(this.configuration).create(createInterviewDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all interviews
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewsApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return InterviewsApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all interviews for a specific application
     * @param {string} applicationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewsApi
     */
    public findByApplication(applicationId: string, options?: AxiosRequestConfig) {
        return InterviewsApiFp(this.configuration).findByApplication(applicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single interview by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewsApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return InterviewsApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel/delete an interview
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return InterviewsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an interview (reschedule, change status, etc.)
     * @param {string} id 
     * @param {UpdateInterviewDto} updateInterviewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewsApi
     */
    public update(id: string, updateInterviewDto: UpdateInterviewDto, options?: AxiosRequestConfig) {
        return InterviewsApiFp(this.configuration).update(id, updateInterviewDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * JobAdvertisementsApi - axios parameter creator
 * @export
 */
export const JobAdvertisementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate or refine a job ad description / requirements with AI, using other tenant ads as context
         * @param {AiGenerateJobAdDto} aiGenerateJobAdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiGenerate: async (aiGenerateJobAdDto: AiGenerateJobAdDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aiGenerateJobAdDto' is not null or undefined
            assertParamExists('aiGenerate', 'aiGenerateJobAdDto', aiGenerateJobAdDto)
            const localVarPath = `/api/v1/job-advertisements/ai-generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiGenerateJobAdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateJobAdDto} createJobAdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createJobAdDto: CreateJobAdDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createJobAdDto' is not null or undefined
            assertParamExists('create', 'createJobAdDto', createJobAdDto)
            const localVarPath = `/api/v1/job-advertisements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createJobAdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/job-advertisements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllBySeason: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAllBySeason', 'seasonId', seasonId)
            const localVarPath = `/api/v1/job-advertisements/findAllBySeason/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCandidates: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findCandidates', 'id', id)
            const localVarPath = `/api/v1/job-advertisements/findCandidates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} company 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (company: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'company' is not null or undefined
            assertParamExists('findOne', 'company', company)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/job-advertisements/findOne/{company}/{id}`
                .replace(`{${"company"}}`, encodeURIComponent(String(company)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} company 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicBranding: async (company: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'company' is not null or undefined
            assertParamExists('getPublicBranding', 'company', company)
            const localVarPath = `/api/v1/job-advertisements/branding/{company}`
                .replace(`{${"company"}}`, encodeURIComponent(String(company)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} company 
         * @param {string} id 
         * @param {number} seasonId 
         * @param {CreateEmployeeDto} createEmployeeDto 
         * @param {string} [source] Optional platform identifier the application originated from (e.g. INDEED, LINKEDIN).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newCandidate: async (company: string, id: string, seasonId: number, createEmployeeDto: CreateEmployeeDto, source?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'company' is not null or undefined
            assertParamExists('newCandidate', 'company', company)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('newCandidate', 'id', id)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('newCandidate', 'seasonId', seasonId)
            // verify required parameter 'createEmployeeDto' is not null or undefined
            assertParamExists('newCandidate', 'createEmployeeDto', createEmployeeDto)
            const localVarPath = `/api/v1/job-advertisements/newCandidate/{company}/{id}/{seasonId}`
                .replace(`{${"company"}}`, encodeURIComponent(String(company)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/job-advertisements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Translate HTML content to a target language using AI
         * @param {AiTranslateDto} aiTranslateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translateContent: async (aiTranslateDto: AiTranslateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aiTranslateDto' is not null or undefined
            assertParamExists('translateContent', 'aiTranslateDto', aiTranslateDto)
            const localVarPath = `/api/v1/job-advertisements/translate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiTranslateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateJobAdDto} updateJobAdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateJobAdDto: UpdateJobAdDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateJobAdDto' is not null or undefined
            assertParamExists('update', 'updateJobAdDto', updateJobAdDto)
            const localVarPath = `/api/v1/job-advertisements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateJobAdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobAdvertisementsApi - functional programming interface
 * @export
 */
export const JobAdvertisementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobAdvertisementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Generate or refine a job ad description / requirements with AI, using other tenant ads as context
         * @param {AiGenerateJobAdDto} aiGenerateJobAdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiGenerate(aiGenerateJobAdDto: AiGenerateJobAdDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiGenerateJobAdResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiGenerate(aiGenerateJobAdDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateJobAdDto} createJobAdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createJobAdDto: CreateJobAdDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createJobAdDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllBySeason(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllBySeason(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCandidates(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCandidates(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} company 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(company: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(company, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} company 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicBranding(company: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicBranding(company, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} company 
         * @param {string} id 
         * @param {number} seasonId 
         * @param {CreateEmployeeDto} createEmployeeDto 
         * @param {string} [source] Optional platform identifier the application originated from (e.g. INDEED, LINKEDIN).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newCandidate(company: string, id: string, seasonId: number, createEmployeeDto: CreateEmployeeDto, source?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.newCandidate(company, id, seasonId, createEmployeeDto, source, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Translate HTML content to a target language using AI
         * @param {AiTranslateDto} aiTranslateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async translateContent(aiTranslateDto: AiTranslateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.translateContent(aiTranslateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateJobAdDto} updateJobAdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateJobAdDto: UpdateJobAdDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateJobAdDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * JobAdvertisementsApi - factory interface
 * @export
 */
export const JobAdvertisementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobAdvertisementsApiFp(configuration)
    return {
        /**
         * 
         * @summary Generate or refine a job ad description / requirements with AI, using other tenant ads as context
         * @param {AiGenerateJobAdDto} aiGenerateJobAdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiGenerate(aiGenerateJobAdDto: AiGenerateJobAdDto, options?: any): AxiosPromise<AiGenerateJobAdResponseDto> {
            return localVarFp.aiGenerate(aiGenerateJobAdDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateJobAdDto} createJobAdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createJobAdDto: CreateJobAdDto, options?: any): AxiosPromise<JobEntity> {
            return localVarFp.create(createJobAdDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<JobEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllBySeason(seasonId: number, options?: any): AxiosPromise<Array<JobEntity>> {
            return localVarFp.findAllBySeason(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCandidates(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.findCandidates(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} company 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(company: string, id: string, options?: any): AxiosPromise<JobEntity> {
            return localVarFp.findOne(company, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} company 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicBranding(company: string, options?: any): AxiosPromise<void> {
            return localVarFp.getPublicBranding(company, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} company 
         * @param {string} id 
         * @param {number} seasonId 
         * @param {CreateEmployeeDto} createEmployeeDto 
         * @param {string} [source] Optional platform identifier the application originated from (e.g. INDEED, LINKEDIN).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newCandidate(company: string, id: string, seasonId: number, createEmployeeDto: CreateEmployeeDto, source?: string, options?: any): AxiosPromise<EmployeeEntity> {
            return localVarFp.newCandidate(company, id, seasonId, createEmployeeDto, source, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Translate HTML content to a target language using AI
         * @param {AiTranslateDto} aiTranslateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        translateContent(aiTranslateDto: AiTranslateDto, options?: any): AxiosPromise<void> {
            return localVarFp.translateContent(aiTranslateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateJobAdDto} updateJobAdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateJobAdDto: UpdateJobAdDto, options?: any): AxiosPromise<JobEntity> {
            return localVarFp.update(id, updateJobAdDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobAdvertisementsApi - object-oriented interface
 * @export
 * @class JobAdvertisementsApi
 * @extends {BaseAPI}
 */
export class JobAdvertisementsApi extends BaseAPI {
    /**
     * 
     * @summary Generate or refine a job ad description / requirements with AI, using other tenant ads as context
     * @param {AiGenerateJobAdDto} aiGenerateJobAdDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAdvertisementsApi
     */
    public aiGenerate(aiGenerateJobAdDto: AiGenerateJobAdDto, options?: AxiosRequestConfig) {
        return JobAdvertisementsApiFp(this.configuration).aiGenerate(aiGenerateJobAdDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateJobAdDto} createJobAdDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAdvertisementsApi
     */
    public create(createJobAdDto: CreateJobAdDto, options?: AxiosRequestConfig) {
        return JobAdvertisementsApiFp(this.configuration).create(createJobAdDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAdvertisementsApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return JobAdvertisementsApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAdvertisementsApi
     */
    public findAllBySeason(seasonId: number, options?: AxiosRequestConfig) {
        return JobAdvertisementsApiFp(this.configuration).findAllBySeason(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAdvertisementsApi
     */
    public findCandidates(id: number, options?: AxiosRequestConfig) {
        return JobAdvertisementsApiFp(this.configuration).findCandidates(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} company 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAdvertisementsApi
     */
    public findOne(company: string, id: string, options?: AxiosRequestConfig) {
        return JobAdvertisementsApiFp(this.configuration).findOne(company, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} company 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAdvertisementsApi
     */
    public getPublicBranding(company: string, options?: AxiosRequestConfig) {
        return JobAdvertisementsApiFp(this.configuration).getPublicBranding(company, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} company 
     * @param {string} id 
     * @param {number} seasonId 
     * @param {CreateEmployeeDto} createEmployeeDto 
     * @param {string} [source] Optional platform identifier the application originated from (e.g. INDEED, LINKEDIN).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAdvertisementsApi
     */
    public newCandidate(company: string, id: string, seasonId: number, createEmployeeDto: CreateEmployeeDto, source?: string, options?: AxiosRequestConfig) {
        return JobAdvertisementsApiFp(this.configuration).newCandidate(company, id, seasonId, createEmployeeDto, source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAdvertisementsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return JobAdvertisementsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Translate HTML content to a target language using AI
     * @param {AiTranslateDto} aiTranslateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAdvertisementsApi
     */
    public translateContent(aiTranslateDto: AiTranslateDto, options?: AxiosRequestConfig) {
        return JobAdvertisementsApiFp(this.configuration).translateContent(aiTranslateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateJobAdDto} updateJobAdDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobAdvertisementsApi
     */
    public update(id: string, updateJobAdDto: UpdateJobAdDto, options?: AxiosRequestConfig) {
        return JobAdvertisementsApiFp(this.configuration).update(id, updateJobAdDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LicenceApi - axios parameter creator
 * @export
 */
export const LicenceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} licenceId 
         * @param {number} additionalInformationsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLicence: async (licenceId: number, additionalInformationsId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'licenceId' is not null or undefined
            assertParamExists('assignLicence', 'licenceId', licenceId)
            // verify required parameter 'additionalInformationsId' is not null or undefined
            assertParamExists('assignLicence', 'additionalInformationsId', additionalInformationsId)
            const localVarPath = `/api/v1/licence/assignLicence/{licenceId}/{additionalInformationsId}`
                .replace(`{${"licenceId"}}`, encodeURIComponent(String(licenceId)))
                .replace(`{${"additionalInformationsId"}}`, encodeURIComponent(String(additionalInformationsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateLicenceDto} createLicenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createLicenceDto: CreateLicenceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLicenceDto' is not null or undefined
            assertParamExists('create', 'createLicenceDto', createLicenceDto)
            const localVarPath = `/api/v1/licence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLicenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/licence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/licence/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/licence/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} licenceId 
         * @param {number} additionalInformationsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssignment: async (licenceId: number, additionalInformationsId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'licenceId' is not null or undefined
            assertParamExists('removeAssignment', 'licenceId', licenceId)
            // verify required parameter 'additionalInformationsId' is not null or undefined
            assertParamExists('removeAssignment', 'additionalInformationsId', additionalInformationsId)
            const localVarPath = `/api/v1/licence/removeAssignment/{licenceId}/{additionalInformationsId}`
                .replace(`{${"licenceId"}}`, encodeURIComponent(String(licenceId)))
                .replace(`{${"additionalInformationsId"}}`, encodeURIComponent(String(additionalInformationsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLicenceDto} updateLicenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateLicenceDto: UpdateLicenceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateLicenceDto' is not null or undefined
            assertParamExists('update', 'updateLicenceDto', updateLicenceDto)
            const localVarPath = `/api/v1/licence/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLicenceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LicenceApi - functional programming interface
 * @export
 */
export const LicenceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LicenceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} licenceId 
         * @param {number} additionalInformationsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignLicence(licenceId: number, additionalInformationsId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignLicence(licenceId, additionalInformationsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateLicenceDto} createLicenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createLicenceDto: CreateLicenceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicenceEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createLicenceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LicenceEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicenceEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} licenceId 
         * @param {number} additionalInformationsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAssignment(licenceId: number, additionalInformationsId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAssignment(licenceId, additionalInformationsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLicenceDto} updateLicenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateLicenceDto: UpdateLicenceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicenceEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateLicenceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LicenceApi - factory interface
 * @export
 */
export const LicenceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LicenceApiFp(configuration)
    return {
        /**
         * 
         * @param {number} licenceId 
         * @param {number} additionalInformationsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLicence(licenceId: number, additionalInformationsId: number, options?: any): AxiosPromise<void> {
            return localVarFp.assignLicence(licenceId, additionalInformationsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateLicenceDto} createLicenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createLicenceDto: CreateLicenceDto, options?: any): AxiosPromise<LicenceEntity> {
            return localVarFp.create(createLicenceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<LicenceEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<LicenceEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} licenceId 
         * @param {number} additionalInformationsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssignment(licenceId: number, additionalInformationsId: number, options?: any): AxiosPromise<void> {
            return localVarFp.removeAssignment(licenceId, additionalInformationsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateLicenceDto} updateLicenceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateLicenceDto: UpdateLicenceDto, options?: any): AxiosPromise<LicenceEntity> {
            return localVarFp.update(id, updateLicenceDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LicenceApi - object-oriented interface
 * @export
 * @class LicenceApi
 * @extends {BaseAPI}
 */
export class LicenceApi extends BaseAPI {
    /**
     * 
     * @param {number} licenceId 
     * @param {number} additionalInformationsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenceApi
     */
    public assignLicence(licenceId: number, additionalInformationsId: number, options?: AxiosRequestConfig) {
        return LicenceApiFp(this.configuration).assignLicence(licenceId, additionalInformationsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateLicenceDto} createLicenceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenceApi
     */
    public create(createLicenceDto: CreateLicenceDto, options?: AxiosRequestConfig) {
        return LicenceApiFp(this.configuration).create(createLicenceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenceApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return LicenceApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenceApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return LicenceApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenceApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return LicenceApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} licenceId 
     * @param {number} additionalInformationsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenceApi
     */
    public removeAssignment(licenceId: number, additionalInformationsId: number, options?: AxiosRequestConfig) {
        return LicenceApiFp(this.configuration).removeAssignment(licenceId, additionalInformationsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateLicenceDto} updateLicenceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenceApi
     */
    public update(id: string, updateLicenceDto: UpdateLicenceDto, options?: AxiosRequestConfig) {
        return LicenceApiFp(this.configuration).update(id, updateLicenceDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewNotifications: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notifications/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOldNotifications: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notifications/old`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setReadNotification: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setReadNotification', 'body', body)
            const localVarPath = `/api/v1/notifications/setRead`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewNotifications(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewNotifications(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOldNotifications(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOldNotifications(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setReadNotification(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setReadNotification(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewNotifications(options?: any): AxiosPromise<Array<NotificationEntity>> {
            return localVarFp.getNewNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOldNotifications(options?: any): AxiosPromise<Array<NotificationEntity>> {
            return localVarFp.getOldNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setReadNotification(body: object, options?: any): AxiosPromise<void> {
            return localVarFp.setReadNotification(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNewNotifications(options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNewNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getOldNotifications(options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getOldNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public setReadNotification(body: object, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).setReadNotification(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OfferLettersApi - axios parameter creator
 * @export
 */
export const OfferLettersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create an offer letter
         * @param {CreateOfferLetterDto} createOfferLetterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createOfferLetterDto: CreateOfferLetterDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOfferLetterDto' is not null or undefined
            assertParamExists('create', 'createOfferLetterDto', createOfferLetterDto)
            const localVarPath = `/api/v1/offer-letters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOfferLetterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all offer letters for the tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/offer-letters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List offer letters for an application
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByApplication: async (applicationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicationId' is not null or undefined
            assertParamExists('findByApplication', 'applicationId', applicationId)
            const localVarPath = `/api/v1/offer-letters/by-application/{applicationId}`
                .replace(`{${"applicationId"}}`, encodeURIComponent(String(applicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single offer letter
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/offer-letters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get offer details (public, no auth)
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOnePublic: async (tenantId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('findOnePublic', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOnePublic', 'id', id)
            const localVarPath = `/api/v1/offer-letters/public/{tenantId}/{id}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an offer letter
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/offer-letters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept or decline an offer (public, no auth)
         * @param {string} tenantId 
         * @param {string} id 
         * @param {RespondOfferLetterDto} respondOfferLetterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondPublic: async (tenantId: string, id: string, respondOfferLetterDto: RespondOfferLetterDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('respondPublic', 'tenantId', tenantId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('respondPublic', 'id', id)
            // verify required parameter 'respondOfferLetterDto' is not null or undefined
            assertParamExists('respondPublic', 'respondOfferLetterDto', respondOfferLetterDto)
            const localVarPath = `/api/v1/offer-letters/public/{tenantId}/{id}/respond`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(respondOfferLetterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an offer letter
         * @param {string} id 
         * @param {UpdateOfferLetterDto} updateOfferLetterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateOfferLetterDto: UpdateOfferLetterDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateOfferLetterDto' is not null or undefined
            assertParamExists('update', 'updateOfferLetterDto', updateOfferLetterDto)
            const localVarPath = `/api/v1/offer-letters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOfferLetterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OfferLettersApi - functional programming interface
 * @export
 */
export const OfferLettersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OfferLettersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create an offer letter
         * @param {CreateOfferLetterDto} createOfferLetterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createOfferLetterDto: CreateOfferLetterDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferLetterEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createOfferLetterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List all offer letters for the tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OfferLetterEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List offer letters for an application
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByApplication(applicationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OfferLetterEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByApplication(applicationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a single offer letter
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferLetterEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get offer details (public, no auth)
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOnePublic(tenantId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferLetterEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOnePublic(tenantId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an offer letter
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferLetterEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Accept or decline an offer (public, no auth)
         * @param {string} tenantId 
         * @param {string} id 
         * @param {RespondOfferLetterDto} respondOfferLetterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondPublic(tenantId: string, id: string, respondOfferLetterDto: RespondOfferLetterDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferLetterEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.respondPublic(tenantId, id, respondOfferLetterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an offer letter
         * @param {string} id 
         * @param {UpdateOfferLetterDto} updateOfferLetterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateOfferLetterDto: UpdateOfferLetterDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferLetterEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateOfferLetterDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OfferLettersApi - factory interface
 * @export
 */
export const OfferLettersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OfferLettersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create an offer letter
         * @param {CreateOfferLetterDto} createOfferLetterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createOfferLetterDto: CreateOfferLetterDto, options?: any): AxiosPromise<OfferLetterEntity> {
            return localVarFp.create(createOfferLetterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all offer letters for the tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<OfferLetterEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List offer letters for an application
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByApplication(applicationId: string, options?: any): AxiosPromise<Array<OfferLetterEntity>> {
            return localVarFp.findByApplication(applicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single offer letter
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<OfferLetterEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get offer details (public, no auth)
         * @param {string} tenantId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOnePublic(tenantId: string, id: string, options?: any): AxiosPromise<OfferLetterEntity> {
            return localVarFp.findOnePublic(tenantId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an offer letter
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<OfferLetterEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept or decline an offer (public, no auth)
         * @param {string} tenantId 
         * @param {string} id 
         * @param {RespondOfferLetterDto} respondOfferLetterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondPublic(tenantId: string, id: string, respondOfferLetterDto: RespondOfferLetterDto, options?: any): AxiosPromise<OfferLetterEntity> {
            return localVarFp.respondPublic(tenantId, id, respondOfferLetterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an offer letter
         * @param {string} id 
         * @param {UpdateOfferLetterDto} updateOfferLetterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateOfferLetterDto: UpdateOfferLetterDto, options?: any): AxiosPromise<OfferLetterEntity> {
            return localVarFp.update(id, updateOfferLetterDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OfferLettersApi - object-oriented interface
 * @export
 * @class OfferLettersApi
 * @extends {BaseAPI}
 */
export class OfferLettersApi extends BaseAPI {
    /**
     * 
     * @summary Create an offer letter
     * @param {CreateOfferLetterDto} createOfferLetterDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferLettersApi
     */
    public create(createOfferLetterDto: CreateOfferLetterDto, options?: AxiosRequestConfig) {
        return OfferLettersApiFp(this.configuration).create(createOfferLetterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all offer letters for the tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferLettersApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return OfferLettersApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List offer letters for an application
     * @param {string} applicationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferLettersApi
     */
    public findByApplication(applicationId: string, options?: AxiosRequestConfig) {
        return OfferLettersApiFp(this.configuration).findByApplication(applicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single offer letter
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferLettersApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return OfferLettersApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get offer details (public, no auth)
     * @param {string} tenantId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferLettersApi
     */
    public findOnePublic(tenantId: string, id: string, options?: AxiosRequestConfig) {
        return OfferLettersApiFp(this.configuration).findOnePublic(tenantId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an offer letter
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferLettersApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return OfferLettersApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept or decline an offer (public, no auth)
     * @param {string} tenantId 
     * @param {string} id 
     * @param {RespondOfferLetterDto} respondOfferLetterDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferLettersApi
     */
    public respondPublic(tenantId: string, id: string, respondOfferLetterDto: RespondOfferLetterDto, options?: AxiosRequestConfig) {
        return OfferLettersApiFp(this.configuration).respondPublic(tenantId, id, respondOfferLetterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an offer letter
     * @param {string} id 
     * @param {UpdateOfferLetterDto} updateOfferLetterDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferLettersApi
     */
    public update(id: string, updateOfferLetterDto: UpdateOfferLetterDto, options?: AxiosRequestConfig) {
        return OfferLettersApiFp(this.configuration).update(id, updateOfferLetterDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PaymentMethodsApi - axios parameter creator
 * @export
 */
export const PaymentMethodsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreatePaymentMethodDto} createPaymentMethodDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createPaymentMethodDto: CreatePaymentMethodDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPaymentMethodDto' is not null or undefined
            assertParamExists('create', 'createPaymentMethodDto', createPaymentMethodDto)
            const localVarPath = `/api/v1/payment-methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPaymentMethodDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment-methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAvaible: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment-methods/avaible`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/payment-methods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdatePaymentMethodDto} updatePaymentMethodDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updatePaymentMethodDto: UpdatePaymentMethodDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updatePaymentMethodDto' is not null or undefined
            assertParamExists('update', 'updatePaymentMethodDto', updatePaymentMethodDto)
            const localVarPath = `/api/v1/payment-methods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePaymentMethodDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentMethodsApi - functional programming interface
 * @export
 */
export const PaymentMethodsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentMethodsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreatePaymentMethodDto} createPaymentMethodDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createPaymentMethodDto: CreatePaymentMethodDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentMethodEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createPaymentMethodDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaymentMethodEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllAvaible(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllAvaible(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentMethodEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdatePaymentMethodDto} updatePaymentMethodDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updatePaymentMethodDto: UpdatePaymentMethodDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentMethodEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updatePaymentMethodDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PaymentMethodsApi - factory interface
 * @export
 */
export const PaymentMethodsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentMethodsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreatePaymentMethodDto} createPaymentMethodDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createPaymentMethodDto: CreatePaymentMethodDto, options?: any): AxiosPromise<PaymentMethodEntity> {
            return localVarFp.create(createPaymentMethodDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<PaymentMethodEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAvaible(options?: any): AxiosPromise<Array<object>> {
            return localVarFp.findAllAvaible(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<PaymentMethodEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdatePaymentMethodDto} updatePaymentMethodDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updatePaymentMethodDto: UpdatePaymentMethodDto, options?: any): AxiosPromise<PaymentMethodEntity> {
            return localVarFp.update(id, updatePaymentMethodDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentMethodsApi - object-oriented interface
 * @export
 * @class PaymentMethodsApi
 * @extends {BaseAPI}
 */
export class PaymentMethodsApi extends BaseAPI {
    /**
     * 
     * @param {CreatePaymentMethodDto} createPaymentMethodDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public create(createPaymentMethodDto: CreatePaymentMethodDto, options?: AxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).create(createPaymentMethodDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public findAllAvaible(options?: AxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).findAllAvaible(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdatePaymentMethodDto} updatePaymentMethodDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public update(id: string, updatePaymentMethodDto: UpdatePaymentMethodDto, options?: AxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).update(id, updatePaymentMethodDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PipelinesApi - axios parameter creator
 * @export
 */
export const PipelinesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a default hiring pipeline for a job advertisement
         * @param {CreatePipelineDto} createPipelineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createPipelineDto: CreatePipelineDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPipelineDto' is not null or undefined
            assertParamExists('create', 'createPipelineDto', createPipelineDto)
            const localVarPath = `/api/v1/pipelines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPipelineDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all pipelines across all jobs (with job & department info)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/pipelines/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all pipelines for a job advertisement
         * @param {string} jobAdvertisementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByJob: async (jobAdvertisementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobAdvertisementId' is not null or undefined
            assertParamExists('findByJob', 'jobAdvertisementId', jobAdvertisementId)
            const localVarPath = `/api/v1/pipelines/by-job/{jobAdvertisementId}`
                .replace(`{${"jobAdvertisementId"}}`, encodeURIComponent(String(jobAdvertisementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a pipeline with its stages and applications (Kanban board data)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/pipelines/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Move an application to a different pipeline stage (Kanban drag-and-drop)
         * @param {MoveApplicationDto} moveApplicationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveApplication: async (moveApplicationDto: MoveApplicationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moveApplicationDto' is not null or undefined
            assertParamExists('moveApplication', 'moveApplicationDto', moveApplicationDto)
            const localVarPath = `/api/v1/pipelines/move-application`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveApplicationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a pipeline and all its stages
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/pipelines/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reorder pipeline stages (update order values for multiple stages in one call)
         * @param {ReorderStagesDto} reorderStagesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderStages: async (reorderStagesDto: ReorderStagesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reorderStagesDto' is not null or undefined
            assertParamExists('reorderStages', 'reorderStagesDto', reorderStagesDto)
            const localVarPath = `/api/v1/pipelines/reorder-stages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderStagesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PipelinesApi - functional programming interface
 * @export
 */
export const PipelinesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PipelinesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a default hiring pipeline for a job advertisement
         * @param {CreatePipelineDto} createPipelineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createPipelineDto: CreatePipelineDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HiringPipelineEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createPipelineDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all pipelines across all jobs (with job & department info)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HiringPipelineEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all pipelines for a job advertisement
         * @param {string} jobAdvertisementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByJob(jobAdvertisementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HiringPipelineEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByJob(jobAdvertisementId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a pipeline with its stages and applications (Kanban board data)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HiringPipelineEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Move an application to a different pipeline stage (Kanban drag-and-drop)
         * @param {MoveApplicationDto} moveApplicationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveApplication(moveApplicationDto: MoveApplicationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveApplication(moveApplicationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a pipeline and all its stages
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HiringPipelineEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reorder pipeline stages (update order values for multiple stages in one call)
         * @param {ReorderStagesDto} reorderStagesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderStages(reorderStagesDto: ReorderStagesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PipelineStageEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderStages(reorderStagesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PipelinesApi - factory interface
 * @export
 */
export const PipelinesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PipelinesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a default hiring pipeline for a job advertisement
         * @param {CreatePipelineDto} createPipelineDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createPipelineDto: CreatePipelineDto, options?: any): AxiosPromise<HiringPipelineEntity> {
            return localVarFp.create(createPipelineDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all pipelines across all jobs (with job & department info)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<HiringPipelineEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all pipelines for a job advertisement
         * @param {string} jobAdvertisementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByJob(jobAdvertisementId: string, options?: any): AxiosPromise<Array<HiringPipelineEntity>> {
            return localVarFp.findByJob(jobAdvertisementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a pipeline with its stages and applications (Kanban board data)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<HiringPipelineEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Move an application to a different pipeline stage (Kanban drag-and-drop)
         * @param {MoveApplicationDto} moveApplicationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveApplication(moveApplicationDto: MoveApplicationDto, options?: any): AxiosPromise<void> {
            return localVarFp.moveApplication(moveApplicationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a pipeline and all its stages
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<HiringPipelineEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reorder pipeline stages (update order values for multiple stages in one call)
         * @param {ReorderStagesDto} reorderStagesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderStages(reorderStagesDto: ReorderStagesDto, options?: any): AxiosPromise<Array<PipelineStageEntity>> {
            return localVarFp.reorderStages(reorderStagesDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PipelinesApi - object-oriented interface
 * @export
 * @class PipelinesApi
 * @extends {BaseAPI}
 */
export class PipelinesApi extends BaseAPI {
    /**
     * 
     * @summary Create a default hiring pipeline for a job advertisement
     * @param {CreatePipelineDto} createPipelineDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public create(createPipelineDto: CreatePipelineDto, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).create(createPipelineDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all pipelines across all jobs (with job & department info)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all pipelines for a job advertisement
     * @param {string} jobAdvertisementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public findByJob(jobAdvertisementId: string, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).findByJob(jobAdvertisementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a pipeline with its stages and applications (Kanban board data)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Move an application to a different pipeline stage (Kanban drag-and-drop)
     * @param {MoveApplicationDto} moveApplicationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public moveApplication(moveApplicationDto: MoveApplicationDto, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).moveApplication(moveApplicationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a pipeline and all its stages
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reorder pipeline stages (update order values for multiple stages in one call)
     * @param {ReorderStagesDto} reorderStagesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public reorderStages(reorderStagesDto: ReorderStagesDto, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).reorderStages(reorderStagesDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PreContractsApi - axios parameter creator
 * @export
 */
export const PreContractsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUnsignedPdf: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadUnsignedPdf', 'id', id)
            const localVarPath = `/api/v1/pre-contracts/{id}/pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByEmployee: async (employeeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findByEmployee', 'employeeId', employeeId)
            const localVarPath = `/api/v1/pre-contracts/by-employee/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByToken: async (token: string, tenant: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getByToken', 'token', token)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('getByToken', 'tenant', tenant)
            const localVarPath = `/api/v1/pre-contracts/by-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedPdfUrl: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSignedPdfUrl', 'id', id)
            const localVarPath = `/api/v1/pre-contracts/{id}/signed-url`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateConfig: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/pre-contracts/template-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IssuePreContractDto} issuePreContractDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issuePreContract: async (issuePreContractDto: IssuePreContractDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuePreContractDto' is not null or undefined
            assertParamExists('issuePreContract', 'issuePreContractDto', issuePreContractDto)
            const localVarPath = `/api/v1/pre-contracts/issue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(issuePreContractDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public PDF preview stream for the signing page.
         * @summary 
         * @param {string} token 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPdfByToken: async (token: string, tenant: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('previewPdfByToken', 'token', token)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('previewPdfByToken', 'tenant', tenant)
            const localVarPath = `/api/v1/pre-contracts/by-token/pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {string} tenant 
         * @param {SignPreContractDto} signPreContractDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signByToken: async (token: string, tenant: string, signPreContractDto: SignPreContractDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('signByToken', 'token', token)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('signByToken', 'tenant', tenant)
            // verify required parameter 'signPreContractDto' is not null or undefined
            assertParamExists('signByToken', 'signPreContractDto', signPreContractDto)
            const localVarPath = `/api/v1/pre-contracts/by-token/sign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signPreContractDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogo: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/pre-contracts/template-config/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Manager uploads a signed copy when the employee signs OFFLINE (printed, signed by hand, scanned). Marks the pre-contract SIGNED and invalidates any outstanding signing link.
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSigned: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadSigned', 'id', id)
            const localVarPath = `/api/v1/pre-contracts/{id}/upload-signed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * One-shot: snapshot the employee data, create a new pre-contract row, and immediately attach the uploaded signed PDF. Used when the manager has a signed paper copy on hand and never generated a draft.
         * @summary 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSignedForEmployee: async (employeeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('uploadSignedForEmployee', 'employeeId', employeeId)
            const localVarPath = `/api/v1/pre-contracts/upload-signed-for-employee/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertPreContractTemplateConfigDto} upsertPreContractTemplateConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertTemplateConfig: async (upsertPreContractTemplateConfigDto: UpsertPreContractTemplateConfigDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertPreContractTemplateConfigDto' is not null or undefined
            assertParamExists('upsertTemplateConfig', 'upsertPreContractTemplateConfigDto', upsertPreContractTemplateConfigDto)
            const localVarPath = `/api/v1/pre-contracts/template-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertPreContractTemplateConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PreContractsApi - functional programming interface
 * @export
 */
export const PreContractsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PreContractsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadUnsignedPdf(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadUnsignedPdf(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByEmployee(employeeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByEmployee(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} token 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByToken(token: string, tenant: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByToken(token, tenant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSignedPdfUrl(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSignedPdfUrl(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplateConfig(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplateConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {IssuePreContractDto} issuePreContractDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issuePreContract(issuePreContractDto: IssuePreContractDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issuePreContract(issuePreContractDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Public PDF preview stream for the signing page.
         * @summary 
         * @param {string} token 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewPdfByToken(token: string, tenant: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewPdfByToken(token, tenant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} token 
         * @param {string} tenant 
         * @param {SignPreContractDto} signPreContractDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signByToken(token: string, tenant: string, signPreContractDto: SignPreContractDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signByToken(token, tenant, signPreContractDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadLogo(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadLogo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Manager uploads a signed copy when the employee signs OFFLINE (printed, signed by hand, scanned). Marks the pre-contract SIGNED and invalidates any outstanding signing link.
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadSigned(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadSigned(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * One-shot: snapshot the employee data, create a new pre-contract row, and immediately attach the uploaded signed PDF. Used when the manager has a signed paper copy on hand and never generated a draft.
         * @summary 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadSignedForEmployee(employeeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadSignedForEmployee(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpsertPreContractTemplateConfigDto} upsertPreContractTemplateConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertTemplateConfig(upsertPreContractTemplateConfigDto: UpsertPreContractTemplateConfigDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertTemplateConfig(upsertPreContractTemplateConfigDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PreContractsApi - factory interface
 * @export
 */
export const PreContractsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PreContractsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUnsignedPdf(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.downloadUnsignedPdf(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByEmployee(employeeId: string, options?: any): AxiosPromise<object> {
            return localVarFp.findByEmployee(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByToken(token: string, tenant: string, options?: any): AxiosPromise<void> {
            return localVarFp.getByToken(token, tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedPdfUrl(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getSignedPdfUrl(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateConfig(options?: any): AxiosPromise<object> {
            return localVarFp.getTemplateConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IssuePreContractDto} issuePreContractDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issuePreContract(issuePreContractDto: IssuePreContractDto, options?: any): AxiosPromise<object> {
            return localVarFp.issuePreContract(issuePreContractDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Public PDF preview stream for the signing page.
         * @summary 
         * @param {string} token 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewPdfByToken(token: string, tenant: string, options?: any): AxiosPromise<void> {
            return localVarFp.previewPdfByToken(token, tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {string} tenant 
         * @param {SignPreContractDto} signPreContractDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signByToken(token: string, tenant: string, signPreContractDto: SignPreContractDto, options?: any): AxiosPromise<void> {
            return localVarFp.signByToken(token, tenant, signPreContractDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogo(options?: any): AxiosPromise<void> {
            return localVarFp.uploadLogo(options).then((request) => request(axios, basePath));
        },
        /**
         * Manager uploads a signed copy when the employee signs OFFLINE (printed, signed by hand, scanned). Marks the pre-contract SIGNED and invalidates any outstanding signing link.
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSigned(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.uploadSigned(id, options).then((request) => request(axios, basePath));
        },
        /**
         * One-shot: snapshot the employee data, create a new pre-contract row, and immediately attach the uploaded signed PDF. Used when the manager has a signed paper copy on hand and never generated a draft.
         * @summary 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSignedForEmployee(employeeId: string, options?: any): AxiosPromise<void> {
            return localVarFp.uploadSignedForEmployee(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertPreContractTemplateConfigDto} upsertPreContractTemplateConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertTemplateConfig(upsertPreContractTemplateConfigDto: UpsertPreContractTemplateConfigDto, options?: any): AxiosPromise<object> {
            return localVarFp.upsertTemplateConfig(upsertPreContractTemplateConfigDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PreContractsApi - object-oriented interface
 * @export
 * @class PreContractsApi
 * @extends {BaseAPI}
 */
export class PreContractsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreContractsApi
     */
    public downloadUnsignedPdf(id: string, options?: AxiosRequestConfig) {
        return PreContractsApiFp(this.configuration).downloadUnsignedPdf(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreContractsApi
     */
    public findByEmployee(employeeId: string, options?: AxiosRequestConfig) {
        return PreContractsApiFp(this.configuration).findByEmployee(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {string} tenant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreContractsApi
     */
    public getByToken(token: string, tenant: string, options?: AxiosRequestConfig) {
        return PreContractsApiFp(this.configuration).getByToken(token, tenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreContractsApi
     */
    public getSignedPdfUrl(id: string, options?: AxiosRequestConfig) {
        return PreContractsApiFp(this.configuration).getSignedPdfUrl(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreContractsApi
     */
    public getTemplateConfig(options?: AxiosRequestConfig) {
        return PreContractsApiFp(this.configuration).getTemplateConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IssuePreContractDto} issuePreContractDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreContractsApi
     */
    public issuePreContract(issuePreContractDto: IssuePreContractDto, options?: AxiosRequestConfig) {
        return PreContractsApiFp(this.configuration).issuePreContract(issuePreContractDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public PDF preview stream for the signing page.
     * @summary 
     * @param {string} token 
     * @param {string} tenant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreContractsApi
     */
    public previewPdfByToken(token: string, tenant: string, options?: AxiosRequestConfig) {
        return PreContractsApiFp(this.configuration).previewPdfByToken(token, tenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {string} tenant 
     * @param {SignPreContractDto} signPreContractDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreContractsApi
     */
    public signByToken(token: string, tenant: string, signPreContractDto: SignPreContractDto, options?: AxiosRequestConfig) {
        return PreContractsApiFp(this.configuration).signByToken(token, tenant, signPreContractDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreContractsApi
     */
    public uploadLogo(options?: AxiosRequestConfig) {
        return PreContractsApiFp(this.configuration).uploadLogo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Manager uploads a signed copy when the employee signs OFFLINE (printed, signed by hand, scanned). Marks the pre-contract SIGNED and invalidates any outstanding signing link.
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreContractsApi
     */
    public uploadSigned(id: string, options?: AxiosRequestConfig) {
        return PreContractsApiFp(this.configuration).uploadSigned(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * One-shot: snapshot the employee data, create a new pre-contract row, and immediately attach the uploaded signed PDF. Used when the manager has a signed paper copy on hand and never generated a draft.
     * @summary 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreContractsApi
     */
    public uploadSignedForEmployee(employeeId: string, options?: AxiosRequestConfig) {
        return PreContractsApiFp(this.configuration).uploadSignedForEmployee(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertPreContractTemplateConfigDto} upsertPreContractTemplateConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreContractsApi
     */
    public upsertTemplateConfig(upsertPreContractTemplateConfigDto: UpsertPreContractTemplateConfigDto, options?: AxiosRequestConfig) {
        return PreContractsApiFp(this.configuration).upsertTemplateConfig(upsertPreContractTemplateConfigDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PublicDocumentsApi - axios parameter creator
 * @export
 */
export const PublicDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/public-documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/public-documents/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/public-documents/byUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/public-documents/findOne/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/public-documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdatePublicDocumentDto} updatePublicDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: number, updatePublicDocumentDto: UpdatePublicDocumentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updatePublicDocumentDto' is not null or undefined
            assertParamExists('update', 'updatePublicDocumentDto', updatePublicDocumentDto)
            const localVarPath = `/api/v1/public-documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePublicDocumentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicDocumentsApi - functional programming interface
 * @export
 */
export const PublicDocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicDocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublicDocumentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublicDocumentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicDocumentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdatePublicDocumentDto} updatePublicDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: number, updatePublicDocumentDto: UpdatePublicDocumentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updatePublicDocumentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicDocumentsApi - factory interface
 * @export
 */
export const PublicDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicDocumentsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(options?: any): AxiosPromise<void> {
            return localVarFp.create(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<PublicDocumentEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByUser(options?: any): AxiosPromise<Array<PublicDocumentEntity>> {
            return localVarFp.findByUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: number, options?: any): AxiosPromise<PublicDocumentEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdatePublicDocumentDto} updatePublicDocumentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: number, updatePublicDocumentDto: UpdatePublicDocumentDto, options?: any): AxiosPromise<void> {
            return localVarFp.update(id, updatePublicDocumentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicDocumentsApi - object-oriented interface
 * @export
 * @class PublicDocumentsApi
 * @extends {BaseAPI}
 */
export class PublicDocumentsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicDocumentsApi
     */
    public create(options?: AxiosRequestConfig) {
        return PublicDocumentsApiFp(this.configuration).create(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicDocumentsApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return PublicDocumentsApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicDocumentsApi
     */
    public findByUser(options?: AxiosRequestConfig) {
        return PublicDocumentsApiFp(this.configuration).findByUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicDocumentsApi
     */
    public findOne(id: number, options?: AxiosRequestConfig) {
        return PublicDocumentsApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicDocumentsApi
     */
    public remove(id: number, options?: AxiosRequestConfig) {
        return PublicDocumentsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdatePublicDocumentDto} updatePublicDocumentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicDocumentsApi
     */
    public update(id: number, updatePublicDocumentDto: UpdatePublicDocumentDto, options?: AxiosRequestConfig) {
        return PublicDocumentsApiFp(this.configuration).update(id, updatePublicDocumentDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PublicHolidaysApi - axios parameter creator
 * @export
 */
export const PublicHolidaysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Auto-populate holidays for a year from date-holidays library
         * @param {AutoPopulateHolidaysDto} autoPopulateHolidaysDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoPopulate: async (autoPopulateHolidaysDto: AutoPopulateHolidaysDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'autoPopulateHolidaysDto' is not null or undefined
            assertParamExists('autoPopulate', 'autoPopulateHolidaysDto', autoPopulateHolidaysDto)
            const localVarPath = `/api/v1/tenant-config/holidays/auto-populate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(autoPopulateHolidaysDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a custom public holiday
         * @param {CreateHolidayDto} createHolidayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createHolidayDto: CreateHolidayDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createHolidayDto' is not null or undefined
            assertParamExists('create', 'createHolidayDto', createHolidayDto)
            const localVarPath = `/api/v1/tenant-config/holidays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createHolidayDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List public holidays
         * @param {number} [year] 
         * @param {string} [region] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (year?: number, region?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tenant-config/holidays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a public holiday
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/tenant-config/holidays/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a public holiday
         * @param {number} id 
         * @param {UpdateHolidayDto} updateHolidayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: number, updateHolidayDto: UpdateHolidayDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateHolidayDto' is not null or undefined
            assertParamExists('update', 'updateHolidayDto', updateHolidayDto)
            const localVarPath = `/api/v1/tenant-config/holidays/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateHolidayDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicHolidaysApi - functional programming interface
 * @export
 */
export const PublicHolidaysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicHolidaysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Auto-populate holidays for a year from date-holidays library
         * @param {AutoPopulateHolidaysDto} autoPopulateHolidaysDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoPopulate(autoPopulateHolidaysDto: AutoPopulateHolidaysDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutoPopulateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoPopulate(autoPopulateHolidaysDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a custom public holiday
         * @param {CreateHolidayDto} createHolidayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createHolidayDto: CreateHolidayDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicHolidayEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createHolidayDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List public holidays
         * @param {number} [year] 
         * @param {string} [region] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(year?: number, region?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublicHolidayEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(year, region, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a public holiday
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a public holiday
         * @param {number} id 
         * @param {UpdateHolidayDto} updateHolidayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: number, updateHolidayDto: UpdateHolidayDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicHolidayEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateHolidayDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicHolidaysApi - factory interface
 * @export
 */
export const PublicHolidaysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicHolidaysApiFp(configuration)
    return {
        /**
         * 
         * @summary Auto-populate holidays for a year from date-holidays library
         * @param {AutoPopulateHolidaysDto} autoPopulateHolidaysDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoPopulate(autoPopulateHolidaysDto: AutoPopulateHolidaysDto, options?: any): AxiosPromise<AutoPopulateResponseDto> {
            return localVarFp.autoPopulate(autoPopulateHolidaysDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a custom public holiday
         * @param {CreateHolidayDto} createHolidayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createHolidayDto: CreateHolidayDto, options?: any): AxiosPromise<PublicHolidayEntity> {
            return localVarFp.create(createHolidayDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List public holidays
         * @param {number} [year] 
         * @param {string} [region] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(year?: number, region?: string, options?: any): AxiosPromise<Array<PublicHolidayEntity>> {
            return localVarFp.list(year, region, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a public holiday
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a public holiday
         * @param {number} id 
         * @param {UpdateHolidayDto} updateHolidayDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: number, updateHolidayDto: UpdateHolidayDto, options?: any): AxiosPromise<PublicHolidayEntity> {
            return localVarFp.update(id, updateHolidayDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicHolidaysApi - object-oriented interface
 * @export
 * @class PublicHolidaysApi
 * @extends {BaseAPI}
 */
export class PublicHolidaysApi extends BaseAPI {
    /**
     * 
     * @summary Auto-populate holidays for a year from date-holidays library
     * @param {AutoPopulateHolidaysDto} autoPopulateHolidaysDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidaysApi
     */
    public autoPopulate(autoPopulateHolidaysDto: AutoPopulateHolidaysDto, options?: AxiosRequestConfig) {
        return PublicHolidaysApiFp(this.configuration).autoPopulate(autoPopulateHolidaysDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a custom public holiday
     * @param {CreateHolidayDto} createHolidayDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidaysApi
     */
    public create(createHolidayDto: CreateHolidayDto, options?: AxiosRequestConfig) {
        return PublicHolidaysApiFp(this.configuration).create(createHolidayDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List public holidays
     * @param {number} [year] 
     * @param {string} [region] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidaysApi
     */
    public list(year?: number, region?: string, options?: AxiosRequestConfig) {
        return PublicHolidaysApiFp(this.configuration).list(year, region, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a public holiday
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidaysApi
     */
    public remove(id: number, options?: AxiosRequestConfig) {
        return PublicHolidaysApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a public holiday
     * @param {number} id 
     * @param {UpdateHolidayDto} updateHolidayDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidaysApi
     */
    public update(id: number, updateHolidayDto: UpdateHolidayDto, options?: AxiosRequestConfig) {
        return PublicHolidaysApiFp(this.configuration).update(id, updateHolidayDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResumeApi - axios parameter creator
 * @export
 */
export const ResumeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('create', 'body', body)
            const localVarPath = `/api/v1/resume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllapplicationCVs: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/resume/findAllapplicationCVs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/resume/findOne/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findResumeData: async (candidateId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('findResumeData', 'candidateId', candidateId)
            const localVarPath = `/api/v1/resume/findResumeData/{candidateId}`
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadURL: async (candidateId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('getDownloadURL', 'candidateId', candidateId)
            const localVarPath = `/api/v1/resume/getDownloadURL/{candidateId}`
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/resume/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Re-parse a CV from S3 using AI (Bedrock/Claude)
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reparse: async (applicationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicationId' is not null or undefined
            assertParamExists('reparse', 'applicationId', applicationId)
            const localVarPath = `/api/v1/resume/reparse/{applicationId}`
                .replace(`{${"applicationId"}}`, encodeURIComponent(String(applicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeElaboration: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/resume/resumeElaboration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('update', 'body', body)
            const localVarPath = `/api/v1/resume/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} applicationId 
         * @param {string} tenant 
         * @param {string} secret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhook: async (applicationId: number, tenant: string, secret: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applicationId' is not null or undefined
            assertParamExists('webhook', 'applicationId', applicationId)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('webhook', 'tenant', tenant)
            // verify required parameter 'secret' is not null or undefined
            assertParamExists('webhook', 'secret', secret)
            const localVarPath = `/api/v1/resume/webhook/{applicationId}/{tenant}/{secret}`
                .replace(`{${"applicationId"}}`, encodeURIComponent(String(applicationId)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"secret"}}`, encodeURIComponent(String(secret)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResumeApi - functional programming interface
 * @export
 */
export const ResumeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResumeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllapplicationCVs(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllapplicationCVs(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findResumeData(candidateId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findResumeData(candidateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDownloadURL(candidateId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDownloadURL(candidateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Re-parse a CV from S3 using AI (Bedrock/Claude)
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reparse(applicationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reparse(applicationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeElaboration(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeElaboration(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} applicationId 
         * @param {string} tenant 
         * @param {string} secret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhook(applicationId: number, tenant: string, secret: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webhook(applicationId, tenant, secret, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResumeApi - factory interface
 * @export
 */
export const ResumeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResumeApiFp(configuration)
    return {
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body: object, options?: any): AxiosPromise<string> {
            return localVarFp.create(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllapplicationCVs(options?: any): AxiosPromise<Array<ApplicationEntity>> {
            return localVarFp.findAllapplicationCVs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<ResumeEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findResumeData(candidateId: number, options?: any): AxiosPromise<object> {
            return localVarFp.findResumeData(candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadURL(candidateId: number, options?: any): AxiosPromise<object> {
            return localVarFp.getDownloadURL(candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Re-parse a CV from S3 using AI (Bedrock/Claude)
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reparse(applicationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.reparse(applicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeElaboration(options?: any): AxiosPromise<void> {
            return localVarFp.resumeElaboration(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, body: object, options?: any): AxiosPromise<string> {
            return localVarFp.update(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} applicationId 
         * @param {string} tenant 
         * @param {string} secret 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhook(applicationId: number, tenant: string, secret: string, options?: any): AxiosPromise<void> {
            return localVarFp.webhook(applicationId, tenant, secret, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResumeApi - object-oriented interface
 * @export
 * @class ResumeApi
 * @extends {BaseAPI}
 */
export class ResumeApi extends BaseAPI {
    /**
     * 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public create(body: object, options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).create(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public findAllapplicationCVs(options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).findAllapplicationCVs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public findResumeData(candidateId: number, options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).findResumeData(candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public getDownloadURL(candidateId: number, options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).getDownloadURL(candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Re-parse a CV from S3 using AI (Bedrock/Claude)
     * @param {string} applicationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public reparse(applicationId: string, options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).reparse(applicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public resumeElaboration(options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).resumeElaboration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public update(id: string, body: object, options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).update(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} applicationId 
     * @param {string} tenant 
     * @param {string} secret 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public webhook(applicationId: number, tenant: string, secret: string, options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).webhook(applicationId, tenant, secret, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RewardsApi - axios parameter creator
 * @export
 */
export const RewardsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateRewardsDto} createRewardsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRewards: async (createRewardsDto: CreateRewardsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRewardsDto' is not null or undefined
            assertParamExists('createRewards', 'createRewardsDto', createRewardsDto)
            const localVarPath = `/api/v1/rewards/{id}/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRewardsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRewards: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRewards', 'id', id)
            const localVarPath = `/api/v1/rewards/{id}/delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/rewards/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllNames: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/rewards/all-names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByContract: async (contractId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('findByContract', 'contractId', contractId)
            const localVarPath = `/api/v1/rewards/byContract/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RewardsApi - functional programming interface
 * @export
 */
export const RewardsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RewardsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateRewardsDto} createRewardsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRewards(createRewardsDto: CreateRewardsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRewards(createRewardsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRewards(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRewards(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RewardEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllNames(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UsedRewardNameEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllNames(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByContract(contractId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RewardEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByContract(contractId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RewardsApi - factory interface
 * @export
 */
export const RewardsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RewardsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateRewardsDto} createRewardsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRewards(createRewardsDto: CreateRewardsDto, options?: any): AxiosPromise<void> {
            return localVarFp.createRewards(createRewardsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRewards(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRewards(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<RewardEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllNames(options?: any): AxiosPromise<Array<UsedRewardNameEntity>> {
            return localVarFp.findAllNames(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByContract(contractId: number, options?: any): AxiosPromise<Array<RewardEntity>> {
            return localVarFp.findByContract(contractId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RewardsApi - object-oriented interface
 * @export
 * @class RewardsApi
 * @extends {BaseAPI}
 */
export class RewardsApi extends BaseAPI {
    /**
     * 
     * @param {CreateRewardsDto} createRewardsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public createRewards(createRewardsDto: CreateRewardsDto, options?: AxiosRequestConfig) {
        return RewardsApiFp(this.configuration).createRewards(createRewardsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public deleteRewards(id: number, options?: AxiosRequestConfig) {
        return RewardsApiFp(this.configuration).deleteRewards(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return RewardsApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public findAllNames(options?: AxiosRequestConfig) {
        return RewardsApiFp(this.configuration).findAllNames(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} contractId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public findByContract(contractId: number, options?: AxiosRequestConfig) {
        return RewardsApiFp(this.configuration).findByContract(contractId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RoomsApi - axios parameter creator
 * @export
 */
export const RoomsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateRoomDto} createRoomDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createRoomDto: CreateRoomDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRoomDto' is not null or undefined
            assertParamExists('create', 'createRoomDto', createRoomDto)
            const localVarPath = `/api/v1/rooms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoomDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateNotesDto} createNotesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotes: async (createNotesDto: CreateNotesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNotesDto' is not null or undefined
            assertParamExists('createNotes', 'createNotesDto', createNotesDto)
            const localVarPath = `/api/v1/rooms/createNotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNotesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRoomAssignmentDto} createRoomAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoomAssignment: async (createRoomAssignmentDto: CreateRoomAssignmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRoomAssignmentDto' is not null or undefined
            assertParamExists('createRoomAssignment', 'createRoomAssignmentDto', createRoomAssignmentDto)
            const localVarPath = `/api/v1/rooms/assignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoomAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [buildingId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (buildingId?: number, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/rooms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (buildingId !== undefined) {
                localVarQueryParameter['buildingId'] = buildingId;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyRoomAssignments: async (seasonId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findMyRoomAssignments', 'seasonId', seasonId)
            const localVarPath = `/api/v1/rooms/assignments/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/rooms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin diagnostic: returns every room assignment that\'s part of an overlap on the same room + bedIndex with another assignment. Used by the Company settings page to surface and clean up stale/duplicate rows that the tableau hides behind one another.
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOverlappingAssignments: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/rooms/admin/overlap-audit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seasonId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRoomAssignments: async (seasonId: string, employeeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findRoomAssignments', 'seasonId', seasonId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findRoomAssignments', 'employeeId', employeeId)
            const localVarPath = `/api/v1/rooms/assignments/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUnassignedEmployees: async (seasonId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findUnassignedEmployees', 'seasonId', seasonId)
            const localVarPath = `/api/v1/rooms/assignments/unassigned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} roomId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotes: async (roomId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('getNotes', 'roomId', roomId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getNotes', 'seasonId', seasonId)
            const localVarPath = `/api/v1/rooms/{roomId}/notes`
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/rooms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoomAssignment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeRoomAssignment', 'id', id)
            const localVarPath = `/api/v1/rooms/assignment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateRoomDto} updateRoomDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateRoomDto: UpdateRoomDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateRoomDto' is not null or undefined
            assertParamExists('update', 'updateRoomDto', updateRoomDto)
            const localVarPath = `/api/v1/rooms/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoomDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateNotesDto} updateNotesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotes: async (updateNotesDto: UpdateNotesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateNotesDto' is not null or undefined
            assertParamExists('updateNotes', 'updateNotesDto', updateNotesDto)
            const localVarPath = `/api/v1/rooms/assignNotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateRoomAssignmentDto} updateRoomAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoomAssignment: async (id: string, updateRoomAssignmentDto: UpdateRoomAssignmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateRoomAssignment', 'id', id)
            // verify required parameter 'updateRoomAssignmentDto' is not null or undefined
            assertParamExists('updateRoomAssignment', 'updateRoomAssignmentDto', updateRoomAssignmentDto)
            const localVarPath = `/api/v1/rooms/assignment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoomAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoomsApi - functional programming interface
 * @export
 */
export const RoomsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoomsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateRoomDto} createRoomDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createRoomDto: CreateRoomDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createRoomDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateNotesDto} createNotesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotes(createNotesDto: CreateNotesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotes(createNotesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateRoomAssignmentDto} createRoomAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoomAssignment(createRoomAssignmentDto: CreateRoomAssignmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeRoomAssignmentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoomAssignment(createRoomAssignmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [buildingId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(buildingId?: number, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoomEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(buildingId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findMyRoomAssignments(seasonId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeRoomAssignmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findMyRoomAssignments(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Admin diagnostic: returns every room assignment that\'s part of an overlap on the same room + bedIndex with another assignment. Used by the Company settings page to surface and clean up stale/duplicate rows that the tableau hides behind one another.
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOverlappingAssignments(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOverlappingAssignments(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} seasonId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findRoomAssignments(seasonId: string, employeeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeRoomAssignmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRoomAssignments(seasonId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUnassignedEmployees(seasonId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUnassignedEmployees(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} roomId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotes(roomId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomToSeasonEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotes(roomId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeRoomAssignment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeRoomAssignment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateRoomDto} updateRoomDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateRoomDto: UpdateRoomDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateRoomDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateNotesDto} updateNotesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotes(updateNotesDto: UpdateNotesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomToSeasonEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotes(updateNotesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateRoomAssignmentDto} updateRoomAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoomAssignment(id: string, updateRoomAssignmentDto: UpdateRoomAssignmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeRoomAssignmentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoomAssignment(id, updateRoomAssignmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RoomsApi - factory interface
 * @export
 */
export const RoomsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoomsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateRoomDto} createRoomDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createRoomDto: CreateRoomDto, options?: any): AxiosPromise<RoomEntity> {
            return localVarFp.create(createRoomDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateNotesDto} createNotesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotes(createNotesDto: CreateNotesDto, options?: any): AxiosPromise<void> {
            return localVarFp.createNotes(createNotesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRoomAssignmentDto} createRoomAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoomAssignment(createRoomAssignmentDto: CreateRoomAssignmentDto, options?: any): AxiosPromise<EmployeeRoomAssignmentEntity> {
            return localVarFp.createRoomAssignment(createRoomAssignmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [buildingId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(buildingId?: number, seasonId?: number, options?: any): AxiosPromise<Array<RoomEntity>> {
            return localVarFp.findAll(buildingId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyRoomAssignments(seasonId: string, options?: any): AxiosPromise<Array<EmployeeRoomAssignmentEntity>> {
            return localVarFp.findMyRoomAssignments(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, seasonId?: number, options?: any): AxiosPromise<RoomEntity> {
            return localVarFp.findOne(id, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin diagnostic: returns every room assignment that\'s part of an overlap on the same room + bedIndex with another assignment. Used by the Company settings page to surface and clean up stale/duplicate rows that the tableau hides behind one another.
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOverlappingAssignments(options?: any): AxiosPromise<Array<object>> {
            return localVarFp.findOverlappingAssignments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seasonId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRoomAssignments(seasonId: string, employeeId: string, options?: any): AxiosPromise<Array<EmployeeRoomAssignmentEntity>> {
            return localVarFp.findRoomAssignments(seasonId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUnassignedEmployees(seasonId: string, options?: any): AxiosPromise<void> {
            return localVarFp.findUnassignedEmployees(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} roomId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotes(roomId: number, seasonId: number, options?: any): AxiosPromise<RoomToSeasonEntity> {
            return localVarFp.getNotes(roomId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoomAssignment(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeRoomAssignment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateRoomDto} updateRoomDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateRoomDto: UpdateRoomDto, options?: any): AxiosPromise<RoomEntity> {
            return localVarFp.update(id, updateRoomDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateNotesDto} updateNotesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotes(updateNotesDto: UpdateNotesDto, options?: any): AxiosPromise<RoomToSeasonEntity> {
            return localVarFp.updateNotes(updateNotesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateRoomAssignmentDto} updateRoomAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoomAssignment(id: string, updateRoomAssignmentDto: UpdateRoomAssignmentDto, options?: any): AxiosPromise<EmployeeRoomAssignmentEntity> {
            return localVarFp.updateRoomAssignment(id, updateRoomAssignmentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoomsApi - object-oriented interface
 * @export
 * @class RoomsApi
 * @extends {BaseAPI}
 */
export class RoomsApi extends BaseAPI {
    /**
     * 
     * @param {CreateRoomDto} createRoomDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public create(createRoomDto: CreateRoomDto, options?: AxiosRequestConfig) {
        return RoomsApiFp(this.configuration).create(createRoomDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateNotesDto} createNotesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public createNotes(createNotesDto: CreateNotesDto, options?: AxiosRequestConfig) {
        return RoomsApiFp(this.configuration).createNotes(createNotesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRoomAssignmentDto} createRoomAssignmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public createRoomAssignment(createRoomAssignmentDto: CreateRoomAssignmentDto, options?: AxiosRequestConfig) {
        return RoomsApiFp(this.configuration).createRoomAssignment(createRoomAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [buildingId] 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public findAll(buildingId?: number, seasonId?: number, options?: AxiosRequestConfig) {
        return RoomsApiFp(this.configuration).findAll(buildingId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public findMyRoomAssignments(seasonId: string, options?: AxiosRequestConfig) {
        return RoomsApiFp(this.configuration).findMyRoomAssignments(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public findOne(id: string, seasonId?: number, options?: AxiosRequestConfig) {
        return RoomsApiFp(this.configuration).findOne(id, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin diagnostic: returns every room assignment that\'s part of an overlap on the same room + bedIndex with another assignment. Used by the Company settings page to surface and clean up stale/duplicate rows that the tableau hides behind one another.
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public findOverlappingAssignments(options?: AxiosRequestConfig) {
        return RoomsApiFp(this.configuration).findOverlappingAssignments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seasonId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public findRoomAssignments(seasonId: string, employeeId: string, options?: AxiosRequestConfig) {
        return RoomsApiFp(this.configuration).findRoomAssignments(seasonId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public findUnassignedEmployees(seasonId: string, options?: AxiosRequestConfig) {
        return RoomsApiFp(this.configuration).findUnassignedEmployees(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} roomId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public getNotes(roomId: number, seasonId: number, options?: AxiosRequestConfig) {
        return RoomsApiFp(this.configuration).getNotes(roomId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return RoomsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public removeRoomAssignment(id: string, options?: AxiosRequestConfig) {
        return RoomsApiFp(this.configuration).removeRoomAssignment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateRoomDto} updateRoomDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public update(id: string, updateRoomDto: UpdateRoomDto, options?: AxiosRequestConfig) {
        return RoomsApiFp(this.configuration).update(id, updateRoomDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateNotesDto} updateNotesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public updateNotes(updateNotesDto: UpdateNotesDto, options?: AxiosRequestConfig) {
        return RoomsApiFp(this.configuration).updateNotes(updateNotesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateRoomAssignmentDto} updateRoomAssignmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoomsApi
     */
    public updateRoomAssignment(id: string, updateRoomAssignmentDto: UpdateRoomAssignmentDto, options?: AxiosRequestConfig) {
        return RoomsApiFp(this.configuration).updateRoomAssignment(id, updateRoomAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SafetyAreasApi - axios parameter creator
 * @export
 */
export const SafetyAreasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateSafetyAreaDto} createSafetyAreaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createSafetyAreaDto: CreateSafetyAreaDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSafetyAreaDto' is not null or undefined
            assertParamExists('create', 'createSafetyAreaDto', createSafetyAreaDto)
            const localVarPath = `/api/v1/safety-areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSafetyAreaDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateMetaSafetyAreaDto} createMetaSafetyAreaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeta: async (createMetaSafetyAreaDto: CreateMetaSafetyAreaDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMetaSafetyAreaDto' is not null or undefined
            assertParamExists('createMeta', 'createMetaSafetyAreaDto', createMetaSafetyAreaDto)
            const localVarPath = `/api/v1/safety-areas/meta`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMetaSafetyAreaDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/safety-areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllMeta: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/safety-areas/meta`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/safety-areas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneMeta: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOneMeta', 'id', id)
            const localVarPath = `/api/v1/safety-areas/meta/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/safety-areas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMeta: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeMeta', 'id', id)
            const localVarPath = `/api/v1/safety-areas/meta/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateSafetyAreaDto} updateSafetyAreaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateSafetyAreaDto: UpdateSafetyAreaDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateSafetyAreaDto' is not null or undefined
            assertParamExists('update', 'updateSafetyAreaDto', updateSafetyAreaDto)
            const localVarPath = `/api/v1/safety-areas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSafetyAreaDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateMetaSafetyAreaDto} updateMetaSafetyAreaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeta: async (id: string, updateMetaSafetyAreaDto: UpdateMetaSafetyAreaDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMeta', 'id', id)
            // verify required parameter 'updateMetaSafetyAreaDto' is not null or undefined
            assertParamExists('updateMeta', 'updateMetaSafetyAreaDto', updateMetaSafetyAreaDto)
            const localVarPath = `/api/v1/safety-areas/meta/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMetaSafetyAreaDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadFile', 'id', id)
            const localVarPath = `/api/v1/safety-areas/{id}/file`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SafetyAreasApi - functional programming interface
 * @export
 */
export const SafetyAreasApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SafetyAreasApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateSafetyAreaDto} createSafetyAreaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createSafetyAreaDto: CreateSafetyAreaDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyAreaEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createSafetyAreaDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateMetaSafetyAreaDto} createMetaSafetyAreaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMeta(createMetaSafetyAreaDto: CreateMetaSafetyAreaDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaSafetyAreaEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMeta(createMetaSafetyAreaDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SafetyAreaEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllMeta(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MetaSafetyAreaEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllMeta(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyAreaEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOneMeta(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaSafetyAreaEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOneMeta(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeMeta(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaSafetyAreaEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeMeta(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateSafetyAreaDto} updateSafetyAreaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateSafetyAreaDto: UpdateSafetyAreaDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyAreaEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateSafetyAreaDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateMetaSafetyAreaDto} updateMetaSafetyAreaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMeta(id: string, updateMetaSafetyAreaDto: UpdateMetaSafetyAreaDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetaSafetyAreaEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMeta(id, updateMetaSafetyAreaDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFile(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SafetyAreasApi - factory interface
 * @export
 */
export const SafetyAreasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SafetyAreasApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateSafetyAreaDto} createSafetyAreaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createSafetyAreaDto: CreateSafetyAreaDto, options?: any): AxiosPromise<SafetyAreaEntity> {
            return localVarFp.create(createSafetyAreaDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateMetaSafetyAreaDto} createMetaSafetyAreaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeta(createMetaSafetyAreaDto: CreateMetaSafetyAreaDto, options?: any): AxiosPromise<MetaSafetyAreaEntity> {
            return localVarFp.createMeta(createMetaSafetyAreaDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<SafetyAreaEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllMeta(options?: any): AxiosPromise<Array<MetaSafetyAreaEntity>> {
            return localVarFp.findAllMeta(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<SafetyAreaEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneMeta(id: string, options?: any): AxiosPromise<MetaSafetyAreaEntity> {
            return localVarFp.findOneMeta(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMeta(id: string, options?: any): AxiosPromise<MetaSafetyAreaEntity> {
            return localVarFp.removeMeta(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateSafetyAreaDto} updateSafetyAreaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateSafetyAreaDto: UpdateSafetyAreaDto, options?: any): AxiosPromise<SafetyAreaEntity> {
            return localVarFp.update(id, updateSafetyAreaDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateMetaSafetyAreaDto} updateMetaSafetyAreaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMeta(id: string, updateMetaSafetyAreaDto: UpdateMetaSafetyAreaDto, options?: any): AxiosPromise<MetaSafetyAreaEntity> {
            return localVarFp.updateMeta(id, updateMetaSafetyAreaDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.uploadFile(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SafetyAreasApi - object-oriented interface
 * @export
 * @class SafetyAreasApi
 * @extends {BaseAPI}
 */
export class SafetyAreasApi extends BaseAPI {
    /**
     * 
     * @param {CreateSafetyAreaDto} createSafetyAreaDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyAreasApi
     */
    public create(createSafetyAreaDto: CreateSafetyAreaDto, options?: AxiosRequestConfig) {
        return SafetyAreasApiFp(this.configuration).create(createSafetyAreaDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateMetaSafetyAreaDto} createMetaSafetyAreaDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyAreasApi
     */
    public createMeta(createMetaSafetyAreaDto: CreateMetaSafetyAreaDto, options?: AxiosRequestConfig) {
        return SafetyAreasApiFp(this.configuration).createMeta(createMetaSafetyAreaDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyAreasApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return SafetyAreasApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyAreasApi
     */
    public findAllMeta(options?: AxiosRequestConfig) {
        return SafetyAreasApiFp(this.configuration).findAllMeta(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyAreasApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return SafetyAreasApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyAreasApi
     */
    public findOneMeta(id: string, options?: AxiosRequestConfig) {
        return SafetyAreasApiFp(this.configuration).findOneMeta(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyAreasApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return SafetyAreasApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyAreasApi
     */
    public removeMeta(id: string, options?: AxiosRequestConfig) {
        return SafetyAreasApiFp(this.configuration).removeMeta(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateSafetyAreaDto} updateSafetyAreaDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyAreasApi
     */
    public update(id: string, updateSafetyAreaDto: UpdateSafetyAreaDto, options?: AxiosRequestConfig) {
        return SafetyAreasApiFp(this.configuration).update(id, updateSafetyAreaDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateMetaSafetyAreaDto} updateMetaSafetyAreaDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyAreasApi
     */
    public updateMeta(id: string, updateMetaSafetyAreaDto: UpdateMetaSafetyAreaDto, options?: AxiosRequestConfig) {
        return SafetyAreasApiFp(this.configuration).updateMeta(id, updateMetaSafetyAreaDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyAreasApi
     */
    public uploadFile(id: string, options?: AxiosRequestConfig) {
        return SafetyAreasApiFp(this.configuration).uploadFile(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SafetyItemsApi - axios parameter creator
 * @export
 */
export const SafetyItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new safety item
         * @param {CreateSafetyItemDto} createSafetyItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createSafetyItemDto: CreateSafetyItemDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSafetyItemDto' is not null or undefined
            assertParamExists('create', 'createSafetyItemDto', createSafetyItemDto)
            const localVarPath = `/api/v1/safety-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSafetyItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new safety item area content
         * @param {CreateSafetyItemAreaContentDto} createSafetyItemAreaContentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAreaContent: async (createSafetyItemAreaContentDto: CreateSafetyItemAreaContentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSafetyItemAreaContentDto' is not null or undefined
            assertParamExists('createAreaContent', 'createSafetyItemAreaContentDto', createSafetyItemAreaContentDto)
            const localVarPath = `/api/v1/safety-items/area-content`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSafetyItemAreaContentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new safety area item association
         * @param {CreateSafetyAreaItemDto} createSafetyAreaItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAreaItem: async (createSafetyAreaItemDto: CreateSafetyAreaItemDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSafetyAreaItemDto' is not null or undefined
            assertParamExists('createAreaItem', 'createSafetyAreaItemDto', createSafetyAreaItemDto)
            const localVarPath = `/api/v1/safety-items/area-item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSafetyAreaItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new safety item check interval
         * @param {CreateSafetyItemCheckIntervalDto} createSafetyItemCheckIntervalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckInterval: async (createSafetyItemCheckIntervalDto: CreateSafetyItemCheckIntervalDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSafetyItemCheckIntervalDto' is not null or undefined
            assertParamExists('createCheckInterval', 'createSafetyItemCheckIntervalDto', createSafetyItemCheckIntervalDto)
            const localVarPath = `/api/v1/safety-items/check-intervals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSafetyItemCheckIntervalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new safety item area checklist item
         * @param {CreateSafetyItemAreaChecklistItemDto} createSafetyItemAreaChecklistItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChecklistItem: async (createSafetyItemAreaChecklistItemDto: CreateSafetyItemAreaChecklistItemDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSafetyItemAreaChecklistItemDto' is not null or undefined
            assertParamExists('createChecklistItem', 'createSafetyItemAreaChecklistItemDto', createSafetyItemAreaChecklistItemDto)
            const localVarPath = `/api/v1/safety-items/checklist-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSafetyItemAreaChecklistItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSafetyPeriodicCheckDto} createSafetyPeriodicCheckDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPeriodicCheck: async (createSafetyPeriodicCheckDto: CreateSafetyPeriodicCheckDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSafetyPeriodicCheckDto' is not null or undefined
            assertParamExists('createPeriodicCheck', 'createSafetyPeriodicCheckDto', createSafetyPeriodicCheckDto)
            const localVarPath = `/api/v1/safety-items/periodic-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSafetyPeriodicCheckDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all safety items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/safety-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a safety item by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/safety-items/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the effective content for a safety area item
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveAreaContent: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEffectiveAreaContent', 'id', id)
            const localVarPath = `/api/v1/safety-items/area/{id}/content`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the effective check interval for a safety area item
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCheckInterval: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEffectiveCheckInterval', 'id', id)
            const localVarPath = `/api/v1/safety-items/area/{id}/check-interval`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the effective checklist items for a safety area item
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveChecklistItems: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEffectiveChecklistItems', 'id', id)
            const localVarPath = `/api/v1/safety-items/area/{id}/checklist-items`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get safety problems (expired items, expiring items, incomplete checklists)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSafetyProblems: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/safety-items/problems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a safety item
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/safety-items/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a safety area item association
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAreaItem: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeAreaItem', 'id', id)
            const localVarPath = `/api/v1/safety-items/area-item/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a safety item
         * @param {string} id 
         * @param {UpdateSafetyItemDto} updateSafetyItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateSafetyItemDto: UpdateSafetyItemDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateSafetyItemDto' is not null or undefined
            assertParamExists('update', 'updateSafetyItemDto', updateSafetyItemDto)
            const localVarPath = `/api/v1/safety-items/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSafetyItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a safety area item association
         * @param {string} id 
         * @param {UpdateSafetyAreaItemDto} updateSafetyAreaItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAreaItem: async (id: string, updateSafetyAreaItemDto: UpdateSafetyAreaItemDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAreaItem', 'id', id)
            // verify required parameter 'updateSafetyAreaItemDto' is not null or undefined
            assertParamExists('updateAreaItem', 'updateSafetyAreaItemDto', updateSafetyAreaItemDto)
            const localVarPath = `/api/v1/safety-items/area-item/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSafetyAreaItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a file for a safety item
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadFile', 'id', id)
            const localVarPath = `/api/v1/safety-items/{id}/file`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a file for a safety periodic check
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPeriodicCheckFile: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadPeriodicCheckFile', 'id', id)
            const localVarPath = `/api/v1/safety-items/periodic-check/{id}/file`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SafetyItemsApi - functional programming interface
 * @export
 */
export const SafetyItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SafetyItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new safety item
         * @param {CreateSafetyItemDto} createSafetyItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createSafetyItemDto: CreateSafetyItemDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyItemEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createSafetyItemDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new safety item area content
         * @param {CreateSafetyItemAreaContentDto} createSafetyItemAreaContentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAreaContent(createSafetyItemAreaContentDto: CreateSafetyItemAreaContentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAreaContent(createSafetyItemAreaContentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new safety area item association
         * @param {CreateSafetyAreaItemDto} createSafetyAreaItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAreaItem(createSafetyAreaItemDto: CreateSafetyAreaItemDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAreaItem(createSafetyAreaItemDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new safety item check interval
         * @param {CreateSafetyItemCheckIntervalDto} createSafetyItemCheckIntervalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCheckInterval(createSafetyItemCheckIntervalDto: CreateSafetyItemCheckIntervalDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCheckInterval(createSafetyItemCheckIntervalDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new safety item area checklist item
         * @param {CreateSafetyItemAreaChecklistItemDto} createSafetyItemAreaChecklistItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChecklistItem(createSafetyItemAreaChecklistItemDto: CreateSafetyItemAreaChecklistItemDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChecklistItem(createSafetyItemAreaChecklistItemDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSafetyPeriodicCheckDto} createSafetyPeriodicCheckDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPeriodicCheck(createSafetyPeriodicCheckDto: CreateSafetyPeriodicCheckDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPeriodicCheck(createSafetyPeriodicCheckDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all safety items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SafetyItemEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a safety item by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyItemEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the effective content for a safety area item
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEffectiveAreaContent(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEffectiveAreaContent(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the effective check interval for a safety area item
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEffectiveCheckInterval(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEffectiveCheckInterval(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the effective checklist items for a safety area item
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEffectiveChecklistItems(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEffectiveChecklistItems(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get safety problems (expired items, expiring items, incomplete checklists)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSafetyProblems(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyProblemsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSafetyProblems(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a safety item
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a safety area item association
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAreaItem(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAreaItem(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a safety item
         * @param {string} id 
         * @param {UpdateSafetyItemDto} updateSafetyItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateSafetyItemDto: UpdateSafetyItemDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyItemEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateSafetyItemDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a safety area item association
         * @param {string} id 
         * @param {UpdateSafetyAreaItemDto} updateSafetyAreaItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAreaItem(id: string, updateSafetyAreaItemDto: UpdateSafetyAreaItemDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAreaItem(id, updateSafetyAreaItemDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload a file for a safety item
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFile(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload a file for a safety periodic check
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPeriodicCheckFile(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPeriodicCheckFile(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SafetyItemsApi - factory interface
 * @export
 */
export const SafetyItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SafetyItemsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new safety item
         * @param {CreateSafetyItemDto} createSafetyItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createSafetyItemDto: CreateSafetyItemDto, options?: any): AxiosPromise<SafetyItemEntity> {
            return localVarFp.create(createSafetyItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new safety item area content
         * @param {CreateSafetyItemAreaContentDto} createSafetyItemAreaContentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAreaContent(createSafetyItemAreaContentDto: CreateSafetyItemAreaContentDto, options?: any): AxiosPromise<void> {
            return localVarFp.createAreaContent(createSafetyItemAreaContentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new safety area item association
         * @param {CreateSafetyAreaItemDto} createSafetyAreaItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAreaItem(createSafetyAreaItemDto: CreateSafetyAreaItemDto, options?: any): AxiosPromise<void> {
            return localVarFp.createAreaItem(createSafetyAreaItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new safety item check interval
         * @param {CreateSafetyItemCheckIntervalDto} createSafetyItemCheckIntervalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckInterval(createSafetyItemCheckIntervalDto: CreateSafetyItemCheckIntervalDto, options?: any): AxiosPromise<void> {
            return localVarFp.createCheckInterval(createSafetyItemCheckIntervalDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new safety item area checklist item
         * @param {CreateSafetyItemAreaChecklistItemDto} createSafetyItemAreaChecklistItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChecklistItem(createSafetyItemAreaChecklistItemDto: CreateSafetyItemAreaChecklistItemDto, options?: any): AxiosPromise<void> {
            return localVarFp.createChecklistItem(createSafetyItemAreaChecklistItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSafetyPeriodicCheckDto} createSafetyPeriodicCheckDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPeriodicCheck(createSafetyPeriodicCheckDto: CreateSafetyPeriodicCheckDto, options?: any): AxiosPromise<object> {
            return localVarFp.createPeriodicCheck(createSafetyPeriodicCheckDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all safety items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<SafetyItemEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a safety item by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<SafetyItemEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the effective content for a safety area item
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveAreaContent(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getEffectiveAreaContent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the effective check interval for a safety area item
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCheckInterval(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getEffectiveCheckInterval(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the effective checklist items for a safety area item
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveChecklistItems(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getEffectiveChecklistItems(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get safety problems (expired items, expiring items, incomplete checklists)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSafetyProblems(options?: any): AxiosPromise<SafetyProblemsResponseDto> {
            return localVarFp.getSafetyProblems(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a safety item
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a safety area item association
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAreaItem(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeAreaItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a safety item
         * @param {string} id 
         * @param {UpdateSafetyItemDto} updateSafetyItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateSafetyItemDto: UpdateSafetyItemDto, options?: any): AxiosPromise<SafetyItemEntity> {
            return localVarFp.update(id, updateSafetyItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a safety area item association
         * @param {string} id 
         * @param {UpdateSafetyAreaItemDto} updateSafetyAreaItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAreaItem(id: string, updateSafetyAreaItemDto: UpdateSafetyAreaItemDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateAreaItem(id, updateSafetyAreaItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a file for a safety item
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.uploadFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a file for a safety periodic check
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPeriodicCheckFile(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.uploadPeriodicCheckFile(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SafetyItemsApi - object-oriented interface
 * @export
 * @class SafetyItemsApi
 * @extends {BaseAPI}
 */
export class SafetyItemsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new safety item
     * @param {CreateSafetyItemDto} createSafetyItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public create(createSafetyItemDto: CreateSafetyItemDto, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).create(createSafetyItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new safety item area content
     * @param {CreateSafetyItemAreaContentDto} createSafetyItemAreaContentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public createAreaContent(createSafetyItemAreaContentDto: CreateSafetyItemAreaContentDto, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).createAreaContent(createSafetyItemAreaContentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new safety area item association
     * @param {CreateSafetyAreaItemDto} createSafetyAreaItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public createAreaItem(createSafetyAreaItemDto: CreateSafetyAreaItemDto, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).createAreaItem(createSafetyAreaItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new safety item check interval
     * @param {CreateSafetyItemCheckIntervalDto} createSafetyItemCheckIntervalDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public createCheckInterval(createSafetyItemCheckIntervalDto: CreateSafetyItemCheckIntervalDto, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).createCheckInterval(createSafetyItemCheckIntervalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new safety item area checklist item
     * @param {CreateSafetyItemAreaChecklistItemDto} createSafetyItemAreaChecklistItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public createChecklistItem(createSafetyItemAreaChecklistItemDto: CreateSafetyItemAreaChecklistItemDto, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).createChecklistItem(createSafetyItemAreaChecklistItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSafetyPeriodicCheckDto} createSafetyPeriodicCheckDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public createPeriodicCheck(createSafetyPeriodicCheckDto: CreateSafetyPeriodicCheckDto, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).createPeriodicCheck(createSafetyPeriodicCheckDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all safety items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a safety item by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the effective content for a safety area item
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public getEffectiveAreaContent(id: string, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).getEffectiveAreaContent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the effective check interval for a safety area item
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public getEffectiveCheckInterval(id: string, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).getEffectiveCheckInterval(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the effective checklist items for a safety area item
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public getEffectiveChecklistItems(id: string, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).getEffectiveChecklistItems(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get safety problems (expired items, expiring items, incomplete checklists)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public getSafetyProblems(options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).getSafetyProblems(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a safety item
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a safety area item association
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public removeAreaItem(id: string, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).removeAreaItem(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a safety item
     * @param {string} id 
     * @param {UpdateSafetyItemDto} updateSafetyItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public update(id: string, updateSafetyItemDto: UpdateSafetyItemDto, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).update(id, updateSafetyItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a safety area item association
     * @param {string} id 
     * @param {UpdateSafetyAreaItemDto} updateSafetyAreaItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public updateAreaItem(id: string, updateSafetyAreaItemDto: UpdateSafetyAreaItemDto, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).updateAreaItem(id, updateSafetyAreaItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a file for a safety item
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public uploadFile(id: string, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).uploadFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a file for a safety periodic check
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SafetyItemsApi
     */
    public uploadPeriodicCheckFile(id: string, options?: AxiosRequestConfig) {
        return SafetyItemsApiFp(this.configuration).uploadPeriodicCheckFile(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SeasonsApi - axios parameter creator
 * @export
 */
export const SeasonsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AssignEmployeesToSeasonsDto} assignEmployeesToSeasonsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignEmployeesToSeason: async (assignEmployeesToSeasonsDto: AssignEmployeesToSeasonsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignEmployeesToSeasonsDto' is not null or undefined
            assertParamExists('assignEmployeesToSeason', 'assignEmployeesToSeasonsDto', assignEmployeesToSeasonsDto)
            const localVarPath = `/api/v1/seasons/assignEmployees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignEmployeesToSeasonsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateHousing: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bulkUpdateHousing', 'id', id)
            const localVarPath = `/api/v1/seasons/{id}/bulk-update-housing`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSeasonDto} createSeasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createSeasonDto: CreateSeasonDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSeasonDto' is not null or undefined
            assertParamExists('create', 'createSeasonDto', createSeasonDto)
            const localVarPath = `/api/v1/seasons/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSeasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePopulatedSeasonDto} createPopulatedSeasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPopulated: async (createPopulatedSeasonDto: CreatePopulatedSeasonDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPopulatedSeasonDto' is not null or undefined
            assertParamExists('createPopulated', 'createPopulatedSeasonDto', createPopulatedSeasonDto)
            const localVarPath = `/api/v1/seasons/createPopulated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPopulatedSeasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/seasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllIfNotEmployee: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findAllIfNotEmployee', 'employeeId', employeeId)
            const localVarPath = `/api/v1/seasons/findAllIfNotEmployee/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMySeasonInProgress: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/seasons/mySeasonsInProgress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUnique: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findUnique', 'id', id)
            const localVarPath = `/api/v1/seasons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isSeasonActive: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/seasons/isActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/seasons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateSeasonDto} updateSeasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateSeasonDto: UpdateSeasonDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateSeasonDto' is not null or undefined
            assertParamExists('update', 'updateSeasonDto', updateSeasonDto)
            const localVarPath = `/api/v1/seasons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSeasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SeasonsApi - functional programming interface
 * @export
 */
export const SeasonsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SeasonsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AssignEmployeesToSeasonsDto} assignEmployeesToSeasonsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignEmployeesToSeason(assignEmployeesToSeasonsDto: AssignEmployeesToSeasonsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignEmployeesToSeason(assignEmployeesToSeasonsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateHousing(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateHousing(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSeasonDto} createSeasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createSeasonDto: CreateSeasonDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeasonEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createSeasonDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePopulatedSeasonDto} createPopulatedSeasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPopulated(createPopulatedSeasonDto: CreatePopulatedSeasonDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeasonEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPopulated(createPopulatedSeasonDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeasonEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllIfNotEmployee(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeasonEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllIfNotEmployee(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findMySeasonInProgress(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeasonEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findMySeasonInProgress(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUnique(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeasonEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUnique(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isSeasonActive(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isSeasonActive(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateSeasonDto} updateSeasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateSeasonDto: UpdateSeasonDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeasonEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateSeasonDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SeasonsApi - factory interface
 * @export
 */
export const SeasonsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SeasonsApiFp(configuration)
    return {
        /**
         * 
         * @param {AssignEmployeesToSeasonsDto} assignEmployeesToSeasonsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignEmployeesToSeason(assignEmployeesToSeasonsDto: AssignEmployeesToSeasonsDto, options?: any): AxiosPromise<void> {
            return localVarFp.assignEmployeesToSeason(assignEmployeesToSeasonsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateHousing(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.bulkUpdateHousing(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSeasonDto} createSeasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createSeasonDto: CreateSeasonDto, options?: any): AxiosPromise<SeasonEntity> {
            return localVarFp.create(createSeasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePopulatedSeasonDto} createPopulatedSeasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPopulated(createPopulatedSeasonDto: CreatePopulatedSeasonDto, options?: any): AxiosPromise<SeasonEntity> {
            return localVarFp.createPopulated(createPopulatedSeasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<SeasonEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllIfNotEmployee(employeeId: number, options?: any): AxiosPromise<Array<SeasonEntity>> {
            return localVarFp.findAllIfNotEmployee(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMySeasonInProgress(options?: any): AxiosPromise<Array<SeasonEntity>> {
            return localVarFp.findMySeasonInProgress(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUnique(id: string, options?: any): AxiosPromise<SeasonEntity> {
            return localVarFp.findUnique(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isSeasonActive(options?: any): AxiosPromise<boolean> {
            return localVarFp.isSeasonActive(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateSeasonDto} updateSeasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateSeasonDto: UpdateSeasonDto, options?: any): AxiosPromise<SeasonEntity> {
            return localVarFp.update(id, updateSeasonDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SeasonsApi - object-oriented interface
 * @export
 * @class SeasonsApi
 * @extends {BaseAPI}
 */
export class SeasonsApi extends BaseAPI {
    /**
     * 
     * @param {AssignEmployeesToSeasonsDto} assignEmployeesToSeasonsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonsApi
     */
    public assignEmployeesToSeason(assignEmployeesToSeasonsDto: AssignEmployeesToSeasonsDto, options?: AxiosRequestConfig) {
        return SeasonsApiFp(this.configuration).assignEmployeesToSeason(assignEmployeesToSeasonsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonsApi
     */
    public bulkUpdateHousing(id: string, options?: AxiosRequestConfig) {
        return SeasonsApiFp(this.configuration).bulkUpdateHousing(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSeasonDto} createSeasonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonsApi
     */
    public create(createSeasonDto: CreateSeasonDto, options?: AxiosRequestConfig) {
        return SeasonsApiFp(this.configuration).create(createSeasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePopulatedSeasonDto} createPopulatedSeasonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonsApi
     */
    public createPopulated(createPopulatedSeasonDto: CreatePopulatedSeasonDto, options?: AxiosRequestConfig) {
        return SeasonsApiFp(this.configuration).createPopulated(createPopulatedSeasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonsApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return SeasonsApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonsApi
     */
    public findAllIfNotEmployee(employeeId: number, options?: AxiosRequestConfig) {
        return SeasonsApiFp(this.configuration).findAllIfNotEmployee(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonsApi
     */
    public findMySeasonInProgress(options?: AxiosRequestConfig) {
        return SeasonsApiFp(this.configuration).findMySeasonInProgress(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonsApi
     */
    public findUnique(id: string, options?: AxiosRequestConfig) {
        return SeasonsApiFp(this.configuration).findUnique(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonsApi
     */
    public isSeasonActive(options?: AxiosRequestConfig) {
        return SeasonsApiFp(this.configuration).isSeasonActive(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return SeasonsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateSeasonDto} updateSeasonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonsApi
     */
    public update(id: string, updateSeasonDto: UpdateSeasonDto, options?: AxiosRequestConfig) {
        return SeasonsApiFp(this.configuration).update(id, updateSeasonDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SectionsApi - axios parameter creator
 * @export
 */
export const SectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ExtendedCreateSectionDto} extendedCreateSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (extendedCreateSectionDto: ExtendedCreateSectionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'extendedCreateSectionDto' is not null or undefined
            assertParamExists('create', 'extendedCreateSectionDto', extendedCreateSectionDto)
            const localVarPath = `/api/v1/sections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extendedCreateSectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAll', 'seasonId', seasonId)
            const localVarPath = `/api/v1/sections/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByDepartment: async (departmentId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('findAllByDepartment', 'departmentId', departmentId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAllByDepartment', 'seasonId', seasonId)
            const localVarPath = `/api/v1/sections/findByDepartment/{departmentId}/{seasonId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEnabledSections: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findEnabledSections', 'seasonId', seasonId)
            const localVarPath = `/api/v1/sections/enabled-sections/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findOne', 'seasonId', seasonId)
            const localVarPath = `/api/v1/sections/findOne/{id}/{seasonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTicketingSections: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findTicketingSections', 'seasonId', seasonId)
            const localVarPath = `/api/v1/sections/ticketing/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/sections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ExtendedUpdateSectionDto} extendedUpdateSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, extendedUpdateSectionDto: ExtendedUpdateSectionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'extendedUpdateSectionDto' is not null or undefined
            assertParamExists('update', 'extendedUpdateSectionDto', extendedUpdateSectionDto)
            const localVarPath = `/api/v1/sections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extendedUpdateSectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SectionsApi - functional programming interface
 * @export
 */
export const SectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ExtendedCreateSectionDto} extendedCreateSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(extendedCreateSectionDto: ExtendedCreateSectionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SectionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(extendedCreateSectionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SectionEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllByDepartment(departmentId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SectionEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllByDepartment(departmentId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findEnabledSections(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SectionEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findEnabledSections(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SectionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findTicketingSections(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SectionEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findTicketingSections(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SectionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ExtendedUpdateSectionDto} extendedUpdateSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, extendedUpdateSectionDto: ExtendedUpdateSectionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SectionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, extendedUpdateSectionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SectionsApi - factory interface
 * @export
 */
export const SectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SectionsApiFp(configuration)
    return {
        /**
         * 
         * @param {ExtendedCreateSectionDto} extendedCreateSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(extendedCreateSectionDto: ExtendedCreateSectionDto, options?: any): AxiosPromise<SectionEntity> {
            return localVarFp.create(extendedCreateSectionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(seasonId: number, options?: any): AxiosPromise<Array<SectionEntity>> {
            return localVarFp.findAll(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByDepartment(departmentId: number, seasonId: number, options?: any): AxiosPromise<Array<SectionEntity>> {
            return localVarFp.findAllByDepartment(departmentId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEnabledSections(seasonId: number, options?: any): AxiosPromise<Array<SectionEntity>> {
            return localVarFp.findEnabledSections(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: number, seasonId: number, options?: any): AxiosPromise<SectionEntity> {
            return localVarFp.findOne(id, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTicketingSections(seasonId: number, options?: any): AxiosPromise<Array<SectionEntity>> {
            return localVarFp.findTicketingSections(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<SectionEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ExtendedUpdateSectionDto} extendedUpdateSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, extendedUpdateSectionDto: ExtendedUpdateSectionDto, options?: any): AxiosPromise<SectionEntity> {
            return localVarFp.update(id, extendedUpdateSectionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SectionsApi - object-oriented interface
 * @export
 * @class SectionsApi
 * @extends {BaseAPI}
 */
export class SectionsApi extends BaseAPI {
    /**
     * 
     * @param {ExtendedCreateSectionDto} extendedCreateSectionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectionsApi
     */
    public create(extendedCreateSectionDto: ExtendedCreateSectionDto, options?: AxiosRequestConfig) {
        return SectionsApiFp(this.configuration).create(extendedCreateSectionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectionsApi
     */
    public findAll(seasonId: number, options?: AxiosRequestConfig) {
        return SectionsApiFp(this.configuration).findAll(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} departmentId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectionsApi
     */
    public findAllByDepartment(departmentId: number, seasonId: number, options?: AxiosRequestConfig) {
        return SectionsApiFp(this.configuration).findAllByDepartment(departmentId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectionsApi
     */
    public findEnabledSections(seasonId: number, options?: AxiosRequestConfig) {
        return SectionsApiFp(this.configuration).findEnabledSections(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectionsApi
     */
    public findOne(id: number, seasonId: number, options?: AxiosRequestConfig) {
        return SectionsApiFp(this.configuration).findOne(id, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectionsApi
     */
    public findTicketingSections(seasonId: number, options?: AxiosRequestConfig) {
        return SectionsApiFp(this.configuration).findTicketingSections(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectionsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return SectionsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ExtendedUpdateSectionDto} extendedUpdateSectionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectionsApi
     */
    public update(id: string, extendedUpdateSectionDto: ExtendedUpdateSectionDto, options?: AxiosRequestConfig) {
        return SectionsApiFp(this.configuration).update(id, extendedUpdateSectionDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SegmentApi - axios parameter creator
 * @export
 */
export const SegmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            const localVarPath = `/api/v1/segment/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSegmentDto} createSegmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createSegmentDto: CreateSegmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSegmentDto' is not null or undefined
            assertParamExists('create', 'createSegmentDto', createSegmentDto)
            const localVarPath = `/api/v1/segment/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSegmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/segment/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllWithCount: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAllWithCount', 'seasonId', seasonId)
            const localVarPath = `/api/v1/segment/allWithCount/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByUser: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findByUser', 'seasonId', seasonId)
            const localVarPath = `/api/v1/segment/byUser/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SegmentApi - functional programming interface
 * @export
 */
export const SegmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SegmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateSegmentDto} createSegmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createSegmentDto: CreateSegmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createSegmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SegmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllWithCount(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SegmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllWithCount(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByUser(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SegmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByUser(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SegmentApi - factory interface
 * @export
 */
export const SegmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SegmentApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSegmentDto} createSegmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createSegmentDto: CreateSegmentDto, options?: any): AxiosPromise<void> {
            return localVarFp.create(createSegmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<SegmentEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllWithCount(seasonId: number, options?: any): AxiosPromise<Array<SegmentEntity>> {
            return localVarFp.findAllWithCount(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByUser(seasonId: number, options?: any): AxiosPromise<Array<SegmentEntity>> {
            return localVarFp.findByUser(seasonId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SegmentApi - object-oriented interface
 * @export
 * @class SegmentApi
 * @extends {BaseAPI}
 */
export class SegmentApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentApi
     */
    public _delete(id: number, options?: AxiosRequestConfig) {
        return SegmentApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSegmentDto} createSegmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentApi
     */
    public create(createSegmentDto: CreateSegmentDto, options?: AxiosRequestConfig) {
        return SegmentApiFp(this.configuration).create(createSegmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return SegmentApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentApi
     */
    public findAllWithCount(seasonId: number, options?: AxiosRequestConfig) {
        return SegmentApiFp(this.configuration).findAllWithCount(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentApi
     */
    public findByUser(seasonId: number, options?: AxiosRequestConfig) {
        return SegmentApiFp(this.configuration).findByUser(seasonId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShiftApi - axios parameter creator
 * @export
 */
export const ShiftApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allAvailabilityRequests: async (departmentId?: number, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shift/allRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AssignShiftToEmployeeDto} assignShiftToEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignEmployee: async (assignShiftToEmployeeDto: AssignShiftToEmployeeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignShiftToEmployeeDto' is not null or undefined
            assertParamExists('assignEmployee', 'assignShiftToEmployeeDto', assignShiftToEmployeeDto)
            const localVarPath = `/api/v1/shift/assignEmployee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignShiftToEmployeeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} seasonId 
         * @param {number} [departmentId] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availabilityRequestsByManager: async (startDate: string, endDate: string, seasonId: number, departmentId?: number, expirationDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('availabilityRequestsByManager', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('availabilityRequestsByManager', 'endDate', endDate)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('availabilityRequestsByManager', 'seasonId', seasonId)
            const localVarPath = `/api/v1/shift/requestsByManager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (expirationDate !== undefined) {
                localVarQueryParameter['expirationDate'] = (expirationDate as any instanceof Date) ?
                    (expirationDate as any).toISOString() :
                    expirationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets the order/priority of subordinates for the logged-in employee in specific departments and seasons. Accepts an array of subordinate order configurations. Accessible to DEPCHIEF and above (not regular USERs).
         * @summary Configure subordinate order
         * @param {ConfigureSubordinateOrderDto} configureSubordinateOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configureSubordinateOrder: async (configureSubordinateOrderDto: ConfigureSubordinateOrderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configureSubordinateOrderDto' is not null or undefined
            assertParamExists('configureSubordinateOrder', 'configureSubordinateOrderDto', configureSubordinateOrderDto)
            const localVarPath = `/api/v1/shift/configureSubordinateOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configureSubordinateOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AcceptAvaibilityDto} acceptAvaibilityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmRequests: async (acceptAvaibilityDto: AcceptAvaibilityDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptAvaibilityDto' is not null or undefined
            assertParamExists('confirmRequests', 'acceptAvaibilityDto', acceptAvaibilityDto)
            const localVarPath = `/api/v1/shift/confirmRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptAvaibilityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CopyShiftPlanDto} copyShiftPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyShiftPlan: async (copyShiftPlanDto: CopyShiftPlanDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'copyShiftPlanDto' is not null or undefined
            assertParamExists('copyShiftPlan', 'copyShiftPlanDto', copyShiftPlanDto)
            const localVarPath = `/api/v1/shift/copyShiftPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyShiftPlanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateShiftDto} createShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createShiftDto: CreateShiftDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createShiftDto' is not null or undefined
            assertParamExists('create', 'createShiftDto', createShiftDto)
            const localVarPath = `/api/v1/shift`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShiftDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateAvailabilityRequestsDto} createAvailabilityRequestsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAviabilityRequests: async (createAvailabilityRequestsDto: CreateAvailabilityRequestsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAvailabilityRequestsDto' is not null or undefined
            assertParamExists('createAviabilityRequests', 'createAvailabilityRequestsDto', createAvailabilityRequestsDto)
            const localVarPath = `/api/v1/shift/createAviabilityRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAvailabilityRequestsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateShiftDetailWithChoiceDto} createShiftDetailWithChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDetailWithChoice: async (createShiftDetailWithChoiceDto: CreateShiftDetailWithChoiceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createShiftDetailWithChoiceDto' is not null or undefined
            assertParamExists('createDetailWithChoice', 'createShiftDetailWithChoiceDto', createShiftDetailWithChoiceDto)
            const localVarPath = `/api/v1/shift/createDetailWithChoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShiftDetailWithChoiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateShiftDetailDto} createShiftDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShiftDetails: async (createShiftDetailDto: CreateShiftDetailDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createShiftDetailDto' is not null or undefined
            assertParamExists('createShiftDetails', 'createShiftDetailDto', createShiftDetailDto)
            const localVarPath = `/api/v1/shift/shiftDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShiftDetailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} seasonId 
         * @param {string} date 
         * @param {string} checkAvailability 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAssignableShiftDetailsForEmployee: async (employeeId: string, seasonId: string, date: string, checkAvailability: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findAssignableShiftDetailsForEmployee', 'employeeId', employeeId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAssignableShiftDetailsForEmployee', 'seasonId', seasonId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('findAssignableShiftDetailsForEmployee', 'date', date)
            // verify required parameter 'checkAvailability' is not null or undefined
            assertParamExists('findAssignableShiftDetailsForEmployee', 'checkAvailability', checkAvailability)
            const localVarPath = `/api/v1/shift/assignableShiftDetails/{employeeId}/{seasonId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (checkAvailability !== undefined) {
                localVarQueryParameter['checkAvailability'] = checkAvailability;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAssignments: async (id: number, departmentId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findAssignments', 'id', id)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('findAssignments', 'departmentId', departmentId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAssignments', 'seasonId', seasonId)
            const localVarPath = `/api/v1/shift/findAssignments/{id}/{departmentId}/{seasonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAssignmentsForUser: async (employeeId: string, seasonId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findAssignmentsForUser', 'employeeId', employeeId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAssignmentsForUser', 'seasonId', seasonId)
            const localVarPath = `/api/v1/shift/assignmentsById/{employeeId}/{seasonId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByTemplate: async (id: number, departmentId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findByTemplate', 'id', id)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('findByTemplate', 'departmentId', departmentId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findByTemplate', 'seasonId', seasonId)
            const localVarPath = `/api/v1/shift/{id}/{departmentId}/{seasonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyExpiredRequests: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shift/expiredRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyRequests: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shift/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findShiftDetails: async (id: number, departmentId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findShiftDetails', 'id', id)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('findShiftDetails', 'departmentId', departmentId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findShiftDetails', 'seasonId', seasonId)
            const localVarPath = `/api/v1/shift/findShiftDetails/{id}/{departmentId}/{seasonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUserAssignments: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shift/assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeesToPublish: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shift/employeesToPublish`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns comprehensive statistics about shifts including employees on duty, hourly breakdown, department averages, and more.
         * @summary Get shift statistics
         * @param {string} [startDate] Optional start date for the period. If not provided, uses current date. If endDate is also provided, calculates statistics for the date range.
         * @param {string} [endDate] Optional end date for the period. If not provided and startDate is provided, uses startDate (single day). If neither is provided, uses current date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShiftStatistics: async (startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shift/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the ordered list of subordinates for the current user (extracted from token) in the specified department and season.
         * @summary Get subordinate order for current user
         * @param {string} departmentId 
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubordinateOrder: async (departmentId: string, seasonId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('getSubordinateOrder', 'departmentId', departmentId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getSubordinateOrder', 'seasonId', seasonId)
            const localVarPath = `/api/v1/shift/subordinateOrder/{departmentId}/{seasonId}`
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} seasonId 
         * @param {number} [departmentId] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasAvailabilityBeenSent: async (startDate: string, endDate: string, seasonId: number, departmentId?: number, expirationDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('hasAvailabilityBeenSent', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('hasAvailabilityBeenSent', 'endDate', endDate)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('hasAvailabilityBeenSent', 'seasonId', seasonId)
            const localVarPath = `/api/v1/shift/availabilityForTheDay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (expirationDate !== undefined) {
                localVarQueryParameter['expirationDate'] = (expirationDate as any instanceof Date) ?
                    (expirationDate as any).toISOString() :
                    expirationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} seasonId Season ID
         * @param {number} [departmentId] Optional department ID for DEPCHIEF access validation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hoursForPeriod: async (startDate: string, endDate: string, seasonId: number, departmentId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('hoursForPeriod', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('hoursForPeriod', 'endDate', endDate)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('hoursForPeriod', 'seasonId', seasonId)
            const localVarPath = `/api/v1/shift/hoursForPeriod`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} seasonId Season ID
         * @param {number} [departmentId] Optional department ID for DEPCHIEF access validation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hoursForPeriodDaily: async (startDate: string, endDate: string, seasonId: number, departmentId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('hoursForPeriodDaily', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('hoursForPeriodDaily', 'endDate', endDate)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('hoursForPeriodDaily', 'seasonId', seasonId)
            const localVarPath = `/api/v1/shift/hoursForPeriodDaily`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isUpdate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shift/isUpdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: number, departmentId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('remove', 'departmentId', departmentId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('remove', 'seasonId', seasonId)
            const localVarPath = `/api/v1/shift/{id}/{departmentId}/{seasonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDetail: async (id: number, departmentId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeDetail', 'id', id)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('removeDetail', 'departmentId', departmentId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('removeDetail', 'seasonId', seasonId)
            const localVarPath = `/api/v1/shift/deleteDetail/{id}/{departmentId}/{seasonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {RemoveShiftDetailWithChoiceDto} removeShiftDetailWithChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDetailWithChoice: async (id: number, removeShiftDetailWithChoiceDto: RemoveShiftDetailWithChoiceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeDetailWithChoice', 'id', id)
            // verify required parameter 'removeShiftDetailWithChoiceDto' is not null or undefined
            assertParamExists('removeDetailWithChoice', 'removeShiftDetailWithChoiceDto', removeShiftDetailWithChoiceDto)
            const localVarPath = `/api/v1/shift/removeDetailWithChoice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeShiftDetailWithChoiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEmployeeAssingment: async (id: number, departmentId: number, seasonId: number, employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeEmployeeAssingment', 'id', id)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('removeEmployeeAssingment', 'departmentId', departmentId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('removeEmployeeAssingment', 'seasonId', seasonId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('removeEmployeeAssingment', 'employeeId', employeeId)
            const localVarPath = `/api/v1/shift/deleteEmployeeAssignment/{id}/{departmentId}/{seasonId}/{employeeId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RepeatShiftPlanDto} repeatShiftPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repeatShiftPlan: async (repeatShiftPlanDto: RepeatShiftPlanDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repeatShiftPlanDto' is not null or undefined
            assertParamExists('repeatShiftPlan', 'repeatShiftPlanDto', repeatShiftPlanDto)
            const localVarPath = `/api/v1/shift/repeatShiftPlan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repeatShiftPlanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendShifts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shift/sendShifts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateShiftDto} updateShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: number, updateShiftDto: UpdateShiftDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateShiftDto' is not null or undefined
            assertParamExists('update', 'updateShiftDto', updateShiftDto)
            const localVarPath = `/api/v1/shift/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateShiftDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateAvailabilityRequestDto} updateAvailabilityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailability: async (id: number, updateAvailabilityRequestDto: UpdateAvailabilityRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAvailability', 'id', id)
            // verify required parameter 'updateAvailabilityRequestDto' is not null or undefined
            assertParamExists('updateAvailability', 'updateAvailabilityRequestDto', updateAvailabilityRequestDto)
            const localVarPath = `/api/v1/shift/updateAvailability/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAvailabilityRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateShiftDetailWithChoiceDto} updateShiftDetailWithChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDetailWithChoice: async (id: number, updateShiftDetailWithChoiceDto: UpdateShiftDetailWithChoiceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDetailWithChoice', 'id', id)
            // verify required parameter 'updateShiftDetailWithChoiceDto' is not null or undefined
            assertParamExists('updateDetailWithChoice', 'updateShiftDetailWithChoiceDto', updateShiftDetailWithChoiceDto)
            const localVarPath = `/api/v1/shift/updateDetailWithChoice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateShiftDetailWithChoiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrDuplicate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shift/updateOrDuplicate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateShiftAndDetailsWithChoiceDto} updateShiftAndDetailsWithChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShiftAndDetailsWithChoice: async (id: number, updateShiftAndDetailsWithChoiceDto: UpdateShiftAndDetailsWithChoiceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateShiftAndDetailsWithChoice', 'id', id)
            // verify required parameter 'updateShiftAndDetailsWithChoiceDto' is not null or undefined
            assertParamExists('updateShiftAndDetailsWithChoice', 'updateShiftAndDetailsWithChoiceDto', updateShiftAndDetailsWithChoiceDto)
            const localVarPath = `/api/v1/shift/updateShiftAndDetailsWithChoice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateShiftAndDetailsWithChoiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {UpdateShiftDetailDto} updateShiftDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShiftDetails: async (id: number, departmentId: number, updateShiftDetailDto: UpdateShiftDetailDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateShiftDetails', 'id', id)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('updateShiftDetails', 'departmentId', departmentId)
            // verify required parameter 'updateShiftDetailDto' is not null or undefined
            assertParamExists('updateShiftDetails', 'updateShiftDetailDto', updateShiftDetailDto)
            const localVarPath = `/api/v1/shift/updateShiftDetail/{id}/{departmentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"departmentId"}}`, encodeURIComponent(String(departmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateShiftDetailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateShiftWithChoiceDto} updateShiftWithChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWithChoice: async (id: number, updateShiftWithChoiceDto: UpdateShiftWithChoiceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateWithChoice', 'id', id)
            // verify required parameter 'updateShiftWithChoiceDto' is not null or undefined
            assertParamExists('updateWithChoice', 'updateShiftWithChoiceDto', updateShiftWithChoiceDto)
            const localVarPath = `/api/v1/shift/updateWithChoice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateShiftWithChoiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {string} date 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weeklyEmployeeHours: async (employeeId: number, date: string, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('weeklyEmployeeHours', 'employeeId', employeeId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('weeklyEmployeeHours', 'date', date)
            const localVarPath = `/api/v1/shift/weeklyHours`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches weekly worked hours for specified employees. This is a bulk endpoint to reduce the number of requests when fetching hours for multiple employees. Returns an array with employeeId and hours for each employee.
         * @summary Get weekly hours for multiple employees in a single request
         * @param {EmployeeWeeklyHoursBulkDto} employeeWeeklyHoursBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weeklyEmployeeHoursBulk: async (employeeWeeklyHoursBulkDto: EmployeeWeeklyHoursBulkDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeWeeklyHoursBulkDto' is not null or undefined
            assertParamExists('weeklyEmployeeHoursBulk', 'employeeWeeklyHoursBulkDto', employeeWeeklyHoursBulkDto)
            const localVarPath = `/api/v1/shift/weeklyHoursBulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeWeeklyHoursBulkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShiftApi - functional programming interface
 * @export
 */
export const ShiftApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShiftApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allAvailabilityRequests(departmentId?: number, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftAvailabilityRequestEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allAvailabilityRequests(departmentId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AssignShiftToEmployeeDto} assignShiftToEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignEmployee(assignShiftToEmployeeDto: AssignShiftToEmployeeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignEmployee(assignShiftToEmployeeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} seasonId 
         * @param {number} [departmentId] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async availabilityRequestsByManager(startDate: string, endDate: string, seasonId: number, departmentId?: number, expirationDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftAvailabilityRequestEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.availabilityRequestsByManager(startDate, endDate, seasonId, departmentId, expirationDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sets the order/priority of subordinates for the logged-in employee in specific departments and seasons. Accepts an array of subordinate order configurations. Accessible to DEPCHIEF and above (not regular USERs).
         * @summary Configure subordinate order
         * @param {ConfigureSubordinateOrderDto} configureSubordinateOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configureSubordinateOrder(configureSubordinateOrderDto: ConfigureSubordinateOrderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubordinateOrderEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configureSubordinateOrder(configureSubordinateOrderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AcceptAvaibilityDto} acceptAvaibilityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmRequests(acceptAvaibilityDto: AcceptAvaibilityDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmRequests(acceptAvaibilityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CopyShiftPlanDto} copyShiftPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyShiftPlan(copyShiftPlanDto: CopyShiftPlanDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyShiftPlan(copyShiftPlanDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateShiftDto} createShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createShiftDto: CreateShiftDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createShiftDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateAvailabilityRequestsDto} createAvailabilityRequestsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAviabilityRequests(createAvailabilityRequestsDto: CreateAvailabilityRequestsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAviabilityRequests(createAvailabilityRequestsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateShiftDetailWithChoiceDto} createShiftDetailWithChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDetailWithChoice(createShiftDetailWithChoiceDto: CreateShiftDetailWithChoiceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDetailWithChoice(createShiftDetailWithChoiceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateShiftDetailDto} createShiftDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShiftDetails(createShiftDetailDto: CreateShiftDetailDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftDetailEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShiftDetails(createShiftDetailDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} seasonId 
         * @param {string} date 
         * @param {string} checkAvailability 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAssignableShiftDetailsForEmployee(employeeId: string, seasonId: string, date: string, checkAvailability: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftDetailEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAssignableShiftDetailsForEmployee(employeeId, seasonId, date, checkAvailability, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAssignments(id: number, departmentId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftAssignmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAssignments(id, departmentId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAssignmentsForUser(employeeId: string, seasonId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftAssignmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAssignmentsForUser(employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByTemplate(id: number, departmentId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByTemplate(id, departmentId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findMyExpiredRequests(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftAvailabilityEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findMyExpiredRequests(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findMyRequests(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftAvailabilityEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findMyRequests(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findShiftDetails(id: number, departmentId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftDetailEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findShiftDetails(id, departmentId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUserAssignments(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftAssignmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUserAssignments(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeesToPublish(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeesToPublish(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns comprehensive statistics about shifts including employees on duty, hourly breakdown, department averages, and more.
         * @summary Get shift statistics
         * @param {string} [startDate] Optional start date for the period. If not provided, uses current date. If endDate is also provided, calculates statistics for the date range.
         * @param {string} [endDate] Optional end date for the period. If not provided and startDate is provided, uses startDate (single day). If neither is provided, uses current date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShiftStatistics(startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftStatisticsEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShiftStatistics(startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the ordered list of subordinates for the current user (extracted from token) in the specified department and season.
         * @summary Get subordinate order for current user
         * @param {string} departmentId 
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubordinateOrder(departmentId: string, seasonId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubordinateOrderEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubordinateOrder(departmentId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} seasonId 
         * @param {number} [departmentId] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hasAvailabilityBeenSent(startDate: string, endDate: string, seasonId: number, departmentId?: number, expirationDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hasAvailabilityBeenSent(startDate, endDate, seasonId, departmentId, expirationDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} seasonId Season ID
         * @param {number} [departmentId] Optional department ID for DEPCHIEF access validation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hoursForPeriod(startDate: string, endDate: string, seasonId: number, departmentId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeHoursDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hoursForPeriod(startDate, endDate, seasonId, departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} seasonId Season ID
         * @param {number} [departmentId] Optional department ID for DEPCHIEF access validation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hoursForPeriodDaily(startDate: string, endDate: string, seasonId: number, departmentId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeHoursDailyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hoursForPeriodDaily(startDate, endDate, seasonId, departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isUpdate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isUpdate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: number, departmentId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, departmentId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDetail(id: number, departmentId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDetail(id, departmentId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {RemoveShiftDetailWithChoiceDto} removeShiftDetailWithChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDetailWithChoice(id: number, removeShiftDetailWithChoiceDto: RemoveShiftDetailWithChoiceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDetailWithChoice(id, removeShiftDetailWithChoiceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEmployeeAssingment(id: number, departmentId: number, seasonId: number, employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEmployeeAssingment(id, departmentId, seasonId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RepeatShiftPlanDto} repeatShiftPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repeatShiftPlan(repeatShiftPlanDto: RepeatShiftPlanDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repeatShiftPlan(repeatShiftPlanDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendShifts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendShifts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateShiftDto} updateShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: number, updateShiftDto: UpdateShiftDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateShiftDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateAvailabilityRequestDto} updateAvailabilityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAvailability(id: number, updateAvailabilityRequestDto: UpdateAvailabilityRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftAvailabilityRequestEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAvailability(id, updateAvailabilityRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateShiftDetailWithChoiceDto} updateShiftDetailWithChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDetailWithChoice(id: number, updateShiftDetailWithChoiceDto: UpdateShiftDetailWithChoiceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDetailWithChoice(id, updateShiftDetailWithChoiceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrDuplicate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrDuplicate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateShiftAndDetailsWithChoiceDto} updateShiftAndDetailsWithChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateShiftAndDetailsWithChoice(id: number, updateShiftAndDetailsWithChoiceDto: UpdateShiftAndDetailsWithChoiceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateShiftAndDetailsWithChoice(id, updateShiftAndDetailsWithChoiceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {UpdateShiftDetailDto} updateShiftDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateShiftDetails(id: number, departmentId: number, updateShiftDetailDto: UpdateShiftDetailDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateShiftDetails(id, departmentId, updateShiftDetailDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateShiftWithChoiceDto} updateShiftWithChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWithChoice(id: number, updateShiftWithChoiceDto: UpdateShiftWithChoiceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWithChoice(id, updateShiftWithChoiceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {string} date 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async weeklyEmployeeHours(employeeId: number, date: string, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.weeklyEmployeeHours(employeeId, date, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetches weekly worked hours for specified employees. This is a bulk endpoint to reduce the number of requests when fetching hours for multiple employees. Returns an array with employeeId and hours for each employee.
         * @summary Get weekly hours for multiple employees in a single request
         * @param {EmployeeWeeklyHoursBulkDto} employeeWeeklyHoursBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async weeklyEmployeeHoursBulk(employeeWeeklyHoursBulkDto: EmployeeWeeklyHoursBulkDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeWeeklyHoursResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.weeklyEmployeeHoursBulk(employeeWeeklyHoursBulkDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShiftApi - factory interface
 * @export
 */
export const ShiftApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShiftApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allAvailabilityRequests(departmentId?: number, seasonId?: number, options?: any): AxiosPromise<Array<ShiftAvailabilityRequestEntity>> {
            return localVarFp.allAvailabilityRequests(departmentId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AssignShiftToEmployeeDto} assignShiftToEmployeeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignEmployee(assignShiftToEmployeeDto: AssignShiftToEmployeeDto, options?: any): AxiosPromise<void> {
            return localVarFp.assignEmployee(assignShiftToEmployeeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} seasonId 
         * @param {number} [departmentId] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availabilityRequestsByManager(startDate: string, endDate: string, seasonId: number, departmentId?: number, expirationDate?: string, options?: any): AxiosPromise<Array<ShiftAvailabilityRequestEntity>> {
            return localVarFp.availabilityRequestsByManager(startDate, endDate, seasonId, departmentId, expirationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets the order/priority of subordinates for the logged-in employee in specific departments and seasons. Accepts an array of subordinate order configurations. Accessible to DEPCHIEF and above (not regular USERs).
         * @summary Configure subordinate order
         * @param {ConfigureSubordinateOrderDto} configureSubordinateOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configureSubordinateOrder(configureSubordinateOrderDto: ConfigureSubordinateOrderDto, options?: any): AxiosPromise<Array<SubordinateOrderEntity>> {
            return localVarFp.configureSubordinateOrder(configureSubordinateOrderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AcceptAvaibilityDto} acceptAvaibilityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmRequests(acceptAvaibilityDto: AcceptAvaibilityDto, options?: any): AxiosPromise<void> {
            return localVarFp.confirmRequests(acceptAvaibilityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CopyShiftPlanDto} copyShiftPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyShiftPlan(copyShiftPlanDto: CopyShiftPlanDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.copyShiftPlan(copyShiftPlanDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateShiftDto} createShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createShiftDto: CreateShiftDto, options?: any): AxiosPromise<ShiftEntity> {
            return localVarFp.create(createShiftDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateAvailabilityRequestsDto} createAvailabilityRequestsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAviabilityRequests(createAvailabilityRequestsDto: CreateAvailabilityRequestsDto, options?: any): AxiosPromise<void> {
            return localVarFp.createAviabilityRequests(createAvailabilityRequestsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateShiftDetailWithChoiceDto} createShiftDetailWithChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDetailWithChoice(createShiftDetailWithChoiceDto: CreateShiftDetailWithChoiceDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createDetailWithChoice(createShiftDetailWithChoiceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateShiftDetailDto} createShiftDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShiftDetails(createShiftDetailDto: CreateShiftDetailDto, options?: any): AxiosPromise<Array<ShiftDetailEntity>> {
            return localVarFp.createShiftDetails(createShiftDetailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} seasonId 
         * @param {string} date 
         * @param {string} checkAvailability 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAssignableShiftDetailsForEmployee(employeeId: string, seasonId: string, date: string, checkAvailability: string, options?: any): AxiosPromise<Array<ShiftDetailEntity>> {
            return localVarFp.findAssignableShiftDetailsForEmployee(employeeId, seasonId, date, checkAvailability, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAssignments(id: number, departmentId: number, seasonId: number, options?: any): AxiosPromise<Array<ShiftAssignmentEntity>> {
            return localVarFp.findAssignments(id, departmentId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} employeeId 
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAssignmentsForUser(employeeId: string, seasonId: string, options?: any): AxiosPromise<Array<ShiftAssignmentEntity>> {
            return localVarFp.findAssignmentsForUser(employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByTemplate(id: number, departmentId: number, seasonId: number, options?: any): AxiosPromise<Array<ShiftEntity>> {
            return localVarFp.findByTemplate(id, departmentId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyExpiredRequests(options?: any): AxiosPromise<Array<ShiftAvailabilityEntity>> {
            return localVarFp.findMyExpiredRequests(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findMyRequests(options?: any): AxiosPromise<Array<ShiftAvailabilityEntity>> {
            return localVarFp.findMyRequests(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findShiftDetails(id: number, departmentId: number, seasonId: number, options?: any): AxiosPromise<Array<ShiftDetailEntity>> {
            return localVarFp.findShiftDetails(id, departmentId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUserAssignments(options?: any): AxiosPromise<Array<ShiftAssignmentEntity>> {
            return localVarFp.findUserAssignments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeesToPublish(options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.getEmployeesToPublish(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns comprehensive statistics about shifts including employees on duty, hourly breakdown, department averages, and more.
         * @summary Get shift statistics
         * @param {string} [startDate] Optional start date for the period. If not provided, uses current date. If endDate is also provided, calculates statistics for the date range.
         * @param {string} [endDate] Optional end date for the period. If not provided and startDate is provided, uses startDate (single day). If neither is provided, uses current date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShiftStatistics(startDate?: string, endDate?: string, options?: any): AxiosPromise<ShiftStatisticsEntity> {
            return localVarFp.getShiftStatistics(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the ordered list of subordinates for the current user (extracted from token) in the specified department and season.
         * @summary Get subordinate order for current user
         * @param {string} departmentId 
         * @param {string} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubordinateOrder(departmentId: string, seasonId: string, options?: any): AxiosPromise<Array<SubordinateOrderEntity>> {
            return localVarFp.getSubordinateOrder(departmentId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} seasonId 
         * @param {number} [departmentId] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasAvailabilityBeenSent(startDate: string, endDate: string, seasonId: number, departmentId?: number, expirationDate?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.hasAvailabilityBeenSent(startDate, endDate, seasonId, departmentId, expirationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} seasonId Season ID
         * @param {number} [departmentId] Optional department ID for DEPCHIEF access validation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hoursForPeriod(startDate: string, endDate: string, seasonId: number, departmentId?: number, options?: any): AxiosPromise<Array<EmployeeHoursDto>> {
            return localVarFp.hoursForPeriod(startDate, endDate, seasonId, departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} seasonId Season ID
         * @param {number} [departmentId] Optional department ID for DEPCHIEF access validation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hoursForPeriodDaily(startDate: string, endDate: string, seasonId: number, departmentId?: number, options?: any): AxiosPromise<Array<EmployeeHoursDailyDto>> {
            return localVarFp.hoursForPeriodDaily(startDate, endDate, seasonId, departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isUpdate(options?: any): AxiosPromise<object> {
            return localVarFp.isUpdate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: number, departmentId: number, seasonId: number, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, departmentId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDetail(id: number, departmentId: number, seasonId: number, options?: any): AxiosPromise<void> {
            return localVarFp.removeDetail(id, departmentId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {RemoveShiftDetailWithChoiceDto} removeShiftDetailWithChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDetailWithChoice(id: number, removeShiftDetailWithChoiceDto: RemoveShiftDetailWithChoiceDto, options?: any): AxiosPromise<object> {
            return localVarFp.removeDetailWithChoice(id, removeShiftDetailWithChoiceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEmployeeAssingment(id: number, departmentId: number, seasonId: number, employeeId: number, options?: any): AxiosPromise<void> {
            return localVarFp.removeEmployeeAssingment(id, departmentId, seasonId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RepeatShiftPlanDto} repeatShiftPlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repeatShiftPlan(repeatShiftPlanDto: RepeatShiftPlanDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.repeatShiftPlan(repeatShiftPlanDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendShifts(options?: any): AxiosPromise<void> {
            return localVarFp.sendShifts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateShiftDto} updateShiftDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: number, updateShiftDto: UpdateShiftDto, options?: any): AxiosPromise<ShiftEntity> {
            return localVarFp.update(id, updateShiftDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateAvailabilityRequestDto} updateAvailabilityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailability(id: number, updateAvailabilityRequestDto: UpdateAvailabilityRequestDto, options?: any): AxiosPromise<ShiftAvailabilityRequestEntity> {
            return localVarFp.updateAvailability(id, updateAvailabilityRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateShiftDetailWithChoiceDto} updateShiftDetailWithChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDetailWithChoice(id: number, updateShiftDetailWithChoiceDto: UpdateShiftDetailWithChoiceDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateDetailWithChoice(id, updateShiftDetailWithChoiceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrDuplicate(options?: any): AxiosPromise<ShiftEntity> {
            return localVarFp.updateOrDuplicate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateShiftAndDetailsWithChoiceDto} updateShiftAndDetailsWithChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShiftAndDetailsWithChoice(id: number, updateShiftAndDetailsWithChoiceDto: UpdateShiftAndDetailsWithChoiceDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateShiftAndDetailsWithChoice(id, updateShiftAndDetailsWithChoiceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} departmentId 
         * @param {UpdateShiftDetailDto} updateShiftDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShiftDetails(id: number, departmentId: number, updateShiftDetailDto: UpdateShiftDetailDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateShiftDetails(id, departmentId, updateShiftDetailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateShiftWithChoiceDto} updateShiftWithChoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWithChoice(id: number, updateShiftWithChoiceDto: UpdateShiftWithChoiceDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateWithChoice(id, updateShiftWithChoiceDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {string} date 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weeklyEmployeeHours(employeeId: number, date: string, seasonId?: number, options?: any): AxiosPromise<number> {
            return localVarFp.weeklyEmployeeHours(employeeId, date, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches weekly worked hours for specified employees. This is a bulk endpoint to reduce the number of requests when fetching hours for multiple employees. Returns an array with employeeId and hours for each employee.
         * @summary Get weekly hours for multiple employees in a single request
         * @param {EmployeeWeeklyHoursBulkDto} employeeWeeklyHoursBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        weeklyEmployeeHoursBulk(employeeWeeklyHoursBulkDto: EmployeeWeeklyHoursBulkDto, options?: any): AxiosPromise<Array<EmployeeWeeklyHoursResponseDto>> {
            return localVarFp.weeklyEmployeeHoursBulk(employeeWeeklyHoursBulkDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShiftApi - object-oriented interface
 * @export
 * @class ShiftApi
 * @extends {BaseAPI}
 */
export class ShiftApi extends BaseAPI {
    /**
     * 
     * @param {number} [departmentId] 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public allAvailabilityRequests(departmentId?: number, seasonId?: number, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).allAvailabilityRequests(departmentId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AssignShiftToEmployeeDto} assignShiftToEmployeeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public assignEmployee(assignShiftToEmployeeDto: AssignShiftToEmployeeDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).assignEmployee(assignShiftToEmployeeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {number} seasonId 
     * @param {number} [departmentId] 
     * @param {string} [expirationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public availabilityRequestsByManager(startDate: string, endDate: string, seasonId: number, departmentId?: number, expirationDate?: string, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).availabilityRequestsByManager(startDate, endDate, seasonId, departmentId, expirationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets the order/priority of subordinates for the logged-in employee in specific departments and seasons. Accepts an array of subordinate order configurations. Accessible to DEPCHIEF and above (not regular USERs).
     * @summary Configure subordinate order
     * @param {ConfigureSubordinateOrderDto} configureSubordinateOrderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public configureSubordinateOrder(configureSubordinateOrderDto: ConfigureSubordinateOrderDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).configureSubordinateOrder(configureSubordinateOrderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AcceptAvaibilityDto} acceptAvaibilityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public confirmRequests(acceptAvaibilityDto: AcceptAvaibilityDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).confirmRequests(acceptAvaibilityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CopyShiftPlanDto} copyShiftPlanDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public copyShiftPlan(copyShiftPlanDto: CopyShiftPlanDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).copyShiftPlan(copyShiftPlanDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateShiftDto} createShiftDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public create(createShiftDto: CreateShiftDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).create(createShiftDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateAvailabilityRequestsDto} createAvailabilityRequestsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public createAviabilityRequests(createAvailabilityRequestsDto: CreateAvailabilityRequestsDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).createAviabilityRequests(createAvailabilityRequestsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateShiftDetailWithChoiceDto} createShiftDetailWithChoiceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public createDetailWithChoice(createShiftDetailWithChoiceDto: CreateShiftDetailWithChoiceDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).createDetailWithChoice(createShiftDetailWithChoiceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateShiftDetailDto} createShiftDetailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public createShiftDetails(createShiftDetailDto: CreateShiftDetailDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).createShiftDetails(createShiftDetailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {string} seasonId 
     * @param {string} date 
     * @param {string} checkAvailability 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public findAssignableShiftDetailsForEmployee(employeeId: string, seasonId: string, date: string, checkAvailability: string, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).findAssignableShiftDetailsForEmployee(employeeId, seasonId, date, checkAvailability, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} departmentId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public findAssignments(id: number, departmentId: number, seasonId: number, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).findAssignments(id, departmentId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} employeeId 
     * @param {string} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public findAssignmentsForUser(employeeId: string, seasonId: string, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).findAssignmentsForUser(employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} departmentId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public findByTemplate(id: number, departmentId: number, seasonId: number, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).findByTemplate(id, departmentId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public findMyExpiredRequests(options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).findMyExpiredRequests(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public findMyRequests(options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).findMyRequests(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} departmentId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public findShiftDetails(id: number, departmentId: number, seasonId: number, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).findShiftDetails(id, departmentId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public findUserAssignments(options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).findUserAssignments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public getEmployeesToPublish(options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).getEmployeesToPublish(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns comprehensive statistics about shifts including employees on duty, hourly breakdown, department averages, and more.
     * @summary Get shift statistics
     * @param {string} [startDate] Optional start date for the period. If not provided, uses current date. If endDate is also provided, calculates statistics for the date range.
     * @param {string} [endDate] Optional end date for the period. If not provided and startDate is provided, uses startDate (single day). If neither is provided, uses current date.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public getShiftStatistics(startDate?: string, endDate?: string, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).getShiftStatistics(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the ordered list of subordinates for the current user (extracted from token) in the specified department and season.
     * @summary Get subordinate order for current user
     * @param {string} departmentId 
     * @param {string} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public getSubordinateOrder(departmentId: string, seasonId: string, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).getSubordinateOrder(departmentId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {number} seasonId 
     * @param {number} [departmentId] 
     * @param {string} [expirationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public hasAvailabilityBeenSent(startDate: string, endDate: string, seasonId: number, departmentId?: number, expirationDate?: string, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).hasAvailabilityBeenSent(startDate, endDate, seasonId, departmentId, expirationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {number} seasonId Season ID
     * @param {number} [departmentId] Optional department ID for DEPCHIEF access validation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public hoursForPeriod(startDate: string, endDate: string, seasonId: number, departmentId?: number, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).hoursForPeriod(startDate, endDate, seasonId, departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {number} seasonId Season ID
     * @param {number} [departmentId] Optional department ID for DEPCHIEF access validation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public hoursForPeriodDaily(startDate: string, endDate: string, seasonId: number, departmentId?: number, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).hoursForPeriodDaily(startDate, endDate, seasonId, departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public isUpdate(options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).isUpdate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} departmentId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public remove(id: number, departmentId: number, seasonId: number, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).remove(id, departmentId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} departmentId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public removeDetail(id: number, departmentId: number, seasonId: number, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).removeDetail(id, departmentId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {RemoveShiftDetailWithChoiceDto} removeShiftDetailWithChoiceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public removeDetailWithChoice(id: number, removeShiftDetailWithChoiceDto: RemoveShiftDetailWithChoiceDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).removeDetailWithChoice(id, removeShiftDetailWithChoiceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} departmentId 
     * @param {number} seasonId 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public removeEmployeeAssingment(id: number, departmentId: number, seasonId: number, employeeId: number, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).removeEmployeeAssingment(id, departmentId, seasonId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RepeatShiftPlanDto} repeatShiftPlanDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public repeatShiftPlan(repeatShiftPlanDto: RepeatShiftPlanDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).repeatShiftPlan(repeatShiftPlanDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public sendShifts(options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).sendShifts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateShiftDto} updateShiftDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public update(id: number, updateShiftDto: UpdateShiftDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).update(id, updateShiftDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateAvailabilityRequestDto} updateAvailabilityRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public updateAvailability(id: number, updateAvailabilityRequestDto: UpdateAvailabilityRequestDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).updateAvailability(id, updateAvailabilityRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateShiftDetailWithChoiceDto} updateShiftDetailWithChoiceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public updateDetailWithChoice(id: number, updateShiftDetailWithChoiceDto: UpdateShiftDetailWithChoiceDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).updateDetailWithChoice(id, updateShiftDetailWithChoiceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public updateOrDuplicate(options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).updateOrDuplicate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateShiftAndDetailsWithChoiceDto} updateShiftAndDetailsWithChoiceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public updateShiftAndDetailsWithChoice(id: number, updateShiftAndDetailsWithChoiceDto: UpdateShiftAndDetailsWithChoiceDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).updateShiftAndDetailsWithChoice(id, updateShiftAndDetailsWithChoiceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} departmentId 
     * @param {UpdateShiftDetailDto} updateShiftDetailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public updateShiftDetails(id: number, departmentId: number, updateShiftDetailDto: UpdateShiftDetailDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).updateShiftDetails(id, departmentId, updateShiftDetailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateShiftWithChoiceDto} updateShiftWithChoiceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public updateWithChoice(id: number, updateShiftWithChoiceDto: UpdateShiftWithChoiceDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).updateWithChoice(id, updateShiftWithChoiceDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} employeeId 
     * @param {string} date 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public weeklyEmployeeHours(employeeId: number, date: string, seasonId?: number, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).weeklyEmployeeHours(employeeId, date, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches weekly worked hours for specified employees. This is a bulk endpoint to reduce the number of requests when fetching hours for multiple employees. Returns an array with employeeId and hours for each employee.
     * @summary Get weekly hours for multiple employees in a single request
     * @param {EmployeeWeeklyHoursBulkDto} employeeWeeklyHoursBulkDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftApi
     */
    public weeklyEmployeeHoursBulk(employeeWeeklyHoursBulkDto: EmployeeWeeklyHoursBulkDto, options?: AxiosRequestConfig) {
        return ShiftApiFp(this.configuration).weeklyEmployeeHoursBulk(employeeWeeklyHoursBulkDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShiftTemplateApi - axios parameter creator
 * @export
 */
export const ShiftTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateShiftTemplateDto} createShiftTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createShiftTemplateDto: CreateShiftTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createShiftTemplateDto' is not null or undefined
            assertParamExists('create', 'createShiftTemplateDto', createShiftTemplateDto)
            const localVarPath = `/api/v1/shift-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShiftTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} templateId 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromTemplate: async (templateId: number, name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('createFromTemplate', 'templateId', templateId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('createFromTemplate', 'name', name)
            const localVarPath = `/api/v1/shift-template/copyFromTemplate/{templateId}/{name}`
                .replace(`{${"templateId"}}`, encodeURIComponent(String(templateId)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (departmentId?: number, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shift-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllWhereIsBoss: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAllWhereIsBoss', 'seasonId', seasonId)
            const localVarPath = `/api/v1/shift-template/whereIsBoss/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/shift-template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} seasonId 
         * @param {UpdateShiftTemplateDto} updateShiftTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: number, seasonId: number, updateShiftTemplateDto: UpdateShiftTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('update', 'seasonId', seasonId)
            // verify required parameter 'updateShiftTemplateDto' is not null or undefined
            assertParamExists('update', 'updateShiftTemplateDto', updateShiftTemplateDto)
            const localVarPath = `/api/v1/shift-template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateShiftTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShiftTemplateApi - functional programming interface
 * @export
 */
export const ShiftTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShiftTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateShiftTemplateDto} createShiftTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createShiftTemplateDto: CreateShiftTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftTemplateEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createShiftTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} templateId 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFromTemplate(templateId: number, name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftTemplateEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFromTemplate(templateId, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(departmentId?: number, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftTemplateEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(departmentId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllWhereIsBoss(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftTemplateEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllWhereIsBoss(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} seasonId 
         * @param {UpdateShiftTemplateDto} updateShiftTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: number, seasonId: number, updateShiftTemplateDto: UpdateShiftTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftTemplateEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, seasonId, updateShiftTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShiftTemplateApi - factory interface
 * @export
 */
export const ShiftTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShiftTemplateApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateShiftTemplateDto} createShiftTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createShiftTemplateDto: CreateShiftTemplateDto, options?: any): AxiosPromise<ShiftTemplateEntity> {
            return localVarFp.create(createShiftTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} templateId 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFromTemplate(templateId: number, name: string, options?: any): AxiosPromise<ShiftTemplateEntity> {
            return localVarFp.createFromTemplate(templateId, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(departmentId?: number, seasonId?: number, options?: any): AxiosPromise<Array<ShiftTemplateEntity>> {
            return localVarFp.findAll(departmentId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllWhereIsBoss(seasonId: number, options?: any): AxiosPromise<Array<ShiftTemplateEntity>> {
            return localVarFp.findAllWhereIsBoss(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} seasonId 
         * @param {UpdateShiftTemplateDto} updateShiftTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: number, seasonId: number, updateShiftTemplateDto: UpdateShiftTemplateDto, options?: any): AxiosPromise<ShiftTemplateEntity> {
            return localVarFp.update(id, seasonId, updateShiftTemplateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShiftTemplateApi - object-oriented interface
 * @export
 * @class ShiftTemplateApi
 * @extends {BaseAPI}
 */
export class ShiftTemplateApi extends BaseAPI {
    /**
     * 
     * @param {CreateShiftTemplateDto} createShiftTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftTemplateApi
     */
    public create(createShiftTemplateDto: CreateShiftTemplateDto, options?: AxiosRequestConfig) {
        return ShiftTemplateApiFp(this.configuration).create(createShiftTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} templateId 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftTemplateApi
     */
    public createFromTemplate(templateId: number, name: string, options?: AxiosRequestConfig) {
        return ShiftTemplateApiFp(this.configuration).createFromTemplate(templateId, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [departmentId] 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftTemplateApi
     */
    public findAll(departmentId?: number, seasonId?: number, options?: AxiosRequestConfig) {
        return ShiftTemplateApiFp(this.configuration).findAll(departmentId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftTemplateApi
     */
    public findAllWhereIsBoss(seasonId: number, options?: AxiosRequestConfig) {
        return ShiftTemplateApiFp(this.configuration).findAllWhereIsBoss(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftTemplateApi
     */
    public remove(id: number, options?: AxiosRequestConfig) {
        return ShiftTemplateApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} seasonId 
     * @param {UpdateShiftTemplateDto} updateShiftTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftTemplateApi
     */
    public update(id: number, seasonId: number, updateShiftTemplateDto: UpdateShiftTemplateDto, options?: AxiosRequestConfig) {
        return ShiftTemplateApiFp(this.configuration).update(id, seasonId, updateShiftTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SimpleDepositsApi - axios parameter creator
 * @export
 */
export const SimpleDepositsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateSimpleDepositDto} createSimpleDepositDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createSimpleDepositDto: CreateSimpleDepositDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSimpleDepositDto' is not null or undefined
            assertParamExists('create', 'createSimpleDepositDto', createSimpleDepositDto)
            const localVarPath = `/api/v1/simple-deposits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSimpleDepositDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} startDate 
         * @param {number} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByDate: async (startDate: number, endDate: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('findByDate', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('findByDate', 'endDate', endDate)
            const localVarPath = `/api/v1/simple-deposits/findByDate/{startDate}/{endDate}`
                .replace(`{${"startDate"}}`, encodeURIComponent(String(startDate)))
                .replace(`{${"endDate"}}`, encodeURIComponent(String(endDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneByDate: async (date: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('findOneByDate', 'date', date)
            const localVarPath = `/api/v1/simple-deposits/findOneByDate/{date}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDateSums: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getDateSums', 'seasonId', seasonId)
            const localVarPath = `/api/v1/simple-deposits/dateSums/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} dateTimeStamps 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getdDateDepositable: async (dateTimeStamps: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dateTimeStamps' is not null or undefined
            assertParamExists('getdDateDepositable', 'dateTimeStamps', dateTimeStamps)
            const localVarPath = `/api/v1/simple-deposits/dateDepositable/{dateTimeStamps}`
                .replace(`{${"dateTimeStamps"}}`, encodeURIComponent(String(dateTimeStamps)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getdDateDepositables: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getdDateDepositables', 'seasonId', seasonId)
            const localVarPath = `/api/v1/simple-deposits/dateDepositables/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/simple-deposits/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateSimpleDepositDto} updateSimpleDepositDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateSimpleDepositDto: UpdateSimpleDepositDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateSimpleDepositDto' is not null or undefined
            assertParamExists('update', 'updateSimpleDepositDto', updateSimpleDepositDto)
            const localVarPath = `/api/v1/simple-deposits/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSimpleDepositDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SimpleDepositsApi - functional programming interface
 * @export
 */
export const SimpleDepositsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SimpleDepositsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateSimpleDepositDto} createSimpleDepositDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createSimpleDepositDto: CreateSimpleDepositDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createSimpleDepositDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} startDate 
         * @param {number} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByDate(startDate: number, endDate: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimpleDepositEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByDate(startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOneByDate(date: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleDepositEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOneByDate(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDateSums(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DateSumEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDateSums(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} dateTimeStamps 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getdDateDepositable(dateTimeStamps: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getdDateDepositable(dateTimeStamps, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getdDateDepositables(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DateSumEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getdDateDepositables(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateSimpleDepositDto} updateSimpleDepositDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateSimpleDepositDto: UpdateSimpleDepositDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateSimpleDepositDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SimpleDepositsApi - factory interface
 * @export
 */
export const SimpleDepositsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SimpleDepositsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateSimpleDepositDto} createSimpleDepositDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createSimpleDepositDto: CreateSimpleDepositDto, options?: any): AxiosPromise<void> {
            return localVarFp.create(createSimpleDepositDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} startDate 
         * @param {number} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByDate(startDate: number, endDate: number, options?: any): AxiosPromise<Array<SimpleDepositEntity>> {
            return localVarFp.findByDate(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneByDate(date: number, options?: any): AxiosPromise<SimpleDepositEntity> {
            return localVarFp.findOneByDate(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDateSums(seasonId: number, options?: any): AxiosPromise<Array<DateSumEntity>> {
            return localVarFp.getDateSums(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} dateTimeStamps 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getdDateDepositable(dateTimeStamps: number, options?: any): AxiosPromise<number> {
            return localVarFp.getdDateDepositable(dateTimeStamps, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getdDateDepositables(seasonId: number, options?: any): AxiosPromise<Array<DateSumEntity>> {
            return localVarFp.getdDateDepositables(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateSimpleDepositDto} updateSimpleDepositDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateSimpleDepositDto: UpdateSimpleDepositDto, options?: any): AxiosPromise<void> {
            return localVarFp.update(id, updateSimpleDepositDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SimpleDepositsApi - object-oriented interface
 * @export
 * @class SimpleDepositsApi
 * @extends {BaseAPI}
 */
export class SimpleDepositsApi extends BaseAPI {
    /**
     * 
     * @param {CreateSimpleDepositDto} createSimpleDepositDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimpleDepositsApi
     */
    public create(createSimpleDepositDto: CreateSimpleDepositDto, options?: AxiosRequestConfig) {
        return SimpleDepositsApiFp(this.configuration).create(createSimpleDepositDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} startDate 
     * @param {number} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimpleDepositsApi
     */
    public findByDate(startDate: number, endDate: number, options?: AxiosRequestConfig) {
        return SimpleDepositsApiFp(this.configuration).findByDate(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimpleDepositsApi
     */
    public findOneByDate(date: number, options?: AxiosRequestConfig) {
        return SimpleDepositsApiFp(this.configuration).findOneByDate(date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimpleDepositsApi
     */
    public getDateSums(seasonId: number, options?: AxiosRequestConfig) {
        return SimpleDepositsApiFp(this.configuration).getDateSums(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} dateTimeStamps 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimpleDepositsApi
     */
    public getdDateDepositable(dateTimeStamps: number, options?: AxiosRequestConfig) {
        return SimpleDepositsApiFp(this.configuration).getdDateDepositable(dateTimeStamps, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimpleDepositsApi
     */
    public getdDateDepositables(seasonId: number, options?: AxiosRequestConfig) {
        return SimpleDepositsApiFp(this.configuration).getdDateDepositables(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimpleDepositsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return SimpleDepositsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateSimpleDepositDto} updateSimpleDepositDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimpleDepositsApi
     */
    public update(id: string, updateSimpleDepositDto: UpdateSimpleDepositDto, options?: AxiosRequestConfig) {
        return SimpleDepositsApiFp(this.configuration).update(id, updateSimpleDepositDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StatusApi - axios parameter creator
 * @export
 */
export const StatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateStatusDto} createStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createStatusDto: CreateStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createStatusDto' is not null or undefined
            assertParamExists('create', 'createStatusDto', createStatusDto)
            const localVarPath = `/api/v1/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/status/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatusApi - functional programming interface
 * @export
 */
export const StatusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatusApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateStatusDto} createStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createStatusDto: CreateStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatusEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StatusApi - factory interface
 * @export
 */
export const StatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatusApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateStatusDto} createStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createStatusDto: CreateStatusDto, options?: any): AxiosPromise<StatusEntity> {
            return localVarFp.create(createStatusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<StatusEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatusApi - object-oriented interface
 * @export
 * @class StatusApi
 * @extends {BaseAPI}
 */
export class StatusApi extends BaseAPI {
    /**
     * 
     * @param {CreateStatusDto} createStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusApi
     */
    public create(createStatusDto: CreateStatusDto, options?: AxiosRequestConfig) {
        return StatusApiFp(this.configuration).create(createStatusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return StatusApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return StatusApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StatusChangeApi - axios parameter creator
 * @export
 */
export const StatusChangeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateStatusChangeDto} createStatusChangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createStatusChangeDto: CreateStatusChangeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createStatusChangeDto' is not null or undefined
            assertParamExists('create', 'createStatusChangeDto', createStatusChangeDto)
            const localVarPath = `/api/v1/status-change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStatusChangeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (employeeId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findAll', 'employeeId', employeeId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAll', 'seasonId', seasonId)
            const localVarPath = `/api/v1/status-change/byEmployee/{employeeId}/{seasonId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByDate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/status-change/byDay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/status-change/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            const localVarPath = `/api/v1/status-change/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatusChangeApi - functional programming interface
 * @export
 */
export const StatusChangeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatusChangeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateStatusChangeDto} createStatusChangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createStatusChangeDto: CreateStatusChangeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusChangeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createStatusChangeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(employeeId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatusChangeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByDate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByDate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusChangeEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StatusChangeApi - factory interface
 * @export
 */
export const StatusChangeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatusChangeApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateStatusChangeDto} createStatusChangeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createStatusChangeDto: CreateStatusChangeDto, options?: any): AxiosPromise<StatusChangeEntity> {
            return localVarFp.create(createStatusChangeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(employeeId: number, seasonId: number, options?: any): AxiosPromise<Array<StatusChangeEntity>> {
            return localVarFp.findAll(employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByDate(options?: any): AxiosPromise<void> {
            return localVarFp.findByDate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: number, options?: any): AxiosPromise<StatusChangeEntity> {
            return localVarFp.update(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatusChangeApi - object-oriented interface
 * @export
 * @class StatusChangeApi
 * @extends {BaseAPI}
 */
export class StatusChangeApi extends BaseAPI {
    /**
     * 
     * @param {CreateStatusChangeDto} createStatusChangeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusChangeApi
     */
    public create(createStatusChangeDto: CreateStatusChangeDto, options?: AxiosRequestConfig) {
        return StatusChangeApiFp(this.configuration).create(createStatusChangeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} employeeId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusChangeApi
     */
    public findAll(employeeId: number, seasonId: number, options?: AxiosRequestConfig) {
        return StatusChangeApiFp(this.configuration).findAll(employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusChangeApi
     */
    public findByDate(options?: AxiosRequestConfig) {
        return StatusChangeApiFp(this.configuration).findByDate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusChangeApi
     */
    public remove(id: number, options?: AxiosRequestConfig) {
        return StatusChangeApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusChangeApi
     */
    public update(id: number, options?: AxiosRequestConfig) {
        return StatusChangeApiFp(this.configuration).update(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenantBankingInformationApi - axios parameter creator
 * @export
 */
export const TenantBankingInformationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateTenantBankingInformationDto} createTenantBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createTenantBankingInformationDto: CreateTenantBankingInformationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTenantBankingInformationDto' is not null or undefined
            assertParamExists('create', 'createTenantBankingInformationDto', createTenantBankingInformationDto)
            const localVarPath = `/api/v1/tenant-banking-information`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTenantBankingInformationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tenant-banking-information`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} paymentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAssignable: async (paymentType: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentType' is not null or undefined
            assertParamExists('findAssignable', 'paymentType', paymentType)
            const localVarPath = `/api/v1/tenant-banking-information/assignable/{paymentType}`
                .replace(`{${"paymentType"}}`, encodeURIComponent(String(paymentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/tenant-banking-information/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/tenant-banking-information/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateTenantBankingInformationDto} updateTenantBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: number, updateTenantBankingInformationDto: UpdateTenantBankingInformationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateTenantBankingInformationDto' is not null or undefined
            assertParamExists('update', 'updateTenantBankingInformationDto', updateTenantBankingInformationDto)
            const localVarPath = `/api/v1/tenant-banking-information/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTenantBankingInformationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantBankingInformationApi - functional programming interface
 * @export
 */
export const TenantBankingInformationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantBankingInformationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateTenantBankingInformationDto} createTenantBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createTenantBankingInformationDto: CreateTenantBankingInformationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantBankingInformationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createTenantBankingInformationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantBankingInformationEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} paymentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAssignable(paymentType: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenantBankingInformationEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAssignable(paymentType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantBankingInformationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantBankingInformationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateTenantBankingInformationDto} updateTenantBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: number, updateTenantBankingInformationDto: UpdateTenantBankingInformationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantBankingInformationEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateTenantBankingInformationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantBankingInformationApi - factory interface
 * @export
 */
export const TenantBankingInformationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantBankingInformationApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateTenantBankingInformationDto} createTenantBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createTenantBankingInformationDto: CreateTenantBankingInformationDto, options?: any): AxiosPromise<TenantBankingInformationEntity> {
            return localVarFp.create(createTenantBankingInformationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<TenantBankingInformationEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} paymentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAssignable(paymentType: string, options?: any): AxiosPromise<Array<TenantBankingInformationEntity>> {
            return localVarFp.findAssignable(paymentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: number, options?: any): AxiosPromise<TenantBankingInformationEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: number, options?: any): AxiosPromise<TenantBankingInformationEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateTenantBankingInformationDto} updateTenantBankingInformationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: number, updateTenantBankingInformationDto: UpdateTenantBankingInformationDto, options?: any): AxiosPromise<TenantBankingInformationEntity> {
            return localVarFp.update(id, updateTenantBankingInformationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantBankingInformationApi - object-oriented interface
 * @export
 * @class TenantBankingInformationApi
 * @extends {BaseAPI}
 */
export class TenantBankingInformationApi extends BaseAPI {
    /**
     * 
     * @param {CreateTenantBankingInformationDto} createTenantBankingInformationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantBankingInformationApi
     */
    public create(createTenantBankingInformationDto: CreateTenantBankingInformationDto, options?: AxiosRequestConfig) {
        return TenantBankingInformationApiFp(this.configuration).create(createTenantBankingInformationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantBankingInformationApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return TenantBankingInformationApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} paymentType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantBankingInformationApi
     */
    public findAssignable(paymentType: string, options?: AxiosRequestConfig) {
        return TenantBankingInformationApiFp(this.configuration).findAssignable(paymentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantBankingInformationApi
     */
    public findOne(id: number, options?: AxiosRequestConfig) {
        return TenantBankingInformationApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantBankingInformationApi
     */
    public remove(id: number, options?: AxiosRequestConfig) {
        return TenantBankingInformationApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateTenantBankingInformationDto} updateTenantBankingInformationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantBankingInformationApi
     */
    public update(id: number, updateTenantBankingInformationDto: UpdateTenantBankingInformationDto, options?: AxiosRequestConfig) {
        return TenantBankingInformationApiFp(this.configuration).update(id, updateTenantBankingInformationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TenantConfigApi - axios parameter creator
 * @export
 */
export const TenantConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areShiftsPublic: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tenant-config/areShiftsPublic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        encryptionKeyRecovery: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tenant-config/encryptionKeyRecovery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findConfigs: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tenant-config/configs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncryptDocumentsByDefault: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tenant-config/getEncryptDocumentsByDefault`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTrackingPolicy: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tenant-config/time-tracking-policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVacationConfig: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tenant-config/getVacationConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isEncryptionKeySet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tenant-config/isEncryptionKeySet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTenantConfigDto} updateTenantConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateTenantConfigDto: UpdateTenantConfigDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateTenantConfigDto' is not null or undefined
            assertParamExists('update', 'updateTenantConfigDto', updateTenantConfigDto)
            const localVarPath = `/api/v1/tenant-config/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTenantConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateTenantOptions} updateTenantOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings: async (id: number, updateTenantOptions: UpdateTenantOptions, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSettings', 'id', id)
            // verify required parameter 'updateTenantOptions' is not null or undefined
            assertParamExists('updateSettings', 'updateTenantOptions', updateTenantOptions)
            const localVarPath = `/api/v1/tenant-config/settings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTenantOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeTrackingPolicy: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tenant-config/time-tracking-policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateZoomFactorDto} updateZoomFactorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZoomFactor: async (id: string, updateZoomFactorDto: UpdateZoomFactorDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateZoomFactor', 'id', id)
            // verify required parameter 'updateZoomFactorDto' is not null or undefined
            assertParamExists('updateZoomFactor', 'updateZoomFactorDto', updateZoomFactorDto)
            const localVarPath = `/api/v1/tenant-config/zoom-factor/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateZoomFactorDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantConfigApi - functional programming interface
 * @export
 */
export const TenantConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async areShiftsPublic(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.areShiftsPublic(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async encryptionKeyRecovery(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.encryptionKeyRecovery(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findConfigs(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConfigResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findConfigs(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncryptDocumentsByDefault(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncryptDocumentsByDefault(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeTrackingPolicy(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimeTrackingPolicy(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVacationConfig(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VacationConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVacationConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isEncryptionKeySet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isEncryptionKeySet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTenantConfigDto} updateTenantConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateTenantConfigDto: UpdateTenantConfigDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConfigEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateTenantConfigDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateTenantOptions} updateTenantOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSettings(id: number, updateTenantOptions: UpdateTenantOptions, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSettings(id, updateTenantOptions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTimeTrackingPolicy(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTimeTrackingPolicy(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateZoomFactorDto} updateZoomFactorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateZoomFactor(id: string, updateZoomFactorDto: UpdateZoomFactorDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConfigEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateZoomFactor(id, updateZoomFactorDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TenantConfigApi - factory interface
 * @export
 */
export const TenantConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantConfigApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areShiftsPublic(options?: any): AxiosPromise<boolean> {
            return localVarFp.areShiftsPublic(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        encryptionKeyRecovery(options?: any): AxiosPromise<void> {
            return localVarFp.encryptionKeyRecovery(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findConfigs(options?: any): AxiosPromise<TenantConfigResponseDto> {
            return localVarFp.findConfigs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncryptDocumentsByDefault(options?: any): AxiosPromise<boolean> {
            return localVarFp.getEncryptDocumentsByDefault(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTrackingPolicy(options?: any): AxiosPromise<object> {
            return localVarFp.getTimeTrackingPolicy(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVacationConfig(options?: any): AxiosPromise<VacationConfigDto> {
            return localVarFp.getVacationConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isEncryptionKeySet(options?: any): AxiosPromise<void> {
            return localVarFp.isEncryptionKeySet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTenantConfigDto} updateTenantConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateTenantConfigDto: UpdateTenantConfigDto, options?: any): AxiosPromise<TenantConfigEntity> {
            return localVarFp.update(id, updateTenantConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {UpdateTenantOptions} updateTenantOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings(id: number, updateTenantOptions: UpdateTenantOptions, options?: any): AxiosPromise<void> {
            return localVarFp.updateSettings(id, updateTenantOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTimeTrackingPolicy(options?: any): AxiosPromise<object> {
            return localVarFp.updateTimeTrackingPolicy(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateZoomFactorDto} updateZoomFactorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZoomFactor(id: string, updateZoomFactorDto: UpdateZoomFactorDto, options?: any): AxiosPromise<TenantConfigEntity> {
            return localVarFp.updateZoomFactor(id, updateZoomFactorDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantConfigApi - object-oriented interface
 * @export
 * @class TenantConfigApi
 * @extends {BaseAPI}
 */
export class TenantConfigApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConfigApi
     */
    public areShiftsPublic(options?: AxiosRequestConfig) {
        return TenantConfigApiFp(this.configuration).areShiftsPublic(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConfigApi
     */
    public encryptionKeyRecovery(options?: AxiosRequestConfig) {
        return TenantConfigApiFp(this.configuration).encryptionKeyRecovery(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConfigApi
     */
    public findConfigs(options?: AxiosRequestConfig) {
        return TenantConfigApiFp(this.configuration).findConfigs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConfigApi
     */
    public getEncryptDocumentsByDefault(options?: AxiosRequestConfig) {
        return TenantConfigApiFp(this.configuration).getEncryptDocumentsByDefault(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConfigApi
     */
    public getTimeTrackingPolicy(options?: AxiosRequestConfig) {
        return TenantConfigApiFp(this.configuration).getTimeTrackingPolicy(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConfigApi
     */
    public getVacationConfig(options?: AxiosRequestConfig) {
        return TenantConfigApiFp(this.configuration).getVacationConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConfigApi
     */
    public isEncryptionKeySet(options?: AxiosRequestConfig) {
        return TenantConfigApiFp(this.configuration).isEncryptionKeySet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateTenantConfigDto} updateTenantConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConfigApi
     */
    public update(id: string, updateTenantConfigDto: UpdateTenantConfigDto, options?: AxiosRequestConfig) {
        return TenantConfigApiFp(this.configuration).update(id, updateTenantConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {UpdateTenantOptions} updateTenantOptions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConfigApi
     */
    public updateSettings(id: number, updateTenantOptions: UpdateTenantOptions, options?: AxiosRequestConfig) {
        return TenantConfigApiFp(this.configuration).updateSettings(id, updateTenantOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConfigApi
     */
    public updateTimeTrackingPolicy(options?: AxiosRequestConfig) {
        return TenantConfigApiFp(this.configuration).updateTimeTrackingPolicy(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateZoomFactorDto} updateZoomFactorDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantConfigApi
     */
    public updateZoomFactor(id: string, updateZoomFactorDto: UpdateZoomFactorDto, options?: AxiosRequestConfig) {
        return TenantConfigApiFp(this.configuration).updateZoomFactor(id, updateZoomFactorDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TimeEntriesApi - axios parameter creator
 * @export
 */
export const TimeEntriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Bulk-confirm planned shifts that have no recorded time entry
         * @param {BulkConfirmDto} bulkConfirmDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkConfirm: async (bulkConfirmDto: BulkConfirmDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkConfirmDto' is not null or undefined
            assertParamExists('bulkConfirm', 'bulkConfirmDto', bulkConfirmDto)
            const localVarPath = `/api/v1/time-entries/bulk-confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkConfirmDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a time entry (clock-in or full shift)
         * @param {CreateTimeEntryDto} createTimeEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createTimeEntryDto: CreateTimeEntryDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTimeEntryDto' is not null or undefined
            assertParamExists('create', 'createTimeEntryDto', createTimeEntryDto)
            const localVarPath = `/api/v1/time-entries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTimeEntryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single time entry
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/time-entries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check whether time & attendance is enabled for this tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureStatus: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/time-entries/feature-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the attendance grid for a department / date range
         * @param {number} seasonId 
         * @param {number} departmentId 
         * @param {string} fromDate Inclusive start date in tenant TZ (YYYY-MM-DD)
         * @param {string} toDate Inclusive end date in tenant TZ (YYYY-MM-DD)
         * @param {number} [employeeId] Filter to a single employee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrid: async (seasonId: number, departmentId: number, fromDate: string, toDate: string, employeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getGrid', 'seasonId', seasonId)
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('getGrid', 'departmentId', departmentId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getGrid', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getGrid', 'toDate', toDate)
            const localVarPath = `/api/v1/time-entries/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-delete a time entry
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/time-entries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a time entry (times, match override, breaks)
         * @param {number} id 
         * @param {UpdateTimeEntryDto} updateTimeEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: number, updateTimeEntryDto: UpdateTimeEntryDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateTimeEntryDto' is not null or undefined
            assertParamExists('update', 'updateTimeEntryDto', updateTimeEntryDto)
            const localVarPath = `/api/v1/time-entries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTimeEntryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimeEntriesApi - functional programming interface
 * @export
 */
export const TimeEntriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TimeEntriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Bulk-confirm planned shifts that have no recorded time entry
         * @param {BulkConfirmDto} bulkConfirmDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkConfirm(bulkConfirmDto: BulkConfirmDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkConfirm(bulkConfirmDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a time entry (clock-in or full shift)
         * @param {CreateTimeEntryDto} createTimeEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createTimeEntryDto: CreateTimeEntryDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createTimeEntryDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a single time entry
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check whether time & attendance is enabled for this tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeatureStatus(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeatureStatus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch the attendance grid for a department / date range
         * @param {number} seasonId 
         * @param {number} departmentId 
         * @param {string} fromDate Inclusive start date in tenant TZ (YYYY-MM-DD)
         * @param {string} toDate Inclusive end date in tenant TZ (YYYY-MM-DD)
         * @param {number} [employeeId] Filter to a single employee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGrid(seasonId: number, departmentId: number, fromDate: string, toDate: string, employeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryGridResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGrid(seasonId, departmentId, fromDate, toDate, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Soft-delete a time entry
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a time entry (times, match override, breaks)
         * @param {number} id 
         * @param {UpdateTimeEntryDto} updateTimeEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: number, updateTimeEntryDto: UpdateTimeEntryDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateTimeEntryDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TimeEntriesApi - factory interface
 * @export
 */
export const TimeEntriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TimeEntriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Bulk-confirm planned shifts that have no recorded time entry
         * @param {BulkConfirmDto} bulkConfirmDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkConfirm(bulkConfirmDto: BulkConfirmDto, options?: any): AxiosPromise<void> {
            return localVarFp.bulkConfirm(bulkConfirmDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a time entry (clock-in or full shift)
         * @param {CreateTimeEntryDto} createTimeEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createTimeEntryDto: CreateTimeEntryDto, options?: any): AxiosPromise<TimeEntryResponseDto> {
            return localVarFp.create(createTimeEntryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a single time entry
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: number, options?: any): AxiosPromise<TimeEntryResponseDto> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check whether time & attendance is enabled for this tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureStatus(options?: any): AxiosPromise<void> {
            return localVarFp.getFeatureStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the attendance grid for a department / date range
         * @param {number} seasonId 
         * @param {number} departmentId 
         * @param {string} fromDate Inclusive start date in tenant TZ (YYYY-MM-DD)
         * @param {string} toDate Inclusive end date in tenant TZ (YYYY-MM-DD)
         * @param {number} [employeeId] Filter to a single employee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrid(seasonId: number, departmentId: number, fromDate: string, toDate: string, employeeId?: number, options?: any): AxiosPromise<TimeEntryGridResponseDto> {
            return localVarFp.getGrid(seasonId, departmentId, fromDate, toDate, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-delete a time entry
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a time entry (times, match override, breaks)
         * @param {number} id 
         * @param {UpdateTimeEntryDto} updateTimeEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: number, updateTimeEntryDto: UpdateTimeEntryDto, options?: any): AxiosPromise<TimeEntryResponseDto> {
            return localVarFp.update(id, updateTimeEntryDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimeEntriesApi - object-oriented interface
 * @export
 * @class TimeEntriesApi
 * @extends {BaseAPI}
 */
export class TimeEntriesApi extends BaseAPI {
    /**
     * 
     * @summary Bulk-confirm planned shifts that have no recorded time entry
     * @param {BulkConfirmDto} bulkConfirmDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntriesApi
     */
    public bulkConfirm(bulkConfirmDto: BulkConfirmDto, options?: AxiosRequestConfig) {
        return TimeEntriesApiFp(this.configuration).bulkConfirm(bulkConfirmDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a time entry (clock-in or full shift)
     * @param {CreateTimeEntryDto} createTimeEntryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntriesApi
     */
    public create(createTimeEntryDto: CreateTimeEntryDto, options?: AxiosRequestConfig) {
        return TimeEntriesApiFp(this.configuration).create(createTimeEntryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a single time entry
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntriesApi
     */
    public findOne(id: number, options?: AxiosRequestConfig) {
        return TimeEntriesApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check whether time & attendance is enabled for this tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntriesApi
     */
    public getFeatureStatus(options?: AxiosRequestConfig) {
        return TimeEntriesApiFp(this.configuration).getFeatureStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the attendance grid for a department / date range
     * @param {number} seasonId 
     * @param {number} departmentId 
     * @param {string} fromDate Inclusive start date in tenant TZ (YYYY-MM-DD)
     * @param {string} toDate Inclusive end date in tenant TZ (YYYY-MM-DD)
     * @param {number} [employeeId] Filter to a single employee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntriesApi
     */
    public getGrid(seasonId: number, departmentId: number, fromDate: string, toDate: string, employeeId?: number, options?: AxiosRequestConfig) {
        return TimeEntriesApiFp(this.configuration).getGrid(seasonId, departmentId, fromDate, toDate, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-delete a time entry
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntriesApi
     */
    public remove(id: number, options?: AxiosRequestConfig) {
        return TimeEntriesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a time entry (times, match override, breaks)
     * @param {number} id 
     * @param {UpdateTimeEntryDto} updateTimeEntryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntriesApi
     */
    public update(id: number, updateTimeEntryDto: UpdateTimeEntryDto, options?: AxiosRequestConfig) {
        return TimeEntriesApiFp(this.configuration).update(id, updateTimeEntryDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TimeEntryApprovalsApi - axios parameter creator
 * @export
 */
export const TimeEntryApprovalsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve an overtime time entry
         * @param {number} timeEntryId 
         * @param {ApproveTimeEntryDto} approveTimeEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approve: async (timeEntryId: number, approveTimeEntryDto: ApproveTimeEntryDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeEntryId' is not null or undefined
            assertParamExists('approve', 'timeEntryId', timeEntryId)
            // verify required parameter 'approveTimeEntryDto' is not null or undefined
            assertParamExists('approve', 'approveTimeEntryDto', approveTimeEntryDto)
            const localVarPath = `/api/v1/approvals/{timeEntryId}/approve`
                .replace(`{${"timeEntryId"}}`, encodeURIComponent(String(timeEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveTimeEntryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Count pending overtime approvals visible to the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPending: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/approvals/pending/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List pending overtime approvals
         * @param {number} [seasonId] 
         * @param {number} [departmentId] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPending: async (seasonId?: number, departmentId?: number, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/approvals/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject an overtime time entry
         * @param {number} timeEntryId 
         * @param {RejectTimeEntryDto} rejectTimeEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reject: async (timeEntryId: number, rejectTimeEntryDto: RejectTimeEntryDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeEntryId' is not null or undefined
            assertParamExists('reject', 'timeEntryId', timeEntryId)
            // verify required parameter 'rejectTimeEntryDto' is not null or undefined
            assertParamExists('reject', 'rejectTimeEntryDto', rejectTimeEntryDto)
            const localVarPath = `/api/v1/approvals/{timeEntryId}/reject`
                .replace(`{${"timeEntryId"}}`, encodeURIComponent(String(timeEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectTimeEntryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimeEntryApprovalsApi - functional programming interface
 * @export
 */
export const TimeEntryApprovalsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TimeEntryApprovalsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve an overtime time entry
         * @param {number} timeEntryId 
         * @param {ApproveTimeEntryDto} approveTimeEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approve(timeEntryId: number, approveTimeEntryDto: ApproveTimeEntryDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approve(timeEntryId, approveTimeEntryDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Count pending overtime approvals visible to the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countPending(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countPending(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List pending overtime approvals
         * @param {number} [seasonId] 
         * @param {number} [departmentId] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPending(seasonId?: number, departmentId?: number, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendingApprovalListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPending(seasonId, departmentId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject an overtime time entry
         * @param {number} timeEntryId 
         * @param {RejectTimeEntryDto} rejectTimeEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reject(timeEntryId: number, rejectTimeEntryDto: RejectTimeEntryDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reject(timeEntryId, rejectTimeEntryDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TimeEntryApprovalsApi - factory interface
 * @export
 */
export const TimeEntryApprovalsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TimeEntryApprovalsApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve an overtime time entry
         * @param {number} timeEntryId 
         * @param {ApproveTimeEntryDto} approveTimeEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approve(timeEntryId: number, approveTimeEntryDto: ApproveTimeEntryDto, options?: any): AxiosPromise<void> {
            return localVarFp.approve(timeEntryId, approveTimeEntryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Count pending overtime approvals visible to the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPending(options?: any): AxiosPromise<void> {
            return localVarFp.countPending(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List pending overtime approvals
         * @param {number} [seasonId] 
         * @param {number} [departmentId] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPending(seasonId?: number, departmentId?: number, page?: number, limit?: number, options?: any): AxiosPromise<PendingApprovalListResponseDto> {
            return localVarFp.listPending(seasonId, departmentId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject an overtime time entry
         * @param {number} timeEntryId 
         * @param {RejectTimeEntryDto} rejectTimeEntryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reject(timeEntryId: number, rejectTimeEntryDto: RejectTimeEntryDto, options?: any): AxiosPromise<void> {
            return localVarFp.reject(timeEntryId, rejectTimeEntryDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimeEntryApprovalsApi - object-oriented interface
 * @export
 * @class TimeEntryApprovalsApi
 * @extends {BaseAPI}
 */
export class TimeEntryApprovalsApi extends BaseAPI {
    /**
     * 
     * @summary Approve an overtime time entry
     * @param {number} timeEntryId 
     * @param {ApproveTimeEntryDto} approveTimeEntryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApprovalsApi
     */
    public approve(timeEntryId: number, approveTimeEntryDto: ApproveTimeEntryDto, options?: AxiosRequestConfig) {
        return TimeEntryApprovalsApiFp(this.configuration).approve(timeEntryId, approveTimeEntryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Count pending overtime approvals visible to the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApprovalsApi
     */
    public countPending(options?: AxiosRequestConfig) {
        return TimeEntryApprovalsApiFp(this.configuration).countPending(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List pending overtime approvals
     * @param {number} [seasonId] 
     * @param {number} [departmentId] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApprovalsApi
     */
    public listPending(seasonId?: number, departmentId?: number, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return TimeEntryApprovalsApiFp(this.configuration).listPending(seasonId, departmentId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject an overtime time entry
     * @param {number} timeEntryId 
     * @param {RejectTimeEntryDto} rejectTimeEntryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApprovalsApi
     */
    public reject(timeEntryId: number, rejectTimeEntryDto: RejectTimeEntryDto, options?: AxiosRequestConfig) {
        return TimeEntryApprovalsApiFp(this.configuration).reject(timeEntryId, rejectTimeEntryDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TimeEntryReportsApi - axios parameter creator
 * @export
 */
export const TimeEntryReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export monthly attendance as XLSX or CSV (no decrypted cost; for plain-cost or no-encryption tenants)
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [departmentId] 
         * @param {'xlsx' | 'csv'} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMonthly: async (seasonId: number, fromDate: string, toDate: string, departmentId?: number, format?: 'xlsx' | 'csv', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('exportMonthly', 'seasonId', seasonId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('exportMonthly', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('exportMonthly', 'toDate', toDate)
            const localVarPath = `/api/v1/reports/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export monthly attendance with frontend-decrypted cost map merged into cost columns
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {MonthlyExportBodyDto} monthlyExportBodyDto 
         * @param {number} [departmentId] 
         * @param {'xlsx' | 'csv'} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMonthlyWithCost: async (seasonId: number, fromDate: string, toDate: string, monthlyExportBodyDto: MonthlyExportBodyDto, departmentId?: number, format?: 'xlsx' | 'csv', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('exportMonthlyWithCost', 'seasonId', seasonId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('exportMonthlyWithCost', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('exportMonthlyWithCost', 'toDate', toDate)
            // verify required parameter 'monthlyExportBodyDto' is not null or undefined
            assertParamExists('exportMonthlyWithCost', 'monthlyExportBodyDto', monthlyExportBodyDto)
            const localVarPath = `/api/v1/reports/export-with-cost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(monthlyExportBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Daily variance between planned and worked hours
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLaborHoursVariance: async (seasonId: number, fromDate: string, toDate: string, departmentId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getLaborHoursVariance', 'seasonId', seasonId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getLaborHoursVariance', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getLaborHoursVariance', 'toDate', toDate)
            const localVarPath = `/api/v1/reports/labor-hours-variance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aggregate worked/planned/overtime stats per employee for a period
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeriodSummary: async (seasonId: number, fromDate: string, toDate: string, departmentId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getPeriodSummary', 'seasonId', seasonId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getPeriodSummary', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getPeriodSummary', 'toDate', toDate)
            const localVarPath = `/api/v1/reports/period-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Daily plan accuracy (planned vs worked shifts)
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanAccuracy: async (seasonId: number, fromDate: string, toDate: string, departmentId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getPlanAccuracy', 'seasonId', seasonId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getPlanAccuracy', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getPlanAccuracy', 'toDate', toDate)
            const localVarPath = `/api/v1/reports/plan-accuracy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List employees with insufficient rest between consecutive shifts
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRestViolations: async (seasonId: number, fromDate: string, toDate: string, departmentId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getRestViolations', 'seasonId', seasonId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getRestViolations', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getRestViolations', 'toDate', toDate)
            const localVarPath = `/api/v1/reports/rest-violations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimeEntryReportsApi - functional programming interface
 * @export
 */
export const TimeEntryReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TimeEntryReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export monthly attendance as XLSX or CSV (no decrypted cost; for plain-cost or no-encryption tenants)
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [departmentId] 
         * @param {'xlsx' | 'csv'} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportMonthly(seasonId: number, fromDate: string, toDate: string, departmentId?: number, format?: 'xlsx' | 'csv', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportMonthly(seasonId, fromDate, toDate, departmentId, format, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Export monthly attendance with frontend-decrypted cost map merged into cost columns
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {MonthlyExportBodyDto} monthlyExportBodyDto 
         * @param {number} [departmentId] 
         * @param {'xlsx' | 'csv'} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportMonthlyWithCost(seasonId: number, fromDate: string, toDate: string, monthlyExportBodyDto: MonthlyExportBodyDto, departmentId?: number, format?: 'xlsx' | 'csv', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportMonthlyWithCost(seasonId, fromDate, toDate, monthlyExportBodyDto, departmentId, format, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Daily variance between planned and worked hours
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLaborHoursVariance(seasonId: number, fromDate: string, toDate: string, departmentId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LaborHoursVarianceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLaborHoursVariance(seasonId, fromDate, toDate, departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Aggregate worked/planned/overtime stats per employee for a period
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPeriodSummary(seasonId: number, fromDate: string, toDate: string, departmentId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PeriodSummaryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPeriodSummary(seasonId, fromDate, toDate, departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Daily plan accuracy (planned vs worked shifts)
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanAccuracy(seasonId: number, fromDate: string, toDate: string, departmentId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanAccuracyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanAccuracy(seasonId, fromDate, toDate, departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List employees with insufficient rest between consecutive shifts
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRestViolations(seasonId: number, fromDate: string, toDate: string, departmentId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestViolationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRestViolations(seasonId, fromDate, toDate, departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TimeEntryReportsApi - factory interface
 * @export
 */
export const TimeEntryReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TimeEntryReportsApiFp(configuration)
    return {
        /**
         * 
         * @summary Export monthly attendance as XLSX or CSV (no decrypted cost; for plain-cost or no-encryption tenants)
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [departmentId] 
         * @param {'xlsx' | 'csv'} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMonthly(seasonId: number, fromDate: string, toDate: string, departmentId?: number, format?: 'xlsx' | 'csv', options?: any): AxiosPromise<void> {
            return localVarFp.exportMonthly(seasonId, fromDate, toDate, departmentId, format, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export monthly attendance with frontend-decrypted cost map merged into cost columns
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {MonthlyExportBodyDto} monthlyExportBodyDto 
         * @param {number} [departmentId] 
         * @param {'xlsx' | 'csv'} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMonthlyWithCost(seasonId: number, fromDate: string, toDate: string, monthlyExportBodyDto: MonthlyExportBodyDto, departmentId?: number, format?: 'xlsx' | 'csv', options?: any): AxiosPromise<void> {
            return localVarFp.exportMonthlyWithCost(seasonId, fromDate, toDate, monthlyExportBodyDto, departmentId, format, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Daily variance between planned and worked hours
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLaborHoursVariance(seasonId: number, fromDate: string, toDate: string, departmentId?: number, options?: any): AxiosPromise<LaborHoursVarianceResponseDto> {
            return localVarFp.getLaborHoursVariance(seasonId, fromDate, toDate, departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aggregate worked/planned/overtime stats per employee for a period
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeriodSummary(seasonId: number, fromDate: string, toDate: string, departmentId?: number, options?: any): AxiosPromise<PeriodSummaryResponseDto> {
            return localVarFp.getPeriodSummary(seasonId, fromDate, toDate, departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Daily plan accuracy (planned vs worked shifts)
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanAccuracy(seasonId: number, fromDate: string, toDate: string, departmentId?: number, options?: any): AxiosPromise<PlanAccuracyResponseDto> {
            return localVarFp.getPlanAccuracy(seasonId, fromDate, toDate, departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List employees with insufficient rest between consecutive shifts
         * @param {number} seasonId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {number} [departmentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRestViolations(seasonId: number, fromDate: string, toDate: string, departmentId?: number, options?: any): AxiosPromise<RestViolationsResponseDto> {
            return localVarFp.getRestViolations(seasonId, fromDate, toDate, departmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimeEntryReportsApi - object-oriented interface
 * @export
 * @class TimeEntryReportsApi
 * @extends {BaseAPI}
 */
export class TimeEntryReportsApi extends BaseAPI {
    /**
     * 
     * @summary Export monthly attendance as XLSX or CSV (no decrypted cost; for plain-cost or no-encryption tenants)
     * @param {number} seasonId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {number} [departmentId] 
     * @param {'xlsx' | 'csv'} [format] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryReportsApi
     */
    public exportMonthly(seasonId: number, fromDate: string, toDate: string, departmentId?: number, format?: 'xlsx' | 'csv', options?: AxiosRequestConfig) {
        return TimeEntryReportsApiFp(this.configuration).exportMonthly(seasonId, fromDate, toDate, departmentId, format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export monthly attendance with frontend-decrypted cost map merged into cost columns
     * @param {number} seasonId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {MonthlyExportBodyDto} monthlyExportBodyDto 
     * @param {number} [departmentId] 
     * @param {'xlsx' | 'csv'} [format] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryReportsApi
     */
    public exportMonthlyWithCost(seasonId: number, fromDate: string, toDate: string, monthlyExportBodyDto: MonthlyExportBodyDto, departmentId?: number, format?: 'xlsx' | 'csv', options?: AxiosRequestConfig) {
        return TimeEntryReportsApiFp(this.configuration).exportMonthlyWithCost(seasonId, fromDate, toDate, monthlyExportBodyDto, departmentId, format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Daily variance between planned and worked hours
     * @param {number} seasonId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {number} [departmentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryReportsApi
     */
    public getLaborHoursVariance(seasonId: number, fromDate: string, toDate: string, departmentId?: number, options?: AxiosRequestConfig) {
        return TimeEntryReportsApiFp(this.configuration).getLaborHoursVariance(seasonId, fromDate, toDate, departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aggregate worked/planned/overtime stats per employee for a period
     * @param {number} seasonId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {number} [departmentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryReportsApi
     */
    public getPeriodSummary(seasonId: number, fromDate: string, toDate: string, departmentId?: number, options?: AxiosRequestConfig) {
        return TimeEntryReportsApiFp(this.configuration).getPeriodSummary(seasonId, fromDate, toDate, departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Daily plan accuracy (planned vs worked shifts)
     * @param {number} seasonId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {number} [departmentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryReportsApi
     */
    public getPlanAccuracy(seasonId: number, fromDate: string, toDate: string, departmentId?: number, options?: AxiosRequestConfig) {
        return TimeEntryReportsApiFp(this.configuration).getPlanAccuracy(seasonId, fromDate, toDate, departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List employees with insufficient rest between consecutive shifts
     * @param {number} seasonId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {number} [departmentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryReportsApi
     */
    public getRestViolations(seasonId: number, fromDate: string, toDate: string, departmentId?: number, options?: AxiosRequestConfig) {
        return TimeEntryReportsApiFp(this.configuration).getRestViolations(seasonId, fromDate, toDate, departmentId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TokenApi - axios parameter creator
 * @export
 */
export const TokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GenerateTokenDto} generateTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateToken: async (generateTokenDto: GenerateTokenDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateTokenDto' is not null or undefined
            assertParamExists('generateToken', 'generateTokenDto', generateTokenDto)
            const localVarPath = `/api/v1/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GenerateTokenDto} generateTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTokenWithExpiredToken: async (generateTokenDto: GenerateTokenDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateTokenDto' is not null or undefined
            assertParamExists('generateTokenWithExpiredToken', 'generateTokenDto', generateTokenDto)
            const localVarPath = `/api/v1/token/withExpiredToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isTokenValid: async (token: string, tenant: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('isTokenValid', 'token', token)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('isTokenValid', 'tenant', tenant)
            const localVarPath = `/api/v1/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWithToken: async (token: string, tenant: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('updateWithToken', 'token', token)
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('updateWithToken', 'tenant', tenant)
            const localVarPath = `/api/v1/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokenApi - functional programming interface
 * @export
 */
export const TokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {GenerateTokenDto} generateTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateToken(generateTokenDto: GenerateTokenDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateToken(generateTokenDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GenerateTokenDto} generateTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTokenWithExpiredToken(generateTokenDto: GenerateTokenDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTokenWithExpiredToken(generateTokenDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} token 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isTokenValid(token: string, tenant: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isTokenValid(token, tenant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} token 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWithToken(token: string, tenant: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWithToken(token, tenant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TokenApi - factory interface
 * @export
 */
export const TokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokenApiFp(configuration)
    return {
        /**
         * 
         * @param {GenerateTokenDto} generateTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateToken(generateTokenDto: GenerateTokenDto, options?: any): AxiosPromise<void> {
            return localVarFp.generateToken(generateTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GenerateTokenDto} generateTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTokenWithExpiredToken(generateTokenDto: GenerateTokenDto, options?: any): AxiosPromise<void> {
            return localVarFp.generateTokenWithExpiredToken(generateTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isTokenValid(token: string, tenant: string, options?: any): AxiosPromise<void> {
            return localVarFp.isTokenValid(token, tenant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWithToken(token: string, tenant: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateWithToken(token, tenant, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TokenApi - object-oriented interface
 * @export
 * @class TokenApi
 * @extends {BaseAPI}
 */
export class TokenApi extends BaseAPI {
    /**
     * 
     * @param {GenerateTokenDto} generateTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public generateToken(generateTokenDto: GenerateTokenDto, options?: AxiosRequestConfig) {
        return TokenApiFp(this.configuration).generateToken(generateTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GenerateTokenDto} generateTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public generateTokenWithExpiredToken(generateTokenDto: GenerateTokenDto, options?: AxiosRequestConfig) {
        return TokenApiFp(this.configuration).generateTokenWithExpiredToken(generateTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {string} tenant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public isTokenValid(token: string, tenant: string, options?: AxiosRequestConfig) {
        return TokenApiFp(this.configuration).isTokenValid(token, tenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {string} tenant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public updateWithToken(token: string, tenant: string, options?: AxiosRequestConfig) {
        return TokenApiFp(this.configuration).updateWithToken(token, tenant, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TrainingApi - axios parameter creator
 * @export
 */
export const TrainingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Migrate legacy EmployeeDocument records matching CourseType names into EmployeeCertification records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateLegacyDocs: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/training/migrate-legacy-docs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrainingApi - functional programming interface
 * @export
 */
export const TrainingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrainingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Migrate legacy EmployeeDocument records matching CourseType names into EmployeeCertification records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateLegacyDocs(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MigrateLegacyDocsResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateLegacyDocs(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrainingApi - factory interface
 * @export
 */
export const TrainingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrainingApiFp(configuration)
    return {
        /**
         * 
         * @summary Migrate legacy EmployeeDocument records matching CourseType names into EmployeeCertification records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateLegacyDocs(options?: any): AxiosPromise<MigrateLegacyDocsResultDto> {
            return localVarFp.migrateLegacyDocs(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrainingApi - object-oriented interface
 * @export
 * @class TrainingApi
 * @extends {BaseAPI}
 */
export class TrainingApi extends BaseAPI {
    /**
     * 
     * @summary Migrate legacy EmployeeDocument records matching CourseType names into EmployeeCertification records
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingApi
     */
    public migrateLegacyDocs(options?: AxiosRequestConfig) {
        return TrainingApiFp(this.configuration).migrateLegacyDocs(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TrainingComplianceApi - axios parameter creator
 * @export
 */
export const TrainingComplianceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns certifications that are expired or expiring within 30 days, with employee and department details.
         * @summary Get expiring and expired certification alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpiringAlerts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/training-compliance/alerts/expiring`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gap analysis: returns employees who are missing required certifications based on their department/position training requirements.
         * @summary Get missing mandatory certification alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMissingAlerts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/training-compliance/alerts/missing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns counts of valid, expiring, expired, and missing mandatory certifications for active/candidate employees.
         * @summary Get training compliance statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStats: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/training-compliance/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrainingComplianceApi - functional programming interface
 * @export
 */
export const TrainingComplianceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrainingComplianceApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns certifications that are expired or expiring within 30 days, with employee and department details.
         * @summary Get expiring and expired certification alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExpiringAlerts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExpiringCertificationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExpiringAlerts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gap analysis: returns employees who are missing required certifications based on their department/position training requirements.
         * @summary Get missing mandatory certification alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMissingAlerts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MissingCertificationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMissingAlerts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns counts of valid, expiring, expired, and missing mandatory certifications for active/candidate employees.
         * @summary Get training compliance statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStats(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStats(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrainingComplianceApi - factory interface
 * @export
 */
export const TrainingComplianceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrainingComplianceApiFp(configuration)
    return {
        /**
         * Returns certifications that are expired or expiring within 30 days, with employee and department details.
         * @summary Get expiring and expired certification alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpiringAlerts(options?: any): AxiosPromise<Array<ExpiringCertificationDto>> {
            return localVarFp.getExpiringAlerts(options).then((request) => request(axios, basePath));
        },
        /**
         * Gap analysis: returns employees who are missing required certifications based on their department/position training requirements.
         * @summary Get missing mandatory certification alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMissingAlerts(options?: any): AxiosPromise<Array<MissingCertificationDto>> {
            return localVarFp.getMissingAlerts(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns counts of valid, expiring, expired, and missing mandatory certifications for active/candidate employees.
         * @summary Get training compliance statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStats(options?: any): AxiosPromise<ComplianceStatsDto> {
            return localVarFp.getStats(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrainingComplianceApi - object-oriented interface
 * @export
 * @class TrainingComplianceApi
 * @extends {BaseAPI}
 */
export class TrainingComplianceApi extends BaseAPI {
    /**
     * Returns certifications that are expired or expiring within 30 days, with employee and department details.
     * @summary Get expiring and expired certification alerts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingComplianceApi
     */
    public getExpiringAlerts(options?: AxiosRequestConfig) {
        return TrainingComplianceApiFp(this.configuration).getExpiringAlerts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gap analysis: returns employees who are missing required certifications based on their department/position training requirements.
     * @summary Get missing mandatory certification alerts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingComplianceApi
     */
    public getMissingAlerts(options?: AxiosRequestConfig) {
        return TrainingComplianceApiFp(this.configuration).getMissingAlerts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns counts of valid, expiring, expired, and missing mandatory certifications for active/candidate employees.
     * @summary Get training compliance statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingComplianceApi
     */
    public getStats(options?: AxiosRequestConfig) {
        return TrainingComplianceApiFp(this.configuration).getStats(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TrainingCoursesApi - axios parameter creator
 * @export
 */
export const TrainingCoursesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Updates all enrollment records with attendance/pass results. For every employee who passed, an EmployeeCertification is automatically created with expiration calculated from CourseType.validityMonths. All operations run in a single transaction.
         * @summary Mark course as completed and auto-generate certifications
         * @param {string} id 
         * @param {CompleteTrainingCourseDto} completeTrainingCourseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complete: async (id: string, completeTrainingCourseDto: CompleteTrainingCourseDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('complete', 'id', id)
            // verify required parameter 'completeTrainingCourseDto' is not null or undefined
            assertParamExists('complete', 'completeTrainingCourseDto', completeTrainingCourseDto)
            const localVarPath = `/api/v1/training-courses/{id}/complete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeTrainingCourseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new training course session
         * @param {CreateTrainingCourseDto} createTrainingCourseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createTrainingCourseDto: CreateTrainingCourseDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTrainingCourseDto' is not null or undefined
            assertParamExists('create', 'createTrainingCourseDto', createTrainingCourseDto)
            const localVarPath = `/api/v1/training-courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTrainingCourseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enroll one or more employees in a training course
         * @param {string} id 
         * @param {EnrollEmployeesDto} enrollEmployeesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enroll: async (id: string, enrollEmployeesDto: EnrollEmployeesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('enroll', 'id', id)
            // verify required parameter 'enrollEmployeesDto' is not null or undefined
            assertParamExists('enroll', 'enrollEmployeesDto', enrollEmployeesDto)
            const localVarPath = `/api/v1/training-courses/{id}/enroll`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enrollEmployeesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all training courses with enrollment count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/training-courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a training course by ID (includes enrollments)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/training-courses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns active employees who need this course type (per TrainingRequirement) but have no valid certification. Excludes employees already enrolled.
         * @summary Get suggested attendees based on gap analysis
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedAttendees: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSuggestedAttendees', 'id', id)
            const localVarPath = `/api/v1/training-courses/{id}/suggested-attendees`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a training course and its enrollments
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/training-courses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the auto-generated EmployeeCertification, resets the enrollment attended/passed flags. Use this to undo a mistaken completion.
         * @summary Reverse completion for a single employee
         * @param {string} id 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uncompleteEmployee: async (id: string, employeeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uncompleteEmployee', 'id', id)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('uncompleteEmployee', 'employeeId', employeeId)
            const localVarPath = `/api/v1/training-courses/{id}/uncomplete/{employeeId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove an employee from a training course
         * @param {string} id 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unenroll: async (id: string, employeeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unenroll', 'id', id)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('unenroll', 'employeeId', employeeId)
            const localVarPath = `/api/v1/training-courses/{id}/enroll/{employeeId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a training course (status, dates, details)
         * @param {string} id 
         * @param {UpdateTrainingCourseDto} updateTrainingCourseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateTrainingCourseDto: UpdateTrainingCourseDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateTrainingCourseDto' is not null or undefined
            assertParamExists('update', 'updateTrainingCourseDto', updateTrainingCourseDto)
            const localVarPath = `/api/v1/training-courses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTrainingCourseDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrainingCoursesApi - functional programming interface
 * @export
 */
export const TrainingCoursesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrainingCoursesApiAxiosParamCreator(configuration)
    return {
        /**
         * Updates all enrollment records with attendance/pass results. For every employee who passed, an EmployeeCertification is automatically created with expiration calculated from CourseType.validityMonths. All operations run in a single transaction.
         * @summary Mark course as completed and auto-generate certifications
         * @param {string} id 
         * @param {CompleteTrainingCourseDto} completeTrainingCourseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complete(id: string, completeTrainingCourseDto: CompleteTrainingCourseDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingCourseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complete(id, completeTrainingCourseDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new training course session
         * @param {CreateTrainingCourseDto} createTrainingCourseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createTrainingCourseDto: CreateTrainingCourseDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingCourseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createTrainingCourseDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Enroll one or more employees in a training course
         * @param {string} id 
         * @param {EnrollEmployeesDto} enrollEmployeesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enroll(id: string, enrollEmployeesDto: EnrollEmployeesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingCourseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enroll(id, enrollEmployeesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all training courses with enrollment count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrainingCourseEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a training course by ID (includes enrollments)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingCourseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns active employees who need this course type (per TrainingRequirement) but have no valid certification. Excludes employees already enrolled.
         * @summary Get suggested attendees based on gap analysis
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuggestedAttendees(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuggestedAttendees(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a training course and its enrollments
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingCourseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes the auto-generated EmployeeCertification, resets the enrollment attended/passed flags. Use this to undo a mistaken completion.
         * @summary Reverse completion for a single employee
         * @param {string} id 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uncompleteEmployee(id: string, employeeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingCourseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uncompleteEmployee(id, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove an employee from a training course
         * @param {string} id 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unenroll(id: string, employeeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingCourseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unenroll(id, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a training course (status, dates, details)
         * @param {string} id 
         * @param {UpdateTrainingCourseDto} updateTrainingCourseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateTrainingCourseDto: UpdateTrainingCourseDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingCourseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateTrainingCourseDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrainingCoursesApi - factory interface
 * @export
 */
export const TrainingCoursesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrainingCoursesApiFp(configuration)
    return {
        /**
         * Updates all enrollment records with attendance/pass results. For every employee who passed, an EmployeeCertification is automatically created with expiration calculated from CourseType.validityMonths. All operations run in a single transaction.
         * @summary Mark course as completed and auto-generate certifications
         * @param {string} id 
         * @param {CompleteTrainingCourseDto} completeTrainingCourseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complete(id: string, completeTrainingCourseDto: CompleteTrainingCourseDto, options?: any): AxiosPromise<TrainingCourseEntity> {
            return localVarFp.complete(id, completeTrainingCourseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new training course session
         * @param {CreateTrainingCourseDto} createTrainingCourseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createTrainingCourseDto: CreateTrainingCourseDto, options?: any): AxiosPromise<TrainingCourseEntity> {
            return localVarFp.create(createTrainingCourseDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enroll one or more employees in a training course
         * @param {string} id 
         * @param {EnrollEmployeesDto} enrollEmployeesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enroll(id: string, enrollEmployeesDto: EnrollEmployeesDto, options?: any): AxiosPromise<TrainingCourseEntity> {
            return localVarFp.enroll(id, enrollEmployeesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all training courses with enrollment count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<TrainingCourseEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a training course by ID (includes enrollments)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<TrainingCourseEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns active employees who need this course type (per TrainingRequirement) but have no valid certification. Excludes employees already enrolled.
         * @summary Get suggested attendees based on gap analysis
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedAttendees(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.getSuggestedAttendees(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a training course and its enrollments
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<TrainingCourseEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the auto-generated EmployeeCertification, resets the enrollment attended/passed flags. Use this to undo a mistaken completion.
         * @summary Reverse completion for a single employee
         * @param {string} id 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uncompleteEmployee(id: string, employeeId: string, options?: any): AxiosPromise<TrainingCourseEntity> {
            return localVarFp.uncompleteEmployee(id, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove an employee from a training course
         * @param {string} id 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unenroll(id: string, employeeId: string, options?: any): AxiosPromise<TrainingCourseEntity> {
            return localVarFp.unenroll(id, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a training course (status, dates, details)
         * @param {string} id 
         * @param {UpdateTrainingCourseDto} updateTrainingCourseDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateTrainingCourseDto: UpdateTrainingCourseDto, options?: any): AxiosPromise<TrainingCourseEntity> {
            return localVarFp.update(id, updateTrainingCourseDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrainingCoursesApi - object-oriented interface
 * @export
 * @class TrainingCoursesApi
 * @extends {BaseAPI}
 */
export class TrainingCoursesApi extends BaseAPI {
    /**
     * Updates all enrollment records with attendance/pass results. For every employee who passed, an EmployeeCertification is automatically created with expiration calculated from CourseType.validityMonths. All operations run in a single transaction.
     * @summary Mark course as completed and auto-generate certifications
     * @param {string} id 
     * @param {CompleteTrainingCourseDto} completeTrainingCourseDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingCoursesApi
     */
    public complete(id: string, completeTrainingCourseDto: CompleteTrainingCourseDto, options?: AxiosRequestConfig) {
        return TrainingCoursesApiFp(this.configuration).complete(id, completeTrainingCourseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new training course session
     * @param {CreateTrainingCourseDto} createTrainingCourseDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingCoursesApi
     */
    public create(createTrainingCourseDto: CreateTrainingCourseDto, options?: AxiosRequestConfig) {
        return TrainingCoursesApiFp(this.configuration).create(createTrainingCourseDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enroll one or more employees in a training course
     * @param {string} id 
     * @param {EnrollEmployeesDto} enrollEmployeesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingCoursesApi
     */
    public enroll(id: string, enrollEmployeesDto: EnrollEmployeesDto, options?: AxiosRequestConfig) {
        return TrainingCoursesApiFp(this.configuration).enroll(id, enrollEmployeesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all training courses with enrollment count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingCoursesApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return TrainingCoursesApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a training course by ID (includes enrollments)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingCoursesApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return TrainingCoursesApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns active employees who need this course type (per TrainingRequirement) but have no valid certification. Excludes employees already enrolled.
     * @summary Get suggested attendees based on gap analysis
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingCoursesApi
     */
    public getSuggestedAttendees(id: string, options?: AxiosRequestConfig) {
        return TrainingCoursesApiFp(this.configuration).getSuggestedAttendees(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a training course and its enrollments
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingCoursesApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return TrainingCoursesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the auto-generated EmployeeCertification, resets the enrollment attended/passed flags. Use this to undo a mistaken completion.
     * @summary Reverse completion for a single employee
     * @param {string} id 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingCoursesApi
     */
    public uncompleteEmployee(id: string, employeeId: string, options?: AxiosRequestConfig) {
        return TrainingCoursesApiFp(this.configuration).uncompleteEmployee(id, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove an employee from a training course
     * @param {string} id 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingCoursesApi
     */
    public unenroll(id: string, employeeId: string, options?: AxiosRequestConfig) {
        return TrainingCoursesApiFp(this.configuration).unenroll(id, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a training course (status, dates, details)
     * @param {string} id 
     * @param {UpdateTrainingCourseDto} updateTrainingCourseDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingCoursesApi
     */
    public update(id: string, updateTrainingCourseDto: UpdateTrainingCourseDto, options?: AxiosRequestConfig) {
        return TrainingCoursesApiFp(this.configuration).update(id, updateTrainingCourseDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TrainingRequirementsApi - axios parameter creator
 * @export
 */
export const TrainingRequirementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Assign a course type as required for a department/position
         * @param {CreateTrainingRequirementDto} createTrainingRequirementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createTrainingRequirementDto: CreateTrainingRequirementDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTrainingRequirementDto' is not null or undefined
            assertParamExists('create', 'createTrainingRequirementDto', createTrainingRequirementDto)
            const localVarPath = `/api/v1/training-requirements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTrainingRequirementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all training requirements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/training-requirements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all training requirements for a specific department
         * @param {number} departmentId Department ID to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByDepartment: async (departmentId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'departmentId' is not null or undefined
            assertParamExists('findByDepartment', 'departmentId', departmentId)
            const localVarPath = `/api/v1/training-requirements/by-department`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a training requirement by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/training-requirements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a training requirement
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/training-requirements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrainingRequirementsApi - functional programming interface
 * @export
 */
export const TrainingRequirementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrainingRequirementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Assign a course type as required for a department/position
         * @param {CreateTrainingRequirementDto} createTrainingRequirementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createTrainingRequirementDto: CreateTrainingRequirementDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingRequirementEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createTrainingRequirementDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all training requirements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrainingRequirementEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all training requirements for a specific department
         * @param {number} departmentId Department ID to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByDepartment(departmentId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrainingRequirementEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByDepartment(departmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a training requirement by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingRequirementEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove a training requirement
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingRequirementEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TrainingRequirementsApi - factory interface
 * @export
 */
export const TrainingRequirementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrainingRequirementsApiFp(configuration)
    return {
        /**
         * 
         * @summary Assign a course type as required for a department/position
         * @param {CreateTrainingRequirementDto} createTrainingRequirementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createTrainingRequirementDto: CreateTrainingRequirementDto, options?: any): AxiosPromise<TrainingRequirementEntity> {
            return localVarFp.create(createTrainingRequirementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all training requirements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<TrainingRequirementEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all training requirements for a specific department
         * @param {number} departmentId Department ID to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByDepartment(departmentId: number, options?: any): AxiosPromise<Array<TrainingRequirementEntity>> {
            return localVarFp.findByDepartment(departmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a training requirement by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<TrainingRequirementEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a training requirement
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<TrainingRequirementEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrainingRequirementsApi - object-oriented interface
 * @export
 * @class TrainingRequirementsApi
 * @extends {BaseAPI}
 */
export class TrainingRequirementsApi extends BaseAPI {
    /**
     * 
     * @summary Assign a course type as required for a department/position
     * @param {CreateTrainingRequirementDto} createTrainingRequirementDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingRequirementsApi
     */
    public create(createTrainingRequirementDto: CreateTrainingRequirementDto, options?: AxiosRequestConfig) {
        return TrainingRequirementsApiFp(this.configuration).create(createTrainingRequirementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all training requirements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingRequirementsApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return TrainingRequirementsApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all training requirements for a specific department
     * @param {number} departmentId Department ID to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingRequirementsApi
     */
    public findByDepartment(departmentId: number, options?: AxiosRequestConfig) {
        return TrainingRequirementsApiFp(this.configuration).findByDepartment(departmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a training requirement by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingRequirementsApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return TrainingRequirementsApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a training requirement
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrainingRequirementsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return TrainingRequirementsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TurnoverItemsApi - axios parameter creator
 * @export
 */
export const TurnoverItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkControllerModification: async (dateTimeStamp: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dateTimeStamp' is not null or undefined
            assertParamExists('checkControllerModification', 'dateTimeStamp', dateTimeStamp)
            const localVarPath = `/api/v1/turnover-items/checkControllerModification/{dateTimeStamp}`
                .replace(`{${"dateTimeStamp"}}`, encodeURIComponent(String(dateTimeStamp)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {CreateTurnoverItemDto} createTurnoverItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (seasonId: number, employeeId: number, createTurnoverItemDto: CreateTurnoverItemDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('create', 'seasonId', seasonId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('create', 'employeeId', employeeId)
            // verify required parameter 'createTurnoverItemDto' is not null or undefined
            assertParamExists('create', 'createTurnoverItemDto', createTurnoverItemDto)
            const localVarPath = `/api/v1/turnover-items/{seasonId}/{employeeId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTurnoverItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyValues: async (dateTimeStamp: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dateTimeStamp' is not null or undefined
            assertParamExists('dailyValues', 'dateTimeStamp', dateTimeStamp)
            const localVarPath = `/api/v1/turnover-items/daily/{dateTimeStamp}`
                .replace(`{${"dateTimeStamp"}}`, encodeURIComponent(String(dateTimeStamp)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAcceptedByController: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/turnover-items/findAcceptedByController`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} exludeOnlyToShowSections 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (exludeOnlyToShowSections: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exludeOnlyToShowSections' is not null or undefined
            assertParamExists('findAll', 'exludeOnlyToShowSections', exludeOnlyToShowSections)
            const localVarPath = `/api/v1/turnover-items/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (exludeOnlyToShowSections !== undefined) {
                localVarQueryParameter['exludeOnlyToShowSections'] = exludeOnlyToShowSections;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} dateTimeStamp 
         * @param {number} paymentSectionId 
         * @param {number} paymentMethodId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllWithoutEmployee: async (dateTimeStamp: number, paymentSectionId: number, paymentMethodId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dateTimeStamp' is not null or undefined
            assertParamExists('findAllWithoutEmployee', 'dateTimeStamp', dateTimeStamp)
            // verify required parameter 'paymentSectionId' is not null or undefined
            assertParamExists('findAllWithoutEmployee', 'paymentSectionId', paymentSectionId)
            // verify required parameter 'paymentMethodId' is not null or undefined
            assertParamExists('findAllWithoutEmployee', 'paymentMethodId', paymentMethodId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findAllWithoutEmployee', 'seasonId', seasonId)
            const localVarPath = `/api/v1/turnover-items/{dateTimeStamp}/{paymentSectionId}/{paymentMethodId}/{seasonId}`
                .replace(`{${"dateTimeStamp"}}`, encodeURIComponent(String(dateTimeStamp)))
                .replace(`{${"paymentSectionId"}}`, encodeURIComponent(String(paymentSectionId)))
                .replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(paymentMethodId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOwedByController: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/turnover-items/owedByController`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} dateTimeStamp 
         * @param {number} paymentSectionId 
         * @param {number} paymentMethodId 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUnique: async (dateTimeStamp: number, paymentSectionId: number, paymentMethodId: number, seasonId: number, employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dateTimeStamp' is not null or undefined
            assertParamExists('findUnique', 'dateTimeStamp', dateTimeStamp)
            // verify required parameter 'paymentSectionId' is not null or undefined
            assertParamExists('findUnique', 'paymentSectionId', paymentSectionId)
            // verify required parameter 'paymentMethodId' is not null or undefined
            assertParamExists('findUnique', 'paymentMethodId', paymentMethodId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findUnique', 'seasonId', seasonId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findUnique', 'employeeId', employeeId)
            const localVarPath = `/api/v1/turnover-items/{dateTimeStamp}/{paymentSectionId}/{paymentMethodId}/{seasonId}/{employeeId}`
                .replace(`{${"dateTimeStamp"}}`, encodeURIComponent(String(dateTimeStamp)))
                .replace(`{${"paymentSectionId"}}`, encodeURIComponent(String(paymentSectionId)))
                .replace(`{${"paymentMethodId"}}`, encodeURIComponent(String(paymentMethodId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {number} dateTimeStamp 
         * @param {Array<string>} sectionIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositableSums: async (seasonId: number, dateTimeStamp: number, sectionIds: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getDepositableSums', 'seasonId', seasonId)
            // verify required parameter 'dateTimeStamp' is not null or undefined
            assertParamExists('getDepositableSums', 'dateTimeStamp', dateTimeStamp)
            // verify required parameter 'sectionIds' is not null or undefined
            assertParamExists('getDepositableSums', 'sectionIds', sectionIds)
            const localVarPath = `/api/v1/turnover-items/depositableSums/{seasonId}/{dateTimeStamp}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)))
                .replace(`{${"dateTimeStamp"}}`, encodeURIComponent(String(dateTimeStamp)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sectionIds) {
                localVarQueryParameter['sectionIds'] = sectionIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverviewForWidget: async (seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('getOverviewForWidget', 'seasonId', seasonId)
            const localVarPath = `/api/v1/turnover-items/overviewForWidget/{seasonId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TurnoverComparisonDto} turnoverComparisonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTurnoverComparison: async (turnoverComparisonDto: TurnoverComparisonDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'turnoverComparisonDto' is not null or undefined
            assertParamExists('getTurnoverComparison', 'turnoverComparisonDto', turnoverComparisonDto)
            const localVarPath = `/api/v1/turnover-items/comparison`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(turnoverComparisonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {Array<string>} sectionIds 
         * @param {Array<string>} employeeIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTurnoverPrediction: async (fromDate: string, toDate: string, sectionIds: Array<string>, employeeIds: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getTurnoverPrediction', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getTurnoverPrediction', 'toDate', toDate)
            // verify required parameter 'sectionIds' is not null or undefined
            assertParamExists('getTurnoverPrediction', 'sectionIds', sectionIds)
            // verify required parameter 'employeeIds' is not null or undefined
            assertParamExists('getTurnoverPrediction', 'employeeIds', employeeIds)
            const localVarPath = `/api/v1/turnover-items/prediction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (sectionIds) {
                localVarQueryParameter['sectionIds'] = sectionIds;
            }

            if (employeeIds) {
                localVarQueryParameter['employeeIds'] = employeeIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} exludeOnlyToShowSections 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grouped: async (exludeOnlyToShowSections: boolean, fromDate: string, toDate: string, status: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exludeOnlyToShowSections' is not null or undefined
            assertParamExists('grouped', 'exludeOnlyToShowSections', exludeOnlyToShowSections)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('grouped', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('grouped', 'toDate', toDate)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('grouped', 'status', status)
            const localVarPath = `/api/v1/turnover-items/grouped/{status}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (exludeOnlyToShowSections !== undefined) {
                localVarQueryParameter['exludeOnlyToShowSections'] = exludeOnlyToShowSections;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} timeStamp 
         * @param {number} seasonId 
         * @param {number} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemOfDay: async (timeStamp: number, seasonId: number, sectionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeStamp' is not null or undefined
            assertParamExists('itemOfDay', 'timeStamp', timeStamp)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('itemOfDay', 'seasonId', seasonId)
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('itemOfDay', 'sectionId', sectionId)
            const localVarPath = `/api/v1/turnover-items/itemOfDay/{timeStamp}/{seasonId}/{sectionId}`
                .replace(`{${"timeStamp"}}`, encodeURIComponent(String(timeStamp)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)))
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {number} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemOfToday: async (seasonId: number, sectionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('itemOfToday', 'seasonId', seasonId)
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('itemOfToday', 'sectionId', sectionId)
            const localVarPath = `/api/v1/turnover-items/itemOfToday/{seasonId}/{sectionId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)))
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {number} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemOfYesterday: async (seasonId: number, sectionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('itemOfYesterday', 'seasonId', seasonId)
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('itemOfYesterday', 'sectionId', sectionId)
            const localVarPath = `/api/v1/turnover-items/itemOfYesterday/{seasonId}/{sectionId}`
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)))
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTurnovers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/turnover-items/moveTurnovers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/turnover-items/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAcceptedByController: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setAcceptedByController', 'id', id)
            const localVarPath = `/api/v1/turnover-items/acceptedByController/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} controllerId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAcceptedByOwner: async (controllerId: string, date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controllerId' is not null or undefined
            assertParamExists('setAcceptedByOwner', 'controllerId', controllerId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('setAcceptedByOwner', 'date', date)
            const localVarPath = `/api/v1/turnover-items/acceptedByOwner/{controllerId}`
                .replace(`{${"controllerId"}}`, encodeURIComponent(String(controllerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTurnoverItemDto} updateTurnoverItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateTurnoverItemDto: UpdateTurnoverItemDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateTurnoverItemDto' is not null or undefined
            assertParamExists('update', 'updateTurnoverItemDto', updateTurnoverItemDto)
            const localVarPath = `/api/v1/turnover-items/{id}/{seasonId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTurnoverItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TurnoverItemsApi - functional programming interface
 * @export
 */
export const TurnoverItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TurnoverItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkControllerModification(dateTimeStamp: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkControllerModification(dateTimeStamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {CreateTurnoverItemDto} createTurnoverItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(seasonId: number, employeeId: number, createTurnoverItemDto: CreateTurnoverItemDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TurnoverItemEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(seasonId, employeeId, createTurnoverItemDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dailyValues(dateTimeStamp: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dailyValues(dateTimeStamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAcceptedByController(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TurnoverItemEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAcceptedByController(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} exludeOnlyToShowSections 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(exludeOnlyToShowSections: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TurnoverItemEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(exludeOnlyToShowSections, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} dateTimeStamp 
         * @param {number} paymentSectionId 
         * @param {number} paymentMethodId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllWithoutEmployee(dateTimeStamp: number, paymentSectionId: number, paymentMethodId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllWithoutEmployee(dateTimeStamp, paymentSectionId, paymentMethodId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOwedByController(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOwedByController(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} dateTimeStamp 
         * @param {number} paymentSectionId 
         * @param {number} paymentMethodId 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUnique(dateTimeStamp: number, paymentSectionId: number, paymentMethodId: number, seasonId: number, employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TurnoverItemEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUnique(dateTimeStamp, paymentSectionId, paymentMethodId, seasonId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {number} dateTimeStamp 
         * @param {Array<string>} sectionIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepositableSums(seasonId: number, dateTimeStamp: number, sectionIds: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TurnoverDepositableSumEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepositableSums(seasonId, dateTimeStamp, sectionIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOverviewForWidget(seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOverviewForWidget(seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TurnoverComparisonDto} turnoverComparisonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTurnoverComparison(turnoverComparisonDto: TurnoverComparisonDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTurnoverComparison(turnoverComparisonDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {Array<string>} sectionIds 
         * @param {Array<string>} employeeIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTurnoverPrediction(fromDate: string, toDate: string, sectionIds: Array<string>, employeeIds: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTurnoverPrediction(fromDate, toDate, sectionIds, employeeIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} exludeOnlyToShowSections 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grouped(exludeOnlyToShowSections: boolean, fromDate: string, toDate: string, status: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grouped(exludeOnlyToShowSections, fromDate, toDate, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} timeStamp 
         * @param {number} seasonId 
         * @param {number} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemOfDay(timeStamp: number, seasonId: number, sectionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemOfDay(timeStamp, seasonId, sectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {number} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemOfToday(seasonId: number, sectionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemOfToday(seasonId, sectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {number} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async itemOfYesterday(seasonId: number, sectionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.itemOfYesterday(seasonId, sectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveTurnovers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveTurnovers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TurnoverItemEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAcceptedByController(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TurnoverItemEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAcceptedByController(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} controllerId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAcceptedByOwner(controllerId: string, date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAcceptedByOwner(controllerId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTurnoverItemDto} updateTurnoverItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateTurnoverItemDto: UpdateTurnoverItemDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TurnoverItemEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateTurnoverItemDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TurnoverItemsApi - factory interface
 * @export
 */
export const TurnoverItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TurnoverItemsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkControllerModification(dateTimeStamp: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.checkControllerModification(dateTimeStamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {CreateTurnoverItemDto} createTurnoverItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(seasonId: number, employeeId: number, createTurnoverItemDto: CreateTurnoverItemDto, options?: any): AxiosPromise<TurnoverItemEntity> {
            return localVarFp.create(seasonId, employeeId, createTurnoverItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} dateTimeStamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyValues(dateTimeStamp: number, options?: any): AxiosPromise<Array<EmployeeEntity>> {
            return localVarFp.dailyValues(dateTimeStamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAcceptedByController(options?: any): AxiosPromise<Array<TurnoverItemEntity>> {
            return localVarFp.findAcceptedByController(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} exludeOnlyToShowSections 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(exludeOnlyToShowSections: boolean, options?: any): AxiosPromise<Array<TurnoverItemEntity>> {
            return localVarFp.findAll(exludeOnlyToShowSections, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} dateTimeStamp 
         * @param {number} paymentSectionId 
         * @param {number} paymentMethodId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllWithoutEmployee(dateTimeStamp: number, paymentSectionId: number, paymentMethodId: number, seasonId: number, options?: any): AxiosPromise<void> {
            return localVarFp.findAllWithoutEmployee(dateTimeStamp, paymentSectionId, paymentMethodId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOwedByController(options?: any): AxiosPromise<number> {
            return localVarFp.findOwedByController(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} dateTimeStamp 
         * @param {number} paymentSectionId 
         * @param {number} paymentMethodId 
         * @param {number} seasonId 
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUnique(dateTimeStamp: number, paymentSectionId: number, paymentMethodId: number, seasonId: number, employeeId: number, options?: any): AxiosPromise<TurnoverItemEntity> {
            return localVarFp.findUnique(dateTimeStamp, paymentSectionId, paymentMethodId, seasonId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {number} dateTimeStamp 
         * @param {Array<string>} sectionIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepositableSums(seasonId: number, dateTimeStamp: number, sectionIds: Array<string>, options?: any): AxiosPromise<Array<TurnoverDepositableSumEntity>> {
            return localVarFp.getDepositableSums(seasonId, dateTimeStamp, sectionIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverviewForWidget(seasonId: number, options?: any): AxiosPromise<object> {
            return localVarFp.getOverviewForWidget(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TurnoverComparisonDto} turnoverComparisonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTurnoverComparison(turnoverComparisonDto: TurnoverComparisonDto, options?: any): AxiosPromise<void> {
            return localVarFp.getTurnoverComparison(turnoverComparisonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {Array<string>} sectionIds 
         * @param {Array<string>} employeeIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTurnoverPrediction(fromDate: string, toDate: string, sectionIds: Array<string>, employeeIds: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.getTurnoverPrediction(fromDate, toDate, sectionIds, employeeIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} exludeOnlyToShowSections 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {string} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grouped(exludeOnlyToShowSections: boolean, fromDate: string, toDate: string, status: string, options?: any): AxiosPromise<object> {
            return localVarFp.grouped(exludeOnlyToShowSections, fromDate, toDate, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} timeStamp 
         * @param {number} seasonId 
         * @param {number} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemOfDay(timeStamp: number, seasonId: number, sectionId: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.itemOfDay(timeStamp, seasonId, sectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {number} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemOfToday(seasonId: number, sectionId: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.itemOfToday(seasonId, sectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {number} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        itemOfYesterday(seasonId: number, sectionId: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.itemOfYesterday(seasonId, sectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTurnovers(options?: any): AxiosPromise<object> {
            return localVarFp.moveTurnovers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: number, options?: any): AxiosPromise<TurnoverItemEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAcceptedByController(id: string, options?: any): AxiosPromise<TurnoverItemEntity> {
            return localVarFp.setAcceptedByController(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} controllerId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAcceptedByOwner(controllerId: string, date: string, options?: any): AxiosPromise<object> {
            return localVarFp.setAcceptedByOwner(controllerId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateTurnoverItemDto} updateTurnoverItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateTurnoverItemDto: UpdateTurnoverItemDto, options?: any): AxiosPromise<TurnoverItemEntity> {
            return localVarFp.update(id, updateTurnoverItemDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TurnoverItemsApi - object-oriented interface
 * @export
 * @class TurnoverItemsApi
 * @extends {BaseAPI}
 */
export class TurnoverItemsApi extends BaseAPI {
    /**
     * 
     * @param {number} dateTimeStamp 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public checkControllerModification(dateTimeStamp: number, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).checkControllerModification(dateTimeStamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {number} employeeId 
     * @param {CreateTurnoverItemDto} createTurnoverItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public create(seasonId: number, employeeId: number, createTurnoverItemDto: CreateTurnoverItemDto, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).create(seasonId, employeeId, createTurnoverItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} dateTimeStamp 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public dailyValues(dateTimeStamp: number, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).dailyValues(dateTimeStamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public findAcceptedByController(options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).findAcceptedByController(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} exludeOnlyToShowSections 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public findAll(exludeOnlyToShowSections: boolean, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).findAll(exludeOnlyToShowSections, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} dateTimeStamp 
     * @param {number} paymentSectionId 
     * @param {number} paymentMethodId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public findAllWithoutEmployee(dateTimeStamp: number, paymentSectionId: number, paymentMethodId: number, seasonId: number, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).findAllWithoutEmployee(dateTimeStamp, paymentSectionId, paymentMethodId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public findOwedByController(options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).findOwedByController(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} dateTimeStamp 
     * @param {number} paymentSectionId 
     * @param {number} paymentMethodId 
     * @param {number} seasonId 
     * @param {number} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public findUnique(dateTimeStamp: number, paymentSectionId: number, paymentMethodId: number, seasonId: number, employeeId: number, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).findUnique(dateTimeStamp, paymentSectionId, paymentMethodId, seasonId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {number} dateTimeStamp 
     * @param {Array<string>} sectionIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public getDepositableSums(seasonId: number, dateTimeStamp: number, sectionIds: Array<string>, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).getDepositableSums(seasonId, dateTimeStamp, sectionIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public getOverviewForWidget(seasonId: number, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).getOverviewForWidget(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TurnoverComparisonDto} turnoverComparisonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public getTurnoverComparison(turnoverComparisonDto: TurnoverComparisonDto, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).getTurnoverComparison(turnoverComparisonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {Array<string>} sectionIds 
     * @param {Array<string>} employeeIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public getTurnoverPrediction(fromDate: string, toDate: string, sectionIds: Array<string>, employeeIds: Array<string>, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).getTurnoverPrediction(fromDate, toDate, sectionIds, employeeIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} exludeOnlyToShowSections 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {string} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public grouped(exludeOnlyToShowSections: boolean, fromDate: string, toDate: string, status: string, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).grouped(exludeOnlyToShowSections, fromDate, toDate, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} timeStamp 
     * @param {number} seasonId 
     * @param {number} sectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public itemOfDay(timeStamp: number, seasonId: number, sectionId: number, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).itemOfDay(timeStamp, seasonId, sectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {number} sectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public itemOfToday(seasonId: number, sectionId: number, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).itemOfToday(seasonId, sectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {number} sectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public itemOfYesterday(seasonId: number, sectionId: number, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).itemOfYesterday(seasonId, sectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public moveTurnovers(options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).moveTurnovers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public remove(id: number, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public setAcceptedByController(id: string, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).setAcceptedByController(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} controllerId 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public setAcceptedByOwner(controllerId: string, date: string, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).setAcceptedByOwner(controllerId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateTurnoverItemDto} updateTurnoverItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TurnoverItemsApi
     */
    public update(id: string, updateTurnoverItemDto: UpdateTurnoverItemDto, options?: AxiosRequestConfig) {
        return TurnoverItemsApiFp(this.configuration).update(id, updateTurnoverItemDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguage: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLanguage', 'id', id)
            const localVarPath = `/api/v1/users/getLanguage/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetLanguageDto} setLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLanguage: async (setLanguageDto: SetLanguageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setLanguageDto' is not null or undefined
            assertParamExists('setLanguage', 'setLanguageDto', setLanguageDto)
            const localVarPath = `/api/v1/users/setLanguage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setLanguageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLanguage(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLanguage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetLanguageDto} setLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setLanguage(setLanguageDto: SetLanguageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setLanguage(setLanguageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLanguage(id: number, options?: any): AxiosPromise<string> {
            return localVarFp.getLanguage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetLanguageDto} setLanguageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLanguage(setLanguageDto: SetLanguageDto, options?: any): AxiosPromise<void> {
            return localVarFp.setLanguage(setLanguageDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getLanguage(id: number, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getLanguage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetLanguageDto} setLanguageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public setLanguage(setLanguageDto: SetLanguageDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).setLanguage(setLanguageDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WorkPositionsApi - axios parameter creator
 * @export
 */
export const WorkPositionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a secondary boss to a work position
         * @param {string} id 
         * @param {AddSecondaryBossDto} addSecondaryBossDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSecondaryBoss: async (id: string, addSecondaryBossDto: AddSecondaryBossDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addSecondaryBoss', 'id', id)
            // verify required parameter 'addSecondaryBossDto' is not null or undefined
            assertParamExists('addSecondaryBoss', 'addSecondaryBossDto', addSecondaryBossDto)
            const localVarPath = `/api/v1/work-positions/{id}/secondary-bosses`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSecondaryBossDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {CreateWorkPositionDto} createWorkPositionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (seasonId: number, createWorkPositionDto: CreateWorkPositionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('create', 'seasonId', seasonId)
            // verify required parameter 'createWorkPositionDto' is not null or undefined
            assertParamExists('create', 'createWorkPositionDto', createWorkPositionDto)
            const localVarPath = `/api/v1/work-positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkPositionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (departmentId?: number, seasonId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/work-positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByEmployee: async (employeeId: number, seasonId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('findByEmployee', 'employeeId', employeeId)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('findByEmployee', 'seasonId', seasonId)
            const localVarPath = `/api/v1/work-positions/byEmployee/{employeeId}/{seasonId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"seasonId"}}`, encodeURIComponent(String(seasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/work-positions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/work-positions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a secondary boss from a work position
         * @param {string} id 
         * @param {string} bossId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSecondaryBoss: async (id: string, bossId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeSecondaryBoss', 'id', id)
            // verify required parameter 'bossId' is not null or undefined
            assertParamExists('removeSecondaryBoss', 'bossId', bossId)
            const localVarPath = `/api/v1/work-positions/{id}/secondary-bosses/{bossId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"bossId"}}`, encodeURIComponent(String(bossId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} seasonId 
         * @param {UpdateWorkPositionDto} updateWorkPositionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, seasonId: number, updateWorkPositionDto: UpdateWorkPositionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'seasonId' is not null or undefined
            assertParamExists('update', 'seasonId', seasonId)
            // verify required parameter 'updateWorkPositionDto' is not null or undefined
            assertParamExists('update', 'updateWorkPositionDto', updateWorkPositionDto)
            const localVarPath = `/api/v1/work-positions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkPositionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkPositionsApi - functional programming interface
 * @export
 */
export const WorkPositionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkPositionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a secondary boss to a work position
         * @param {string} id 
         * @param {AddSecondaryBossDto} addSecondaryBossDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSecondaryBoss(id: string, addSecondaryBossDto: AddSecondaryBossDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSecondaryBoss(id, addSecondaryBossDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {CreateWorkPositionDto} createWorkPositionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(seasonId: number, createWorkPositionDto: CreateWorkPositionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkPositionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(seasonId, createWorkPositionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(departmentId?: number, seasonId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkPositionEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(departmentId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findByEmployee(employeeId: number, seasonId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkPositionEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findByEmployee(employeeId, seasonId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkPositionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove a secondary boss from a work position
         * @param {string} id 
         * @param {string} bossId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeSecondaryBoss(id: string, bossId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeSecondaryBoss(id, bossId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} seasonId 
         * @param {UpdateWorkPositionDto} updateWorkPositionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, seasonId: number, updateWorkPositionDto: UpdateWorkPositionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkPositionEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, seasonId, updateWorkPositionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WorkPositionsApi - factory interface
 * @export
 */
export const WorkPositionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkPositionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a secondary boss to a work position
         * @param {string} id 
         * @param {AddSecondaryBossDto} addSecondaryBossDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSecondaryBoss(id: string, addSecondaryBossDto: AddSecondaryBossDto, options?: any): AxiosPromise<void> {
            return localVarFp.addSecondaryBoss(id, addSecondaryBossDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} seasonId 
         * @param {CreateWorkPositionDto} createWorkPositionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(seasonId: number, createWorkPositionDto: CreateWorkPositionDto, options?: any): AxiosPromise<WorkPositionEntity> {
            return localVarFp.create(seasonId, createWorkPositionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(departmentId?: number, seasonId?: number, options?: any): AxiosPromise<Array<WorkPositionEntity>> {
            return localVarFp.findAll(departmentId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} employeeId 
         * @param {number} seasonId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByEmployee(employeeId: number, seasonId: number, options?: any): AxiosPromise<Array<WorkPositionEntity>> {
            return localVarFp.findByEmployee(employeeId, seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<WorkPositionEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a secondary boss from a work position
         * @param {string} id 
         * @param {string} bossId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSecondaryBoss(id: string, bossId: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeSecondaryBoss(id, bossId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {number} seasonId 
         * @param {UpdateWorkPositionDto} updateWorkPositionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, seasonId: number, updateWorkPositionDto: UpdateWorkPositionDto, options?: any): AxiosPromise<WorkPositionEntity> {
            return localVarFp.update(id, seasonId, updateWorkPositionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkPositionsApi - object-oriented interface
 * @export
 * @class WorkPositionsApi
 * @extends {BaseAPI}
 */
export class WorkPositionsApi extends BaseAPI {
    /**
     * 
     * @summary Add a secondary boss to a work position
     * @param {string} id 
     * @param {AddSecondaryBossDto} addSecondaryBossDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkPositionsApi
     */
    public addSecondaryBoss(id: string, addSecondaryBossDto: AddSecondaryBossDto, options?: AxiosRequestConfig) {
        return WorkPositionsApiFp(this.configuration).addSecondaryBoss(id, addSecondaryBossDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} seasonId 
     * @param {CreateWorkPositionDto} createWorkPositionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkPositionsApi
     */
    public create(seasonId: number, createWorkPositionDto: CreateWorkPositionDto, options?: AxiosRequestConfig) {
        return WorkPositionsApiFp(this.configuration).create(seasonId, createWorkPositionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [departmentId] 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkPositionsApi
     */
    public findAll(departmentId?: number, seasonId?: number, options?: AxiosRequestConfig) {
        return WorkPositionsApiFp(this.configuration).findAll(departmentId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} employeeId 
     * @param {number} seasonId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkPositionsApi
     */
    public findByEmployee(employeeId: number, seasonId: number, options?: AxiosRequestConfig) {
        return WorkPositionsApiFp(this.configuration).findByEmployee(employeeId, seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkPositionsApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return WorkPositionsApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkPositionsApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return WorkPositionsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a secondary boss from a work position
     * @param {string} id 
     * @param {string} bossId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkPositionsApi
     */
    public removeSecondaryBoss(id: string, bossId: string, options?: AxiosRequestConfig) {
        return WorkPositionsApiFp(this.configuration).removeSecondaryBoss(id, bossId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {number} seasonId 
     * @param {UpdateWorkPositionDto} updateWorkPositionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkPositionsApi
     */
    public update(id: string, seasonId: number, updateWorkPositionDto: UpdateWorkPositionDto, options?: AxiosRequestConfig) {
        return WorkPositionsApiFp(this.configuration).update(id, seasonId, updateWorkPositionDto, options).then((request) => request(this.axios, this.basePath));
    }
}




/**
 * 
 * @export
 * @interface CreateShiftNoteDto
 */
export interface CreateShiftNoteDto {
    /**
     * The text content of the shift note
     * @type {string}
     * @memberof CreateShiftNoteDto
     */
    'text': string;
    /**
     * The date of the shift note
     * @type {string}
     * @memberof CreateShiftNoteDto
     */
    'date': string;
    /**
     * The path to the uploaded image (optional)
     * @type {string}
     * @memberof CreateShiftNoteDto
     */
    'imagePath'?: string;
}
/**
 * 
 * @export
 * @interface UpdateShiftNoteDto
 */
export interface UpdateShiftNoteDto {
    /**
     * The text content of the shift note
     * @type {string}
     * @memberof UpdateShiftNoteDto
     */
    'text'?: string;
    /**
     * The date of the shift note
     * @type {string}
     * @memberof UpdateShiftNoteDto
     */
    'date'?: string;
    /**
     * The path to the uploaded image (optional)
     * @type {string}
     * @memberof UpdateShiftNoteDto
     */
    'imagePath'?: string;
}
/**
 * 
 * @export
 * @interface ShiftNoteEntity
 */
export interface ShiftNoteEntity {
    /**
     * 
     * @type {string}
     * @memberof ShiftNoteEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ShiftNoteEntity
     */
    'editedAt': string;
    /**
     * 
     * @type {number}
     * @memberof ShiftNoteEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof ShiftNoteEntity
     */
    'createdById': number;
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof ShiftNoteEntity
     */
    'createdBy'?: EmployeeEntity;
    /**
     * 
     * @type {string}
     * @memberof ShiftNoteEntity
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof ShiftNoteEntity
     */
    'date': string;
    /**
     * 
     * @type {boolean}
     * @memberof ShiftNoteEntity
     */
    'resolved': boolean;
    /**
     * 
     * @type {string}
     * @memberof ShiftNoteEntity
     */
    'imagePath': string | null;
}


/**
 * ShiftNotesApi - axios parameter creator
 * @export
 */
export const ShiftNotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateShiftNoteDto} createShiftNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createShiftNoteDto: CreateShiftNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createShiftNoteDto' is not null or undefined
            assertParamExists('create', 'createShiftNoteDto', createShiftNoteDto)
            const localVarPath = `/api/v1/shift-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShiftNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload an image along with the shift note data. The image will be stored in the cloud and a presigned URL will be returned.
         * @summary Create a new shift note with an uploaded image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithImage: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shift-notes/with-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/shift-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/shift-notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/shift-notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolve: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resolve', 'id', id)
            const localVarPath = `/api/v1/shift-notes/resolve/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unresolve: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unresolve', 'id', id)
            const localVarPath = `/api/v1/shift-notes/unresolve/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateShiftNoteDto} updateShiftNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateShiftNoteDto: UpdateShiftNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateShiftNoteDto' is not null or undefined
            assertParamExists('update', 'updateShiftNoteDto', updateShiftNoteDto)
            const localVarPath = `/api/v1/shift-notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateShiftNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShiftNotesApi - functional programming interface
 * @export
 */
export const ShiftNotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShiftNotesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateShiftNoteDto} createShiftNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createShiftNoteDto: CreateShiftNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createShiftNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload an image along with the shift note data. The image will be stored in the cloud and a presigned URL will be returned.
         * @summary Create a new shift note with an uploaded image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWithImage(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWithImage(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftNoteEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolve(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unresolve(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unresolve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateShiftNoteDto} updateShiftNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateShiftNoteDto: UpdateShiftNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateShiftNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShiftNotesApi - factory interface
 * @export
 */
export const ShiftNotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShiftNotesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateShiftNoteDto} createShiftNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createShiftNoteDto: CreateShiftNoteDto, options?: any): AxiosPromise<ShiftNoteEntity> {
            return localVarFp.create(createShiftNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload an image along with the shift note data. The image will be stored in the cloud and a presigned URL will be returned.
         * @summary Create a new shift note with an uploaded image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithImage(options?: any): AxiosPromise<void> {
            return localVarFp.createWithImage(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<ShiftNoteEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<ShiftNoteEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<ShiftNoteEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolve(id: string, options?: any): AxiosPromise<ShiftNoteEntity> {
            return localVarFp.resolve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unresolve(id: string, options?: any): AxiosPromise<ShiftNoteEntity> {
            return localVarFp.unresolve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateShiftNoteDto} updateShiftNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateShiftNoteDto: UpdateShiftNoteDto, options?: any): AxiosPromise<ShiftNoteEntity> {
            return localVarFp.update(id, updateShiftNoteDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShiftNotesApi - object-oriented interface
 * @export
 * @class ShiftNotesApi
 * @extends {BaseAPI}
 */
export class ShiftNotesApi extends BaseAPI {
    /**
     * 
     * @param {CreateShiftNoteDto} createShiftNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftNotesApi
     */
    public create(createShiftNoteDto: CreateShiftNoteDto, options?: AxiosRequestConfig) {
        return ShiftNotesApiFp(this.configuration).create(createShiftNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload an image along with the shift note data. The image will be stored in the cloud and a presigned URL will be returned.
     * @summary Create a new shift note with an uploaded image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftNotesApi
     */
    public createWithImage(options?: AxiosRequestConfig) {
        return ShiftNotesApiFp(this.configuration).createWithImage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftNotesApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return ShiftNotesApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftNotesApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return ShiftNotesApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftNotesApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return ShiftNotesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftNotesApi
     */
    public resolve(id: string, options?: AxiosRequestConfig) {
        return ShiftNotesApiFp(this.configuration).resolve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftNotesApi
     */
    public unresolve(id: string, options?: AxiosRequestConfig) {
        return ShiftNotesApiFp(this.configuration).unresolve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateShiftNoteDto} updateShiftNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShiftNotesApi
     */
    public update(id: string, updateShiftNoteDto: UpdateShiftNoteDto, options?: AxiosRequestConfig) {
        return ShiftNotesApiFp(this.configuration).update(id, updateShiftNoteDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * 
 * @export
 * @interface CreateEmployeeDayNoteDto
 */
export interface CreateEmployeeDayNoteDto {
    /**
     * The text content of the employee day note
     * @type {string}
     * @memberof CreateEmployeeDayNoteDto
     */
    'text': string;
    /**
     * The date the note refers to
     * @type {string}
     * @memberof CreateEmployeeDayNoteDto
     */
    'date': string;
    /**
     * The id of the employee the note is about
     * @type {number}
     * @memberof CreateEmployeeDayNoteDto
     */
    'employeeId': number;
    /**
     * The path to the uploaded image (optional)
     * @type {string}
     * @memberof CreateEmployeeDayNoteDto
     */
    'imagePath'?: string;
}
/**
 * 
 * @export
 * @interface UpdateEmployeeDayNoteDto
 */
export interface UpdateEmployeeDayNoteDto {
    /**
     * The text content of the employee day note
     * @type {string}
     * @memberof UpdateEmployeeDayNoteDto
     */
    'text'?: string;
    /**
     * The date the note refers to
     * @type {string}
     * @memberof UpdateEmployeeDayNoteDto
     */
    'date'?: string;
    /**
     * The id of the employee the note is about
     * @type {number}
     * @memberof UpdateEmployeeDayNoteDto
     */
    'employeeId'?: number;
    /**
     * The path to the uploaded image (optional)
     * @type {string}
     * @memberof UpdateEmployeeDayNoteDto
     */
    'imagePath'?: string;
}
/**
 * 
 * @export
 * @interface EmployeeDayNoteEntity
 */
export interface EmployeeDayNoteEntity {
    /**
     * 
     * @type {string}
     * @memberof EmployeeDayNoteEntity
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDayNoteEntity
     */
    'editedAt': string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeDayNoteEntity
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof EmployeeDayNoteEntity
     */
    'createdById': number;
    /**
     * 
     * @type {EmployeeEntity}
     * @memberof EmployeeDayNoteEntity
     */
    'createdBy'?: EmployeeEntity;
    /**
     * 
     * @type {number}
     * @memberof EmployeeDayNoteEntity
     */
    'employeeId': number;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDayNoteEntity
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDayNoteEntity
     */
    'date': string;
    /**
     * 
     * @type {boolean}
     * @memberof EmployeeDayNoteEntity
     */
    'resolved': boolean;
    /**
     * 
     * @type {string}
     * @memberof EmployeeDayNoteEntity
     */
    'imagePath': string | null;
}


/**
 * EmployeeDayNotesApi - axios parameter creator
 * @export
 */
export const EmployeeDayNotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateEmployeeDayNoteDto} createEmployeeDayNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createEmployeeDayNoteDto: CreateEmployeeDayNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmployeeDayNoteDto' is not null or undefined
            assertParamExists('create', 'createEmployeeDayNoteDto', createEmployeeDayNoteDto)
            const localVarPath = `/api/v1/employee-day-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeDayNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload an image along with the employee day note data. The image will be stored in the cloud and a presigned URL will be returned.
         * @summary Create a new employee day note with an uploaded image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithImage: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employee-day-notes/with-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/employee-day-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findOne', 'id', id)
            const localVarPath = `/api/v1/employee-day-notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/v1/employee-day-notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolve: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resolve', 'id', id)
            const localVarPath = `/api/v1/employee-day-notes/resolve/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unresolve: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unresolve', 'id', id)
            const localVarPath = `/api/v1/employee-day-notes/unresolve/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeDayNoteDto} updateEmployeeDayNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: string, updateEmployeeDayNoteDto: UpdateEmployeeDayNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            // verify required parameter 'updateEmployeeDayNoteDto' is not null or undefined
            assertParamExists('update', 'updateEmployeeDayNoteDto', updateEmployeeDayNoteDto)
            const localVarPath = `/api/v1/employee-day-notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeDayNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeDayNotesApi - functional programming interface
 * @export
 */
export const EmployeeDayNotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeDayNotesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateEmployeeDayNoteDto} createEmployeeDayNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createEmployeeDayNoteDto: CreateEmployeeDayNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDayNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createEmployeeDayNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload an image along with the employee day note data. The image will be stored in the cloud and a presigned URL will be returned.
         * @summary Create a new employee day note with an uploaded image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWithImage(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWithImage(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeDayNoteEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDayNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDayNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolve(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDayNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unresolve(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDayNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unresolve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeDayNoteDto} updateEmployeeDayNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: string, updateEmployeeDayNoteDto: UpdateEmployeeDayNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeDayNoteEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateEmployeeDayNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmployeeDayNotesApi - factory interface
 * @export
 */
export const EmployeeDayNotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeDayNotesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateEmployeeDayNoteDto} createEmployeeDayNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createEmployeeDayNoteDto: CreateEmployeeDayNoteDto, options?: any): AxiosPromise<EmployeeDayNoteEntity> {
            return localVarFp.create(createEmployeeDayNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload an image along with the employee day note data. The image will be stored in the cloud and a presigned URL will be returned.
         * @summary Create a new employee day note with an uploaded image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithImage(options?: any): AxiosPromise<void> {
            return localVarFp.createWithImage(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): AxiosPromise<Array<EmployeeDayNoteEntity>> {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOne(id: string, options?: any): AxiosPromise<EmployeeDayNoteEntity> {
            return localVarFp.findOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: string, options?: any): AxiosPromise<EmployeeDayNoteEntity> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolve(id: string, options?: any): AxiosPromise<EmployeeDayNoteEntity> {
            return localVarFp.resolve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unresolve(id: string, options?: any): AxiosPromise<EmployeeDayNoteEntity> {
            return localVarFp.unresolve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateEmployeeDayNoteDto} updateEmployeeDayNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: string, updateEmployeeDayNoteDto: UpdateEmployeeDayNoteDto, options?: any): AxiosPromise<EmployeeDayNoteEntity> {
            return localVarFp.update(id, updateEmployeeDayNoteDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeDayNotesApi - object-oriented interface
 * @export
 * @class EmployeeDayNotesApi
 * @extends {BaseAPI}
 */
export class EmployeeDayNotesApi extends BaseAPI {
    /**
     * 
     * @param {CreateEmployeeDayNoteDto} createEmployeeDayNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDayNotesApi
     */
    public create(createEmployeeDayNoteDto: CreateEmployeeDayNoteDto, options?: AxiosRequestConfig) {
        return EmployeeDayNotesApiFp(this.configuration).create(createEmployeeDayNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload an image along with the employee day note data. The image will be stored in the cloud and a presigned URL will be returned.
     * @summary Create a new employee day note with an uploaded image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDayNotesApi
     */
    public createWithImage(options?: AxiosRequestConfig) {
        return EmployeeDayNotesApiFp(this.configuration).createWithImage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDayNotesApi
     */
    public findAll(options?: AxiosRequestConfig) {
        return EmployeeDayNotesApiFp(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDayNotesApi
     */
    public findOne(id: string, options?: AxiosRequestConfig) {
        return EmployeeDayNotesApiFp(this.configuration).findOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDayNotesApi
     */
    public remove(id: string, options?: AxiosRequestConfig) {
        return EmployeeDayNotesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDayNotesApi
     */
    public resolve(id: string, options?: AxiosRequestConfig) {
        return EmployeeDayNotesApiFp(this.configuration).resolve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDayNotesApi
     */
    public unresolve(id: string, options?: AxiosRequestConfig) {
        return EmployeeDayNotesApiFp(this.configuration).unresolve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateEmployeeDayNoteDto} updateEmployeeDayNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeDayNotesApi
     */
    public update(id: string, updateEmployeeDayNoteDto: UpdateEmployeeDayNoteDto, options?: AxiosRequestConfig) {
        return EmployeeDayNotesApiFp(this.configuration).update(id, updateEmployeeDayNoteDto, options).then((request) => request(this.axios, this.basePath));
    }
}
